/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(154);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(155);
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _lodashCollectionFind = __webpack_require__(197);
	
	var _lodashCollectionFind2 = _interopRequireDefault(_lodashCollectionFind);
	
	var _lodashCollectionFilter = __webpack_require__(246);
	
	var _lodashCollectionFilter2 = _interopRequireDefault(_lodashCollectionFilter);
	
	var _createRoutes = __webpack_require__(249);
	
	var _createRoutes2 = _interopRequireDefault(_createRoutes);
	
	var _app = __webpack_require__(270);
	
	var _app2 = _interopRequireDefault(_app);
	
	function loadConfig(cb) {
	  var stuff = __webpack_require__(258);
	  if (false) {
	    module.hot.accept(stuff.id, function hotAccept() {
	      return cb();
	    });
	  }
	  return cb();
	}
	
	loadConfig(function loadConfigFunc() {
	  return _app2['default'].loadContext(function loadContextFunc(pagesReq) {
	    var router = undefined;
	    var ref = __webpack_require__(258);
	    var pages = ref.pages;
	    var config = ref.config;
	    var linkPrefix = config.linkPrefix;
	    if (!(undefined) || !linkPrefix) {
	      linkPrefix = '';
	    }
	
	    var routes = (0, _createRoutes2['default'])(pages, pagesReq);
	    // Remove templates files.
	    pages = (0, _lodashCollectionFilter2['default'])(pages, function (page) {
	      return page.path !== null;
	    });
	
	    // Route already exists meaning we're hot-reloading.
	    if (router) {
	      router.replaceRoutes([_app2['default']]);
	    } else {
	      router = _reactRouter2['default'].run([routes], _reactRouter2['default'].HistoryLocation, function (Handler, state) {
	        var page = undefined;
	        page = (0, _lodashCollectionFind2['default'])(pages, function (p) {
	          var path = linkPrefix + p.path;
	          return path === state.path || path === state.pathname;
	        });
	
	        // Let app know the route is changing.
	        if (_app2['default'].onRouteChange) {
	          _app2['default'].onRouteChange(state, page, pages, config);
	        }
	
	        return _reactDom2['default'].render(_react2['default'].createElement(Handler, {
	          config: config,
	          pages: pages,
	          page: page,
	          state: state }), typeof window !== 'undefined' ? document.getElementById('react-mount') : void 0);
	      });
	    }
	  });
	});

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(3);


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var ReactDOM = __webpack_require__(4);
	var ReactDOMServer = __webpack_require__(144);
	var ReactIsomorphic = __webpack_require__(148);
	
	var assign = __webpack_require__(39);
	var deprecated = __webpack_require__(153);
	
	// `version` will be added here by ReactIsomorphic.
	var React = {};
	
	assign(React, ReactIsomorphic);
	
	assign(React, {
	  // ReactDOM
	  findDOMNode: deprecated('findDOMNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.findDOMNode),
	  render: deprecated('render', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.render),
	  unmountComponentAtNode: deprecated('unmountComponentAtNode', 'ReactDOM', 'react-dom', ReactDOM, ReactDOM.unmountComponentAtNode),
	
	  // ReactDOMServer
	  renderToString: deprecated('renderToString', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToString),
	  renderToStaticMarkup: deprecated('renderToStaticMarkup', 'ReactDOMServer', 'react-dom/server', ReactDOMServer, ReactDOMServer.renderToStaticMarkup)
	});
	
	React.__SECRET_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOM;
	React.__SECRET_DOM_SERVER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactDOMServer;
	
	module.exports = React;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactDOMTextComponent = __webpack_require__(6);
	var ReactDefaultInjection = __webpack_require__(71);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdates = __webpack_require__(54);
	var ReactVersion = __webpack_require__(142);
	
	var findDOMNode = __webpack_require__(91);
	var renderSubtreeIntoContainer = __webpack_require__(143);
	var warning = __webpack_require__(25);
	
	ReactDefaultInjection.inject();
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        console.debug('Download the React DevTools for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : undefined;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim,
	
	    // shams
	    Object.create, Object.freeze];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error('One or more ES5 shim/shams expected by React are not available: ' + 'https://fb.me/react-warning-polyfills');
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(7);
	var DOMPropertyOperations = __webpack_require__(22);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactMount = __webpack_require__(28);
	
	var assign = __webpack_require__(39);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var setTextContent = __webpack_require__(20);
	var validateDOMNesting = __webpack_require__(70);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function (text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting('span', null, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    this._rootNodeID = rootID;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement('span');
	      DOMPropertyOperations.setAttributeForID(el, rootID);
	      // Populate node cache
	      ReactMount.getID(el);
	      setTextContent(el, this._stringText);
	      return el;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this in a `span` for the reasons stated above, but
	        // since this is a situation where React won't take over (static pages),
	        // we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' + escapedText + '</span>';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var node = ReactMount.getNode(this._rootNodeID);
	        DOMChildrenOperations.updateTextContent(node, nextStringText);
	      }
	    }
	  },
	
	  unmountComponent: function () {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(8);
	var ReactMultiChildUpdateTypes = __webpack_require__(16);
	var ReactPerf = __webpack_require__(18);
	
	var setInnerHTML = __webpack_require__(19);
	var setTextContent = __webpack_require__(20);
	var invariant = __webpack_require__(13);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	
	  // fix render order error in safari
	  // IE8 will throw error when index out of list size.
	  var beforeChild = index >= parentNode.childNodes.length ? null : parentNode.childNodes.item(index);
	
	  parentNode.insertBefore(childNode, beforeChild);
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function (updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING || update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        !updatedChild ?  false ? invariant(false, 'processUpdates(): Unable to find child %s of element. This ' + 'probably means the DOM was unexpectedly mutated (e.g., by the ' + 'browser), usually due to forgetting a <tbody> when using tables, ' + 'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' + 'in an <svg> parent. Try inspecting the child nodes of the element ' + 'with React ID `%s`.', updatedIndex, parentID) : invariant(false) : undefined;
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup;
	    // markupList is either a list of markup or just a list of elements
	    if (markupList.length && typeof markupList[0] === 'string') {
	      renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	    } else {
	      renderedMarkup = markupList;
	    }
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(update.parentNode, renderedMarkup[update.markupIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(update.parentNode, initialChildren[update.parentID][update.fromIndex], update.toIndex);
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(update.parentNode, update.content);
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMChildrenOperations, 'DOMChildrenOperations', {
	  updateTextContent: 'updateTextContent'
	});
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(10);
	var emptyFunction = __webpack_require__(15);
	var getMarkupWrap = __webpack_require__(14);
	var invariant = __webpack_require__(13);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function (markupList) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' + 'thread. Make sure `window` and `document` are available globally ' + 'before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString for server rendering.') : invariant(false) : undefined;
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      !markupList[i] ?  false ? invariant(false, 'dangerouslyRenderMarkup(...): Missing markup.') : invariant(false) : undefined;
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(OPEN_TAG_NAME_EXP,
	          // This index will be parsed back out below.
	          '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" ');
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(markupListByNodeName.join(''), emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute && renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          !!resultList.hasOwnProperty(resultIndex) ?  false ? invariant(false, 'Danger: Assigning to an already-occupied result index.') : invariant(false) : undefined;
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	        } else if (false) {
	          console.error('Danger: Discarding unexpected node:', renderNode);
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    !(resultListAssignmentCount === resultList.length) ?  false ? invariant(false, 'Danger: Did not assign to every index of resultList.') : invariant(false) : undefined;
	
	    !(resultList.length === markupList.length) ?  false ? invariant(false, 'Danger: Expected markup to render %s nodes, but rendered %s.', markupList.length, resultList.length) : invariant(false) : undefined;
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' + 'worker thread. Make sure `window` and `document` are available ' + 'globally before requiring React when unit testing or use ' + 'ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(false) : undefined;
	    !(oldChild.tagName.toLowerCase() !== 'html') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' + '<html> node. This is because browser quirks make this unreliable ' + 'and/or slow. If you want to render to the root you must use ' + 'server rendering. See ReactDOMServer.renderToString().') : invariant(false) : undefined;
	
	    var newChild;
	    if (typeof markup === 'string') {
	      newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    } else {
	      newChild = markup;
	    }
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(11);
	var getMarkupWrap = __webpack_require__(14);
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : undefined;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : undefined;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	'use strict';
	
	var toArray = __webpack_require__(12);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : undefined;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : undefined;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : undefined;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : undefined;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 15 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	"use strict";
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function (obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : undefined;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function (object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(objectName, methodNames[key], object[key]);
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function (objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function () {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function (measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function (node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function (node, html) {
	    MSApp.execUnsafeLocalFunction(function () {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var setInnerHTML = __webpack_require__(19);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 21 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ReactPerf = __webpack_require__(18);
	
	var quoteAttributeValueForBrowser = __webpack_require__(24);
	var warning = __webpack_require__(25);
	
	// Simplified subset
	var VALID_ATTRIBUTE_NAME_REGEX = /^[a-zA-Z_][\w\.\-]*$/;
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : undefined;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function (name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] || warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = DOMProperty.isCustomAttribute(lowerCasedName) ? lowerCasedName : DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ? DOMProperty.getPossibleStandardName[lowerCasedName] : null;
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    process.env.NODE_ENV !== 'production' ? warning(standardName == null, 'Unknown DOM property %s. Did you mean %s?', name, standardName) : undefined;
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (propertyInfo.mustUseAttribute) {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      } else {
	        var propName = propertyInfo.propertyName;
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== '' + value) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseAttribute) {
	        node.removeAttribute(propertyInfo.attributeName);
	      } else {
	        var propName = propertyInfo.propertyName;
	        var defaultValue = DOMProperty.getDefaultValueForProperty(node.nodeName, propName);
	        if (!propertyInfo.hasSideEffects || '' + node[propName] !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(DOMPropertyOperations, 'DOMPropertyOperations', {
	  setValueForProperty: 'setValueForProperty',
	  setValueForAttribute: 'setValueForAttribute',
	  deleteValueForProperty: 'deleteValueForProperty'
	});
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' + '\'%s\' which has already been injected. You may be accidentally ' + 'injecting the same DOM property config twice, or you may be ' + 'injecting two configs that have conflicting property names.', propName) : invariant(false) : undefined;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseAttribute: checkMask(propConfig, Injection.MUST_USE_ATTRIBUTE),
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasSideEffects: checkMask(propConfig, Injection.HAS_SIDE_EFFECTS),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	
	      !(!propertyInfo.mustUseAttribute || !propertyInfo.mustUseProperty) ?  false ? invariant(false, 'DOMProperty: Cannot require using both attribute and property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.mustUseProperty || !propertyInfo.hasSideEffects) ?  false ? invariant(false, 'DOMProperty: Properties that have side effects must use property: %s', propName) : invariant(false) : undefined;
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or ' + 'numeric value, but not a combination: %s', propName) : invariant(false) : undefined;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseAttribute:
	   *   Whether the property must be accessed and mutated using `*Attribute()`.
	   *   (This includes anything that fails `<propName> in <element>`.)
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasSideEffects:
	   *   Whether or not setting a value causes side effects such as triggering
	   *   resources to be loaded or text selection changes. If true, we read from
	   *   the DOM before updating to ensure that the value is only set if it has
	   *   changed.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function (nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(21);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(27);
	var ReactMount = __webpack_require__(28);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID: ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(7);
	var DOMPropertyOperations = __webpack_require__(22);
	var ReactMount = __webpack_require__(28);
	var ReactPerf = __webpack_require__(18);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyByID()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML: '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function (id, name, value) {
	    var node = ReactMount.getNode(id);
	    !!INVALID_PROPERTY_ERRORS.hasOwnProperty(name) ?  false ? invariant(false, 'updatePropertyByID(...): %s', INVALID_PROPERTY_ERRORS[name]) : invariant(false) : undefined;
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function (id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactDOMFeatureFlags = __webpack_require__(41);
	var ReactElement = __webpack_require__(42);
	var ReactEmptyComponentRegistry = __webpack_require__(44);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactMarkupChecksum = __webpack_require__(48);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdateQueue = __webpack_require__(53);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var containsNode = __webpack_require__(59);
	var instantiateReactComponent = __webpack_require__(62);
	var invariant = __webpack_require__(13);
	var setInnerHTML = __webpack_require__(19);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var validateDOMNesting = __webpack_require__(70);
	var warning = __webpack_require__(25);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var ownerDocumentContextKey = '__ReactMount_ownerDocument$' + Math.random().toString(36).slice(2);
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        !!isValid(cached, id) ?  false ? invariant(false, 'ReactMount: Two valid but unequal nodes with the same `%s`: %s', ATTR_NAME, id) : invariant(false) : undefined;
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponentRegistry.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    !(internalGetID(node) === id) ?  false ? invariant(false, 'ReactMount: Unexpected modification of `%s`', ATTR_NAME) : invariant(false) : undefined;
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(targetID, findDeepestCachedAncestorImpl);
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(componentInstance, rootID, container, transaction, shouldReuseMarkup, context) {
	  if (ReactDOMFeatureFlags.useCreateElement) {
	    context = assign({}, context);
	    if (container.nodeType === DOC_NODE_TYPE) {
	      context[ownerDocumentContextKey] = container;
	    } else {
	      context[ownerDocumentContextKey] = container.ownerDocument;
	    }
	  }
	  if (false) {
	    if (context === emptyObject) {
	      context = {};
	    }
	    var tag = container.nodeName.toLowerCase();
	    context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(null, tag, null);
	  }
	  var markup = ReactReconciler.mountComponent(componentInstance, rootID, transaction, context);
	  componentInstance._renderedComponent._topLevelWrapper = componentInstance;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, rootID, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* forceHTML */shouldReuseMarkup);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, rootID, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container) {
	  ReactReconciler.unmountComponent(instance);
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(node) {
	  var reactRootID = getReactRootID(node);
	  return reactRootID ? reactRootID !== ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID) : false;
	}
	
	/**
	 * Returns the first (deepest) ancestor of a node which is rendered by this copy
	 * of React.
	 */
	function findFirstReactDOMImpl(node) {
	  // This node might be from another React instance, so we make sure not to
	  // examine the node cache here
	  for (; node && node.parentNode !== node; node = node.parentNode) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      continue;
	    }
	    var nodeID = internalGetID(node);
	    if (!nodeID) {
	      continue;
	    }
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	
	    // If containersByReactRootID contains the container we find by crawling up
	    // the tree, we know that this instance of React rendered the node.
	    // nb. isValid's strategy (with containsNode) does not work because render
	    // trees may be nested and we don't want a false positive in that case.
	    var current = node;
	    var lastID;
	    do {
	      lastID = internalGetID(current);
	      current = current.parentNode;
	      if (current == null) {
	        // The passed-in node has been detached from the container it was
	        // originally rendered into.
	        return null;
	      }
	    } while (lastID !== reactRootID);
	
	    if (current === containersByReactRootID[reactRootID]) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var TopLevelWrapper = function () {};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] = getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function (nextComponent, container) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(componentInstance, container);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, reactRootID, container, shouldReuseMarkup, context);
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] = getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && parentComponent._reactInternalInstance != null) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : invariant(false) : undefined;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing an element string, make sure to instantiate ' + 'it by passing it to React.createElement.' : typeof nextElement === 'function' ? ' Instead of passing a component class, make sure to instantiate ' + 'it by passing it to React.createElement.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : invariant(false) : undefined;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : undefined;
	
	    var nextWrappedElement = new ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : undefined;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : undefined;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, parentComponent != null ? parentComponent._reactInternalInstance._processChildContext(parentComponent._reactInternalInstance._context) : emptyObject)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function (container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : undefined;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : invariant(false) : undefined;
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var containerID = internalGetID(container);
	      var isContainerReactRoot = containerID && containerID === ReactInstanceHandles.getReactRootIDFromNodeID(containerID);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : undefined;
	      }
	
	      return false;
	    }
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function (id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        process.env.NODE_ENV !== 'production' ? warning(
	        // Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID, 'ReactMount: Root element ID differed from reactRootID.') : undefined;
	        var containerChild = container.firstChild;
	        if (containerChild && reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'ReactMount: Root element has been removed from its original ' + 'container. New container: %s', rootElement.parentNode) : undefined;
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function (id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component rendered by this copy of React.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function (node) {
	    return findFirstReactDOMImpl(node);
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function (ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    if (false) {
	      // This will throw on the next line; give an early warning
	      process.env.NODE_ENV !== 'production' ? warning(deepestAncestor != null, 'React can\'t find the root component node for data-reactid value ' + '`%s`. If you\'re seeing this message, it probably means that ' + 'you\'ve loaded two copies of React on the page. At this time, only ' + 'a single copy of React can be loaded at a time.', targetID) : undefined;
	    }
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	     true ?  false ? invariant(false, 'findComponentRoot(..., %s): Unable to find element. This probably ' + 'means the DOM was unexpectedly mutated (e.g., by the browser), ' + 'usually due to forgetting a <tbody> when using tables, nesting tags ' + 'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' + 'parent. ' + 'Try inspecting the child nodes of the element with React ID `%s`.', targetID, ReactMount.getID(ancestorNode)) : invariant(false) : undefined;
	  },
	
	  _mountImageIntoNode: function (markup, container, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : invariant(false) : undefined;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using ' + 'server rendering but the checksum was invalid. This usually ' + 'means you rendered a different component type or props on ' + 'the client from the one on the server, or your render() ' + 'methods are impure. React cannot handle this case due to ' + 'cross-browser quirks by rendering at the document root. You ' + 'should look for environment dependent code in your components ' + 'and ensure the props are the same client and server side:\n%s', difference) : invariant(false) : undefined;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : undefined;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but ' + 'you didn\'t use server rendering. We can\'t do this ' + 'without using server rendering due to cross-browser quirks. ' + 'See ReactDOMServer.renderToString() for server rendering.') : invariant(false) : undefined;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      container.appendChild(markup);
	    } else {
	      setInnerHTML(container, markup);
	    }
	  },
	
	  ownerDocumentContextKey: ownerDocumentContextKey,
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  isValid: isValid,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	var EventPluginRegistry = __webpack_require__(32);
	var ReactEventEmitterMixin = __webpack_require__(37);
	var ReactPerf = __webpack_require__(18);
	var ViewportMetrics = __webpack_require__(38);
	
	var assign = __webpack_require__(39);
	var isEventSupported = __webpack_require__(40);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	ReactPerf.measureMethods(ReactBrowserEventEmitter, 'ReactBrowserEventEmitter', {
	  putListener: 'putListener',
	  deleteListener: 'deleteListener'
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(32);
	var EventPluginUtils = __webpack_require__(33);
	var ReactErrorUtils = __webpack_require__(34);
	
	var accumulateInto = __webpack_require__(35);
	var forEachAccumulated = __webpack_require__(36);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid = InstanceHandle && InstanceHandle.traverseTwoPhase && InstanceHandle.traverseEnterLeave;
	   false ? warning(valid, 'InstanceHandle not injected before use!') : undefined;
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function (InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function () {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function (id, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : invariant(false) : undefined;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(id, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (id, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(id, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function (id) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank[registrationName][id]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(id, registrationName);
	      }
	
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing ' + 'an event queue. Support for this has not yet been implemented.') : invariant(false) : undefined;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in ' + 'the plugin ordering, `%s`.', pluginName) : invariant(false) : undefined;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` ' + 'method, but `%s` does not.', pluginName) : invariant(false) : undefined;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : invariant(false) : undefined;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'event name, `%s`.', eventName) : invariant(false) : undefined;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same ' + 'registration name, `%s`.', registrationName) : invariant(false) : undefined;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than ' + 'once. You are likely trying to load more than one copy of React.') : invariant(false) : undefined;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins ' + 'using the same name, `%s`.', pluginName) : invariant(false) : undefined;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var ReactErrorUtils = __webpack_require__(34);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function (InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(InjectedMount && InjectedMount.getNode && InjectedMount.getID, 'EventPluginUtils.injection.injectMount(...): Injected Mount ' + 'module is missing getNode or getID.') : undefined;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(idsIsArr === listenersIsArr && IDsLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : undefined;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, simulated, listener, domID) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = injection.Mount.getNode(domID);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event, domID);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event, domID);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchIDs);
	  }
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : invariant(false) : undefined;
	  var res = dispatchListener ? dispatchListener(event, dispatchID) : null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getNode: function (id) {
	    return injection.Mount.getNode(id);
	  },
	  getID: function (node) {
	    return injection.Mount.getID(node);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : invariant(false) : undefined;
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 36 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function (arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(31);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 38 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 39 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = (eventName in document);
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 41 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	
	var assign = __webpack_require__(39);
	var canDefineProperty = __webpack_require__(43);
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    Object.freeze(element.props);
	    Object.freeze(element);
	  }
	
	  return element;
	};
	
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	ReactElement.cloneAndReplaceProps = function (oldElement, newProps) {
	  var newElement = ReactElement(oldElement.type, oldElement.key, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, newProps);
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	
	  return newElement;
	};
	
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 44 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponentRegistry
	 */
	
	'use strict';
	
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponentRegistry = {
	  isNullComponentID: isNullComponentID,
	  registerNullComponentID: registerNullComponentID,
	  deregisterNullComponentID: deregisterNullComponentID
	};
	
	module.exports = ReactEmptyComponentRegistry;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(46);
	
	var invariant = __webpack_require__(13);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 10000;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR;
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return descendantID.indexOf(ancestorID) === 0 && isBoundary(descendantID, ancestorID.length);
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  !(isValidID(ancestorID) && isValidID(destinationID)) ?  false ? invariant(false, 'getNextDescendantID(%s, %s): Received an invalid React DOM ID.', ancestorID, destinationID) : invariant(false) : undefined;
	  !isAncestorIDOf(ancestorID, destinationID) ?  false ? invariant(false, 'getNextDescendantID(...): React has made an invalid assumption about ' + 'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.', ancestorID, destinationID) : invariant(false) : undefined;
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  !isValidID(longestCommonID) ?  false ? invariant(false, 'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s', oneID, twoID, longestCommonID) : invariant(false) : undefined;
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {*} arg Argument to invoke the callback with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  !(start !== stop) ?  false ? invariant(false, 'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.', start) : invariant(false) : undefined;
	  var traverseUp = isAncestorIDOf(stop, start);
	  !(traverseUp || isAncestorIDOf(start, stop)) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' + 'not have a parent path.', start, stop) : invariant(false) : undefined;
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start;; /* until break */id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    !(depth++ < MAX_TREE_DEPTH) ?  false ? invariant(false, 'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' + 'traversing the React DOM ID tree. This may be due to malformed IDs: %s', start, stop, id) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function () {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function (rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function (id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function (leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Same as `traverseTwoPhase` but skips the `targetID`.
	   */
	  traverseTwoPhaseSkipTarget: function (targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, true);
	      traverseParentPath(targetID, '', cb, arg, true, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function (targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;

/***/ },
/* 46 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function (_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(49);
	
	var TAG_END = /\/?>/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags and self-closing tags)
	    return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 49 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    for (; i < Math.min(i + 4096, m); i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(51);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(52);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might ' + 'be adding a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might ' + 'be removing a ref to a component that was not created inside a component\'s ' + '`render` method, or you have multiple copies of React loaded ' + '(details: https://fb.me/react-refs-must-have-owner).') : invariant(false) : undefined;
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : undefined;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition ' + '(such as within `render`). Render methods should be a pure function ' + 'of props and state.', callerName) : undefined;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    !(typeof callback === 'function') ?  false ? invariant(false, 'enqueueCallback(...): You called `setProps`, `replaceProps`, ' + '`setState`, `replaceState`, or `forceUpdate` with a callback that ' + 'isn\'t callable.') : invariant(false) : undefined;
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueSetPropsInternal(internalInstance, partialProps);
	  },
	
	  enqueueSetPropsInternal: function (internalInstance, partialProps) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'setProps(...): You called `setProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    var props = assign({}, element.props, partialProps);
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceProps');
	    if (!internalInstance) {
	      return;
	    }
	    ReactUpdateQueue.enqueueReplacePropsInternal(internalInstance, props);
	  },
	
	  enqueueReplacePropsInternal: function (internalInstance, props) {
	    var topLevelWrapper = internalInstance._topLevelWrapper;
	    !topLevelWrapper ?  false ? invariant(false, 'replaceProps(...): You called `replaceProps` on a ' + 'component with a parent. This is an anti-pattern since props will ' + 'get reactively updated when rendered. Instead, change the owner\'s ' + '`render` method to pass the correct value as props to the component ' + 'where it is created.') : invariant(false) : undefined;
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var wrapElement = topLevelWrapper._pendingElement || topLevelWrapper._currentElement;
	    var element = wrapElement.props;
	    topLevelWrapper._pendingElement = ReactElement.cloneAndReplaceProps(wrapElement, ReactElement.cloneAndReplaceProps(element, props));
	
	    enqueueUpdate(topLevelWrapper);
	  },
	
	  enqueueElementInternal: function (internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(55);
	var PooledClass = __webpack_require__(56);
	var ReactPerf = __webpack_require__(18);
	var ReactReconciler = __webpack_require__(50);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching ' + 'strategy') : invariant(false) : undefined;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled( /* forceHTML */false);
	}
	
	assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to ' + 'match dirty-components array length (%s).', len, dirtyComponents.length) : invariant(false) : undefined;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction);
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure('ReactUpdates', 'flushBatchedUpdates', flushBatchedUpdates);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' + 'updates are not being batched.') : invariant(false) : undefined;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : invariant(false) : undefined;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : invariant(false) : undefined;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : invariant(false) : undefined;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : invariant(false) : undefined;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : invariant(false) : undefined;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there ' + 'is already an outstanding transaction.') : invariant(false) : undefined;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : invariant(false) : undefined;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isTextNode = __webpack_require__(60);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var outerNode = _x,
	        innerNode = _x2;
	    _again = false;
	
	    if (!outerNode || !innerNode) {
	      return false;
	    } else if (outerNode === innerNode) {
	      return true;
	    } else if (isTextNode(outerNode)) {
	      return false;
	    } else if (isTextNode(innerNode)) {
	      _x = outerNode;
	      _x2 = innerNode.parentNode;
	      _again = true;
	      continue _function;
	    } else if (outerNode.contains) {
	      return outerNode.contains(innerNode);
	    } else if (outerNode.compareDocumentPosition) {
	      return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	    } else {
	      return false;
	    }
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	'use strict';
	
	var isNode = __webpack_require__(61);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 61 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	'use strict';
	
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(63);
	var ReactEmptyComponent = __webpack_require__(68);
	var ReactNativeComponent = __webpack_require__(69);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function () {};
	assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = new ReactEmptyComponent(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) ' + 'or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : invariant(false) : undefined;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactNativeComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : invariant(false) : undefined;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.construct === 'function' && typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : undefined;
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactPerf = __webpack_require__(18);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactReconciler = __webpack_require__(50);
	var ReactUpdateQueue = __webpack_require__(53);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var warning = __webpack_require__(25);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  return Component(this.props, this.context, this.updater);
	};
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    // Initialize the public class
	    var inst;
	    var renderedElement;
	
	    // This is a way to detect if Component is a stateless arrow function
	    // component, which is not newable. It might not be 100% reliable but is
	    // something we can do until we start detecting that Component extends
	    // React.Component. We already assume that typeof Component === 'function'.
	    var canInstantiate = ('prototype' in Component);
	
	    if (canInstantiate) {
	      if (false) {
	        ReactCurrentOwner.current = this;
	        try {
	          inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	        } finally {
	          ReactCurrentOwner.current = null;
	        }
	      } else {
	        inst = new Component(publicProps, publicContext, ReactUpdateQueue);
	      }
	    }
	
	    if (!canInstantiate || inst === null || inst === false || ReactElement.isValidElement(inst)) {
	      renderedElement = inst;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`, returned ' + 'null/false from a stateless component, or tried to render an ' + 'element whose type is a function that isn\'t a React component.', Component.displayName || Component.name || 'Component') : undefined;
	      } else {
	        // We support ES6 inheriting from React.Component, the module pattern,
	        // and stateless components, but not ES6 classes that don't extend
	        process.env.NODE_ENV !== 'production' ? warning(Component.prototype && Component.prototype.isReactComponent || !canInstantiate || !(inst instanceof Component), '%s(...): React component classes must extend React.Component.', Component.displayName || Component.name || 'Component') : undefined;
	      }
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = ReactUpdateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : undefined;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    if (inst.componentWillMount) {
	      inst.componentWillMount();
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(renderedElement);
	
	    var markup = ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, this._processChildContext(context));
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function () {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      inst.componentWillUnmount();
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	    this._instance = null;
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var maskedContext = null;
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkPropTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to ' + 'use getChildContext().', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	      if (false) {
	        this._checkPropTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : invariant(false) : undefined;
	      }
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function (newProps) {
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.propTypes) {
	        this._checkPropTypes(Component.propTypes, newProps, ReactPropTypeLocations.prop);
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function (propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually ' + 'from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // top-level render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	             false ? warning(false, 'Failed Composite propType: %s%s', error.message, addendum) : undefined;
	          } else {
	             false ? warning(false, 'Failed Context Types: %s%s', error.message, addendum) : undefined;
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement || this._currentElement, transaction, this._context);
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	
	    var nextContext = this._context === nextUnmaskedContext ? inst.context : this._processContext(nextUnmaskedContext);
	    var nextProps;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement === nextParentElement) {
	      // Skip checking prop types again -- we don't read inst.props to avoid
	      // warning for DOM component props in this upgrade
	      nextProps = nextParentElement.props;
	    } else {
	      nextProps = this._processProps(nextParentElement.props);
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate = this._pendingForceUpdate || !inst.shouldComponentUpdate || inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(typeof shouldUpdate !== 'undefined', '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : undefined;
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(nextRenderedElement);
	      var nextMarkup = ReactReconciler.mountComponent(this._renderedComponent, thisID, transaction, this._processChildContext(context));
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function (prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid ReactComponent must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : invariant(false) : undefined;
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : invariant(false) : undefined;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : undefined;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(ReactCompositeComponentMixin, 'ReactCompositeComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent',
	  _renderValidatedComponent: '_renderValidatedComponent'
	});
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(13);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : invariant(false) : undefined;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID = environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(17);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 67 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactEmptyComponentRegistry = __webpack_require__(44);
	var ReactReconciler = __webpack_require__(50);
	
	var assign = __webpack_require__(39);
	
	var placeholderElement;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function (component) {
	    placeholderElement = ReactElement.createElement(component);
	  }
	};
	
	var ReactEmptyComponent = function (instantiate) {
	  this._currentElement = null;
	  this._rootNodeID = null;
	  this._renderedComponent = instantiate(placeholderElement);
	};
	assign(ReactEmptyComponent.prototype, {
	  construct: function (element) {},
	  mountComponent: function (rootID, transaction, context) {
	    ReactEmptyComponentRegistry.registerNullComponentID(rootID);
	    this._rootNodeID = rootID;
	    return ReactReconciler.mountComponent(this._renderedComponent, rootID, transaction, context);
	  },
	  receiveComponent: function () {},
	  unmountComponent: function (rootID, transaction, context) {
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    ReactEmptyComponentRegistry.deregisterNullComponentID(this._rootNodeID);
	    this._rootNodeID = null;
	    this._renderedComponent = null;
	  }
	});
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : invariant(false) : undefined;
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(25);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    parentTag: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.parentTag = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    /*eslint-disable space-after-keywords */
	    do {
	      /*eslint-enable space-after-keywords */
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a child of <%s>. ' + 'See %s.%s', childTag, ancestorTag, ownerInfo, info) : undefined;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): <%s> cannot appear as a descendant of ' + '<%s>. See %s.', childTag, ancestorTag, ownerInfo) : undefined;
	      }
	    }
	  };
	
	  validateDOMNesting.ancestorInfoContextKey = '__validateDOMNesting_ancestorInfo$' + Math.random().toString(36).slice(2);
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.parentTag;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(72);
	var ChangeEventPlugin = __webpack_require__(80);
	var ClientReactRootIndex = __webpack_require__(83);
	var DefaultEventPluginOrder = __webpack_require__(84);
	var EnterLeaveEventPlugin = __webpack_require__(85);
	var ExecutionEnvironment = __webpack_require__(9);
	var HTMLDOMPropertyConfig = __webpack_require__(89);
	var ReactBrowserComponentMixin = __webpack_require__(90);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactDefaultBatchingStrategy = __webpack_require__(92);
	var ReactDOMComponent = __webpack_require__(93);
	var ReactDOMTextComponent = __webpack_require__(6);
	var ReactEventListener = __webpack_require__(118);
	var ReactInjection = __webpack_require__(121);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactReconcileTransaction = __webpack_require__(125);
	var SelectEventPlugin = __webpack_require__(130);
	var ServerReactRootIndex = __webpack_require__(131);
	var SimpleEventPlugin = __webpack_require__(132);
	var SVGDOMPropertyConfig = __webpack_require__(141);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.NativeComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(ExecutionEnvironment.canUseDOM ? ClientReactRootIndex.createReactRootIndex : ServerReactRootIndex.createReactRootIndex);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	
	  if (false) {
	    var url = ExecutionEnvironment.canUseDOM && window.location.href || '';
	    if (/[?&]react_perf\b/.test(url)) {
	      var ReactDefaultPerf = require('./ReactDefaultPerf');
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(74);
	var SyntheticCompositionEvent = __webpack_require__(76);
	var SyntheticInputEvent = __webpack_require__(78);
	
	var keyOf = __webpack_require__(79);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, topLevelTargetID, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	
	var warning = __webpack_require__(25);
	
	var accumulateInto = __webpack_require__(35);
	var forEachAccumulated = __webpack_require__(36);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(domID, 'Dispatching id must not be null') : undefined;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhaseSkipTarget(event.dispatchMarker, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(fromID, toID, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var getTextContentAccessor = __webpack_require__(75);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	var warning = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	  this.target = nativeEventTarget;
	  this.currentTarget = nativeEventTarget;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `preventDefault` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(event, 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re calling `stopPropagation` on a ' + 'released/nullified synthetic event. This is a no-op. See ' + 'https://fb.me/react-event-pooling for more information.') : undefined;
	    }
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPluginHub = __webpack_require__(31);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactUpdates = __webpack_require__(54);
	var SyntheticEvent = __webpack_require__(77);
	
	var getEventTarget = __webpack_require__(81);
	var isEventSupported = __webpack_require__(40);
	var isTextInputElement = __webpack_require__(82);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementID, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetIDForClickEvent(topLevelType, topLevelTarget, topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(topLevelType, topLevelTarget, topLevelTargetID);
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, targetID, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, topLevelTarget, topLevelTargetID);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 82 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName && (nodeName === 'input' && supportedInputTypes[elem.type] || nodeName === 'textarea');
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 83 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function () {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(79);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var SyntheticMouseEvent = __webpack_require__(86);
	
	var ReactMount = __webpack_require__(28);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    var fromID = '';
	    var toID = '';
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      fromID = topLevelTargetID;
	      to = getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement);
	      if (to) {
	        toID = ReactMount.getID(to);
	      } else {
	        to = win;
	      }
	      to = to || win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	      toID = topLevelTargetID;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, fromID, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, toID, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	var ViewportMetrics = __webpack_require__(38);
	
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	var getEventTarget = __webpack_require__(81);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 88 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = implementation && implementation.hasFeature && implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	}
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(/^(data|aria)-[a-z_][a-z\d_.\-]*$/),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    challenge: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    inputMode: MUST_USE_ATTRIBUTE,
	    integrity: null,
	    is: MUST_USE_ATTRIBUTE,
	    keyParams: MUST_USE_ATTRIBUTE,
	    keyType: MUST_USE_ATTRIBUTE,
	    kind: null,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    minLength: MUST_USE_ATTRIBUTE,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    nonce: MUST_USE_ATTRIBUTE,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcLang: null,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    summary: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	    wrap: null,
	
	    /**
	     * RDFa Properties
	     */
	    about: MUST_USE_ATTRIBUTE,
	    datatype: MUST_USE_ATTRIBUTE,
	    inlist: MUST_USE_ATTRIBUTE,
	    prefix: MUST_USE_ATTRIBUTE,
	    // property is also supported for OpenGraph in meta tags.
	    property: MUST_USE_ATTRIBUTE,
	    resource: MUST_USE_ATTRIBUTE,
	    'typeof': MUST_USE_ATTRIBUTE,
	    vocab: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: null,
	    // color is for Safari mask-icon link
	    color: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: null,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: MUST_USE_ATTRIBUTE,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    autoSave: 'autosave',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var ReactInstanceMap = __webpack_require__(47);
	
	var findDOMNode = __webpack_require__(91);
	var warning = __webpack_require__(25);
	
	var didWarnKey = '_getDOMNodeDidWarn';
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function () {
	     false ? warning(this.constructor[didWarnKey], '%s.getDOMNode(...) is deprecated. Please use ' + 'ReactDOM.findDOMNode(instance) instead.', ReactInstanceMap.get(this).getName() || this.tagName || 'Unknown') : undefined;
	    this.constructor[didWarnKey] = true;
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactInstanceMap = __webpack_require__(47);
	var ReactMount = __webpack_require__(28);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing getDOMNode or findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : undefined;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  !(componentOrElement.render == null || typeof componentOrElement.render !== 'function') ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : invariant(false) : undefined;
	   true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : invariant(false) : undefined;
	}
	
	module.exports = findDOMNode;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(54);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var AutoFocusUtils = __webpack_require__(94);
	var CSSPropertyOperations = __webpack_require__(96);
	var DOMProperty = __webpack_require__(23);
	var DOMPropertyOperations = __webpack_require__(22);
	var EventConstants = __webpack_require__(30);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactComponentBrowserEnvironment = __webpack_require__(26);
	var ReactDOMButton = __webpack_require__(104);
	var ReactDOMInput = __webpack_require__(105);
	var ReactDOMOption = __webpack_require__(109);
	var ReactDOMSelect = __webpack_require__(112);
	var ReactDOMTextarea = __webpack_require__(113);
	var ReactMount = __webpack_require__(28);
	var ReactMultiChild = __webpack_require__(114);
	var ReactPerf = __webpack_require__(18);
	var ReactUpdateQueue = __webpack_require__(53);
	
	var assign = __webpack_require__(39);
	var canDefineProperty = __webpack_require__(43);
	var escapeTextContentForBrowser = __webpack_require__(21);
	var invariant = __webpack_require__(13);
	var isEventSupported = __webpack_require__(40);
	var keyOf = __webpack_require__(79);
	var setInnerHTML = __webpack_require__(19);
	var setTextContent = __webpack_require__(20);
	var shallowEqual = __webpack_require__(117);
	var validateDOMNesting = __webpack_require__(70);
	var warning = __webpack_require__(25);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var CHILDREN = keyOf({ children: null });
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	
	var ELEMENT_NODE_TYPE = 1;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	var legacyPropsDescriptor;
	if (false) {
	  legacyPropsDescriptor = {
	    props: {
	      enumerable: false,
	      get: function () {
	        var component = this._reactInternalComponent;
	        process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .props of a DOM node; instead, ' + 'recreate the props as `render` did originally or read the DOM ' + 'properties/attributes directly from this node (e.g., ' + 'this.refs.box.className).%s', getDeclarationErrorAddendum(component)) : undefined;
	        return component._currentElement.props;
	      }
	    }
	  };
	}
	
	function legacyGetDOMNode() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .getDOMNode() of a DOM node; ' + 'instead, use the node directly.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return this;
	}
	
	function legacyIsMounted() {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .isMounted() of a DOM node.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  return !!component;
	}
	
	function legacySetStateEtc() {
	  if (false) {
	    var component = this._reactInternalComponent;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setState(), .replaceState(), or ' + '.forceUpdate() of a DOM node. This is a no-op.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	}
	
	function legacySetProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .setProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueSetPropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function legacyReplaceProps(partialProps, callback) {
	  var component = this._reactInternalComponent;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, 'ReactDOMComponent: Do not access .replaceProps() of a DOM node. ' + 'Instead, call ReactDOM.render again at the top level.%s', getDeclarationErrorAddendum(component)) : undefined;
	  }
	  if (!component) {
	    return;
	  }
	  ReactUpdateQueue.enqueueReplacePropsInternal(component, partialProps);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallbackInternal(component, callback);
	  }
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined becauses undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : undefined;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (false) {
	    if (voidElementTags[component._tag]) {
	      process.env.NODE_ENV !== 'production' ? warning(props.children == null && props.dangerouslySetInnerHTML == null, '%s is a void element tag and must not have `children` or ' + 'use `props.dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : undefined;
	    }
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : invariant(false) : undefined;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' + 'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' + 'for more information.') : invariant(false) : undefined;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : undefined;
	    process.env.NODE_ENV !== 'production' ? warning(!props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : undefined;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, ' + 'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' + 'using JSX.%s', getDeclarationErrorAddendum(component)) : invariant(false) : undefined;
	}
	
	function enqueuePutListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : undefined;
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ? container.ownerDocument : container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getReactMountReady().enqueue(putListener, {
	    id: id,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  ReactBrowserEventEmitter.putListener(listenerToPut.id, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : invariant(false) : undefined;
	  var node = ReactMount.getNode(inst._rootNodeID);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : invariant(false) : undefined;
	
	  switch (inst._tag) {
	    case 'iframe':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	  }
	}
	
	function mountReadyInputWrapper() {
	  ReactDOMInput.mountReadyWrapper(this);
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = ({}).hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : invariant(false) : undefined;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function processChildContextDev(context, inst) {
	  // Pass down our tag name to child components for validation purposes
	  context = assign({}, context);
	  var info = context[validateDOMNesting.ancestorInfoContextKey];
	  context[validateDOMNesting.ancestorInfoContextKey] = validateDOMNesting.updatedAncestorInfo(info, inst._tag, inst);
	  return context;
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag.toLowerCase();
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._nodeWithLegacyProperties = null;
	  if (false) {
	    this._unprocessedContextDev = null;
	    this._processedContextDev = null;
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function (element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (rootID, transaction, context) {
	    this._rootNodeID = rootID;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getNativeProps(this, props, context);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, context);
	        props = ReactDOMInput.getNativeProps(this, props, context);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, context);
	        props = ReactDOMOption.getNativeProps(this, props, context);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, context);
	        props = ReactDOMSelect.getNativeProps(this, props, context);
	        context = ReactDOMSelect.processChildContext(this, props, context);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, context);
	        props = ReactDOMTextarea.getNativeProps(this, props, context);
	        break;
	    }
	
	    assertValidProps(this, props);
	    if (false) {
	      if (context[validateDOMNesting.ancestorInfoContextKey]) {
	        validateDOMNesting(this._tag, this, context[validateDOMNesting.ancestorInfoContextKey]);
	      }
	    }
	
	    if (false) {
	      this._unprocessedContextDev = context;
	      this._processedContextDev = processChildContextDev(context, this);
	      context = this._processedContextDev;
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = context[ReactMount.ownerDocumentContextKey];
	      var el = ownerDocument.createElement(this._currentElement.type);
	      DOMPropertyOperations.setAttributeForID(el, this._rootNodeID);
	      // Populate node cache
	      ReactMount.getID(el);
	      this._updateDOMProperties({}, props, transaction, el);
	      this._createInitialChildren(transaction, props, context, el);
	      mountImage = el;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(mountReadyInputWrapper, this);
	      // falls through
	      case 'button':
	      case 'select':
	      case 'textarea':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this._rootNodeID, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (propKey !== CHILDREN) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, el) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        setInnerHTML(el, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        setTextContent(el, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          el.appendChild(mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getNativeProps(this, lastProps);
	        nextProps = ReactDOMButton.getNativeProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getNativeProps(this, lastProps);
	        nextProps = ReactDOMInput.getNativeProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getNativeProps(this, lastProps);
	        nextProps = ReactDOMOption.getNativeProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getNativeProps(this, lastProps);
	        nextProps = ReactDOMSelect.getNativeProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getNativeProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getNativeProps(this, nextProps);
	        break;
	    }
	
	    if (false) {
	      // If the context is reference-equal to the old one, pass down the same
	      // processed object so the update bailout in ReactReconciler behaves
	      // correctly (and identically in dev and prod). See #5005.
	      if (this._unprocessedContextDev !== context) {
	        this._unprocessedContextDev = context;
	        this._processedContextDev = processChildContextDev(context, this);
	      }
	      context = this._processedContextDev;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction, null);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (!canDefineProperty && this._nodeWithLegacyProperties) {
	      this._nodeWithLegacyProperties.props = nextProps;
	    }
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction, node) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        DOMPropertyOperations.deleteValueForProperty(node, propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this._rootNodeID, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this._rootNodeID, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        if (propKey === CHILDREN) {
	          nextProp = null;
	        }
	        DOMPropertyOperations.setValueForAttribute(node, propKey, nextProp);
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        if (!node) {
	          node = ReactMount.getNode(this._rootNodeID);
	        }
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertantly setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      if (!node) {
	        node = ReactMount.getNode(this._rootNodeID);
	      }
	      CSSPropertyOperations.setValueForStyles(node, styleUpdates);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function () {
	    switch (this._tag) {
	      case 'iframe':
	      case 'img':
	      case 'form':
	      case 'video':
	      case 'audio':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	        ReactDOMInput.unmountWrapper(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is ' + 'impossible to unmount some top-level components (eg <html>, ' + '<head>, and <body>) reliably and efficiently. To fix this, have a ' + 'single top-level component that never unmounts render these ' + 'elements.', this._tag) : invariant(false) : undefined;
	        break;
	    }
	
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._wrapperState = null;
	    if (this._nodeWithLegacyProperties) {
	      var node = this._nodeWithLegacyProperties;
	      node._reactInternalComponent = null;
	      this._nodeWithLegacyProperties = null;
	    }
	  },
	
	  getPublicInstance: function () {
	    if (!this._nodeWithLegacyProperties) {
	      var node = ReactMount.getNode(this._rootNodeID);
	
	      node._reactInternalComponent = this;
	      node.getDOMNode = legacyGetDOMNode;
	      node.isMounted = legacyIsMounted;
	      node.setState = legacySetStateEtc;
	      node.replaceState = legacySetStateEtc;
	      node.forceUpdate = legacySetStateEtc;
	      node.setProps = legacySetProps;
	      node.replaceProps = legacyReplaceProps;
	
	      if (false) {
	        if (canDefineProperty) {
	          Object.defineProperties(node, legacyPropsDescriptor);
	        } else {
	          // updateComponent will update this property on subsequent renders
	          node.props = this._currentElement.props;
	        }
	      } else {
	        // updateComponent will update this property on subsequent renders
	        node.props = this._currentElement.props;
	      }
	
	      this._nodeWithLegacyProperties = node;
	    }
	    return this._nodeWithLegacyProperties;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(28);
	
	var findDOMNode = __webpack_require__(91);
	var focusNode = __webpack_require__(95);
	
	var Mixin = {
	  componentDidMount: function () {
	    if (this.props.autoFocus) {
	      focusNode(findDOMNode(this));
	    }
	  }
	};
	
	var AutoFocusUtils = {
	  Mixin: Mixin,
	
	  focusDOMComponent: function () {
	    focusNode(ReactMount.getNode(this._rootNodeID));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 95 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(97);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactPerf = __webpack_require__(18);
	
	var camelizeStyleName = __webpack_require__(98);
	var dangerousStyleValue = __webpack_require__(100);
	var hyphenateStyleName = __webpack_require__(101);
	var memoizeStringOnly = __webpack_require__(103);
	var warning = __webpack_require__(25);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?', name, camelizeStyleName(name)) : undefined;
	  };
	
	  var warnBadVendoredStyleName = function (name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1)) : undefined;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon. ' + 'Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, '')) : undefined;
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function (name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function (node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	ReactPerf.measureMethods(CSSPropertyOperations, 'CSSPropertyOperations', {
	  setValueForStyles: 'setValueForStyles'
	});
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  stopOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(99);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 99 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	"use strict";
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(97);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(102);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	'use strict';
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 103 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 104 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var mouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getNativeProps: function (inst, props, context) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var nativeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && !mouseListenerNames[key]) {
	        nativeProps[key] = props[key];
	      }
	    }
	
	    return nativeProps;
	  }
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(27);
	var LinkedValueUtils = __webpack_require__(106);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getNativeProps: function (inst, props, context) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var nativeProps = assign({}, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  mountReadyWrapper: function (inst) {
	    // Can't be in mountWrapper or else server rendering leaks.
	    instancesByReactID[inst._rootNodeID] = inst;
	  },
	
	  unmountWrapper: function (inst) {
	    delete instancesByReactID[inst._rootNodeID];
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'checked', checked || false);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactMount.getNode(this._rootNodeID);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React with non-React.
	      var otherID = ReactMount.getID(otherNode);
	      !otherID ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the ' + 'same `name` is not supported.') : invariant(false) : undefined;
	      var otherInstance = instancesByReactID[otherID];
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Unknown radio button ID %s.', otherID) : invariant(false) : undefined;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(107);
	var ReactPropTypeLocations = __webpack_require__(65);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use ' + 'checkedLink, you probably don\'t want to use valueLink and vice versa.') : invariant(false) : undefined;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want ' + 'to use value or onChange, you probably don\'t want to use valueLink.') : invariant(false) : undefined;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. ' + 'If you want to use checked or onChange, you probably don\'t want to ' + 'use checkedLink') : invariant(false) : undefined;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	
	var emptyFunction = __webpack_require__(15);
	var getIteratorFn = __webpack_require__(108);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return '<<anonymous>>';
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 108 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactDOMSelect = __webpack_require__(112);
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	var valueContextKey = ReactDOMSelect.valueContextKey;
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, context) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : undefined;
	    }
	
	    // Look up whether this option is 'selected' via context
	    var selectValue = context[valueContextKey];
	
	    // If context key is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === '' + props.value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === '' + props.value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  getNativeProps: function (inst, props, context) {
	    var nativeProps = assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      nativeProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = '';
	
	    // Flatten children and warn if they aren't strings or numbers;
	    // invalid types are ignored.
	    ReactChildren.forEach(props.children, function (child) {
	      if (child == null) {
	        return;
	      }
	      if (typeof child === 'string' || typeof child === 'number') {
	        content += child;
	      } else {
	         false ? warning(false, 'Only strings and numbers are supported as <option> children.') : undefined;
	      }
	    });
	
	    nativeProps.children = content;
	    return nativeProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	var ReactElement = __webpack_require__(42);
	
	var emptyFunction = __webpack_require__(15);
	var traverseAllChildren = __webpack_require__(111);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/(?!\/)/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '//');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild !== child ? escapeUserProvidedKey(mappedChild.key || '') + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceHandles = __webpack_require__(45);
	
	var getIteratorFn = __webpack_require__(108);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} text Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, userProvidedKeyEscaper);
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : undefined;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + wrapUserProvidedKey(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : invariant(false) : undefined;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(106);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	var valueContextKey = '__ReactDOMSelect_value$' + Math.random().toString(36).slice(2);
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, props, value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : undefined;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactMount.getNode(inst._rootNodeID).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  valueContextKey: valueContextKey,
	
	  getNativeProps: function (inst, props, context) {
	    return assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	  },
	
	  processChildContext: function (inst, props, context) {
	    // Pass down initial value so initial generated markup has correct
	    // `selected` attributes
	    var childContext = assign({}, context);
	    childContext[valueContextKey] = inst._wrapperState.initialValue;
	    return childContext;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // the context value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  this._wrapperState.pendingUpdate = true;
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var LinkedValueUtils = __webpack_require__(106);
	var ReactDOMIDOperations = __webpack_require__(27);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getNativeProps: function (inst, props, context) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : invariant(false) : undefined;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    var nativeProps = assign({}, props, {
	      defaultValue: undefined,
	      value: undefined,
	      children: inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return nativeProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	    }
	
	    var defaultValue = props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = props.children;
	    if (children != null) {
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : undefined;
	      }
	      !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : invariant(false) : undefined;
	      if (Array.isArray(children)) {
	        !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : invariant(false) : undefined;
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(props);
	
	    inst._wrapperState = {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue),
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      ReactDOMIDOperations.updatePropertyByID(inst._rootNodeID, 'value', '' + value);
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactMultiChildUpdateTypes = __webpack_require__(16);
	
	var ReactCurrentOwner = __webpack_require__(5);
	var ReactReconciler = __webpack_require__(50);
	var ReactChildReconciler = __webpack_require__(115);
	
	var flattenChildren = __webpack_require__(116);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueInsertMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    content: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    content: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the markup of a node.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function enqueueSetMarkup(parentID, markup) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    markupIndex: null,
	    content: markup,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    content: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(updateQueue, markupQueue);
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      return ReactChildReconciler.updateChildren(prevChildren, nextChildren, transaction, context);
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChild(prevChildren[name]);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        this.setMarkup(nextMarkup);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildrenElements, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, transaction, context);
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChild(prevChild);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(nextChild, name, nextIndex, transaction, context);
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChild(prevChildren[name]);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function () {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, mountImage) {
	      enqueueInsertMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function (textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Sets this markup string.
	     *
	     * @param {string} markup Markup to set.
	     * @protected
	     */
	    setMarkup: function (markup) {
	      enqueueSetMarkup(this._rootNodeID, markup);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function (child, name, index, transaction, context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(child, rootID, transaction, context);
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(50);
	
	var instantiateReactComponent = __webpack_require__(62);
	var shouldUpdateReactComponent = __webpack_require__(67);
	var traverseAllChildren = __webpack_require__(111);
	var warning = __webpack_require__(25);
	
	function instantiateChild(childInstances, child, name) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, null);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	    traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, null);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(111);
	var warning = __webpack_require__(25);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = result[name] === undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.', name) : undefined;
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 117 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 * 
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(119);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(56);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMount = __webpack_require__(28);
	var ReactUpdates = __webpack_require__(54);
	
	var assign = __webpack_require__(39);
	var getEventTarget = __webpack_require__(81);
	var getUnboundedScrollPosition = __webpack_require__(120);
	
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  // TODO: Re-enable event.path handling
	  //
	  // if (bookKeeping.nativeEvent.path && bookKeeping.nativeEvent.path.length > 1) {
	  //   // New browsers have a path attribute on native events
	  //   handleTopLevelWithPath(bookKeeping);
	  // } else {
	  //   // Legacy browsers don't have a path attribute on native events
	  //   handleTopLevelWithoutPath(bookKeeping);
	  // }
	
	  void handleTopLevelWithPath; // temporarily unused
	  handleTopLevelWithoutPath(bookKeeping);
	}
	
	// Legacy browsers don't have a path attribute on native events
	function handleTopLevelWithoutPath(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(getEventTarget(bookKeeping.nativeEvent)) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, topLevelTarget, topLevelTargetID, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	// New browsers have a path attribute on native events
	function handleTopLevelWithPath(bookKeeping) {
	  var path = bookKeeping.nativeEvent.path;
	  var currentNativeTarget = path[0];
	  var eventsFired = 0;
	  for (var i = 0; i < path.length; i++) {
	    var currentPathElement = path[i];
	    if (currentPathElement.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE) {
	      currentNativeTarget = path[i + 1];
	    }
	    // TODO: slow
	    var reactParent = ReactMount.getFirstReactDOM(currentPathElement);
	    if (reactParent === currentPathElement) {
	      var currentPathElementID = ReactMount.getID(currentPathElement);
	      var newRootID = ReactInstanceHandles.getReactRootIDFromNodeID(currentPathElementID);
	      bookKeeping.ancestors.push(currentPathElement);
	
	      var topLevelTargetID = ReactMount.getID(currentPathElement) || '';
	      eventsFired++;
	      ReactEventListener._handleTopLevel(bookKeeping.topLevelType, currentPathElement, topLevelTargetID, bookKeeping.nativeEvent, currentNativeTarget);
	
	      // Jump to the root of this React render tree
	      while (currentPathElementID !== newRootID) {
	        i++;
	        currentPathElement = path[i];
	        currentPathElementID = ReactMount.getID(currentPathElement);
	      }
	    }
	  }
	  if (eventsFired === 0) {
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, window, '', bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function () {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function (target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function () {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function () {}
	};
	
	module.exports = EventListener;

/***/ },
/* 120 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	var EventPluginHub = __webpack_require__(31);
	var ReactComponentEnvironment = __webpack_require__(64);
	var ReactClass = __webpack_require__(122);
	var ReactEmptyComponent = __webpack_require__(68);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactNativeComponent = __webpack_require__(69);
	var ReactPerf = __webpack_require__(18);
	var ReactRootIndex = __webpack_require__(46);
	var ReactUpdates = __webpack_require__(54);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(123);
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactNoopUpdateQueue = __webpack_require__(124);
	
	var assign = __webpack_require__(39);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var keyMirror = __webpack_require__(17);
	var keyOf = __webpack_require__(79);
	var warning = __webpack_require__(25);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	var warnedSetProps = false;
	function warnSetProps() {
	  if (!warnedSetProps) {
	    warnedSetProps = true;
	     false ? warning(false, 'setProps(...) and replaceProps(...) are deprecated. ' + 'Instead, call render again at the top level.') : undefined;
	  }
	}
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : undefined;
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name) : invariant(false) : undefined;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name) : invariant(false) : undefined;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component class as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to ' + 'use a component as a mixin. Instead, just use a regular object.') : invariant(false) : undefined;
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name) : invariant(false) : undefined;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = (name in RESERVED_SPEC_KEYS);
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name) : invariant(false) : undefined;
	
	    var isInherited = (name in Constructor);
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name) : invariant(false) : undefined;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : invariant(false) : undefined;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key) : invariant(false) : undefined;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : undefined;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : undefined;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function (partialProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueSetProps(this, partialProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function (newProps, callback) {
	    if (false) {
	      warnSetProps();
	    }
	    this.updater.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function () {};
	assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : undefined;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : invariant(false) : undefined;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : invariant(false) : undefined;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : undefined;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : undefined;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactNoopUpdateQueue = __webpack_require__(124);
	
	var canDefineProperty = __webpack_require__(43);
	var emptyObject = __webpack_require__(58);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a ' + 'function which returns an object of state variables.') : invariant(false) : undefined;
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : undefined;
	  }
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: ['getDOMNode', 'Use ReactDOM.findDOMNode(component) instead.'],
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceProps: ['replaceProps', 'Instead, call render again at the top level.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).'],
	    setProps: ['setProps', 'Instead, call render again at the top level.']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : undefined;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(25);
	
	function warnTDZ(publicInstance, callerName) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor && publicInstance.constructor.displayName || '') : undefined;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnTDZ(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnTDZ(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnTDZ(publicInstance, 'setState');
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function (publicInstance, partialProps) {
	    warnTDZ(publicInstance, 'setProps');
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function (publicInstance, props) {
	    warnTDZ(publicInstance, 'replaceProps');
	  }
	
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(55);
	var PooledClass = __webpack_require__(56);
	var ReactBrowserEventEmitter = __webpack_require__(29);
	var ReactDOMFeatureFlags = __webpack_require__(41);
	var ReactInputSelection = __webpack_require__(126);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(forceHTML) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = !forceHTML && ReactDOMFeatureFlags.useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(127);
	
	var containsNode = __webpack_require__(59);
	var focusNode = __webpack_require__(95);
	var getActiveElement = __webpack_require__(129);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && (input.nodeName && input.nodeName.toLowerCase() === 'input')) {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(128);
	var getTextContentAccessor = __webpack_require__(75);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 128 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not yet defined.
	 */
	'use strict';
	
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventPropagators = __webpack_require__(73);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInputSelection = __webpack_require__(126);
	var SyntheticEvent = __webpack_require__(77);
	
	var getActiveElement = __webpack_require__(129);
	var isTextInputElement = __webpack_require__(82);
	var keyOf = __webpack_require__(79);
	var shallowEqual = __webpack_require__(117);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementID, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) || topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 131 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function () {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(30);
	var EventListener = __webpack_require__(119);
	var EventPropagators = __webpack_require__(73);
	var ReactMount = __webpack_require__(28);
	var SyntheticClipboardEvent = __webpack_require__(133);
	var SyntheticEvent = __webpack_require__(77);
	var SyntheticFocusEvent = __webpack_require__(134);
	var SyntheticKeyboardEvent = __webpack_require__(135);
	var SyntheticMouseEvent = __webpack_require__(86);
	var SyntheticDragEvent = __webpack_require__(138);
	var SyntheticTouchEvent = __webpack_require__(139);
	var SyntheticUIEvent = __webpack_require__(87);
	var SyntheticWheelEvent = __webpack_require__(140);
	
	var emptyFunction = __webpack_require__(15);
	var getEventCharCode = __webpack_require__(136);
	var invariant = __webpack_require__(13);
	var keyOf = __webpack_require__(79);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function (topLevelType, topLevelTarget, topLevelTargetID, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : invariant(false) : undefined;
	    var event = EventConstructor.getPooled(dispatchConfig, topLevelTargetID, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (id, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var node = ReactMount.getNode(id);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (id, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(77);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	var getEventCharCode = __webpack_require__(136);
	var getEventKey = __webpack_require__(137);
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(136);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(86);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(87);
	
	var getEventModifierState = __webpack_require__(88);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(86);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(23);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    xlinkActuate: MUST_USE_ATTRIBUTE,
	    xlinkArcrole: MUST_USE_ATTRIBUTE,
	    xlinkHref: MUST_USE_ATTRIBUTE,
	    xlinkRole: MUST_USE_ATTRIBUTE,
	    xlinkShow: MUST_USE_ATTRIBUTE,
	    xlinkTitle: MUST_USE_ATTRIBUTE,
	    xlinkType: MUST_USE_ATTRIBUTE,
	    xmlBase: MUST_USE_ATTRIBUTE,
	    xmlLang: MUST_USE_ATTRIBUTE,
	    xmlSpace: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox',
	    xlinkActuate: 'xlink:actuate',
	    xlinkArcrole: 'xlink:arcrole',
	    xlinkHref: 'xlink:href',
	    xlinkRole: 'xlink:role',
	    xlinkShow: 'xlink:show',
	    xlinkTitle: 'xlink:title',
	    xlinkType: 'xlink:type',
	    xmlBase: 'xml:base',
	    xmlLang: 'xml:lang',
	    xmlSpace: 'xml:space'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 142 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '0.14.3';

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(28);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMServer
	 */
	
	'use strict';
	
	var ReactDefaultInjection = __webpack_require__(71);
	var ReactServerRendering = __webpack_require__(145);
	var ReactVersion = __webpack_require__(142);
	
	ReactDefaultInjection.inject();
	
	var ReactDOMServer = {
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  version: ReactVersion
	};
	
	module.exports = ReactDOMServer;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactDefaultBatchingStrategy = __webpack_require__(92);
	var ReactElement = __webpack_require__(42);
	var ReactInstanceHandles = __webpack_require__(45);
	var ReactMarkupChecksum = __webpack_require__(48);
	var ReactServerBatchingStrategy = __webpack_require__(146);
	var ReactServerRenderingTransaction = __webpack_require__(147);
	var ReactUpdates = __webpack_require__(54);
	
	var emptyObject = __webpack_require__(58);
	var instantiateReactComponent = __webpack_require__(62);
	var invariant = __webpack_require__(13);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup = componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  !ReactElement.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : invariant(false) : undefined;
	
	  var transaction;
	  try {
	    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);
	
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function () {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	    // Revert to the DOM batching strategy since these two renderers
	    // currently share these stateful modules.
	    ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};

/***/ },
/* 146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerBatchingStrategy
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactServerBatchingStrategy = {
	  isBatchingUpdates: false,
	  batchedUpdates: function (callback) {
	    // Don't do anything here. During the server rendering we don't want to
	    // schedule any updates. We will simply ignore them.
	  }
	};
	
	module.exports = ReactServerBatchingStrategy;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(56);
	var CallbackQueue = __webpack_require__(55);
	var Transaction = __webpack_require__(57);
	
	var assign = __webpack_require__(39);
	var emptyFunction = __webpack_require__(15);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [ON_DOM_READY_QUEUEING];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = false;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactIsomorphic
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(110);
	var ReactComponent = __webpack_require__(123);
	var ReactClass = __webpack_require__(122);
	var ReactDOMFactories = __webpack_require__(149);
	var ReactElement = __webpack_require__(42);
	var ReactElementValidator = __webpack_require__(150);
	var ReactPropTypes = __webpack_require__(107);
	var ReactVersion = __webpack_require__(142);
	
	var assign = __webpack_require__(39);
	var onlyChild = __webpack_require__(152);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	module.exports = React;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactElementValidator = __webpack_require__(150);
	
	var mapObject = __webpack_require__(151);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	var ReactPropTypeLocations = __webpack_require__(65);
	var ReactPropTypeLocationNames = __webpack_require__(66);
	var ReactCurrentOwner = __webpack_require__(5);
	
	var canDefineProperty = __webpack_require__(43);
	var getIteratorFn = __webpack_require__(108);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(25);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (!element._store || element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  var addenda = getAddendaForKeyUse('uniqueKey', element, parentType);
	  if (addenda === null) {
	    // we already showed the warning
	    return;
	  }
	   false ? warning(false, 'Each child in an array or iterator should have a unique "key" prop.' + '%s%s%s', addenda.parentOrOwner || '', addenda.childOwner || '', addenda.url || '') : undefined;
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} messageType A key used for de-duping warnings.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 * @returns {?object} A set of addenda to use in the warning message, or null
	 * if the warning has already been shown before (and shouldn't be shown again).
	 */
	function getAddendaForKeyUse(messageType, element, parentType) {
	  var addendum = getDeclarationErrorAddendum();
	  if (!addendum) {
	    var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	    if (parentName) {
	      addendum = ' Check the top-level render call using <' + parentName + '>.';
	    }
	  }
	
	  var memoizer = ownerHasKeyUseWarning[messageType] || (ownerHasKeyUseWarning[messageType] = {});
	  if (memoizer[addendum]) {
	    return null;
	  }
	  memoizer[addendum] = true;
	
	  var addenda = {
	    parentOrOwner: addendum,
	    url: ' See https://fb.me/react-warning-keys for more information.',
	    childOwner: null
	  };
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	    // Give the component that originally created this child.
	    addenda.childOwner = ' It was passed a child from ' + element._owner.getName() + '.';
	  }
	
	  return addenda;
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (typeof node !== 'object') {
	    return;
	  }
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    if (node._store) {
	      node._store.validated = true;
	    }
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof propTypes[propName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], propName) : invariant(false) : undefined;
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], propName, typeof error) : undefined;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum();
	         false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : undefined;
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  var componentClass = element.type;
	  if (typeof componentClass !== 'function') {
	    return;
	  }
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(name, componentClass.propTypes, element.props, ReactPropTypeLocations.prop);
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	     false ? warning(componentClass.getDefaultProps.isReactClassApproved, 'getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.') : undefined;
	  }
	}
	
	var ReactElementValidator = {
	
	  createElement: function (type, props, children) {
	    var validType = typeof type === 'string' || typeof type === 'function';
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	     false ? warning(validType, 'React.createElement: type should not be null, undefined, boolean, or ' + 'number. It should be a string (for DOM elements) or a ReactClass ' + '(for composite components).%s', getDeclarationErrorAddendum()) : undefined;
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    // Skip key warning if the type isn't valid since our key validation logic
	    // doesn't expect a non-string/function type and can throw confusing errors.
	    // We don't want exception behavior to differ between dev and prod.
	    // (Rendering will throw with a helpful message and as soon as the type is
	    // fixed, the key warnings will appear.)
	    if (validType) {
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], type);
	      }
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function (type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(null, type);
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      if (canDefineProperty) {
	        Object.defineProperty(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.') : undefined;
	            Object.defineProperty(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	    }
	
	    return validatedFactory;
	  },
	
	  cloneElement: function (element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;

/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(42);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : invariant(false) : undefined;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule deprecated
	 */
	
	'use strict';
	
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(25);
	
	/**
	 * This will log a single deprecation notice per function and forward the call
	 * on to the new API.
	 *
	 * @param {string} fnName The name of the function
	 * @param {string} newModule The module that fn will exist in
	 * @param {string} newPackage The module that fn will exist in
	 * @param {*} ctx The context this forwarded call should run in
	 * @param {function} fn The function to forward on to
	 * @return {function} The function that will warn once and then call fn
	 */
	function deprecated(fnName, newModule, newPackage, ctx, fn) {
	  var warned = false;
	  if (false) {
	    var newFn = function () {
	      process.env.NODE_ENV !== 'production' ? warning(warned,
	      // Require examples in this string must be split to prevent React's
	      // build tools from mistaking them for real requires.
	      // Otherwise the build tools will attempt to build a '%s' module.
	      'React.%s is deprecated. Please use %s.%s from require' + '(\'%s\') ' + 'instead.', fnName, newModule, fnName, newPackage) : undefined;
	      warned = true;
	      return fn.apply(ctx, arguments);
	    };
	    // We need to make sure all properties of the original fn are copied over.
	    // In particular, this is needed to support PropTypes
	    return assign(newFn, fn);
	  }
	
	  return fn;
	}
	
	module.exports = deprecated;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(4);


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.DefaultRoute = __webpack_require__(156);
	exports.Link = __webpack_require__(171);
	exports.NotFoundRoute = __webpack_require__(172);
	exports.Redirect = __webpack_require__(173);
	exports.Route = __webpack_require__(170);
	exports.ActiveHandler = __webpack_require__(168);
	exports.RouteHandler = exports.ActiveHandler;
	
	exports.HashLocation = __webpack_require__(174);
	exports.HistoryLocation = __webpack_require__(178);
	exports.RefreshLocation = __webpack_require__(179);
	exports.StaticLocation = __webpack_require__(180);
	exports.TestLocation = __webpack_require__(181);
	
	exports.ImitateBrowserBehavior = __webpack_require__(182);
	exports.ScrollToTopBehavior = __webpack_require__(183);
	
	exports.History = __webpack_require__(176);
	exports.Navigation = __webpack_require__(184);
	exports.State = __webpack_require__(185);
	
	exports.createRoute = __webpack_require__(158).createRoute;
	exports.createDefaultRoute = __webpack_require__(158).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(158).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(158).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(186);
	
	exports.create = __webpack_require__(187);
	exports.run = __webpack_require__(196);

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(157);
	var RouteHandler = __webpack_require__(168);
	var Route = __webpack_require__(170);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  _inherits(DefaultRoute, _Route);
	
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    _get(Object.getPrototypeOf(DefaultRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return DefaultRoute;
	})(Route);
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(39);
	var ReactPropTypes = __webpack_require__(2).PropTypes;
	var Route = __webpack_require__(158);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var assign = __webpack_require__(39);
	var invariant = __webpack_require__(159);
	var warning = __webpack_require__(160);
	var PathUtils = __webpack_require__(161);
	
	var _currentRoute;
	
	var Route = (function () {
	  _createClass(Route, null, [{
	    key: 'createRoute',
	
	    /**
	     * Creates and returns a new route. Options may be a URL pathname string
	     * with placeholders for named params or an object with any of the following
	     * properties:
	     *
	     * - name                     The name of the route. This is used to lookup a
	     *                            route relative to its parent route and should be
	     *                            unique among all child routes of the same parent
	     * - path                     A URL pathname string with optional placeholders
	     *                            that specify the names of params to extract from
	     *                            the URL when the path matches. Defaults to `/${name}`
	     *                            when there is a name given, or the path of the parent
	     *                            route, or /
	     * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	     *                            the scroll behavior of the router
	     * - isDefault                True to make this route the default route among all
	     *                            its siblings
	     * - isNotFound               True to make this route the "not found" route among
	     *                            all its siblings
	     * - onEnter                  A transition hook that will be called when the
	     *                            router is going to enter this route
	     * - onLeave                  A transition hook that will be called when the
	     *                            router is going to leave this route
	     * - handler                  A React component that will be rendered when
	     *                            this route is active
	     * - parentRoute              The parent route to use for this route. This option
	     *                            is automatically supplied when creating routes inside
	     *                            the callback to another invocation of createRoute. You
	     *                            only ever need to use this when declaring routes
	     *                            independently of one another to manually piece together
	     *                            the route hierarchy
	     *
	     * The callback may be used to structure your route hierarchy. Any call to
	     * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	     * inside the callback automatically uses this route as its parent.
	     */
	    value: function createRoute(options, callback) {
	      options = options || {};
	
	      if (typeof options === 'string') options = { path: options };
	
	      var parentRoute = _currentRoute;
	
	      if (parentRoute) {
	        warning(options.parentRoute == null || options.parentRoute === parentRoute, 'You should not use parentRoute with createRoute inside another route\'s child callback; it is ignored');
	      } else {
	        parentRoute = options.parentRoute;
	      }
	
	      var name = options.name;
	      var path = options.path || name;
	
	      if (path && !(options.isDefault || options.isNotFound)) {
	        if (PathUtils.isAbsolute(path)) {
	          if (parentRoute) {
	            invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, 'You cannot nest path "%s" inside "%s"; the parent requires URL parameters', path, parentRoute.path);
	          }
	        } else if (parentRoute) {
	          // Relative paths extend their parent.
	          path = PathUtils.join(parentRoute.path, path);
	        } else {
	          path = '/' + path;
	        }
	      } else {
	        path = parentRoute ? parentRoute.path : '/';
	      }
	
	      if (options.isNotFound && !/\*$/.test(path)) path += '*'; // Auto-append * to the path of not found routes.
	
	      var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	      if (parentRoute) {
	        if (route.isDefault) {
	          invariant(parentRoute.defaultRoute == null, '%s may not have more than one default route', parentRoute);
	
	          parentRoute.defaultRoute = route;
	        } else if (route.isNotFound) {
	          invariant(parentRoute.notFoundRoute == null, '%s may not have more than one not found route', parentRoute);
	
	          parentRoute.notFoundRoute = route;
	        }
	
	        parentRoute.appendChild(route);
	      }
	
	      // Any routes created in the callback
	      // use this route as their parent.
	      if (typeof callback === 'function') {
	        var currentRoute = _currentRoute;
	        _currentRoute = route;
	        callback.call(route, route);
	        _currentRoute = currentRoute;
	      }
	
	      return route;
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL.
	     */
	  }, {
	    key: 'createDefaultRoute',
	    value: function createDefaultRoute(options) {
	      return Route.createRoute(assign({}, options, { isDefault: true }));
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL but none of its siblings do.
	     */
	  }, {
	    key: 'createNotFoundRoute',
	    value: function createNotFoundRoute(options) {
	      return Route.createRoute(assign({}, options, { isNotFound: true }));
	    }
	
	    /**
	     * Creates and returns a route that automatically redirects the transition
	     * to another route. In addition to the normal options to createRoute, this
	     * function accepts the following options:
	     *
	     * - from         An alias for the `path` option. Defaults to *
	     * - to           The path/route/route name to redirect to
	     * - params       The params to use in the redirect URL. Defaults
	     *                to using the current params
	     * - query        The query to use in the redirect URL. Defaults
	     *                to using the current query
	     */
	  }, {
	    key: 'createRedirect',
	    value: function createRedirect(options) {
	      return Route.createRoute(assign({}, options, {
	        path: options.path || options.from || '*',
	        onEnter: function onEnter(transition, params, query) {
	          transition.redirect(options.to, options.params || params, options.query || query);
	        }
	      }));
	    }
	  }]);
	
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  /**
	   * Appends the given route to this route's child routes.
	   */
	
	  _createClass(Route, [{
	    key: 'appendChild',
	    value: function appendChild(route) {
	      invariant(route instanceof Route, 'route.appendChild must use a valid Route');
	
	      if (!this.childRoutes) this.childRoutes = [];
	
	      this.childRoutes.push(route);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '<Route';
	
	      if (this.name) string += ' name="' + this.name + '"';
	
	      string += ' path="' + this.path + '">';
	
	      return string;
	    }
	  }]);
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of https://github.com/facebook/react/tree/0.13-stable.
	 * An additional grant of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function warning() {};
	
	if (__DEV__) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(159);
	var assign = __webpack_require__(162);
	var qs = __webpack_require__(163);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?(?![^\/=]+=.*$)/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return '([^/?#]+)';
	      } else if (match === '*') {
	        paramNames.push('splat');
	        return '(.*?)';
	      } else {
	        return '\\' + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp('^' + source + '$', 'i'),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === '/';
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, '/') + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) return null;
	
	    var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || 'splat';
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === '?') {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return '';
	      } else {
	        invariant(params[paramName] != null, 'Missing "%s" parameter for path "%s"', paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === 'splat' && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, 'Missing splat # %s for path "%s"', splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, '/');
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, '');
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? assign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: 'brackets' });
	
	    if (queryString) return PathUtils.withoutQuery(path) + '?' + queryString;
	
	    return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ },
/* 162 */
/***/ function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(164);


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(165);
	var Parse = __webpack_require__(167);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(166);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ },
/* 166 */
/***/ function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(166);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var ContextWrapper = __webpack_require__(169);
	var assign = __webpack_require__(39);
	var PropTypes = __webpack_require__(157);
	
	var REF_NAME = '__routeHandler__';
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  _inherits(RouteHandler, _React$Component);
	
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    _get(Object.getPrototypeOf(RouteHandler.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(RouteHandler, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        routeDepth: this.context.routeDepth + 1
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._updateRouteComponent(null);
	    }
	  }, {
	    key: '_updateRouteComponent',
	    value: function _updateRouteComponent(component) {
	      this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	    }
	  }, {
	    key: 'getRouteDepth',
	    value: function getRouteDepth() {
	      return this.context.routeDepth;
	    }
	  }, {
	    key: 'createChildRouteHandler',
	    value: function createChildRouteHandler(props) {
	      var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	
	      if (route == null) return null;
	
	      var childProps = assign({}, props || this.props, {
	        ref: REF_NAME,
	        params: this.context.router.getCurrentParams(),
	        query: this.context.router.getCurrentQuery()
	      });
	
	      return React.createElement(route.handler, childProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handler = this.createChildRouteHandler();
	      // <script/> for things like <CSSTransitionGroup/> that don't like null
	      return handler ? React.createElement(
	        ContextWrapper,
	        null,
	        handler
	      ) : React.createElement('script', null);
	    }
	  }]);
	
	  return RouteHandler;
	})(React.Component);
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	
	var ContextWrapper = (function (_React$Component) {
	  _inherits(ContextWrapper, _React$Component);
	
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    _get(Object.getPrototypeOf(ContextWrapper.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ContextWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var invariant = __webpack_require__(159);
	var PropTypes = __webpack_require__(157);
	var RouteHandler = __webpack_require__(168);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div className="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    _classCallCheck(this, Route);
	
	    _get(Object.getPrototypeOf(Route.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Route, [{
	    key: 'render',
	    value: function render() {
	      invariant(false, '%s elements are for router configuration only and should not be rendered', this.constructor.name);
	    }
	  }]);
	
	  return Route;
	})(React.Component);
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var assign = __webpack_require__(39);
	var PropTypes = __webpack_require__(157);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    _get(Object.getPrototypeOf(Link.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var allowTransition = true;
	      var clickResult;
	
	      if (this.props.onClick) clickResult = this.props.onClick(event);
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	      if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	      event.preventDefault();
	
	      if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "href" attribute to use on the DOM element.
	     */
	  }, {
	    key: 'getHref',
	    value: function getHref() {
	      return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "class" attribute to use on the DOM element, which contains
	     * the value of the activeClassName property when this <Link> is active.
	     */
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var className = this.props.className;
	
	      if (this.getActiveState()) className += ' ' + this.props.activeClassName;
	
	      return className;
	    }
	  }, {
	    key: 'getActiveState',
	    value: function getActiveState() {
	      return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = assign({}, this.props, {
	        href: this.getHref(),
	        className: this.getClassName(),
	        onClick: this.handleClick.bind(this)
	      });
	
	      if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	      return React.DOM.a(props, this.props.children);
	    }
	  }]);
	
	  return Link;
	})(React.Component);
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: 'active',
	  className: ''
	};
	
	module.exports = Link;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(157);
	var RouteHandler = __webpack_require__(168);
	var Route = __webpack_require__(170);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  _inherits(NotFoundRoute, _Route);
	
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    _get(Object.getPrototypeOf(NotFoundRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return NotFoundRoute;
	})(Route);
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(157);
	var Route = __webpack_require__(170);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  _inherits(Redirect, _Route);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    _get(Object.getPrototypeOf(Redirect.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return Redirect;
	})(Route);
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(175);
	var History = __webpack_require__(176);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === '/') return true;
	
	  HashLocation.replace('/' + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('hashchange', onHashChange, false);
	      } else {
	        window.attachEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener('hashchange', onHashChange, false);
	      } else {
	        window.removeEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + '#' + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split('#')[1] || '');
	  },
	
	  toString: function toString() {
	    return '<HashLocation>';
	  }
	
	};
	
	module.exports = HashLocation;

/***/ },
/* 175 */
/***/ function(module, exports) {

	/**
	 * Actions that modify the URL.
	 */
	'use strict';
	
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: 'push',
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: 'replace',
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: 'pop'
	
	};
	
	module.exports = LocationActions;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(159);
	var canUseDOM = __webpack_require__(177);
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, 'Cannot use History.back without a DOM');
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ },
/* 177 */
/***/ function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(175);
	var History = __webpack_require__(176);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('popstate', onPopState, false);
	      } else {
	        window.attachEvent('onpopstate', onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener('popstate', onPopState, false);
	      } else {
	        window.removeEvent('onpopstate', onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, '', path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, '', path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return '<HistoryLocation>';
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryLocation = __webpack_require__(178);
	var History = __webpack_require__(176);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return '<RefreshLocation>';
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(159);
	
	function throwCannotModify() {
	  invariant(false, 'You cannot modify a static location');
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(StaticLocation, [{
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.path;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<StaticLocation path="' + this.path + '">';
	    }
	  }]);
	
	  return StaticLocation;
	})();
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(159);
	var LocationActions = __webpack_require__(175);
	var History = __webpack_require__(176);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this.needsDOM = false;
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, [{
	    key: '_updateHistoryLength',
	    value: function _updateHistoryLength() {
	      History.length = this.history.length;
	    }
	  }, {
	    key: '_notifyChange',
	    value: function _notifyChange(type) {
	      var change = {
	        path: this.getCurrentPath(),
	        type: type
	      };
	
	      for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(listener) {
	      this.listeners.push(listener);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(listener) {
	      this.listeners = this.listeners.filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(path) {
	      this.history.push(path);
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.PUSH);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(path) {
	      invariant(this.history.length, 'You cannot replace the current path with no history');
	
	      this.history[this.history.length - 1] = path;
	
	      this._notifyChange(LocationActions.REPLACE);
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      this.history.pop();
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.POP);
	    }
	  }, {
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.history[this.history.length - 1];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<TestLocation>';
	    }
	  }]);
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(175);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	"use strict";
	
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(157);
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: function makePath(to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  },
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: function makeHref(to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: function transitionTo(to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: function replaceWith(to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  },
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: function goBack() {
	    return this.context.router.goBack();
	  }
	
	};
	
	module.exports = Navigation;

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(157);
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: function getPath() {
	    return this.context.router.getCurrentPath();
	  },
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: function getPathname() {
	    return this.context.router.getCurrentPathname();
	  },
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: function getParams() {
	    return this.context.router.getCurrentParams();
	  },
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: function getQuery() {
	    return this.context.router.getCurrentQuery();
	  },
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: function getRoutes() {
	    return this.context.router.getCurrentRoutes();
	  },
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: function isActive(to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  }
	
	};
	
	module.exports = State;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var React = __webpack_require__(2);
	var assign = __webpack_require__(39);
	var warning = __webpack_require__(160);
	var DefaultRoute = __webpack_require__(156);
	var NotFoundRoute = __webpack_require__(172);
	var Redirect = __webpack_require__(173);
	var Route = __webpack_require__(158);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) return;
	
	  var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) return Route.createDefaultRoute(createRouteOptions(props));
	
	  if (type === NotFoundRoute) return Route.createNotFoundRoute(createRouteOptions(props));
	
	  if (type === Redirect) return Route.createRedirect(createRouteOptions(props));
	
	  return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	'use strict';
	
	var React = __webpack_require__(2);
	var warning = __webpack_require__(160);
	var invariant = __webpack_require__(159);
	var canUseDOM = __webpack_require__(177);
	var LocationActions = __webpack_require__(175);
	var ImitateBrowserBehavior = __webpack_require__(182);
	var HashLocation = __webpack_require__(174);
	var HistoryLocation = __webpack_require__(178);
	var RefreshLocation = __webpack_require__(179);
	var StaticLocation = __webpack_require__(180);
	var ScrollHistory = __webpack_require__(188);
	var createRoutesFromReactChildren = __webpack_require__(186);
	var isReactChildren = __webpack_require__(190);
	var Transition = __webpack_require__(191);
	var PropTypes = __webpack_require__(157);
	var Redirect = __webpack_require__(193);
	var History = __webpack_require__(176);
	var Cancellation = __webpack_require__(192);
	var Match = __webpack_require__(194);
	var Route = __webpack_require__(158);
	var supportsHistory = __webpack_require__(195);
	var PathUtils = __webpack_require__(161);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : '/';
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) return false;
	
	  return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, 'You may not have more than one route named "%s"', route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) return false;
	
	  return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) return false;
	
	  return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === 'string') location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ("production") === 'test', 'You should not use a static location in a DOM environment because ' + 'the router will not be kept in sync with the current URL');
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, 'You cannot use %s without a DOM', location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: 'Router',
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, 'Cannot find a route named "%s"', to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? '#' + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, 'goBack() was ignored because there is no router history');
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error('Unhandled aborted transition! Reason: ' + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) return; // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, 'No route matches path "%s". Make sure you have <Route path="%s"> somewhere in your routes', path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, 'Router is already running');
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) return to === state.path;
	
	        return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(159);
	var canUseDOM = __webpack_require__(177);
	var getWindowScrollPosition = __webpack_require__(189);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) return true;
	
	  // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) return false;
	
	  var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, 'Cannot use scroll behavior without a DOM');
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) return;
	
	    var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(159);
	var canUseDOM = __webpack_require__(177);
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	
	'use strict';
	
	var Cancellation = __webpack_require__(192);
	var Redirect = __webpack_require__(193);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || 'ABORT';
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ },
/* 192 */
/***/ function(module, exports) {

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	"use strict";
	
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ },
/* 193 */
/***/ function(module, exports) {

	/**
	 * Encapsulates a redirect to the given route.
	 */
	"use strict";
	
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var PathUtils = __webpack_require__(161);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) return new Match(pathname, params, query, [route, defaultRoute]);
	
	  // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) return new Match(pathname, params, query, [route, notFoundRoute]);
	
	  // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) return new Match(pathname, params, query, [route]);
	
	  return null;
	}
	
	var Match = (function () {
	  _createClass(Match, null, [{
	    key: 'findMatch',
	
	    /**
	     * Attempts to match depth-first a route in the given route's
	     * subtree against the given path and returns the match if it
	     * succeeds, null if no match can be made.
	     */
	    value: function findMatch(routes, path) {
	      var pathname = PathUtils.withoutQuery(path);
	      var query = PathUtils.extractQuery(path);
	      var match = null;
	
	      for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	      return match;
	    }
	  }]);
	
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ },
/* 195 */
/***/ function(module, exports) {

	'use strict';
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	module.exports = supportsHistory;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var createRouter = __webpack_require__(187);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === 'function') {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(198),
	    createFind = __webpack_require__(219);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias detect
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.result(_.find(users, function(chr) {
	 *   return chr.age < 40;
	 * }), 'user');
	 * // => 'barney'
	 *
	 * // using the `_.matches` callback shorthand
	 * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	 * // => 'pebbles'
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.result(_.find(users, 'active', false), 'user');
	 * // => 'fred'
	 *
	 * // using the `_.property` callback shorthand
	 * _.result(_.find(users, 'active'), 'user');
	 * // => 'barney'
	 */
	var find = createFind(baseEach);
	
	module.exports = find;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(199),
	    createBaseEach = __webpack_require__(218);
	
	/**
	 * The base implementation of `_.forEach` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object|string} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(200),
	    keys = __webpack_require__(204);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(201);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(202);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(203);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(205),
	    isArrayLike = __webpack_require__(209),
	    isObject = __webpack_require__(203),
	    shimKeys = __webpack_require__(213);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(206);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(207),
	    isObjectLike = __webpack_require__(208);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(203);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 208 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(210),
	    isLength = __webpack_require__(212);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(211);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 211 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(214),
	    isArray = __webpack_require__(215),
	    isIndex = __webpack_require__(216),
	    isLength = __webpack_require__(212),
	    keysIn = __webpack_require__(217);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(209),
	    isObjectLike = __webpack_require__(208);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(205),
	    isLength = __webpack_require__(212),
	    isObjectLike = __webpack_require__(208);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ },
/* 216 */
/***/ function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(214),
	    isArray = __webpack_require__(215),
	    isIndex = __webpack_require__(216),
	    isLength = __webpack_require__(212),
	    isObject = __webpack_require__(203);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(210),
	    isLength = __webpack_require__(212),
	    toObject = __webpack_require__(202);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    var length = collection ? getLength(collection) : 0;
	    if (!isLength(length)) {
	      return eachFunc(collection, iteratee);
	    }
	    var index = fromRight ? length : -1,
	        iterable = toObject(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(220),
	    baseFind = __webpack_require__(244),
	    baseFindIndex = __webpack_require__(245),
	    isArray = __webpack_require__(215);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(eachFunc, fromRight) {
	  return function(collection, predicate, thisArg) {
	    predicate = baseCallback(predicate, thisArg, 3);
	    if (isArray(collection)) {
	      var index = baseFindIndex(collection, predicate, fromRight);
	      return index > -1 ? collection[index] : undefined;
	    }
	    return baseFind(collection, predicate, eachFunc);
	  };
	}
	
	module.exports = createFind;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(221),
	    baseMatchesProperty = __webpack_require__(233),
	    bindCallback = __webpack_require__(240),
	    identity = __webpack_require__(241),
	    property = __webpack_require__(242);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(222),
	    getMatchData = __webpack_require__(230),
	    toObject = __webpack_require__(202);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(223),
	    toObject = __webpack_require__(202);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(224),
	    isObject = __webpack_require__(203),
	    isObjectLike = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(225),
	    equalByTag = __webpack_require__(227),
	    equalObjects = __webpack_require__(228),
	    isArray = __webpack_require__(215),
	    isTypedArray = __webpack_require__(229);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(226);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 227 */
/***/ function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(204);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(212),
	    isObjectLike = __webpack_require__(208);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(231),
	    pairs = __webpack_require__(232);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(203);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(204),
	    toObject = __webpack_require__(202);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(234),
	    baseIsEqual = __webpack_require__(223),
	    baseSlice = __webpack_require__(235),
	    isArray = __webpack_require__(215),
	    isKey = __webpack_require__(236),
	    isStrictComparable = __webpack_require__(231),
	    last = __webpack_require__(237),
	    toObject = __webpack_require__(202),
	    toPath = __webpack_require__(238);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(202);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(215),
	    toObject = __webpack_require__(202);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(239),
	    isArray = __webpack_require__(215);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ },
/* 239 */
/***/ function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(241);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ },
/* 241 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(211),
	    basePropertyDeep = __webpack_require__(243),
	    isKey = __webpack_require__(236);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(234),
	    toPath = __webpack_require__(238);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 244 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	 * without support for callback shorthands and `this` binding, which iterates
	 * over `collection` using the provided `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @param {boolean} [retKey] Specify returning the key of the found element
	 *  instead of the element itself.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFind(collection, predicate, eachFunc, retKey) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = retKey ? key : value;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFind;


/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromRight) {
	  var length = array.length,
	      index = fromRight ? length : -1;
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(247),
	    baseCallback = __webpack_require__(220),
	    baseFilter = __webpack_require__(248),
	    isArray = __webpack_require__(215);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias select
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the new filtered array.
	 * @example
	 *
	 * _.filter([4, 5, 6], function(n) {
	 *   return n % 2 == 0;
	 * });
	 * // => [4, 6]
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * // using the `_.matches` callback shorthand
	 * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	 * // => ['barney']
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.pluck(_.filter(users, 'active', false), 'user');
	 * // => ['fred']
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.filter(users, 'active'), 'user');
	 * // => ['barney']
	 */
	function filter(collection, predicate, thisArg) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  predicate = baseCallback(predicate, thisArg, 3);
	  return func(collection, predicate);
	}
	
	module.exports = filter;


/***/ },
/* 247 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(198);
	
	/**
	 * The base implementation of `_.filter` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.10.0
	'use strict';
	
	(function () {
	  var Router, config, filter, includes, last, link, sortBy;
	
	  Router = __webpack_require__(155);
	
	  filter = __webpack_require__(246);
	
	  sortBy = __webpack_require__(250);
	
	  last = __webpack_require__(237);
	
	  includes = __webpack_require__(256);
	
	  config = __webpack_require__(258).config;
	
	  link = __webpack_require__(259).link;
	
	  module.exports = function (pages, pagesReq) {
	    var filteredPages, handler, htmlWrapper, i, j, len, len1, markdownWrapper, page, parentRoute, parentRoutes, parentTemplateFile, parentTemplates, templateFile, templateFiles, templates;
	    templates = {};
	    templates.root = Router.createRoute({
	      name: 'root-template',
	      path: link("/"),
	      handler: pagesReq('./_template')
	    });
	    templateFiles = filter(pages, function (page) {
	      return page.file.name === "_template" && page.file.dirname !== ".";
	    });
	    for (i = 0, len = templateFiles.length; i < len; i++) {
	      templateFile = templateFiles[i];
	      parentTemplates = filter(templateFiles, function (template) {
	        return includes(templateFile.requirePath, template.file.dirname);
	      });
	      parentTemplates = sortBy(parentTemplates, function (template) {
	        return template != null ? template.file.dirname.length : void 0;
	      });
	      parentTemplateFile = last(parentTemplates);
	      parentRoute = templates[parentTemplateFile != null ? parentTemplateFile.file.dirname : void 0];
	      if (!parentRoute) {
	        parentRoute = templates.root;
	      }
	      templates[templateFile.file.dirname] = Router.createRoute({
	        name: templateFile.file.dirname + "-template",
	        path: link(templateFile.templatePath),
	        parentRoute: parentRoute,
	        handler: pagesReq("./" + templateFile.requirePath)
	      });
	    }
	    filteredPages = filter(pages, function (page) {
	      return page.file.name.slice(0, 1) !== '_';
	    });
	    markdownWrapper = __webpack_require__(261);
	    htmlWrapper = __webpack_require__(269);
	    for (j = 0, len1 = filteredPages.length; j < len1; j++) {
	      page = filteredPages[j];
	      switch (page.file.ext) {
	        case "md":
	          handler = markdownWrapper;
	          page.data = pagesReq("./" + page.requirePath);
	          break;
	        case "html":
	          handler = htmlWrapper;
	          break;
	        case "jsx":
	          handler = pagesReq("./" + page.requirePath);
	          page.data = pagesReq("./" + page.requirePath).metadata ? pagesReq("./" + page.requirePath).metadata() : void 0;
	          break;
	        case "cjsx":
	          handler = pagesReq("./" + page.requirePath);
	          page.data = pagesReq("./" + page.requirePath).metadata ? pagesReq("./" + page.requirePath).metadata() : void 0;
	          break;
	        default:
	          handler = pagesReq("./" + page.requirePath);
	      }
	      parentRoutes = filter(templateFiles, function (templateFile) {
	        return includes(page.requirePath, templateFile.file.dirname);
	      });
	      parentRoutes = sortBy(parentRoutes, function (route) {
	        return route != null ? route.file.dirname.length : void 0;
	      });
	      parentTemplateFile = last(parentRoutes);
	      parentRoute = templates[parentTemplateFile != null ? parentTemplateFile.file.dirname : void 0];
	      if (!parentRoute) {
	        parentRoute = templates.root;
	      }
	      if (includes(page.path, "/index") && parentRoute.file.dirname === parentTemplateFile.file.dirname) {
	        Router.createDefaultRoute({
	          name: page.path,
	          parentRoute: parentRoute,
	          handler: handler
	        });
	      } else {
	        Router.createRoute({
	          name: page.path,
	          path: link(page.path),
	          parentRoute: parentRoute,
	          handler: handler
	        });
	      }
	    }
	    return templates.root;
	  };
	}).call(undefined);

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(220),
	    baseMap = __webpack_require__(251),
	    baseSortBy = __webpack_require__(252),
	    compareAscending = __webpack_require__(253),
	    isIterateeCall = __webpack_require__(255);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection through `iteratee`. This method performs
	 * a stable sort, that is, it preserves the original sort order of equal elements.
	 * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return Math.sin(n);
	 * });
	 * // => [3, 1, 2]
	 *
	 * _.sortBy([1, 2, 3], function(n) {
	 *   return this.sin(n);
	 * }, Math);
	 * // => [3, 1, 2]
	 *
	 * var users = [
	 *   { 'user': 'fred' },
	 *   { 'user': 'pebbles' },
	 *   { 'user': 'barney' }
	 * ];
	 *
	 * // using the `_.property` callback shorthand
	 * _.pluck(_.sortBy(users, 'user'), 'user');
	 * // => ['barney', 'fred', 'pebbles']
	 */
	function sortBy(collection, iteratee, thisArg) {
	  if (collection == null) {
	    return [];
	  }
	  if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	    iteratee = undefined;
	  }
	  var index = -1;
	  iteratee = baseCallback(iteratee, thisArg, 3);
	
	  var result = baseMap(collection, function(value, key, collection) {
	    return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	  });
	  return baseSortBy(result, compareAscending);
	}
	
	module.exports = sortBy;


/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(198),
	    isArrayLike = __webpack_require__(209);
	
	/**
	 * The base implementation of `_.map` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ },
/* 252 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define
	 * the sort order of `array` and replaces criteria objects with their
	 * corresponding values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(254);
	
	/**
	 * Used by `_.sortBy` to compare transformed elements of a collection and stable
	 * sort them in ascending order.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareAscending(object, other) {
	  return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	}
	
	module.exports = compareAscending;


/***/ },
/* 254 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `compareAscending` which compares values and
	 * sorts them in ascending order without guaranteeing a stable sort.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function baseCompareAscending(value, other) {
	  if (value !== other) {
	    var valIsNull = value === null,
	        valIsUndef = value === undefined,
	        valIsReflexive = value === value;
	
	    var othIsNull = other === null,
	        othIsUndef = other === undefined,
	        othIsReflexive = other === other;
	
	    if ((value > other && !othIsNull) || !valIsReflexive ||
	        (valIsNull && !othIsUndef && othIsReflexive) ||
	        (valIsUndef && othIsReflexive)) {
	      return 1;
	    }
	    if ((value < other && !valIsNull) || !othIsReflexive ||
	        (othIsNull && !valIsUndef && valIsReflexive) ||
	        (othIsUndef && valIsReflexive)) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = baseCompareAscending;


/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(209),
	    isIndex = __webpack_require__(216),
	    isObject = __webpack_require__(203);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	var makeString = __webpack_require__(257);
	
	module.exports = function include(str, needle) {
	  if (needle === '') return true;
	  return makeString(str).indexOf(needle) !== -1;
	};


/***/ },
/* 257 */
/***/ function(module, exports) {

	/**
	 * Ensure some object is a coerced to a string
	 **/
	module.exports = function makeString(object) {
	  if (object == null) return '';
	  return '' + object;
	};


/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = {
		"config": {
			"siteTitle": "Reindex",
			"rootURL": "https://www.reindex.io",
			"auth0ClientId": "Oo3B84pCuAvHE3bdI61uGZtOh5v4q9Ne",
			"auth0Domain": "reindex.eu.auth0.com",
			"auth0CallbackUrl": "https://accounts.reindex.io/callback"
		},
		"relativePath": "",
		"pages": [
			{
				"file": {
					"dirname": ".",
					"basename": "_RelaySample.md",
					"name": "_RelaySample",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "_RelaySample.md",
				"data": {}
			},
			{
				"file": {
					"dirname": ".",
					"basename": "_template.jsx",
					"name": "_template",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "_template.jsx",
				"templatePath": "/./"
			},
			{
				"file": {
					"dirname": ".",
					"basename": "404.html",
					"name": "404",
					"extname": ".html",
					"extSegments": [
						".html"
					],
					"ext": "html"
				},
				"requirePath": "404.html",
				"data": "<div style=\"text-align: center\">\n  <h1>404 – Not Found</h1>\n  <p>\n    We could not find a page in this URI.<br>\n    Try the <a href=\"/\">home page</a> instead?\n  </p>\n</div>\n",
				"path": "/404/"
			},
			{
				"file": {
					"dirname": "blog",
					"basename": "_template.jsx",
					"name": "_template",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "blog/_template.jsx",
				"templatePath": "/blog/"
			},
			{
				"file": {
					"dirname": "blog/auth0-and-reindex",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/auth0-and-reindex/index.md",
				"data": {
					"layout": "post",
					"title": "Using Auth0 with Reindex",
					"author": {
						"name": "Mikhail Novikov",
						"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
						"link": "https://twitter.com/freiksenet",
						"twitter": "freiksenet",
						"bio": "CTO & Co-founder"
					},
					"date": "2016-05-24T12:39:00.000Z",
					"categories": [
						"React",
						"React Native",
						"Auth0"
					],
					"excerpt": "Auth0 is a great service to handle your authentication. In this arcticle we will show how to use Auth0 with Reindex, React and React Native",
					"image": "/blog/auth0-and-reindex/auth0-and-reindex.png"
				},
				"path": "/blog/auth0-and-reindex/"
			},
			{
				"file": {
					"dirname": "blog/building-a-graphql-server-with-node-js-and-sql",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/building-a-graphql-server-with-node-js-and-sql/index.md",
				"data": {
					"layout": "post",
					"title": "Building a GraphQL Server with Node.js and SQL",
					"author": {
						"name": "Mikhail Novikov",
						"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
						"link": "https://twitter.com/freiksenet",
						"twitter": "freiksenet",
						"bio": "CTO & Co-founder"
					},
					"date": "2015-08-03T08:51:55.000Z",
					"categories": [
						"GraphQL",
						"JavaScript",
						"Open Source"
					],
					"excerpt": "GraphQL is a new technology from Facebook. It aims to replace REST as a go-to API standard for developing rich applications. In this article we'll build a simple GraphQL server using Node.js and an SQL database.",
					"image": "/blog/building-a-graphql-server-with-node-js-and-sql/GraphQL_NodeJS.png"
				},
				"path": "/blog/building-a-graphql-server-with-node-js-and-sql/"
			},
			{
				"file": {
					"dirname": "blog/discontinuing-backend-as-a-service",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/discontinuing-backend-as-a-service/index.md",
				"data": {
					"layout": "post",
					"title": "Discontinuing Reindex Backend as a Service",
					"author": {
						"name": "Ville Immonen",
						"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
						"link": "https://twitter.com/VilleImmonen",
						"twitter": "VilleImmonen",
						"bio": "CEO & Co-founder"
					},
					"date": "2017-09-20T11:30:00.000Z",
					"categories": [
						"Reindex",
						"GraphQL",
						"News"
					],
					"excerpt": "Two and half years ago we started developing Reindex, the first backend as a service with a GraphQL API. Now we're moving on."
				},
				"path": "/blog/discontinuing-backend-as-a-service/"
			},
			{
				"file": {
					"dirname": "blog/graphql-shopping-cart-api",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/graphql-shopping-cart-api/index.md",
				"data": {
					"layout": "post",
					"title": "Build a GraphQL shopping cart API with Reindex",
					"author": {
						"name": "Ville Immonen",
						"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
						"link": "https://twitter.com/VilleImmonen",
						"twitter": "VilleImmonen",
						"bio": "CEO & Co-founder"
					},
					"date": "2016-05-11T12:40:00.000Z",
					"categories": [
						"Reindex",
						"tutorial",
						"e-commerce",
						"permissions"
					],
					"excerpt": "Build a secure shopping cart API with server-side storage and permissions using Reindex.",
					"image": "/blog/graphql-shopping-cart-api/graphql-shopping-cart.png"
				},
				"path": "/blog/graphql-shopping-cart-api/"
			},
			{
				"file": {
					"dirname": "blog/how-facebooks-graphql-will-change-backend-development",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/how-facebooks-graphql-will-change-backend-development/index.md",
				"data": {
					"layout": "post",
					"title": "How Facebook's GraphQL Will Change Backend Development",
					"author": {
						"name": "Ville Immonen",
						"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
						"link": "https://twitter.com/VilleImmonen",
						"twitter": "VilleImmonen",
						"bio": "CEO & Co-founder"
					},
					"date": "2015-04-27T15:45:26.000Z",
					"categories": [
						"GraphQL",
						"Open Source",
						"Web"
					],
					"excerpt": "Why we're excited about GraphQL, the data query language for fetching data in mobile and web apps?",
					"image": "/blog/how-facebooks-graphql-will-change-backend-development/GraphQL_logo.png"
				},
				"path": "/blog/how-facebooks-graphql-will-change-backend-development/"
			},
			{
				"file": {
					"dirname": "blog",
					"basename": "index.jsx",
					"name": "index",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "blog/index.jsx",
				"path": "/blog/"
			},
			{
				"file": {
					"dirname": "blog/redux-and-relay",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/redux-and-relay/index.md",
				"data": {
					"layout": "post",
					"title": "Comparing Redux and Relay",
					"author": {
						"name": "Mikhail Novikov",
						"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
						"link": "https://twitter.com/freiksenet",
						"twitter": "freiksenet",
						"bio": "CTO & Co-founder"
					},
					"date": "2016-04-29T22:59:00.000Z",
					"categories": [
						"React",
						"Relay",
						"Flux",
						"Redux",
						"JavaScript",
						"GraphQL"
					],
					"excerpt": "Relay and Redux are both state-of-the-art client-side state management libraries for React. In this article we compare the approaches Relay and Redux take and their strengths and weaknesses.",
					"image": "/blog/redux-and-relay/redux-and-relay.png"
				},
				"path": "/blog/redux-and-relay/"
			},
			{
				"file": {
					"dirname": "blog/relay-graphql-pagination-with-mongodb",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/relay-graphql-pagination-with-mongodb/index.md",
				"data": {
					"layout": "post",
					"title": "Relay-compatible GraphQL pagination with MongoDB",
					"author": {
						"name": "Mikhail Novikov",
						"image": "https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg",
						"link": "https://twitter.com/freiksenet",
						"twitter": "freiksenet",
						"bio": "CTO & Co-founder"
					},
					"date": "2016-07-26T12:39:00.000Z",
					"categories": [
						"Relay",
						"GraphQL",
						"MongoDB"
					],
					"excerpt": "In this article I will show how to create a GraphQL server with Relay-compatible pagination using MongoDB"
				},
				"path": "/blog/relay-graphql-pagination-with-mongodb/"
			},
			{
				"file": {
					"dirname": "blog/releasing-reindex-graphql-backend-as-a-service",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/releasing-reindex-graphql-backend-as-a-service/index.md",
				"data": {
					"layout": "post",
					"title": "Releasing Reindex, the GraphQL backend as a service",
					"author": {
						"name": "Ville Immonen",
						"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
						"link": "https://twitter.com/VilleImmonen",
						"twitter": "VilleImmonen",
						"bio": "CEO & Co-founder"
					},
					"date": "2016-01-26T19:00:00.000Z",
					"categories": [
						"Reindex",
						"GraphQL",
						"News"
					],
					"excerpt": "Reindex is available now, time to start building serverless apps with GraphQL!",
					"image": "/blog/releasing-reindex-graphql-backend-as-a-service/illustration-nobg.png"
				},
				"path": "/blog/releasing-reindex-graphql-backend-as-a-service/"
			},
			{
				"file": {
					"dirname": "blog/you-might-not-need-underscore",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "blog/you-might-not-need-underscore/index.md",
				"data": {
					"layout": "post",
					"title": "You Might Not Need Underscore",
					"author": {
						"name": "Ville Immonen",
						"image": "https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg",
						"link": "https://twitter.com/VilleImmonen",
						"twitter": "VilleImmonen",
						"bio": "CEO & Co-founder"
					},
					"date": "2015-06-28T22:26:11.000Z",
					"categories": [
						"JavaScript"
					],
					"excerpt": "Latest features of JavaScript are now easy to use with Babel. We show how you can use the standard JavaScript features to do tasks that previously required a utility library to do without lots of code.",
					"image": "/blog/you-might-not-need-underscore/ES_evolution1.png"
				},
				"path": "/blog/you-might-not-need-underscore/"
			},
			{
				"file": {
					"dirname": "docs",
					"basename": "_template.jsx",
					"name": "_template",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "docs/_template.jsx",
				"templatePath": "/docs/"
			},
			{
				"file": {
					"dirname": "docs/graphql-api",
					"basename": "built-in-types.md",
					"name": "built-in-types",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/graphql-api/built-in-types.md",
				"data": {
					"title": "Built-in types",
					"order": 4
				},
				"path": "/docs/graphql-api/built-in-types/"
			},
			{
				"file": {
					"dirname": "docs/graphql-api",
					"basename": "connections.md",
					"name": "connections",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/graphql-api/connections.md",
				"data": {
					"title": "Connections",
					"order": 3
				},
				"path": "/docs/graphql-api/connections/"
			},
			{
				"file": {
					"dirname": "docs/graphql-api",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/graphql-api/index.md",
				"data": {
					"title": "GraphQL API",
					"order": 3
				},
				"path": "/docs/graphql-api/"
			},
			{
				"file": {
					"dirname": "docs/graphql-api",
					"basename": "mutations.md",
					"name": "mutations",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/graphql-api/mutations.md",
				"data": {
					"title": "Mutations",
					"order": 2
				},
				"path": "/docs/graphql-api/mutations/"
			},
			{
				"file": {
					"dirname": "docs/graphql-api",
					"basename": "queries.md",
					"name": "queries",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/graphql-api/queries.md",
				"data": {
					"title": "Queries",
					"order": 1
				},
				"path": "/docs/graphql-api/queries/"
			},
			{
				"file": {
					"dirname": "docs/importing-data",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/importing-data/index.md",
				"data": {
					"title": "Importing data",
					"order": 6
				},
				"path": "/docs/importing-data/"
			},
			{
				"file": {
					"dirname": "docs",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/index.md",
				"data": {
					"title": "Introduction",
					"order": 0
				},
				"path": "/docs/"
			},
			{
				"file": {
					"dirname": "docs/integrations",
					"basename": "emails.md",
					"name": "emails",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/integrations/emails.md",
				"data": {
					"title": "Sending emails",
					"order": 3
				},
				"path": "/docs/integrations/emails/"
			},
			{
				"file": {
					"dirname": "docs/integrations",
					"basename": "hooks.md",
					"name": "hooks",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/integrations/hooks.md",
				"data": {
					"title": "Hooks",
					"order": 1
				},
				"path": "/docs/integrations/hooks/"
			},
			{
				"file": {
					"dirname": "docs/integrations",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/integrations/index.md",
				"data": {
					"title": "Integrating third-party services",
					"order": 6
				},
				"path": "/docs/integrations/"
			},
			{
				"file": {
					"dirname": "docs/reindex-cli",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/reindex-cli/index.md",
				"data": {
					"title": "Reindex CLI",
					"order": 9
				},
				"path": "/docs/reindex-cli/"
			},
			{
				"file": {
					"dirname": "docs/reindex-js",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/reindex-js/index.md",
				"data": {
					"title": "reindex-js",
					"order": 8
				},
				"path": "/docs/reindex-js/"
			},
			{
				"file": {
					"dirname": "docs/reindex-schema",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/reindex-schema/index.md",
				"data": {
					"title": "Reindex schema",
					"order": 2
				},
				"path": "/docs/reindex-schema/"
			},
			{
				"file": {
					"dirname": "docs/security",
					"basename": "authentication.md",
					"name": "authentication",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/security/authentication.md",
				"data": {
					"title": "Authentication",
					"order": 1
				},
				"path": "/docs/security/authentication/"
			},
			{
				"file": {
					"dirname": "docs/security",
					"basename": "authorization.md",
					"name": "authorization",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/security/authorization.md",
				"data": {
					"title": "Authorization",
					"order": 2
				},
				"path": "/docs/security/authorization/"
			},
			{
				"file": {
					"dirname": "docs/security",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/security/index.md",
				"data": {
					"title": "Security",
					"order": 5
				},
				"path": "/docs/security/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "adding-mutations.md",
					"name": "adding-mutations",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/adding-mutations.md",
				"data": {
					"title": "Adding mutations",
					"order": 4
				},
				"path": "/docs/tutorial/adding-mutations/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "authenticating-users.md",
					"name": "authenticating-users",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/authenticating-users.md",
				"data": {
					"title": "Authenticating users",
					"order": 6
				},
				"path": "/docs/tutorial/authenticating-users/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "defining-the-schema.md",
					"name": "defining-the-schema",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/defining-the-schema.md",
				"data": {
					"title": "Defining the schema",
					"order": 2
				},
				"path": "/docs/tutorial/defining-the-schema/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "deployment.md",
					"name": "deployment",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/deployment.md",
				"data": {
					"title": "Deployment",
					"order": 5
				},
				"path": "/docs/tutorial/deployment/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "displaying-todos.md",
					"name": "displaying-todos",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/displaying-todos.md",
				"data": {
					"title": "Displaying todos",
					"order": 3
				},
				"path": "/docs/tutorial/displaying-todos/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "index.md",
					"name": "index",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/index.md",
				"data": {
					"title": "Tutorial",
					"order": 1
				},
				"path": "/docs/tutorial/"
			},
			{
				"file": {
					"dirname": "docs/tutorial",
					"basename": "setup.md",
					"name": "setup",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "docs/tutorial/setup.md",
				"data": {
					"title": "Setup",
					"order": 1
				},
				"path": "/docs/tutorial/setup/"
			},
			{
				"file": {
					"dirname": ".",
					"basename": "index.jsx",
					"name": "index",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "index.jsx",
				"path": "/"
			},
			{
				"file": {
					"dirname": "policies",
					"basename": "_template.jsx",
					"name": "_template",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "policies/_template.jsx",
				"templatePath": "/policies/"
			},
			{
				"file": {
					"dirname": "policies",
					"basename": "open-source.md",
					"name": "open-source",
					"extname": ".md",
					"extSegments": [
						".md"
					],
					"ext": "md"
				},
				"requirePath": "policies/open-source.md",
				"data": {},
				"path": "/policies/open-source/"
			},
			{
				"file": {
					"dirname": "policies",
					"basename": "privacy-policy.html",
					"name": "privacy-policy",
					"extname": ".html",
					"extSegments": [
						".html"
					],
					"ext": "html"
				},
				"requirePath": "policies/privacy-policy.html",
				"data": "<a\n  href=\"https://www.iubenda.com/privacy-policy/7763734\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Privacy Policy\">\n  Privacy Policy\n</a>\n",
				"path": "/policies/privacy-policy/"
			},
			{
				"file": {
					"dirname": "policies",
					"basename": "terms-and-conditions.html",
					"name": "terms-and-conditions",
					"extname": ".html",
					"extSegments": [
						".html"
					],
					"ext": "html"
				},
				"requirePath": "policies/terms-and-conditions.html",
				"data": "<a\n  href=\"https://www.iubenda.com/terms-and-conditions/7763742\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Terms and Conditions\">\n  Terms and Conditions\n</a>\n",
				"path": "/policies/terms-and-conditions/"
			},
			{
				"file": {
					"dirname": ".",
					"basename": "team.jsx",
					"name": "team",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "team.jsx",
				"path": "/team/"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_Button.jsx",
					"name": "_Button",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_Button.jsx"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_HeaderButton.jsx",
					"name": "_HeaderButton",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_HeaderButton.jsx"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_Logo.jsx",
					"name": "_Logo",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_Logo.jsx"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_MailingListSignupForm.jsx",
					"name": "_MailingListSignupForm",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_MailingListSignupForm.jsx"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_ReindexTypography.jsx",
					"name": "_ReindexTypography",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_ReindexTypography.jsx"
			},
			{
				"file": {
					"dirname": "ui",
					"basename": "_TwitterFollowButton.jsx",
					"name": "_TwitterFollowButton",
					"extname": ".jsx",
					"extSegments": [
						".jsx"
					],
					"ext": "jsx"
				},
				"requirePath": "ui/_TwitterFollowButton.jsx"
			}
		]
	}

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _config = __webpack_require__(258);
	
	var _lodashCollectionFilter = __webpack_require__(246);
	
	var _lodashCollectionFilter2 = _interopRequireDefault(_lodashCollectionFilter);
	
	var _lodashArrayFirst = __webpack_require__(260);
	
	var _lodashArrayFirst2 = _interopRequireDefault(_lodashArrayFirst);
	
	var _underscoreStringInclude = __webpack_require__(256);
	
	var _underscoreStringInclude2 = _interopRequireDefault(_underscoreStringInclude);
	
	// Prefix links for Github Pages.
	// TODO make this generic for all prefixing?
	var link = exports.link = function (_link) {
	  if (false) {
	    return _config.config.linkPrefix + _link;
	  } else {
	    return _link;
	  }
	};
	
	// Get the child pages for a given template.
	exports.templateChildrenPages = function (filename, state) {
	  // Pop off the file name to leave the relative directory
	  // path to this template.
	  var split = filename.split('/');
	  split.pop();
	  var result = '/' + split.join('/');
	
	  result = link(result);
	
	  var childrenRoutes = (0, _lodashArrayFirst2['default'])((0, _lodashCollectionFilter2['default'])(state.routes, function (route) {
	    return (0, _underscoreStringInclude2['default'])(route.path, result);
	  })).childRoutes;
	
	  var childrenPaths = childrenRoutes.map(function (path) {
	    return path.path;
	  });
	
	  var childPages = undefined;
	  if (childrenPaths) {
	    childPages = (0, _lodashCollectionFilter2['default'])(_config.pages, function (page) {
	      return childrenPaths.indexOf(link(page.path)) >= 0;
	    });
	  } else {
	    childPages = [];
	  }
	
	  return childPages;
	};

/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * Gets the first element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @alias head
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the first element of `array`.
	 * @example
	 *
	 * _.first([1, 2, 3]);
	 * // => 1
	 *
	 * _.first([]);
	 * // => undefined
	 */
	function first(array) {
	  return array ? array[0] : undefined;
	}
	
	module.exports = first;


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactDocumentTitle = __webpack_require__(262);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layoutsDefaultLayout = __webpack_require__(264);
	
	var _layoutsDefaultLayout2 = _interopRequireDefault(_layoutsDefaultLayout);
	
	var _layoutsPostLayout = __webpack_require__(265);
	
	var _layoutsPostLayout2 = _interopRequireDefault(_layoutsPostLayout);
	
	var MarkdownWrapper = (function (_React$Component) {
	  _inherits(MarkdownWrapper, _React$Component);
	
	  function MarkdownWrapper() {
	    _classCallCheck(this, MarkdownWrapper);
	
	    _get(Object.getPrototypeOf(MarkdownWrapper.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(MarkdownWrapper, [{
	    key: 'render',
	    value: function render() {
	      var post = this.props.page.data;
	      return _react2['default'].createElement(
	        _reactDocumentTitle2['default'],
	        { title: post.title + ' | ' + this.props.config.siteTitle },
	        post.layout === 'post' ? _react2['default'].createElement(_layoutsPostLayout2['default'], { post: post }) : _react2['default'].createElement(_layoutsDefaultLayout2['default'], { post: post })
	      );
	    }
	  }]);
	
	  return MarkdownWrapper;
	})(_react2['default'].Component);
	
	exports['default'] = MarkdownWrapper;
	module.exports = exports['default'];

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2),
	    withSideEffect = __webpack_require__(263);
	
	function reducePropsToState(propsList) {
	  var innermostProps = propsList[propsList.length - 1];
	  if (innermostProps) {
	    return innermostProps.title;
	  }
	}
	
	function handleStateChangeOnClient(title) {
	  document.title = title || '';
	}
	
	var DocumentTitle = React.createClass({
	  propTypes: {
	    title: React.PropTypes.string.isRequired
	  },
	
	  render: function render() {
	    if (this.props.children) {
	      return React.Children.only(this.props.children);
	    } else {
	      return null;
	    }
	  }
	});
	
	module.exports = withSideEffect(
	  reducePropsToState,
	  handleStateChangeOnClient
	)(DocumentTitle);


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _fbjsLibExecutionEnvironment = __webpack_require__(9);
	
	var _fbjsLibExecutionEnvironment2 = _interopRequireDefault(_fbjsLibExecutionEnvironment);
	
	var _fbjsLibShallowEqual = __webpack_require__(117);
	
	var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = undefined;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = (function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        _Component.apply(this, arguments);
	      }
	
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may ony call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !_fbjsLibShallowEqual2['default'](nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2['default'].createElement(WrappedComponent, this.props);
	      };
	
	      _createClass(SideEffect, null, [{
	        key: 'displayName',
	
	        // Try to use displayName of wrapped component
	        value: 'SideEffect(' + getDisplayName(WrappedComponent) + ')',
	
	        // Expose canUseDOM so tests can monkeypatch it
	        enumerable: true
	      }, {
	        key: 'canUseDOM',
	        value: _fbjsLibExecutionEnvironment2['default'].canUseDOM,
	        enumerable: true
	      }]);
	
	      return SideEffect;
	    })(_react.Component);
	
	    return SideEffect;
	  };
	};

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var DefaultLayout = (function (_React$Component) {
	  _inherits(DefaultLayout, _React$Component);
	
	  function DefaultLayout() {
	    _classCallCheck(this, DefaultLayout);
	
	    _get(Object.getPrototypeOf(DefaultLayout.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(DefaultLayout, [{
	    key: "render",
	    value: function render() {
	      var _props$post = this.props.post;
	      var body = _props$post.body;
	      var title = _props$post.title;
	
	      return _react2["default"].createElement(
	        "div",
	        { className: "markdown" },
	        _react2["default"].createElement(
	          "h1",
	          null,
	          title
	        ),
	        _react2["default"].createElement("div", { dangerouslySetInnerHTML: { __html: body } })
	      );
	    }
	  }]);
	
	  return DefaultLayout;
	})(_react2["default"].Component);
	
	exports["default"] = DefaultLayout;
	module.exports = exports["default"];

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _moment = __webpack_require__(266);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pagesUi_TwitterFollowButton = __webpack_require__(268);
	
	var _pagesUi_TwitterFollowButton2 = _interopRequireDefault(_pagesUi_TwitterFollowButton);
	
	var mutedColor = '#848484';
	
	var styles = {
	  coverWrapper: {
	    maxWidth: '100%',
	    marginTop: 0,
	    position: 'relative',
	    maxHeight: 460,
	    overflow: 'hidden',
	    backgroundColor: '#eee'
	  },
	  cover: {
	    maxHeight: 480,
	    lineHeight: 0
	  },
	  coverImage: {
	    width: '100%',
	    top: 0,
	    position: 'relative'
	  },
	  meta: {
	    color: mutedColor,
	    fontSize: '13px',
	    textTransform: 'uppercase',
	    marginBottom: '0.3em',
	    fontWeight: 300,
	    letterSpacing: '1px'
	  },
	  metaDetails: {
	    display: 'inline',
	    fontSize: '13px',
	    fontStyle: 'normal'
	  },
	  metaLink: {
	    border: 0,
	    color: mutedColor,
	    textDecoration: 'none'
	  },
	  muted: {
	    color: mutedColor
	  },
	  address: {
	    borderTop: '1px solid #ddd',
	    borderBottom: '1px solid #ddd',
	    paddingTop: '1.5em',
	    paddingBottom: '1.5em',
	    margin: '20px 0',
	    display: 'flex'
	  },
	  addressImage: {
	    borderRadius: '50%',
	    width: 64,
	    height: 64,
	    margin: '0 20px 0 0'
	  },
	  addressLink: {
	    textDecoration: 'none'
	  },
	  addressText: {
	    margin: 0,
	    flex: 1
	  },
	  addressFollow: {
	    margin: '1em 0 0'
	  }
	};
	
	var PostLayout = (function (_React$Component) {
	  _inherits(PostLayout, _React$Component);
	
	  function PostLayout() {
	    _classCallCheck(this, PostLayout);
	
	    _get(Object.getPrototypeOf(PostLayout.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(PostLayout, [{
	    key: 'render',
	    value: function render() {
	      var post = this.props.post;
	
	      var author = post.author;
	      var date = (0, _moment2['default'])(post.date).locale('en');
	
	      return _react2['default'].createElement(
	        'article',
	        null,
	        post.cover && _react2['default'].createElement(
	          'div',
	          { style: styles.coverWrapper },
	          _react2['default'].createElement(
	            'div',
	            { style: styles.cover },
	            _react2['default'].createElement('img', {
	              style: styles.coverImage,
	              src: post.cover })
	          )
	        ),
	        _react2['default'].createElement(
	          'header',
	          null,
	          _react2['default'].createElement(
	            'div',
	            { style: styles.meta },
	            'By',
	            ' ',
	            _react2['default'].createElement(
	              'address',
	              { style: styles.metaDetails },
	              _react2['default'].createElement(
	                'a',
	                {
	                  rel: 'author',
	                  href: author.link,
	                  title: author.name,
	                  target: '_blank',
	                  style: styles.metaLink },
	                author.name
	              )
	            ),
	            ' —',
	            _react2['default'].createElement(
	              'time',
	              {
	                pubdate: true,
	                dateTime: date.toISOString(),
	                style: styles.metaDetails },
	              date.format('MMMM Do, YYYY')
	            )
	          ),
	          _react2['default'].createElement(
	            'h1',
	            null,
	            post.title
	          )
	        ),
	        _react2['default'].createElement('section', { dangerouslySetInnerHTML: { __html: post.body } }),
	        _react2['default'].createElement(
	          'address',
	          { style: styles.address },
	          author.image && _react2['default'].createElement('img', { src: author.image, style: styles.addressImage }),
	          _react2['default'].createElement(
	            'div',
	            { style: styles.addressText },
	            _react2['default'].createElement(
	              'div',
	              null,
	              'Written by',
	              ' ',
	              _react2['default'].createElement(
	                'strong',
	                null,
	                _react2['default'].createElement(
	                  'a',
	                  {
	                    rel: 'author',
	                    href: 'https://twitter.com/' + author.twitter,
	                    title: author.name,
	                    target: '_blank',
	                    style: styles.addressLink },
	                  author.name
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: styles.muted },
	              author.bio
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: styles.addressFollow },
	              _react2['default'].createElement(_pagesUi_TwitterFollowButton2['default'], { username: author.twitter })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PostLayout;
	})(_react2['default'].Component);
	
	exports['default'] = PostLayout;
	module.exports = exports['default'];

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.10.6
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            m._isValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated;
	
	            if (m._strict) {
	                m._isValid = m._isValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (typeof from._isAMomentObject !== 'undefined') {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (typeof from._i !== 'undefined') {
	            to._i = from._i;
	        }
	        if (typeof from._f !== 'undefined') {
	            to._f = from._f;
	        }
	        if (typeof from._l !== 'undefined') {
	            to._l = from._l;
	        }
	        if (typeof from._strict !== 'undefined') {
	            to._strict = from._strict;
	        }
	        if (typeof from._tzm !== 'undefined') {
	            to._tzm = from._tzm;
	        }
	        if (typeof from._isUTC !== 'undefined') {
	            to._isUTC = from._isUTC;
	        }
	        if (typeof from._offset !== 'undefined') {
	            to._offset = from._offset;
	        }
	        if (typeof from._pf !== 'undefined') {
	            to._pf = getParsingFlags(from);
	        }
	        if (typeof from._locale !== 'undefined') {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (typeof val !== 'undefined') {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            return Math.ceil(number);
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function Locale() {
	    }
	
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && typeof module !== 'undefined' &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (typeof values === 'undefined') {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, values) {
	        if (values !== null) {
	            values.abbr = name;
	            locales[name] = locales[name] || new Locale();
	            locales[name].set(values);
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
	    }
	
	    function get_set__set (mom, unit, value) {
	        return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	
	    // MOMENTS
	
	    function getSet (units, value) {
	        var unit;
	        if (typeof units === 'object') {
	            for (unit in units) {
	                this.set(unit, units[unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (typeof this[units] === 'function') {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '';
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	    var regexes = {};
	
	    function isFunction (sth) {
	        // https://github.com/moment/moment/issues/2325
	        return typeof sth === 'function' &&
	            Object.prototype.toString.call(sth) === '[object Function]';
	    }
	
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }).replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  matchWord);
	    addRegexToken('MMMM', matchWord);
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m) {
	        return this._months[m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m) {
	        return this._monthsShort[m.month()];
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        // TODO: Move this out of here!
	        if (typeof value === 'string') {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (typeof value !== 'number') {
	                return mom;
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (firstTime) {
	                warn(msg + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	
	    var from_string__isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
	        ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d{2}/],
	        ['YYYY-DDD', /\d{4}-\d{3}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
	        ['HH:mm', /(T| )\d\d:\d\d/],
	        ['HH', /(T| )\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = from_string__isoRegex.exec(string);
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(string)) {
	                    config._f = isoDates[i][0];
	                    break;
	                }
	            }
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(string)) {
	                    // match[6] should be 'T' or space
	                    config._f += (match[6] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (string.match(matchOffset)) {
	                config._f += 'Z';
	            }
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'moment construction falls back to js Date. This is ' +
	        'discouraged and will be removed in upcoming major ' +
	        'release. Please refer to ' +
	        'https://github.com/moment/moment/issues/1407 for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor doesn't accept years < 1970
	        if (y < 1970) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	        if (y < 1970) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', false);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // firstDayOfWeek       0 = sun, 6 = sat
	    //                      the day of the week that starts the week
	    //                      (usually sunday or monday)
	    // firstDayOfWeekOfYear 0 = sun, 6 = sat
	    //                      the first week is the week that contains the first
	    //                      of this day of the week
	    //                      (eg. ISO weeks use thursday (4))
	    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
	        var end = firstDayOfWeekOfYear - firstDayOfWeek,
	            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
	            adjustedMoment;
	
	
	        if (daysToDayOfWeek > end) {
	            daysToDayOfWeek -= 7;
	        }
	
	        if (daysToDayOfWeek < end - 7) {
	            daysToDayOfWeek += 7;
	        }
	
	        adjustedMoment = local__createLocal(mom).add(daysToDayOfWeek, 'd');
	        return {
	            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
	            year: adjustedMoment.year()
	        };
	    }
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
	        var week1Jan = 6 + firstDayOfWeek - firstDayOfWeekOfYear, janX = createUTCDate(year, 0, 1 + week1Jan), d = janX.getUTCDay(), dayOfYear;
	        if (d < firstDayOfWeek) {
	            d += 7;
	        }
	
	        weekday = weekday != null ? 1 * weekday : firstDayOfWeek;
	
	        dayOfYear = 1 + week1Jan + 7 * (week - 1) - d + weekday;
	
	        return {
	            year: dayOfYear > 0 ? year : year - 1,
	            dayOfYear: dayOfYear > 0 ?  dayOfYear : daysInYear(year - 1) + dayOfYear
	        };
	    }
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        var now = new Date();
	        if (config._useUTC) {
	            return [now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()];
	        }
	        return [now.getFullYear(), now.getMonth(), now.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < dow) {
	                    ++week;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);
	
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (getParsingFlags(config).bigHour === true &&
	                config._a[HOUR] <= 12 &&
	                config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = [i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond];
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else {
	            configFromInput(config);
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date();
	        } else if (isDate(input)) {
	            config._d = new Date(+input);
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	         'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
	         function () {
	             var other = local__createLocal.apply(null, arguments);
	             return other < this ? this : other;
	         }
	     );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            return other > this ? this : other;
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 36e5; // 1000 * 60 * 60
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchOffset);
	    addRegexToken('ZZ', matchOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(string) {
	        var matches = ((string || '').match(matchOffset) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? +input : +local__createLocal(input)) - (+res);
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(+res._d + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(input);
	            }
	            if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            this.utcOffset(offsetFromString(this._i));
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (typeof this._isDSTShifted !== 'undefined') {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return !this._isUTC;
	    }
	
	    function isUtcOffset () {
	        return this._isUTC;
	    }
	
	    function isUtc () {
	        return this._isUTC && this._offset === 0;
	    }
	
	    var aspNetRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    var create__isoRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])        * sign,
	                h  : toInt(match[HOUR])        * sign,
	                m  : toInt(match[MINUTE])      * sign,
	                s  : toInt(match[SECOND])      * sign,
	                ms : toInt(match[MILLISECOND]) * sign
	            };
	        } else if (!!(match = create__isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                d : parseIso(match[4], sign),
	                h : parseIso(match[5], sign),
	                m : parseIso(match[6], sign),
	                s : parseIso(match[7], sign),
	                w : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = duration._days,
	            months = duration._months;
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(+mom._d + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            diff = this.diff(sod, 'days', true),
	            format = diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	        return this.format(formats && formats[format] || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this > +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return inputMs < +this.clone().startOf(units);
	        }
	    }
	
	    function isBefore (input, units) {
	        var inputMs;
	        units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this < +input;
	        } else {
	            inputMs = isMoment(input) ? +input : +local__createLocal(input);
	            return +this.clone().endOf(units) < inputMs;
	        }
	    }
	
	    function isBetween (from, to, units) {
	        return this.isAfter(from, units) && this.isBefore(to, units);
	    }
	
	    function isSame (input, units) {
	        var inputMs;
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            input = isMoment(input) ? input : local__createLocal(input);
	            return +this === +input;
	        } else {
	            inputMs = +local__createLocal(input);
	            return +(this.clone().startOf(units)) <= inputMs && inputMs <= +(this.clone().endOf(units));
	        }
	    }
	
	    function diff (input, units, asFloat) {
	        var that = cloneWithOffset(input, this),
	            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4,
	            delta, output;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        return -(wholeMonthDiff + adjust);
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if ('function' === typeof Date.prototype.toISOString) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        var output = formatMoment(this, inputString || utils_hooks__hooks.defaultFormat);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	        return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return +this._d - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(+this / 1000);
	    }
	
	    function toDate () {
	        return this._offset ? new Date(+this) : this._d;
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // HELPERS
	
	    function weeksInYear(year, dow, doy) {
	        return weekOfYear(local__createLocal([year, 11, 31 + dow - doy]), dow, doy).week;
	    }
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getSetISOWeekYear (input) {
	        var year = weekOfYear(this, 1, 4).year;
	        return input == null ? year : this.add((input - year), 'y');
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    addFormatToken('Q', 0, 0, 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   matchWord);
	    addRegexToken('ddd',  matchWord);
	    addRegexToken('dddd', matchWord);
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config) {
	        var weekday = config._locale.weekdaysParse(input);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m) {
	        return this._weekdays[m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return this._weekdaysShort[m.day()];
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return this._weekdaysMin[m.day()];
	    }
	
	    function localeWeekdaysParse (weekdayName) {
	        var i, mom, regex;
	
	        this._weekdaysParse = this._weekdaysParse || [];
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            if (!this._weekdaysParse[i]) {
	                mom = local__createLocal([2000, 1]).day(i);
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	        return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, function () {
	        return this.hours() % 12 || 12;
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add          = add_subtract__add;
	    momentPrototype__proto.calendar     = moment_calendar__calendar;
	    momentPrototype__proto.clone        = clone;
	    momentPrototype__proto.diff         = diff;
	    momentPrototype__proto.endOf        = endOf;
	    momentPrototype__proto.format       = format;
	    momentPrototype__proto.from         = from;
	    momentPrototype__proto.fromNow      = fromNow;
	    momentPrototype__proto.to           = to;
	    momentPrototype__proto.toNow        = toNow;
	    momentPrototype__proto.get          = getSet;
	    momentPrototype__proto.invalidAt    = invalidAt;
	    momentPrototype__proto.isAfter      = isAfter;
	    momentPrototype__proto.isBefore     = isBefore;
	    momentPrototype__proto.isBetween    = isBetween;
	    momentPrototype__proto.isSame       = isSame;
	    momentPrototype__proto.isValid      = moment_valid__isValid;
	    momentPrototype__proto.lang         = lang;
	    momentPrototype__proto.locale       = locale;
	    momentPrototype__proto.localeData   = localeData;
	    momentPrototype__proto.max          = prototypeMax;
	    momentPrototype__proto.min          = prototypeMin;
	    momentPrototype__proto.parsingFlags = parsingFlags;
	    momentPrototype__proto.set          = getSet;
	    momentPrototype__proto.startOf      = startOf;
	    momentPrototype__proto.subtract     = add_subtract__subtract;
	    momentPrototype__proto.toArray      = toArray;
	    momentPrototype__proto.toObject     = toObject;
	    momentPrototype__proto.toDate       = toDate;
	    momentPrototype__proto.toISOString  = moment_format__toISOString;
	    momentPrototype__proto.toJSON       = moment_format__toISOString;
	    momentPrototype__proto.toString     = toString;
	    momentPrototype__proto.unix         = unix;
	    momentPrototype__proto.valueOf      = to_type__valueOf;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isDSTShifted         = isDaylightSavingTimeShifted;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. https://github.com/moment/moment/issues/1779', getSetZone);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key];
	        return typeof output === 'function' ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (typeof output === 'function') ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (typeof prop === 'function') {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto._calendar       = defaultCalendar;
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto._longDateFormat = defaultLongDateFormat;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto._invalidDate    = defaultInvalidDate;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto._ordinal        = defaultOrdinal;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto._ordinalParse   = defaultOrdinalParse;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto._relativeTime   = defaultRelativeTime;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months       =        localeMonths;
	    prototype__proto._months      = defaultLocaleMonths;
	    prototype__proto.monthsShort  =        localeMonthsShort;
	    prototype__proto._monthsShort = defaultLocaleMonthsShort;
	    prototype__proto.monthsParse  =        localeMonthsParse;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto._week = defaultLocaleWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto._weekdays      = defaultLocaleWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto._weekdaysMin   = defaultLocaleWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto._weekdaysShort = defaultLocaleWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto._meridiemParse = defaultLocaleMeridiemParse;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function list (format, index, field, count, setter) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, setter);
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < count; i++) {
	            out[i] = lists__get(format, i, field, setter);
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return list(format, index, 'months', 12, 'month');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return list(format, index, 'monthsShort', 12, 'month');
	    }
	
	    function lists__listWeekdays (format, index) {
	        return list(format, index, 'weekdays', 7, 'day');
	    }
	
	    function lists__listWeekdaysShort (format, index) {
	        return list(format, index, 'weekdaysShort', 7, 'day');
	    }
	
	    function lists__listWeekdaysMin (format, index) {
	        return list(format, index, 'weekdaysMin', 7, 'day');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes === 1          && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   === 1          && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    === 1          && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  === 1          && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   === 1          && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.10.6';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(267)(module)))

/***/ },
/* 267 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var TwitterFollowButton = (function (_React$Component) {
	  _inherits(TwitterFollowButton, _React$Component);
	
	  function TwitterFollowButton() {
	    _classCallCheck(this, TwitterFollowButton);
	
	    _get(Object.getPrototypeOf(TwitterFollowButton.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(TwitterFollowButton, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'a',
	        { href: 'https://twitter.com/' + this.props.username,
	          style: { textDecoration: 'none' } },
	        '@',
	        this.props.username
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      username: _react2['default'].PropTypes.string.isRequired
	    },
	    enumerable: true
	  }]);
	
	  return TwitterFollowButton;
	})(_react2['default'].Component);
	
	exports['default'] = TwitterFollowButton;
	module.exports = exports['default'];

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { 'default': obj };
	}
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	module.exports = _react2['default'].createClass({
	  displayName: 'exports',
	
	  propTypes: {
	    page: _react.PropTypes.shape({
	      data: _react.PropTypes.string
	    })
	  },
	
	  render: function render() {
	    var html = this.props.page.data;
	    return _react2['default'].createElement('div', { dangerouslySetInnerHTML: { __html: html } });
	  }
	});

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.loadContext = function (callback) {
	  var context = __webpack_require__(271);
	  if (false) {
	    module.hot.accept(context.id, function () {
	      context = require.context('./pages', true);
	      callback(require.context('./pages', true));
	    });
	  }
	  callback(context);
	};

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./404.html": 272,
		"./_RelaySample.md": 273,
		"./_template": 274,
		"./_template.jsx": 274,
		"./blog/_template": 329,
		"./blog/_template.jsx": 329,
		"./blog/auth0-and-reindex/auth0-and-reindex.png": 334,
		"./blog/auth0-and-reindex/index.md": 335,
		"./blog/building-a-graphql-server-with-node-js-and-sql/GraphQL_NodeJS.png": 336,
		"./blog/building-a-graphql-server-with-node-js-and-sql/index.md": 337,
		"./blog/discontinuing-backend-as-a-service/index.md": 338,
		"./blog/graphql-shopping-cart-api/data-model.svg": 339,
		"./blog/graphql-shopping-cart-api/graphql-shopping-cart.png": 340,
		"./blog/graphql-shopping-cart-api/index.md": 341,
		"./blog/how-facebooks-graphql-will-change-backend-development/GraphQL_logo.png": 342,
		"./blog/how-facebooks-graphql-will-change-backend-development/index.md": 343,
		"./blog/index": 344,
		"./blog/index.jsx": 344,
		"./blog/redux-and-relay/index.md": 345,
		"./blog/redux-and-relay/redux-and-relay.png": 346,
		"./blog/relay-graphql-pagination-with-mongodb/index.md": 347,
		"./blog/releasing-reindex-graphql-backend-as-a-service/illustration-nobg.png": 348,
		"./blog/releasing-reindex-graphql-backend-as-a-service/index.md": 349,
		"./blog/you-might-not-need-underscore/ES_evolution1.png": 350,
		"./blog/you-might-not-need-underscore/index.md": 351,
		"./cookie.css": 352,
		"./docs/_template": 354,
		"./docs/_template.jsx": 354,
		"./docs/graphql-api/built-in-types.md": 357,
		"./docs/graphql-api/connections.md": 358,
		"./docs/graphql-api/index.md": 359,
		"./docs/graphql-api/mutations.md": 360,
		"./docs/graphql-api/queries.md": 361,
		"./docs/importing-data/index.md": 362,
		"./docs/index.md": 363,
		"./docs/integrations/emails.md": 364,
		"./docs/integrations/hooks.md": 365,
		"./docs/integrations/index.md": 366,
		"./docs/reindex-cli/index.md": 367,
		"./docs/reindex-js/index.md": 368,
		"./docs/reindex-schema/index.md": 369,
		"./docs/security/authentication.md": 370,
		"./docs/security/authorization.md": 371,
		"./docs/security/index.md": 372,
		"./docs/todomvc_screenshot.png": 373,
		"./docs/tutorial/adding-mutations.md": 374,
		"./docs/tutorial/authenticating-users.md": 375,
		"./docs/tutorial/defining-the-schema.md": 376,
		"./docs/tutorial/deployment.md": 377,
		"./docs/tutorial/displaying-todos.md": 378,
		"./docs/tutorial/index.md": 379,
		"./docs/tutorial/setup.md": 380,
		"./favicon-144.png": 381,
		"./favicon-152.png": 382,
		"./favicon.ico": 383,
		"./graphiql.css": 384,
		"./illustration.png": 386,
		"./illustration.svg": 387,
		"./illustration_2017.svg": 388,
		"./index": 389,
		"./index.jsx": 389,
		"./logo-dark.svg": 390,
		"./logo.svg": 391,
		"./policies/_template": 392,
		"./policies/_template.jsx": 392,
		"./policies/open-source.md": 393,
		"./policies/privacy-policy.html": 394,
		"./policies/terms-and-conditions.html": 395,
		"./reindex_icon_110px.png": 396,
		"./robots.txt": 397,
		"./team": 398,
		"./team.jsx": 398,
		"./ui/_Button": 399,
		"./ui/_Button.jsx": 399,
		"./ui/_HeaderButton": 400,
		"./ui/_HeaderButton.jsx": 400,
		"./ui/_Logo": 307,
		"./ui/_Logo.jsx": 307,
		"./ui/_MailingListSignupForm": 401,
		"./ui/_MailingListSignupForm.jsx": 401,
		"./ui/_ReindexTypography": 308,
		"./ui/_ReindexTypography.jsx": 308,
		"./ui/_TwitterFollowButton": 268,
		"./ui/_TwitterFollowButton.jsx": 268,
		"./ui/fa-search_24_24_ffffff_none.png": 402
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 271;


/***/ },
/* 272 */
/***/ function(module, exports) {

	module.exports = "<div style=\"text-align: center\">\n  <h1>404 – Not Found</h1>\n  <p>\n    We could not find a page in this URI.<br>\n    Try the <a href=\"/\">home page</a> instead?\n  </p>\n</div>\n"

/***/ },
/* 273 */
/***/ function(module, exports) {

	module.exports = {"body":"<pre><code class=\"language-js\"><span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">Movie</span>(<span class=\"hljs-params\">{ title, tagline }</span>) </span>{\n  <span class=\"hljs-keyword\">return</span> <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Text</span>&gt;</span>{title} – {tagline}<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">Text</span>&gt;</span>;</span>\n}\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(Movie, {\n  fragments: {\n    movie: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on Movie {\n        title\n        tagline\n      }\n    `</span>,\n  },\n});\n</code></pre>\n"}

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _chromaJs = __webpack_require__(275);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _colorPairsPicker = __webpack_require__(276);
	
	var _colorPairsPicker2 = _interopRequireDefault(_colorPairsPicker);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(155);
	
	var _ui_Logo = __webpack_require__(307);
	
	var _ui_Logo2 = _interopRequireDefault(_ui_Logo);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	__webpack_require__(325);
	
	var headerColor = "white";
	var headerColors = (0, _colorPairsPicker2["default"])(headerColor, { contrast: 12 });
	var darker = (0, _chromaJs2["default"])(headerColor).darken(9).hex();
	var activeHeaderColors = (0, _colorPairsPicker2["default"])(darker, { contrast: 12 });
	var fontSizeToPx = _ui_ReindexTypography2["default"].fontSizeToPx;
	var rhythm = _ui_ReindexTypography2["default"].rhythm;
	
	var footerColors = (0, _colorPairsPicker2["default"])("#444444");
	var dividerColor = (0, _chromaJs2["default"])(footerColors.fg).alpha(0.15).css();
	var styles = {
	  page: {
	    position: "absolute",
	    width: "100%",
	    minHeight: "100%",
	    display: "flex",
	    flexDirection: "column"
	  },
	  header: {
	    marginBottom: rhythm(1.5),
	    background: headerColors.bg,
	    color: headerColors.fg
	  },
	  headerContainer: {
	    maxWidth: 960,
	    marginLeft: "auto",
	    marginRight: "auto",
	    padding: "0 " + rhythm(1 / 2),
	    display: "flex",
	    alignItems: "center",
	    height: 50
	  },
	  headerLinks: {
	    flex: 1,
	    display: "flex"
	  },
	  headerAccountLinks: {
	    flex: 1,
	    display: "flex",
	    alignItems: "center",
	    justifyContent: "flex-end"
	  },
	  headerLink: {
	    textDecoration: "none",
	    textTransform: "uppercase",
	    fontWeight: 400,
	    paddingLeft: rhythm(1 / 2),
	    paddingRight: rhythm(1 / 2),
	    height: 50,
	    lineHeight: "55px",
	    color: headerColors.fg
	  },
	  content: {
	    flex: 1
	  },
	  footer: {
	    background: footerColors.bg,
	    color: footerColors.fg
	  },
	  footerContainer: {
	    maxWidth: 960,
	    marginLeft: "auto",
	    marginRight: "auto",
	    padding: rhythm(2) + " " + rhythm(1),
	    display: "flex",
	    flexWrap: "wrap",
	    "@media (max-width: 800px)": {
	      flexDirection: "column",
	      alignItems: "center"
	    }
	  },
	  footerList: {
	    margin: "0 10px 0 0",
	    listStyle: "none",
	    display: "flex",
	    flexWrap: "wrap",
	    "@media (max-width: 800px)": {
	      margin: "0 10px " + rhythm(1) + " 0",
	      justifyContent: "center"
	    }
	  },
	  footerLink: _extends({}, fontSizeToPx("100%"), {
	    textDecoration: "none",
	    color: footerColors.fg,
	    marginRight: 10
	  }),
	  footerSocialLink: {
	    marginRight: 10,
	    display: "block"
	  },
	  footerLastItemOfGroup: {
	    borderRight: "1px solid " + dividerColor,
	    "@media (max-width: 800px)": {
	      borderRight: "none"
	    }
	  },
	  footerLogo: {
	    flex: 1,
	    display: "flex",
	    justifyContent: "flex-end"
	  }
	};
	
	var Page = (function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page() {
	    _classCallCheck(this, _Page);
	
	    _get(Object.getPrototypeOf(_Page.prototype), "constructor", this).apply(this, arguments);
	  }
	
	  _createClass(Page, [{
	    key: "render",
	    value: function render() {
	      return _react2["default"].createElement(
	        "div",
	        { style: styles.page },
	        _react2["default"].createElement(
	          "header",
	          { style: styles.header },
	          _react2["default"].createElement(
	            "div",
	            { style: styles.headerContainer },
	            _react2["default"].createElement(_ui_Logo2["default"], { height: 33, dark: true }),
	            _react2["default"].createElement("div", { style: styles.headerLinks }),
	            _react2["default"].createElement(
	              "div",
	              { style: styles.headerAccountLinks },
	              _react2["default"].createElement(
	                _reactRouter.Link,
	                {
	                  to: "/team/",
	                  style: styles.headerLink,
	                  activeStyle: _extends({}, styles.headerLink, {
	                    backgroundColor: activeHeaderColors.bg,
	                    color: activeHeaderColors.fg
	                  })
	                },
	                "Team"
	              ),
	              _react2["default"].createElement(
	                _reactRouter.Link,
	                {
	                  to: "/blog/",
	                  style: styles.headerLink,
	                  activeStyle: _extends({}, styles.headerLink, {
	                    backgroundColor: activeHeaderColors.bg,
	                    color: activeHeaderColors.fg
	                  })
	                },
	                "Blog"
	              ),
	              _react2["default"].createElement(
	                _reactRouter.Link,
	                {
	                  to: "/docs/",
	                  style: styles.headerLink,
	                  activeStyle: _extends({}, styles.headerLink, {
	                    backgroundColor: activeHeaderColors.bg,
	                    color: activeHeaderColors.fg
	                  })
	                },
	                "Docs"
	              )
	            )
	          )
	        ),
	        _react2["default"].createElement(
	          "div",
	          { style: styles.content },
	          _react2["default"].createElement(_reactRouter.RouteHandler, this.props)
	        ),
	        _react2["default"].createElement(
	          "footer",
	          { style: styles.footer },
	          _react2["default"].createElement(
	            "div",
	            { style: styles.footerContainer },
	            _react2["default"].createElement(
	              "ul",
	              { style: styles.footerList },
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  _reactRouter.Link,
	                  { to: "/team/", style: styles.footerLink },
	                  "Team"
	                )
	              ),
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  _reactRouter.Link,
	                  { to: "/blog/", style: styles.footerLink },
	                  "Blog"
	                )
	              ),
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  _reactRouter.Link,
	                  { to: "/docs/", style: styles.footerLink },
	                  "Docs"
	                )
	              ),
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  "a",
	                  {
	                    href: "/policies/terms-and-conditions/",
	                    style: styles.footerLink
	                  },
	                  "Policies"
	                )
	              ),
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  "a",
	                  {
	                    href: "https://twitter.com/reindexio",
	                    style: styles.footerLink
	                  },
	                  "Twitter"
	                )
	              ),
	              _react2["default"].createElement(
	                "li",
	                null,
	                _react2["default"].createElement(
	                  "span",
	                  { style: styles.footerSocialLink },
	                  _react2["default"].createElement(
	                    "a",
	                    {
	                      href: "https://github.com/reindexio",
	                      style: styles.footerLink
	                    },
	                    "GitHub"
	                  )
	                )
	              )
	            ),
	            _react2["default"].createElement(
	              "div",
	              { style: styles.footerLogo },
	              _react2["default"].createElement(_ui_Logo2["default"], { height: 24 })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Page = Page;
	  Page = (0, _radium2["default"])(Page) || Page;
	  return Page;
	})(_react2["default"].Component);
	
	exports["default"] = Page;
	module.exports = exports["default"];

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {// Generated by CoffeeScript 1.6.2
	/** echo  * @license echo  * while read i do echo  *  done echo
	*/
	
	
	(function() {
	  var Color, K, PITHIRD, TWOPI, X, Y, Z, bezier, brewer, chroma, clip_rgb, colors, cos, css2rgb, hex2rgb, hsi2rgb, hsl2rgb, hsv2rgb, lab2lch, lab2rgb, lab_xyz, lch2lab, lch2rgb, limit, luminance, luminance_x, num2rgb, rgb2hex, rgb2hsi, rgb2hsl, rgb2hsv, rgb2lab, rgb2lch, rgb2num, rgb_xyz, root, type, unpack, xyz_lab, xyz_rgb, _ref;
	
	  chroma = function(x, y, z, m) {
	    return new Color(x, y, z, m);
	  };
	
	  if ((typeof module !== "undefined" && module !== null) && (module.exports != null)) {
	    module.exports = chroma;
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return chroma;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    root = typeof exports !== "undefined" && exports !== null ? exports : this;
	    root.chroma = chroma;
	  }
	
	  chroma.color = function(x, y, z, m) {
	    return new Color(x, y, z, m);
	  };
	
	  chroma.hsl = function(h, s, l, a) {
	    return new Color(h, s, l, a, 'hsl');
	  };
	
	  chroma.hsv = function(h, s, v, a) {
	    return new Color(h, s, v, a, 'hsv');
	  };
	
	  chroma.rgb = function(r, g, b, a) {
	    return new Color(r, g, b, a, 'rgb');
	  };
	
	  chroma.hex = function(x) {
	    return new Color(x);
	  };
	
	  chroma.css = function(x) {
	    return new Color(x);
	  };
	
	  chroma.lab = function(l, a, b) {
	    return new Color(l, a, b, 'lab');
	  };
	
	  chroma.lch = function(l, c, h) {
	    return new Color(l, c, h, 'lch');
	  };
	
	  chroma.hsi = function(h, s, i) {
	    return new Color(h, s, i, 'hsi');
	  };
	
	  chroma.gl = function(r, g, b, a) {
	    return new Color(r * 255, g * 255, b * 255, a, 'gl');
	  };
	
	  chroma.num = function(n) {
	    return new Color(n, 'num');
	  };
	
	  chroma.random = function() {
	    var code, digits, i, _i;
	
	    digits = '0123456789abcdef';
	    code = '#';
	    for (i = _i = 0; _i < 6; i = ++_i) {
	      code += digits.charAt(Math.floor(Math.random() * 16));
	    }
	    return new Color(code);
	  };
	
	  chroma.interpolate = function(a, b, f, m) {
	    var _ref, _ref1;
	
	    if ((a == null) || (b == null)) {
	      return '#000';
	    }
	    if ((_ref = type(a)) === 'string' || _ref === 'number') {
	      a = new Color(a);
	    }
	    if ((_ref1 = type(b)) === 'string' || _ref1 === 'number') {
	      b = new Color(b);
	    }
	    return a.interpolate(f, b, m);
	  };
	
	  chroma.mix = chroma.interpolate;
	
	  chroma.contrast = function(a, b) {
	    var l1, l2, _ref, _ref1;
	
	    if ((_ref = type(a)) === 'string' || _ref === 'number') {
	      a = new Color(a);
	    }
	    if ((_ref1 = type(b)) === 'string' || _ref1 === 'number') {
	      b = new Color(b);
	    }
	    l1 = a.luminance();
	    l2 = b.luminance();
	    if (l1 > l2) {
	      return (l1 + 0.05) / (l2 + 0.05);
	    } else {
	      return (l2 + 0.05) / (l1 + 0.05);
	    }
	  };
	
	  chroma.luminance = function(color) {
	    return chroma(color).luminance();
	  };
	
	  chroma._Color = Color;
	
	  /**
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	  */
	
	
	  Color = (function() {
	    function Color() {
	      var a, arg, args, m, me, me_rgb, x, y, z, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;
	
	      me = this;
	      args = [];
	      for (_i = 0, _len = arguments.length; _i < _len; _i++) {
	        arg = arguments[_i];
	        if (arg != null) {
	          args.push(arg);
	        }
	      }
	      if (args.length === 0) {
	        _ref = [255, 0, 255, 1, 'rgb'], x = _ref[0], y = _ref[1], z = _ref[2], a = _ref[3], m = _ref[4];
	      } else if (type(args[0]) === "array") {
	        if (args[0].length === 3) {
	          _ref1 = args[0], x = _ref1[0], y = _ref1[1], z = _ref1[2];
	          a = 1;
	        } else if (args[0].length === 4) {
	          _ref2 = args[0], x = _ref2[0], y = _ref2[1], z = _ref2[2], a = _ref2[3];
	        } else {
	          throw 'unknown input argument';
	        }
	        m = (_ref3 = args[1]) != null ? _ref3 : 'rgb';
	      } else if (type(args[0]) === "string") {
	        x = args[0];
	        m = 'hex';
	      } else if (type(args[0]) === "object") {
	        _ref4 = args[0]._rgb, x = _ref4[0], y = _ref4[1], z = _ref4[2], a = _ref4[3];
	        m = 'rgb';
	      } else if (args.length <= 2 && type(args[0]) === "number") {
	        x = args[0];
	        m = 'num';
	      } else if (args.length >= 3) {
	        x = args[0];
	        y = args[1];
	        z = args[2];
	      }
	      if (args.length === 3) {
	        m = 'rgb';
	        a = 1;
	      } else if (args.length === 4) {
	        if (type(args[3]) === "string") {
	          m = args[3];
	          a = 1;
	        } else if (type(args[3]) === "number") {
	          m = 'rgb';
	          a = args[3];
	        }
	      } else if (args.length === 5) {
	        a = args[3];
	        m = args[4];
	      }
	      if (a == null) {
	        a = 1;
	      }
	      if (m === 'rgb') {
	        me._rgb = [x, y, z, a];
	      } else if (m === 'gl') {
	        me._rgb = [x * 255, y * 255, z * 255, a];
	      } else if (m === 'hsl') {
	        me._rgb = hsl2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hsv') {
	        me._rgb = hsv2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hex') {
	        me._rgb = hex2rgb(x);
	      } else if (m === 'lab') {
	        me._rgb = lab2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'lch') {
	        me._rgb = lch2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'hsi') {
	        me._rgb = hsi2rgb(x, y, z);
	        me._rgb[3] = a;
	      } else if (m === 'num') {
	        me._rgb = num2rgb(x);
	      }
	      me_rgb = clip_rgb(me._rgb);
	    }
	
	    Color.prototype.rgb = function() {
	      return this._rgb.slice(0, 3);
	    };
	
	    Color.prototype.rgba = function() {
	      return this._rgb;
	    };
	
	    Color.prototype.hex = function() {
	      return rgb2hex(this._rgb);
	    };
	
	    Color.prototype.toString = function() {
	      return this.name();
	    };
	
	    Color.prototype.hsl = function() {
	      return rgb2hsl(this._rgb);
	    };
	
	    Color.prototype.hsv = function() {
	      return rgb2hsv(this._rgb);
	    };
	
	    Color.prototype.lab = function() {
	      return rgb2lab(this._rgb);
	    };
	
	    Color.prototype.lch = function() {
	      return rgb2lch(this._rgb);
	    };
	
	    Color.prototype.hsi = function() {
	      return rgb2hsi(this._rgb);
	    };
	
	    Color.prototype.gl = function() {
	      return [this._rgb[0] / 255, this._rgb[1] / 255, this._rgb[2] / 255, this._rgb[3]];
	    };
	
	    Color.prototype.num = function() {
	      return rgb2num(this._rgb);
	    };
	
	    Color.prototype.luminance = function(lum, mode) {
	      var cur_lum, eps, max_iter, test;
	
	      if (mode == null) {
	        mode = 'rgb';
	      }
	      if (!arguments.length) {
	        return luminance(this._rgb);
	      }
	      if (lum === 0) {
	        this._rgb = [0, 0, 0, this._rgb[3]];
	      }
	      if (lum === 1) {
	        this._rgb = [255, 255, 255, this._rgb[3]];
	      }
	      cur_lum = luminance(this._rgb);
	      eps = 1e-7;
	      max_iter = 20;
	      test = function(l, h) {
	        var lm, m;
	
	        m = l.interpolate(0.5, h, mode);
	        lm = m.luminance();
	        if (Math.abs(lum - lm) < eps || !max_iter--) {
	          return m;
	        }
	        if (lm > lum) {
	          return test(l, m);
	        }
	        return test(m, h);
	      };
	      this._rgb = (cur_lum > lum ? test(new Color('black'), this) : test(this, new Color('white'))).rgba();
	      return this;
	    };
	
	    Color.prototype.name = function() {
	      var h, k;
	
	      h = this.hex();
	      for (k in chroma.colors) {
	        if (h === chroma.colors[k]) {
	          return k;
	        }
	      }
	      return h;
	    };
	
	    Color.prototype.alpha = function(alpha) {
	      if (arguments.length) {
	        this._rgb[3] = alpha;
	        return this;
	      }
	      return this._rgb[3];
	    };
	
	    Color.prototype.css = function(mode) {
	      var hsl, me, rgb, rnd;
	
	      if (mode == null) {
	        mode = 'rgb';
	      }
	      me = this;
	      rgb = me._rgb;
	      if (mode.length === 3 && rgb[3] < 1) {
	        mode += 'a';
	      }
	      if (mode === 'rgb') {
	        return mode + '(' + rgb.slice(0, 3).map(Math.round).join(',') + ')';
	      } else if (mode === 'rgba') {
	        return mode + '(' + rgb.slice(0, 3).map(Math.round).join(',') + ',' + rgb[3] + ')';
	      } else if (mode === 'hsl' || mode === 'hsla') {
	        hsl = me.hsl();
	        rnd = function(a) {
	          return Math.round(a * 100) / 100;
	        };
	        hsl[0] = rnd(hsl[0]);
	        hsl[1] = rnd(hsl[1] * 100) + '%';
	        hsl[2] = rnd(hsl[2] * 100) + '%';
	        if (mode.length === 4) {
	          hsl[3] = rgb[3];
	        }
	        return mode + '(' + hsl.join(',') + ')';
	      }
	    };
	
	    Color.prototype.interpolate = function(f, col, m) {
	      /*
	      interpolates between colors
	      f = 0 --> me
	      f = 1 --> col
	      */
	
	      var dh, hue, hue0, hue1, lbv, lbv0, lbv1, me, res, sat, sat0, sat1, xyz0, xyz1;
	
	      me = this;
	      if (m == null) {
	        m = 'rgb';
	      }
	      if (type(col) === "string") {
	        col = new Color(col);
	      }
	      if (m === 'hsl' || m === 'hsv' || m === 'lch' || m === 'hsi') {
	        if (m === 'hsl') {
	          xyz0 = me.hsl();
	          xyz1 = col.hsl();
	        } else if (m === 'hsv') {
	          xyz0 = me.hsv();
	          xyz1 = col.hsv();
	        } else if (m === 'hsi') {
	          xyz0 = me.hsi();
	          xyz1 = col.hsi();
	        } else if (m === 'lch') {
	          xyz0 = me.lch();
	          xyz1 = col.lch();
	        }
	        if (m.substr(0, 1) === 'h') {
	          hue0 = xyz0[0], sat0 = xyz0[1], lbv0 = xyz0[2];
	          hue1 = xyz1[0], sat1 = xyz1[1], lbv1 = xyz1[2];
	        } else {
	          lbv0 = xyz0[0], sat0 = xyz0[1], hue0 = xyz0[2];
	          lbv1 = xyz1[0], sat1 = xyz1[1], hue1 = xyz1[2];
	        }
	        if (!isNaN(hue0) && !isNaN(hue1)) {
	          if (hue1 > hue0 && hue1 - hue0 > 180) {
	            dh = hue1 - (hue0 + 360);
	          } else if (hue1 < hue0 && hue0 - hue1 > 180) {
	            dh = hue1 + 360 - hue0;
	          } else {
	            dh = hue1 - hue0;
	          }
	          hue = hue0 + f * dh;
	        } else if (!isNaN(hue0)) {
	          hue = hue0;
	          if ((lbv1 === 1 || lbv1 === 0) && m !== 'hsv') {
	            sat = sat0;
	          }
	        } else if (!isNaN(hue1)) {
	          hue = hue1;
	          if ((lbv0 === 1 || lbv0 === 0) && m !== 'hsv') {
	            sat = sat1;
	          }
	        } else {
	          hue = Number.NaN;
	        }
	        if (sat == null) {
	          sat = sat0 + f * (sat1 - sat0);
	        }
	        lbv = lbv0 + f * (lbv1 - lbv0);
	        if (m.substr(0, 1) === 'h') {
	          res = new Color(hue, sat, lbv, m);
	        } else {
	          res = new Color(lbv, sat, hue, m);
	        }
	      } else if (m === 'rgb') {
	        xyz0 = me._rgb;
	        xyz1 = col._rgb;
	        res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
	      } else if (m === 'num') {
	        if (!(col instanceof Color)) {
	          col = new Color(col, m);
	        }
	        xyz0 = me._rgb;
	        xyz1 = col._rgb;
	        res = new Color(((xyz0[0] + f * (xyz1[0] - xyz0[0])) << 16) + ((xyz0[1] + f * (xyz1[1] - xyz0[1])) << 8) + ((xyz0[2] + f * (xyz1[2] - xyz0[2])) & 0xff), m);
	      } else if (m === 'lab') {
	        xyz0 = me.lab();
	        xyz1 = col.lab();
	        res = new Color(xyz0[0] + f * (xyz1[0] - xyz0[0]), xyz0[1] + f * (xyz1[1] - xyz0[1]), xyz0[2] + f * (xyz1[2] - xyz0[2]), m);
	      } else {
	        throw "color mode " + m + " is not supported";
	      }
	      res.alpha(me.alpha() + f * (col.alpha() - me.alpha()));
	      return res;
	    };
	
	    Color.prototype.premultiply = function() {
	      var a, rgb;
	
	      rgb = this.rgb();
	      a = this.alpha();
	      return chroma(rgb[0] * a, rgb[1] * a, rgb[2] * a, a);
	    };
	
	    Color.prototype.darken = function(amount) {
	      var lch, me;
	
	      if (amount == null) {
	        amount = 20;
	      }
	      me = this;
	      lch = me.lch();
	      lch[0] -= amount;
	      return chroma.lch(lch).alpha(me.alpha());
	    };
	
	    Color.prototype.darker = function(amount) {
	      return this.darken(amount);
	    };
	
	    Color.prototype.brighten = function(amount) {
	      if (amount == null) {
	        amount = 20;
	      }
	      return this.darken(-amount);
	    };
	
	    Color.prototype.brighter = function(amount) {
	      return this.brighten(amount);
	    };
	
	    Color.prototype.saturate = function(amount) {
	      var lch, me;
	
	      if (amount == null) {
	        amount = 20;
	      }
	      me = this;
	      lch = me.lch();
	      lch[1] += amount;
	      return chroma.lch(lch).alpha(me.alpha());
	    };
	
	    Color.prototype.desaturate = function(amount) {
	      if (amount == null) {
	        amount = 20;
	      }
	      return this.saturate(-amount);
	    };
	
	    return Color;
	
	  })();
	
	  clip_rgb = function(rgb) {
	    var i;
	
	    for (i in rgb) {
	      if (i < 3) {
	        if (rgb[i] < 0) {
	          rgb[i] = 0;
	        }
	        if (rgb[i] > 255) {
	          rgb[i] = 255;
	        }
	      } else if (i === 3) {
	        if (rgb[i] < 0) {
	          rgb[i] = 0;
	        }
	        if (rgb[i] > 1) {
	          rgb[i] = 1;
	        }
	      }
	    }
	    return rgb;
	  };
	
	  css2rgb = function(css) {
	    var hsl, i, m, rgb, _i, _j, _k, _l;
	
	    css = css.toLowerCase();
	    if ((chroma.colors != null) && chroma.colors[css]) {
	      return hex2rgb(chroma.colors[css]);
	    }
	    if (m = css.match(/rgb\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*\)/)) {
	      rgb = m.slice(1, 4);
	      for (i = _i = 0; _i <= 2; i = ++_i) {
	        rgb[i] = +rgb[i];
	      }
	      rgb[3] = 1;
	    } else if (m = css.match(/rgba\(\s*(\-?\d+),\s*(\-?\d+)\s*,\s*(\-?\d+)\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      rgb = m.slice(1, 5);
	      for (i = _j = 0; _j <= 3; i = ++_j) {
	        rgb[i] = +rgb[i];
	      }
	    } else if (m = css.match(/rgb\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
	      rgb = m.slice(1, 4);
	      for (i = _k = 0; _k <= 2; i = ++_k) {
	        rgb[i] = Math.round(rgb[i] * 2.55);
	      }
	      rgb[3] = 1;
	    } else if (m = css.match(/rgba\(\s*(\-?\d+(?:\.\d+)?)%,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      rgb = m.slice(1, 5);
	      for (i = _l = 0; _l <= 2; i = ++_l) {
	        rgb[i] = Math.round(rgb[i] * 2.55);
	      }
	      rgb[3] = +rgb[3];
	    } else if (m = css.match(/hsl\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*\)/)) {
	      hsl = m.slice(1, 4);
	      hsl[1] *= 0.01;
	      hsl[2] *= 0.01;
	      rgb = hsl2rgb(hsl);
	      rgb[3] = 1;
	    } else if (m = css.match(/hsla\(\s*(\-?\d+(?:\.\d+)?),\s*(\-?\d+(?:\.\d+)?)%\s*,\s*(\-?\d+(?:\.\d+)?)%\s*,\s*([01]|[01]?\.\d+)\)/)) {
	      hsl = m.slice(1, 4);
	      hsl[1] *= 0.01;
	      hsl[2] *= 0.01;
	      rgb = hsl2rgb(hsl);
	      rgb[3] = +m[4];
	    }
	    return rgb;
	  };
	
	  hex2rgb = function(hex) {
	    var a, b, g, r, rgb, u;
	
	    if (hex.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/)) {
	      if (hex.length === 4 || hex.length === 7) {
	        hex = hex.substr(1);
	      }
	      if (hex.length === 3) {
	        hex = hex.split("");
	        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
	      }
	      u = parseInt(hex, 16);
	      r = u >> 16;
	      g = u >> 8 & 0xFF;
	      b = u & 0xFF;
	      return [r, g, b, 1];
	    }
	    if (hex.match(/^#?([A-Fa-f0-9]{8})$/)) {
	      if (hex.length === 9) {
	        hex = hex.substr(1);
	      }
	      u = parseInt(hex, 16);
	      r = u >> 24 & 0xFF;
	      g = u >> 16 & 0xFF;
	      b = u >> 8 & 0xFF;
	      a = u & 0xFF;
	      return [r, g, b, a];
	    }
	    if (rgb = css2rgb(hex)) {
	      return rgb;
	    }
	    throw "unknown color: " + hex;
	  };
	
	  hsi2rgb = function(h, s, i) {
	    /*
	    borrowed from here:
	    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/hsi2rgb.cpp
	    */
	
	    var b, g, r, _ref;
	
	    _ref = unpack(arguments), h = _ref[0], s = _ref[1], i = _ref[2];
	    h /= 360;
	    if (h < 1 / 3) {
	      b = (1 - s) / 3;
	      r = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      g = 1 - (b + r);
	    } else if (h < 2 / 3) {
	      h -= 1 / 3;
	      r = (1 - s) / 3;
	      g = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      b = 1 - (r + g);
	    } else {
	      h -= 2 / 3;
	      g = (1 - s) / 3;
	      b = (1 + s * cos(TWOPI * h) / cos(PITHIRD - TWOPI * h)) / 3;
	      r = 1 - (g + b);
	    }
	    r = limit(i * r * 3);
	    g = limit(i * g * 3);
	    b = limit(i * b * 3);
	    return [r * 255, g * 255, b * 255];
	  };
	
	  hsl2rgb = function() {
	    var b, c, g, h, i, l, r, s, t1, t2, t3, _i, _ref, _ref1;
	
	    _ref = unpack(arguments), h = _ref[0], s = _ref[1], l = _ref[2];
	    if (s === 0) {
	      r = g = b = l * 255;
	    } else {
	      t3 = [0, 0, 0];
	      c = [0, 0, 0];
	      t2 = l < 0.5 ? l * (1 + s) : l + s - l * s;
	      t1 = 2 * l - t2;
	      h /= 360;
	      t3[0] = h + 1 / 3;
	      t3[1] = h;
	      t3[2] = h - 1 / 3;
	      for (i = _i = 0; _i <= 2; i = ++_i) {
	        if (t3[i] < 0) {
	          t3[i] += 1;
	        }
	        if (t3[i] > 1) {
	          t3[i] -= 1;
	        }
	        if (6 * t3[i] < 1) {
	          c[i] = t1 + (t2 - t1) * 6 * t3[i];
	        } else if (2 * t3[i] < 1) {
	          c[i] = t2;
	        } else if (3 * t3[i] < 2) {
	          c[i] = t1 + (t2 - t1) * ((2 / 3) - t3[i]) * 6;
	        } else {
	          c[i] = t1;
	        }
	      }
	      _ref1 = [Math.round(c[0] * 255), Math.round(c[1] * 255), Math.round(c[2] * 255)], r = _ref1[0], g = _ref1[1], b = _ref1[2];
	    }
	    return [r, g, b];
	  };
	
	  hsv2rgb = function() {
	    var b, f, g, h, i, p, q, r, s, t, v, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
	
	    _ref = unpack(arguments), h = _ref[0], s = _ref[1], v = _ref[2];
	    v *= 255;
	    if (s === 0) {
	      r = g = b = v;
	    } else {
	      if (h === 360) {
	        h = 0;
	      }
	      if (h > 360) {
	        h -= 360;
	      }
	      if (h < 0) {
	        h += 360;
	      }
	      h /= 60;
	      i = Math.floor(h);
	      f = h - i;
	      p = v * (1 - s);
	      q = v * (1 - s * f);
	      t = v * (1 - s * (1 - f));
	      switch (i) {
	        case 0:
	          _ref1 = [v, t, p], r = _ref1[0], g = _ref1[1], b = _ref1[2];
	          break;
	        case 1:
	          _ref2 = [q, v, p], r = _ref2[0], g = _ref2[1], b = _ref2[2];
	          break;
	        case 2:
	          _ref3 = [p, v, t], r = _ref3[0], g = _ref3[1], b = _ref3[2];
	          break;
	        case 3:
	          _ref4 = [p, q, v], r = _ref4[0], g = _ref4[1], b = _ref4[2];
	          break;
	        case 4:
	          _ref5 = [t, p, v], r = _ref5[0], g = _ref5[1], b = _ref5[2];
	          break;
	        case 5:
	          _ref6 = [v, p, q], r = _ref6[0], g = _ref6[1], b = _ref6[2];
	      }
	    }
	    r = Math.round(r);
	    g = Math.round(g);
	    b = Math.round(b);
	    return [r, g, b];
	  };
	
	  K = 18;
	
	  X = 0.950470;
	
	  Y = 1;
	
	  Z = 1.088830;
	
	  lab2lch = function() {
	    var a, b, c, h, l, _ref;
	
	    _ref = unpack(arguments), l = _ref[0], a = _ref[1], b = _ref[2];
	    c = Math.sqrt(a * a + b * b);
	    h = (Math.atan2(b, a) / Math.PI * 180 + 360) % 360;
	    return [l, c, h];
	  };
	
	  lab2rgb = function(l, a, b) {
	    /*
	    adapted to match d3 implementation
	    */
	
	    var g, r, x, y, z, _ref, _ref1;
	
	    if (l !== void 0 && l.length === 3) {
	      _ref = l, l = _ref[0], a = _ref[1], b = _ref[2];
	    }
	    if (l !== void 0 && l.length === 3) {
	      _ref1 = l, l = _ref1[0], a = _ref1[1], b = _ref1[2];
	    }
	    y = (l + 16) / 116;
	    x = y + a / 500;
	    z = y - b / 200;
	    x = lab_xyz(x) * X;
	    y = lab_xyz(y) * Y;
	    z = lab_xyz(z) * Z;
	    r = xyz_rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z);
	    g = xyz_rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z);
	    b = xyz_rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z);
	    return [limit(r, 0, 255), limit(g, 0, 255), limit(b, 0, 255), 1];
	  };
	
	  lab_xyz = function(x) {
	    if (x > 0.206893034) {
	      return x * x * x;
	    } else {
	      return (x - 4 / 29) / 7.787037;
	    }
	  };
	
	  xyz_rgb = function(r) {
	    return Math.round(255 * (r <= 0.00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - 0.055));
	  };
	
	  lch2lab = function() {
	    /*
	    Convert from a qualitative parameter h and a quantitative parameter l to a 24-bit pixel. These formulas were invented by David Dalrymple to obtain maximum contrast without going out of gamut if the parameters are in the range 0-1.
	    A saturation multiplier was added by Gregor Aisch
	    */
	
	    var c, h, l, _ref;
	
	    _ref = unpack(arguments), l = _ref[0], c = _ref[1], h = _ref[2];
	    h = h * Math.PI / 180;
	    return [l, Math.cos(h) * c, Math.sin(h) * c];
	  };
	
	  lch2rgb = function(l, c, h) {
	    var L, a, b, g, r, _ref, _ref1;
	
	    _ref = lch2lab(l, c, h), L = _ref[0], a = _ref[1], b = _ref[2];
	    _ref1 = lab2rgb(L, a, b), r = _ref1[0], g = _ref1[1], b = _ref1[2];
	    return [limit(r, 0, 255), limit(g, 0, 255), limit(b, 0, 255)];
	  };
	
	  luminance = function(r, g, b) {
	    var _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    r = luminance_x(r);
	    g = luminance_x(g);
	    b = luminance_x(b);
	    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
	  };
	
	  luminance_x = function(x) {
	    x /= 255;
	    if (x <= 0.03928) {
	      return x / 12.92;
	    } else {
	      return Math.pow((x + 0.055) / 1.055, 2.4);
	    }
	  };
	
	  num2rgb = function(num) {
	    var b, g, r;
	
	    if (type(num) === "number" && num >= 0 && num <= 0xFFFFFF) {
	      r = num >> 16;
	      g = (num >> 8) & 0xFF;
	      b = num & 0xFF;
	      return [r, g, b, 1];
	    }
	    throw "unknown num color: " + num;
	  };
	
	  rgb2hex = function() {
	    var b, g, r, str, u, _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    u = r << 16 | g << 8 | b;
	    str = "000000" + u.toString(16);
	    return "#" + str.substr(str.length - 6);
	  };
	
	  rgb2hsi = function() {
	    /*
	    borrowed from here:
	    http://hummer.stanford.edu/museinfo/doc/examples/humdrum/keyscape2/rgb2hsi.cpp
	    */
	
	    var TWOPI, b, g, h, i, min, r, s, _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    TWOPI = Math.PI * 2;
	    r /= 255;
	    g /= 255;
	    b /= 255;
	    min = Math.min(r, g, b);
	    i = (r + g + b) / 3;
	    s = 1 - min / i;
	    if (s === 0) {
	      h = 0;
	    } else {
	      h = ((r - g) + (r - b)) / 2;
	      h /= Math.sqrt((r - g) * (r - g) + (r - b) * (g - b));
	      h = Math.acos(h);
	      if (b > g) {
	        h = TWOPI - h;
	      }
	      h /= TWOPI;
	    }
	    return [h * 360, s, i];
	  };
	
	  rgb2hsl = function(r, g, b) {
	    var h, l, max, min, s, _ref;
	
	    if (r !== void 0 && r.length >= 3) {
	      _ref = r, r = _ref[0], g = _ref[1], b = _ref[2];
	    }
	    r /= 255;
	    g /= 255;
	    b /= 255;
	    min = Math.min(r, g, b);
	    max = Math.max(r, g, b);
	    l = (max + min) / 2;
	    if (max === min) {
	      s = 0;
	      h = Number.NaN;
	    } else {
	      s = l < 0.5 ? (max - min) / (max + min) : (max - min) / (2 - max - min);
	    }
	    if (r === max) {
	      h = (g - b) / (max - min);
	    } else if (g === max) {
	      h = 2 + (b - r) / (max - min);
	    } else if (b === max) {
	      h = 4 + (r - g) / (max - min);
	    }
	    h *= 60;
	    if (h < 0) {
	      h += 360;
	    }
	    return [h, s, l];
	  };
	
	  rgb2hsv = function() {
	    var b, delta, g, h, max, min, r, s, v, _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    min = Math.min(r, g, b);
	    max = Math.max(r, g, b);
	    delta = max - min;
	    v = max / 255.0;
	    if (max === 0) {
	      h = Number.NaN;
	      s = 0;
	    } else {
	      s = delta / max;
	      if (r === max) {
	        h = (g - b) / delta;
	      }
	      if (g === max) {
	        h = 2 + (b - r) / delta;
	      }
	      if (b === max) {
	        h = 4 + (r - g) / delta;
	      }
	      h *= 60;
	      if (h < 0) {
	        h += 360;
	      }
	    }
	    return [h, s, v];
	  };
	
	  rgb2lab = function() {
	    var b, g, r, x, y, z, _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    r = rgb_xyz(r);
	    g = rgb_xyz(g);
	    b = rgb_xyz(b);
	    x = xyz_lab((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / X);
	    y = xyz_lab((0.2126729 * r + 0.7151522 * g + 0.0721750 * b) / Y);
	    z = xyz_lab((0.0193339 * r + 0.1191920 * g + 0.9503041 * b) / Z);
	    return [116 * y - 16, 500 * (x - y), 200 * (y - z)];
	  };
	
	  rgb_xyz = function(r) {
	    if ((r /= 255) <= 0.04045) {
	      return r / 12.92;
	    } else {
	      return Math.pow((r + 0.055) / 1.055, 2.4);
	    }
	  };
	
	  xyz_lab = function(x) {
	    if (x > 0.008856) {
	      return Math.pow(x, 1 / 3);
	    } else {
	      return 7.787037 * x + 4 / 29;
	    }
	  };
	
	  rgb2lch = function() {
	    var a, b, g, l, r, _ref, _ref1;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    _ref1 = rgb2lab(r, g, b), l = _ref1[0], a = _ref1[1], b = _ref1[2];
	    return lab2lch(l, a, b);
	  };
	
	  rgb2num = function() {
	    var b, g, r, _ref;
	
	    _ref = unpack(arguments), r = _ref[0], g = _ref[1], b = _ref[2];
	    return (r << 16) + (g << 8) + b;
	  };
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	  */
	
	
	  chroma.scale = function(colors, positions) {
	    var classifyValue, f, getClass, getColor, resetCache, setColors, setDomain, tmap, _colorCache, _colors, _correctLightness, _domain, _fixed, _max, _min, _mode, _nacol, _numClasses, _out, _pos, _spread;
	
	    _mode = 'rgb';
	    _nacol = chroma('#ccc');
	    _spread = 0;
	    _fixed = false;
	    _domain = [0, 1];
	    _colors = [];
	    _out = false;
	    _pos = [];
	    _min = 0;
	    _max = 1;
	    _correctLightness = false;
	    _numClasses = 0;
	    _colorCache = {};
	    setColors = function(colors, positions) {
	      var c, col, _i, _j, _ref, _ref1, _ref2;
	
	      if (colors == null) {
	        colors = ['#ddd', '#222'];
	      }
	      if ((colors != null) && type(colors) === 'string' && (((_ref = chroma.brewer) != null ? _ref[colors] : void 0) != null)) {
	        colors = chroma.brewer[colors];
	      }
	      if (type(colors) === 'array') {
	        colors = colors.slice(0);
	        for (c = _i = 0, _ref1 = colors.length - 1; 0 <= _ref1 ? _i <= _ref1 : _i >= _ref1; c = 0 <= _ref1 ? ++_i : --_i) {
	          col = colors[c];
	          if (type(col) === "string") {
	            colors[c] = chroma(col);
	          }
	        }
	        if (positions != null) {
	          _pos = positions;
	        } else {
	          _pos = [];
	          for (c = _j = 0, _ref2 = colors.length - 1; 0 <= _ref2 ? _j <= _ref2 : _j >= _ref2; c = 0 <= _ref2 ? ++_j : --_j) {
	            _pos.push(c / (colors.length - 1));
	          }
	        }
	      }
	      resetCache();
	      return _colors = colors;
	    };
	    setDomain = function(domain) {
	      if (domain == null) {
	        domain = [];
	      }
	      /*
	      # use this if you want to display a limited number of data classes
	      # possible methods are "equalinterval", "quantiles", "custom"
	      */
	
	      _domain = domain;
	      _min = domain[0];
	      _max = domain[domain.length - 1];
	      resetCache();
	      if (domain.length === 2) {
	        return _numClasses = 0;
	      } else {
	        return _numClasses = domain.length - 1;
	      }
	    };
	    getClass = function(value) {
	      var i, n;
	
	      if (_domain != null) {
	        n = _domain.length - 1;
	        i = 0;
	        while (i < n && value >= _domain[i]) {
	          i++;
	        }
	        return i - 1;
	      }
	      return 0;
	    };
	    tmap = function(t) {
	      return t;
	    };
	    classifyValue = function(value) {
	      var i, maxc, minc, n, val;
	
	      val = value;
	      if (_domain.length > 2) {
	        n = _domain.length - 1;
	        i = getClass(value);
	        minc = _domain[0] + (_domain[1] - _domain[0]) * (0 + _spread * 0.5);
	        maxc = _domain[n - 1] + (_domain[n] - _domain[n - 1]) * (1 - _spread * 0.5);
	        val = _min + ((_domain[i] + (_domain[i + 1] - _domain[i]) * 0.5 - minc) / (maxc - minc)) * (_max - _min);
	      }
	      return val;
	    };
	    getColor = function(val, bypassMap) {
	      var c, col, f0, i, k, p, t, _i, _ref;
	
	      if (bypassMap == null) {
	        bypassMap = false;
	      }
	      if (isNaN(val)) {
	        return _nacol;
	      }
	      if (!bypassMap) {
	        if (_domain.length > 2) {
	          c = getClass(val);
	          t = c / (_numClasses - 1);
	        } else {
	          t = f0 = _min !== _max ? (val - _min) / (_max - _min) : 0;
	          t = f0 = (val - _min) / (_max - _min);
	          t = Math.min(1, Math.max(0, t));
	        }
	      } else {
	        t = val;
	      }
	      if (!bypassMap) {
	        t = tmap(t);
	      }
	      k = Math.floor(t * 10000);
	      if (_colorCache[k]) {
	        col = _colorCache[k];
	      } else {
	        if (type(_colors) === 'array') {
	          for (i = _i = 0, _ref = _pos.length - 1; 0 <= _ref ? _i <= _ref : _i >= _ref; i = 0 <= _ref ? ++_i : --_i) {
	            p = _pos[i];
	            if (t <= p) {
	              col = _colors[i];
	              break;
	            }
	            if (t >= p && i === _pos.length - 1) {
	              col = _colors[i];
	              break;
	            }
	            if (t > p && t < _pos[i + 1]) {
	              t = (t - p) / (_pos[i + 1] - p);
	              col = chroma.interpolate(_colors[i], _colors[i + 1], t, _mode);
	              break;
	            }
	          }
	        } else if (type(_colors) === 'function') {
	          col = _colors(t);
	        }
	        _colorCache[k] = col;
	      }
	      return col;
	    };
	    resetCache = function() {
	      return _colorCache = {};
	    };
	    setColors(colors, positions);
	    f = function(v) {
	      var c;
	
	      c = getColor(v);
	      if (_out && c[_out]) {
	        return c[_out]();
	      } else {
	        return c;
	      }
	    };
	    f.domain = function(domain, classes, mode, key) {
	      var d;
	
	      if (mode == null) {
	        mode = 'e';
	      }
	      if (!arguments.length) {
	        return _domain;
	      }
	      if (classes != null) {
	        d = chroma.analyze(domain, key);
	        if (classes === 0) {
	          domain = [d.min, d.max];
	        } else {
	          domain = chroma.limits(d, mode, classes);
	        }
	      }
	      setDomain(domain);
	      return f;
	    };
	    f.mode = function(_m) {
	      if (!arguments.length) {
	        return _mode;
	      }
	      _mode = _m;
	      resetCache();
	      return f;
	    };
	    f.range = function(colors, _pos) {
	      setColors(colors, _pos);
	      return f;
	    };
	    f.out = function(_o) {
	      _out = _o;
	      return f;
	    };
	    f.spread = function(val) {
	      if (!arguments.length) {
	        return _spread;
	      }
	      _spread = val;
	      return f;
	    };
	    f.correctLightness = function(v) {
	      if (!arguments.length) {
	        return _correctLightness;
	      }
	      _correctLightness = v;
	      resetCache();
	      if (_correctLightness) {
	        tmap = function(t) {
	          var L0, L1, L_actual, L_diff, L_ideal, max_iter, pol, t0, t1;
	
	          L0 = getColor(0, true).lab()[0];
	          L1 = getColor(1, true).lab()[0];
	          pol = L0 > L1;
	          L_actual = getColor(t, true).lab()[0];
	          L_ideal = L0 + (L1 - L0) * t;
	          L_diff = L_actual - L_ideal;
	          t0 = 0;
	          t1 = 1;
	          max_iter = 20;
	          while (Math.abs(L_diff) > 1e-2 && max_iter-- > 0) {
	            (function() {
	              if (pol) {
	                L_diff *= -1;
	              }
	              if (L_diff < 0) {
	                t0 = t;
	                t += (t1 - t) * 0.5;
	              } else {
	                t1 = t;
	                t += (t0 - t) * 0.5;
	              }
	              L_actual = getColor(t, true).lab()[0];
	              return L_diff = L_actual - L_ideal;
	            })();
	          }
	          return t;
	        };
	      } else {
	        tmap = function(t) {
	          return t;
	        };
	      }
	      return f;
	    };
	    f.colors = function(out) {
	      var i, samples, _i, _j, _len, _ref;
	
	      if (out == null) {
	        out = 'hex';
	      }
	      colors = [];
	      samples = [];
	      if (_domain.length > 2) {
	        for (i = _i = 1, _ref = _domain.length; 1 <= _ref ? _i < _ref : _i > _ref; i = 1 <= _ref ? ++_i : --_i) {
	          samples.push((_domain[i - 1] + _domain[i]) * 0.5);
	        }
	      } else {
	        samples = _domain;
	      }
	      for (_j = 0, _len = samples.length; _j < _len; _j++) {
	        i = samples[_j];
	        colors.push(f(i)[out]());
	      }
	      return colors;
	    };
	    return f;
	  };
	
	  if ((_ref = chroma.scales) == null) {
	    chroma.scales = {};
	  }
	
	  chroma.scales.cool = function() {
	    return chroma.scale([chroma.hsl(180, 1, .9), chroma.hsl(250, .7, .4)]);
	  };
	
	  chroma.scales.hot = function() {
	    return chroma.scale(['#000', '#f00', '#ff0', '#fff'], [0, .25, .75, 1]).mode('rgb');
	  };
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	  */
	
	
	  chroma.analyze = function(data, key, filter) {
	    var add, k, r, val, visit, _i, _len;
	
	    r = {
	      min: Number.MAX_VALUE,
	      max: Number.MAX_VALUE * -1,
	      sum: 0,
	      values: [],
	      count: 0
	    };
	    if (filter == null) {
	      filter = function() {
	        return true;
	      };
	    }
	    add = function(val) {
	      if ((val != null) && !isNaN(val)) {
	        r.values.push(val);
	        r.sum += val;
	        if (val < r.min) {
	          r.min = val;
	        }
	        if (val > r.max) {
	          r.max = val;
	        }
	        r.count += 1;
	      }
	    };
	    visit = function(val, k) {
	      if (filter(val, k)) {
	        if ((key != null) && type(key) === 'function') {
	          return add(key(val));
	        } else if ((key != null) && type(key) === 'string' || type(key) === 'number') {
	          return add(val[key]);
	        } else {
	          return add(val);
	        }
	      }
	    };
	    if (type(data) === 'array') {
	      for (_i = 0, _len = data.length; _i < _len; _i++) {
	        val = data[_i];
	        visit(val);
	      }
	    } else {
	      for (k in data) {
	        val = data[k];
	        visit(val, k);
	      }
	    }
	    r.domain = [r.min, r.max];
	    r.limits = function(mode, num) {
	      return chroma.limits(r, mode, num);
	    };
	    return r;
	  };
	
	  chroma.limits = function(data, mode, num) {
	    var assignments, best, centroids, cluster, clusterSizes, dist, i, j, kClusters, limits, max, max_log, min, min_log, mindist, n, nb_iters, newCentroids, p, pb, pr, repeat, sum, tmpKMeansBreaks, value, values, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _ref1, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _s, _t, _u, _v, _w;
	
	    if (mode == null) {
	      mode = 'equal';
	    }
	    if (num == null) {
	      num = 7;
	    }
	    if (type(data) === 'array') {
	      data = chroma.analyze(data);
	    }
	    min = data.min;
	    max = data.max;
	    sum = data.sum;
	    values = data.values.sort(function(a, b) {
	      return a - b;
	    });
	    limits = [];
	    if (mode.substr(0, 1) === 'c') {
	      limits.push(min);
	      limits.push(max);
	    }
	    if (mode.substr(0, 1) === 'e') {
	      limits.push(min);
	      for (i = _i = 1, _ref1 = num - 1; 1 <= _ref1 ? _i <= _ref1 : _i >= _ref1; i = 1 <= _ref1 ? ++_i : --_i) {
	        limits.push(min + (i / num) * (max - min));
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'l') {
	      if (min <= 0) {
	        throw 'Logarithmic scales are only possible for values > 0';
	      }
	      min_log = Math.LOG10E * Math.log(min);
	      max_log = Math.LOG10E * Math.log(max);
	      limits.push(min);
	      for (i = _j = 1, _ref2 = num - 1; 1 <= _ref2 ? _j <= _ref2 : _j >= _ref2; i = 1 <= _ref2 ? ++_j : --_j) {
	        limits.push(Math.pow(10, min_log + (i / num) * (max_log - min_log)));
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'q') {
	      limits.push(min);
	      for (i = _k = 1, _ref3 = num - 1; 1 <= _ref3 ? _k <= _ref3 : _k >= _ref3; i = 1 <= _ref3 ? ++_k : --_k) {
	        p = values.length * i / num;
	        pb = Math.floor(p);
	        if (pb === p) {
	          limits.push(values[pb]);
	        } else {
	          pr = p - pb;
	          limits.push(values[pb] * pr + values[pb + 1] * (1 - pr));
	        }
	      }
	      limits.push(max);
	    } else if (mode.substr(0, 1) === 'k') {
	      /*
	      implementation based on
	      http://code.google.com/p/figue/source/browse/trunk/figue.js#336
	      simplified for 1-d input values
	      */
	
	      n = values.length;
	      assignments = new Array(n);
	      clusterSizes = new Array(num);
	      repeat = true;
	      nb_iters = 0;
	      centroids = null;
	      centroids = [];
	      centroids.push(min);
	      for (i = _l = 1, _ref4 = num - 1; 1 <= _ref4 ? _l <= _ref4 : _l >= _ref4; i = 1 <= _ref4 ? ++_l : --_l) {
	        centroids.push(min + (i / num) * (max - min));
	      }
	      centroids.push(max);
	      while (repeat) {
	        for (j = _m = 0, _ref5 = num - 1; 0 <= _ref5 ? _m <= _ref5 : _m >= _ref5; j = 0 <= _ref5 ? ++_m : --_m) {
	          clusterSizes[j] = 0;
	        }
	        for (i = _n = 0, _ref6 = n - 1; 0 <= _ref6 ? _n <= _ref6 : _n >= _ref6; i = 0 <= _ref6 ? ++_n : --_n) {
	          value = values[i];
	          mindist = Number.MAX_VALUE;
	          for (j = _o = 0, _ref7 = num - 1; 0 <= _ref7 ? _o <= _ref7 : _o >= _ref7; j = 0 <= _ref7 ? ++_o : --_o) {
	            dist = Math.abs(centroids[j] - value);
	            if (dist < mindist) {
	              mindist = dist;
	              best = j;
	            }
	          }
	          clusterSizes[best]++;
	          assignments[i] = best;
	        }
	        newCentroids = new Array(num);
	        for (j = _p = 0, _ref8 = num - 1; 0 <= _ref8 ? _p <= _ref8 : _p >= _ref8; j = 0 <= _ref8 ? ++_p : --_p) {
	          newCentroids[j] = null;
	        }
	        for (i = _q = 0, _ref9 = n - 1; 0 <= _ref9 ? _q <= _ref9 : _q >= _ref9; i = 0 <= _ref9 ? ++_q : --_q) {
	          cluster = assignments[i];
	          if (newCentroids[cluster] === null) {
	            newCentroids[cluster] = values[i];
	          } else {
	            newCentroids[cluster] += values[i];
	          }
	        }
	        for (j = _r = 0, _ref10 = num - 1; 0 <= _ref10 ? _r <= _ref10 : _r >= _ref10; j = 0 <= _ref10 ? ++_r : --_r) {
	          newCentroids[j] *= 1 / clusterSizes[j];
	        }
	        repeat = false;
	        for (j = _s = 0, _ref11 = num - 1; 0 <= _ref11 ? _s <= _ref11 : _s >= _ref11; j = 0 <= _ref11 ? ++_s : --_s) {
	          if (newCentroids[j] !== centroids[i]) {
	            repeat = true;
	            break;
	          }
	        }
	        centroids = newCentroids;
	        nb_iters++;
	        if (nb_iters > 200) {
	          repeat = false;
	        }
	      }
	      kClusters = {};
	      for (j = _t = 0, _ref12 = num - 1; 0 <= _ref12 ? _t <= _ref12 : _t >= _ref12; j = 0 <= _ref12 ? ++_t : --_t) {
	        kClusters[j] = [];
	      }
	      for (i = _u = 0, _ref13 = n - 1; 0 <= _ref13 ? _u <= _ref13 : _u >= _ref13; i = 0 <= _ref13 ? ++_u : --_u) {
	        cluster = assignments[i];
	        kClusters[cluster].push(values[i]);
	      }
	      tmpKMeansBreaks = [];
	      for (j = _v = 0, _ref14 = num - 1; 0 <= _ref14 ? _v <= _ref14 : _v >= _ref14; j = 0 <= _ref14 ? ++_v : --_v) {
	        tmpKMeansBreaks.push(kClusters[j][0]);
	        tmpKMeansBreaks.push(kClusters[j][kClusters[j].length - 1]);
	      }
	      tmpKMeansBreaks = tmpKMeansBreaks.sort(function(a, b) {
	        return a - b;
	      });
	      limits.push(tmpKMeansBreaks[0]);
	      for (i = _w = 1, _ref15 = tmpKMeansBreaks.length - 1; _w <= _ref15; i = _w += 2) {
	        if (!isNaN(tmpKMeansBreaks[i])) {
	          limits.push(tmpKMeansBreaks[i]);
	        }
	      }
	    }
	    return limits;
	  };
	
	  /**
	  	ColorBrewer colors for chroma.js
	  
	  	Copyright (c) 2002 Cynthia Brewer, Mark Harrower, and The 
	  	Pennsylvania State University.
	  
	  	Licensed under the Apache License, Version 2.0 (the "License"); 
	  	you may not use this file except in compliance with the License.
	  	You may obtain a copy of the License at	
	  	http://www.apache.org/licenses/LICENSE-2.0
	  
	  	Unless required by applicable law or agreed to in writing, software distributed
	  	under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
	  	CONDITIONS OF ANY KIND, either express or implied. See the License for the
	  	specific language governing permissions and limitations under the License.
	  
	      @preserve
	  */
	
	
	  chroma.brewer = brewer = {
	    OrRd: ['#fff7ec', '#fee8c8', '#fdd49e', '#fdbb84', '#fc8d59', '#ef6548', '#d7301f', '#b30000', '#7f0000'],
	    PuBu: ['#fff7fb', '#ece7f2', '#d0d1e6', '#a6bddb', '#74a9cf', '#3690c0', '#0570b0', '#045a8d', '#023858'],
	    BuPu: ['#f7fcfd', '#e0ecf4', '#bfd3e6', '#9ebcda', '#8c96c6', '#8c6bb1', '#88419d', '#810f7c', '#4d004b'],
	    Oranges: ['#fff5eb', '#fee6ce', '#fdd0a2', '#fdae6b', '#fd8d3c', '#f16913', '#d94801', '#a63603', '#7f2704'],
	    BuGn: ['#f7fcfd', '#e5f5f9', '#ccece6', '#99d8c9', '#66c2a4', '#41ae76', '#238b45', '#006d2c', '#00441b'],
	    YlOrBr: ['#ffffe5', '#fff7bc', '#fee391', '#fec44f', '#fe9929', '#ec7014', '#cc4c02', '#993404', '#662506'],
	    YlGn: ['#ffffe5', '#f7fcb9', '#d9f0a3', '#addd8e', '#78c679', '#41ab5d', '#238443', '#006837', '#004529'],
	    Reds: ['#fff5f0', '#fee0d2', '#fcbba1', '#fc9272', '#fb6a4a', '#ef3b2c', '#cb181d', '#a50f15', '#67000d'],
	    RdPu: ['#fff7f3', '#fde0dd', '#fcc5c0', '#fa9fb5', '#f768a1', '#dd3497', '#ae017e', '#7a0177', '#49006a'],
	    Greens: ['#f7fcf5', '#e5f5e0', '#c7e9c0', '#a1d99b', '#74c476', '#41ab5d', '#238b45', '#006d2c', '#00441b'],
	    YlGnBu: ['#ffffd9', '#edf8b1', '#c7e9b4', '#7fcdbb', '#41b6c4', '#1d91c0', '#225ea8', '#253494', '#081d58'],
	    Purples: ['#fcfbfd', '#efedf5', '#dadaeb', '#bcbddc', '#9e9ac8', '#807dba', '#6a51a3', '#54278f', '#3f007d'],
	    GnBu: ['#f7fcf0', '#e0f3db', '#ccebc5', '#a8ddb5', '#7bccc4', '#4eb3d3', '#2b8cbe', '#0868ac', '#084081'],
	    Greys: ['#ffffff', '#f0f0f0', '#d9d9d9', '#bdbdbd', '#969696', '#737373', '#525252', '#252525', '#000000'],
	    YlOrRd: ['#ffffcc', '#ffeda0', '#fed976', '#feb24c', '#fd8d3c', '#fc4e2a', '#e31a1c', '#bd0026', '#800026'],
	    PuRd: ['#f7f4f9', '#e7e1ef', '#d4b9da', '#c994c7', '#df65b0', '#e7298a', '#ce1256', '#980043', '#67001f'],
	    Blues: ['#f7fbff', '#deebf7', '#c6dbef', '#9ecae1', '#6baed6', '#4292c6', '#2171b5', '#08519c', '#08306b'],
	    PuBuGn: ['#fff7fb', '#ece2f0', '#d0d1e6', '#a6bddb', '#67a9cf', '#3690c0', '#02818a', '#016c59', '#014636'],
	    Spectral: ['#9e0142', '#d53e4f', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#e6f598', '#abdda4', '#66c2a5', '#3288bd', '#5e4fa2'],
	    RdYlGn: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee08b', '#ffffbf', '#d9ef8b', '#a6d96a', '#66bd63', '#1a9850', '#006837'],
	    RdBu: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#f7f7f7', '#d1e5f0', '#92c5de', '#4393c3', '#2166ac', '#053061'],
	    PiYG: ['#8e0152', '#c51b7d', '#de77ae', '#f1b6da', '#fde0ef', '#f7f7f7', '#e6f5d0', '#b8e186', '#7fbc41', '#4d9221', '#276419'],
	    PRGn: ['#40004b', '#762a83', '#9970ab', '#c2a5cf', '#e7d4e8', '#f7f7f7', '#d9f0d3', '#a6dba0', '#5aae61', '#1b7837', '#00441b'],
	    RdYlBu: ['#a50026', '#d73027', '#f46d43', '#fdae61', '#fee090', '#ffffbf', '#e0f3f8', '#abd9e9', '#74add1', '#4575b4', '#313695'],
	    BrBG: ['#543005', '#8c510a', '#bf812d', '#dfc27d', '#f6e8c3', '#f5f5f5', '#c7eae5', '#80cdc1', '#35978f', '#01665e', '#003c30'],
	    RdGy: ['#67001f', '#b2182b', '#d6604d', '#f4a582', '#fddbc7', '#ffffff', '#e0e0e0', '#bababa', '#878787', '#4d4d4d', '#1a1a1a'],
	    PuOr: ['#7f3b08', '#b35806', '#e08214', '#fdb863', '#fee0b6', '#f7f7f7', '#d8daeb', '#b2abd2', '#8073ac', '#542788', '#2d004b'],
	    Set2: ['#66c2a5', '#fc8d62', '#8da0cb', '#e78ac3', '#a6d854', '#ffd92f', '#e5c494', '#b3b3b3'],
	    Accent: ['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17', '#666666'],
	    Set1: ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf', '#999999'],
	    Set3: ['#8dd3c7', '#ffffb3', '#bebada', '#fb8072', '#80b1d3', '#fdb462', '#b3de69', '#fccde5', '#d9d9d9', '#bc80bd', '#ccebc5', '#ffed6f'],
	    Dark2: ['#1b9e77', '#d95f02', '#7570b3', '#e7298a', '#66a61e', '#e6ab02', '#a6761d', '#666666'],
	    Paired: ['#a6cee3', '#1f78b4', '#b2df8a', '#33a02c', '#fb9a99', '#e31a1c', '#fdbf6f', '#ff7f00', '#cab2d6', '#6a3d9a', '#ffff99', '#b15928'],
	    Pastel2: ['#b3e2cd', '#fdcdac', '#cbd5e8', '#f4cae4', '#e6f5c9', '#fff2ae', '#f1e2cc', '#cccccc'],
	    Pastel1: ['#fbb4ae', '#b3cde3', '#ccebc5', '#decbe4', '#fed9a6', '#ffffcc', '#e5d8bd', '#fddaec', '#f2f2f2']
	  };
	
	  /**
	  	X11 color names
	  
	  	http://www.w3.org/TR/css3-color/#svg-color
	  */
	
	
	  chroma.colors = colors = {
	    indigo: "#4b0082",
	    gold: "#ffd700",
	    hotpink: "#ff69b4",
	    firebrick: "#b22222",
	    indianred: "#cd5c5c",
	    yellow: "#ffff00",
	    mistyrose: "#ffe4e1",
	    darkolivegreen: "#556b2f",
	    olive: "#808000",
	    darkseagreen: "#8fbc8f",
	    pink: "#ffc0cb",
	    tomato: "#ff6347",
	    lightcoral: "#f08080",
	    orangered: "#ff4500",
	    navajowhite: "#ffdead",
	    lime: "#00ff00",
	    palegreen: "#98fb98",
	    darkslategrey: "#2f4f4f",
	    greenyellow: "#adff2f",
	    burlywood: "#deb887",
	    seashell: "#fff5ee",
	    mediumspringgreen: "#00fa9a",
	    fuchsia: "#ff00ff",
	    papayawhip: "#ffefd5",
	    blanchedalmond: "#ffebcd",
	    chartreuse: "#7fff00",
	    dimgray: "#696969",
	    black: "#000000",
	    peachpuff: "#ffdab9",
	    springgreen: "#00ff7f",
	    aquamarine: "#7fffd4",
	    white: "#ffffff",
	    orange: "#ffa500",
	    lightsalmon: "#ffa07a",
	    darkslategray: "#2f4f4f",
	    brown: "#a52a2a",
	    ivory: "#fffff0",
	    dodgerblue: "#1e90ff",
	    peru: "#cd853f",
	    lawngreen: "#7cfc00",
	    chocolate: "#d2691e",
	    crimson: "#dc143c",
	    forestgreen: "#228b22",
	    darkgrey: "#a9a9a9",
	    lightseagreen: "#20b2aa",
	    cyan: "#00ffff",
	    mintcream: "#f5fffa",
	    silver: "#c0c0c0",
	    antiquewhite: "#faebd7",
	    mediumorchid: "#ba55d3",
	    skyblue: "#87ceeb",
	    gray: "#808080",
	    darkturquoise: "#00ced1",
	    goldenrod: "#daa520",
	    darkgreen: "#006400",
	    floralwhite: "#fffaf0",
	    darkviolet: "#9400d3",
	    darkgray: "#a9a9a9",
	    moccasin: "#ffe4b5",
	    saddlebrown: "#8b4513",
	    grey: "#808080",
	    darkslateblue: "#483d8b",
	    lightskyblue: "#87cefa",
	    lightpink: "#ffb6c1",
	    mediumvioletred: "#c71585",
	    slategrey: "#708090",
	    red: "#ff0000",
	    deeppink: "#ff1493",
	    limegreen: "#32cd32",
	    darkmagenta: "#8b008b",
	    palegoldenrod: "#eee8aa",
	    plum: "#dda0dd",
	    turquoise: "#40e0d0",
	    lightgrey: "#d3d3d3",
	    lightgoldenrodyellow: "#fafad2",
	    darkgoldenrod: "#b8860b",
	    lavender: "#e6e6fa",
	    maroon: "#800000",
	    yellowgreen: "#9acd32",
	    sandybrown: "#f4a460",
	    thistle: "#d8bfd8",
	    violet: "#ee82ee",
	    navy: "#000080",
	    magenta: "#ff00ff",
	    dimgrey: "#696969",
	    tan: "#d2b48c",
	    rosybrown: "#bc8f8f",
	    olivedrab: "#6b8e23",
	    blue: "#0000ff",
	    lightblue: "#add8e6",
	    ghostwhite: "#f8f8ff",
	    honeydew: "#f0fff0",
	    cornflowerblue: "#6495ed",
	    slateblue: "#6a5acd",
	    linen: "#faf0e6",
	    darkblue: "#00008b",
	    powderblue: "#b0e0e6",
	    seagreen: "#2e8b57",
	    darkkhaki: "#bdb76b",
	    snow: "#fffafa",
	    sienna: "#a0522d",
	    mediumblue: "#0000cd",
	    royalblue: "#4169e1",
	    lightcyan: "#e0ffff",
	    green: "#008000",
	    mediumpurple: "#9370db",
	    midnightblue: "#191970",
	    cornsilk: "#fff8dc",
	    paleturquoise: "#afeeee",
	    bisque: "#ffe4c4",
	    slategray: "#708090",
	    darkcyan: "#008b8b",
	    khaki: "#f0e68c",
	    wheat: "#f5deb3",
	    teal: "#008080",
	    darkorchid: "#9932cc",
	    deepskyblue: "#00bfff",
	    salmon: "#fa8072",
	    darkred: "#8b0000",
	    steelblue: "#4682b4",
	    palevioletred: "#db7093",
	    lightslategray: "#778899",
	    aliceblue: "#f0f8ff",
	    lightslategrey: "#778899",
	    lightgreen: "#90ee90",
	    orchid: "#da70d6",
	    gainsboro: "#dcdcdc",
	    mediumseagreen: "#3cb371",
	    lightgray: "#d3d3d3",
	    mediumturquoise: "#48d1cc",
	    lemonchiffon: "#fffacd",
	    cadetblue: "#5f9ea0",
	    lightyellow: "#ffffe0",
	    lavenderblush: "#fff0f5",
	    coral: "#ff7f50",
	    purple: "#800080",
	    aqua: "#00ffff",
	    whitesmoke: "#f5f5f5",
	    mediumslateblue: "#7b68ee",
	    darkorange: "#ff8c00",
	    mediumaquamarine: "#66cdaa",
	    darksalmon: "#e9967a",
	    beige: "#f5f5dc",
	    blueviolet: "#8a2be2",
	    azure: "#f0ffff",
	    lightsteelblue: "#b0c4de",
	    oldlace: "#fdf5e6"
	  };
	
	  /*
	      chroma.js
	  
	      Copyright (c) 2011-2013, Gregor Aisch
	      All rights reserved.
	  
	      Redistribution and use in source and binary forms, with or without
	      modification, are permitted provided that the following conditions are met:
	  
	      * Redistributions of source code must retain the above copyright notice, this
	        list of conditions and the following disclaimer.
	  
	      * Redistributions in binary form must reproduce the above copyright notice,
	        this list of conditions and the following disclaimer in the documentation
	        and/or other materials provided with the distribution.
	  
	      * The name Gregor Aisch may not be used to endorse or promote products
	        derived from this software without specific prior written permission.
	  
	      THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
	      AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
	      IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
	      DISCLAIMED. IN NO EVENT SHALL GREGOR AISCH OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
	      INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
	      BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
	      DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
	      OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
	      NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE,
	      EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	  
	      @source: https://github.com/gka/chroma.js
	  */
	
	
	  type = (function() {
	    /*
	    for browser-safe type checking+
	    ported from jQuery's $.type
	    */
	
	    var classToType, name, _i, _len, _ref1;
	
	    classToType = {};
	    _ref1 = "Boolean Number String Function Array Date RegExp Undefined Null".split(" ");
	    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	      name = _ref1[_i];
	      classToType["[object " + name + "]"] = name.toLowerCase();
	    }
	    return function(obj) {
	      var strType;
	
	      strType = Object.prototype.toString.call(obj);
	      return classToType[strType] || "object";
	    };
	  })();
	
	  limit = function(x, min, max) {
	    if (min == null) {
	      min = 0;
	    }
	    if (max == null) {
	      max = 1;
	    }
	    if (x < min) {
	      x = min;
	    }
	    if (x > max) {
	      x = max;
	    }
	    return x;
	  };
	
	  unpack = function(args) {
	    if (args.length >= 3) {
	      return args;
	    } else {
	      return args[0];
	    }
	  };
	
	  TWOPI = Math.PI * 2;
	
	  PITHIRD = Math.PI / 3;
	
	  cos = Math.cos;
	
	  /*
	  interpolates between a set of colors uzing a bezier spline
	  */
	
	
	  bezier = function(colors) {
	    var I, I0, I1, c, lab0, lab1, lab2, lab3, _ref1, _ref2, _ref3;
	
	    colors = (function() {
	      var _i, _len, _results;
	
	      _results = [];
	      for (_i = 0, _len = colors.length; _i < _len; _i++) {
	        c = colors[_i];
	        _results.push(chroma(c));
	      }
	      return _results;
	    })();
	    if (colors.length === 2) {
	      _ref1 = (function() {
	        var _i, _len, _results;
	
	        _results = [];
	        for (_i = 0, _len = colors.length; _i < _len; _i++) {
	          c = colors[_i];
	          _results.push(c.lab());
	        }
	        return _results;
	      })(), lab0 = _ref1[0], lab1 = _ref1[1];
	      I = function(t) {
	        var i, lab;
	
	        lab = (function() {
	          var _i, _results;
	
	          _results = [];
	          for (i = _i = 0; _i <= 2; i = ++_i) {
	            _results.push(lab0[i] + t * (lab1[i] - lab0[i]));
	          }
	          return _results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 3) {
	      _ref2 = (function() {
	        var _i, _len, _results;
	
	        _results = [];
	        for (_i = 0, _len = colors.length; _i < _len; _i++) {
	          c = colors[_i];
	          _results.push(c.lab());
	        }
	        return _results;
	      })(), lab0 = _ref2[0], lab1 = _ref2[1], lab2 = _ref2[2];
	      I = function(t) {
	        var i, lab;
	
	        lab = (function() {
	          var _i, _results;
	
	          _results = [];
	          for (i = _i = 0; _i <= 2; i = ++_i) {
	            _results.push((1 - t) * (1 - t) * lab0[i] + 2 * (1 - t) * t * lab1[i] + t * t * lab2[i]);
	          }
	          return _results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 4) {
	      _ref3 = (function() {
	        var _i, _len, _results;
	
	        _results = [];
	        for (_i = 0, _len = colors.length; _i < _len; _i++) {
	          c = colors[_i];
	          _results.push(c.lab());
	        }
	        return _results;
	      })(), lab0 = _ref3[0], lab1 = _ref3[1], lab2 = _ref3[2], lab3 = _ref3[3];
	      I = function(t) {
	        var i, lab;
	
	        lab = (function() {
	          var _i, _results;
	
	          _results = [];
	          for (i = _i = 0; _i <= 2; i = ++_i) {
	            _results.push((1 - t) * (1 - t) * (1 - t) * lab0[i] + 3 * (1 - t) * (1 - t) * t * lab1[i] + 3 * (1 - t) * t * t * lab2[i] + t * t * t * lab3[i]);
	          }
	          return _results;
	        })();
	        return chroma.lab.apply(chroma, lab);
	      };
	    } else if (colors.length === 5) {
	      I0 = bezier(colors.slice(0, 3));
	      I1 = bezier(colors.slice(2, 5));
	      I = function(t) {
	        if (t < 0.5) {
	          return I0(t * 2);
	        } else {
	          return I1((t - 0.5) * 2);
	        }
	      };
	    }
	    return I;
	  };
	
	  chroma.interpolate.bezier = bezier;
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(267)(module)))

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var chroma, colorPicker, contrastSearch, isObject, objectAssign;
	
	chroma = __webpack_require__(275);
	
	objectAssign = __webpack_require__(162);
	
	contrastSearch = __webpack_require__(277);
	
	isObject = __webpack_require__(281);
	
	module.exports = colorPicker = function(color, targetColor, options) {
	  var bg, contrastToEnd, contrastToStart, end, endColor, fg, highestPossibleContrast, newEnd, newStart, secondColor, start, startColor;
	  if (options == null) {
	    options = {};
	  }
	  if (targetColor == null) {
	    targetColor = color;
	  }
	  if (isObject(targetColor)) {
	    options = targetColor;
	    targetColor = color;
	  }
	  options = objectAssign({
	    colorIsBackground: true,
	    contrast: 5,
	    foregroundMax: 0.98,
	    foregroundMin: 0.02,
	    backgroundMax: 0.85,
	    backgroundMin: 0.15,
	    direction: void 0
	  }, options);
	  if (options.colorIsBackground) {
	    start = options.foregroundMin;
	    end = options.foregroundMax;
	  } else {
	    start = options.backgroundMin;
	    end = options.backgroundMax;
	  }
	  if (options.direction != null) {
	    secondColor = contrastSearch(targetColor, color, start, end, options.direction, options.contrast);
	  } else {
	    endColor = chroma(targetColor, 'lab').luminance(end);
	    startColor = chroma(targetColor, 'lab').luminance(start);
	    contrastToStart = chroma.contrast(color, startColor.css());
	    contrastToEnd = chroma.contrast(color, endColor.css());
	    if (contrastToEnd > options.contrast) {
	      secondColor = contrastSearch(targetColor, color, start, end, 'end', options.contrast);
	    } else if (contrastToStart > options.contrast) {
	      secondColor = contrastSearch(targetColor, color, start, end, 'start', options.contrast);
	    } else {
	      if (options.colorIsBackground) {
	        newStart = options.backgroundMin;
	        newEnd = options.backgroundMax;
	      } else {
	        newStart = options.foregroundMin;
	        newEnd = options.foregroundMax;
	      }
	      if (contrastToEnd > contrastToStart) {
	        secondColor = chroma(targetColor, 'lab').luminance(end);
	        highestPossibleContrast = chroma.contrast(secondColor.css(), chroma(color, 'lab').luminance(newStart));
	        if (highestPossibleContrast > options.contrast) {
	          color = contrastSearch(color, secondColor.css(), newStart, newEnd, 'start', options.contrast);
	        } else {
	          color = chroma(color, 'lab').luminance(newStart).lab();
	        }
	        secondColor = secondColor.lab();
	      } else {
	        secondColor = chroma(color, 'lab').luminance(start);
	        highestPossibleContrast = chroma.contrast(secondColor.css(), chroma(color, 'lab').luminance(newEnd));
	        if (highestPossibleContrast > options.contrast) {
	          color = contrastSearch(color, secondColor.css(), newStart, newEnd, 'end', options.contrast);
	        } else {
	          color = chroma(color, 'lab').luminance(newEnd).lab();
	        }
	        secondColor = secondColor.lab();
	      }
	    }
	  }
	  if (options.colorIsBackground) {
	    bg = color;
	    fg = secondColor;
	  } else {
	    bg = secondColor;
	    fg = color;
	  }
	  return {
	    bg: chroma.lab(bg).css(),
	    fg: chroma.lab(fg).css()
	  };
	};


/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var chroma, color, contrastSearch, counter, debug, targetColor;
	
	chroma = __webpack_require__(275);
	
	debug = __webpack_require__(278)('color-pairs-picker-binary-search-contrast');
	
	counter = 0;
	
	module.exports = contrastSearch = function(targetColor, compareColor, start, end, direction, contrast) {
	  var b, color, curContrast, middle;
	  if (compareColor == null) {
	    compareColor = targetColor;
	  }
	  if (start == null) {
	    start = 0;
	  }
	  if (end == null) {
	    end = 1;
	  }
	  if (direction == null) {
	    direction = "end";
	  }
	  if (contrast == null) {
	    contrast = 5;
	  }
	  counter += 1;
	  middle = (start + end) / 2;
	  b = chroma(targetColor, 'lab');
	  color = b.luminance(middle).lab();
	  curContrast = chroma.contrast(chroma(compareColor).css(), b.css());
	  if (counter > 15) {
	    counter = 0;
	    return color;
	  }
	  if ((contrast - 0.1) < curContrast && curContrast < (contrast + 0.1)) {
	    counter = 0;
	    return color;
	  }
	  if (curContrast > contrast) {
	    if (direction === "end") {
	      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
	    } else {
	      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
	    }
	  } else if (curContrast < contrast) {
	    if (direction === "start") {
	      return contrastSearch(targetColor, compareColor, start, middle - 0.001, direction, contrast);
	    } else {
	      return contrastSearch(targetColor, compareColor, middle + 0.001, end, direction, contrast);
	    }
	  }
	};
	
	color = 'rgb(8, 27, 44)';
	
	targetColor = 'rgb(124, 171, 217)';
	
	color = 'red';
	
	targetColor = 'red';


/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the web browser implementation of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = __webpack_require__(279);
	exports.log = log;
	exports.formatArgs = formatArgs;
	exports.save = save;
	exports.load = load;
	exports.useColors = useColors;
	exports.storage = 'undefined' != typeof chrome
	               && 'undefined' != typeof chrome.storage
	                  ? chrome.storage.local
	                  : localstorage();
	
	/**
	 * Colors.
	 */
	
	exports.colors = [
	  'lightseagreen',
	  'forestgreen',
	  'goldenrod',
	  'dodgerblue',
	  'darkorchid',
	  'crimson'
	];
	
	/**
	 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	 * and the Firebug extension (any Firefox version) are known
	 * to support "%c" CSS customizations.
	 *
	 * TODO: add a `localStorage` variable to explicitly enable/disable colors
	 */
	
	function useColors() {
	  // is webkit? http://stackoverflow.com/a/16459606/376773
	  return ('WebkitAppearance' in document.documentElement.style) ||
	    // is firebug? http://stackoverflow.com/a/398120/376773
	    (window.console && (console.firebug || (console.exception && console.table))) ||
	    // is firefox >= v31?
	    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
	}
	
	/**
	 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	 */
	
	exports.formatters.j = function(v) {
	  return JSON.stringify(v);
	};
	
	
	/**
	 * Colorize log arguments if enabled.
	 *
	 * @api public
	 */
	
	function formatArgs() {
	  var args = arguments;
	  var useColors = this.useColors;
	
	  args[0] = (useColors ? '%c' : '')
	    + this.namespace
	    + (useColors ? ' %c' : ' ')
	    + args[0]
	    + (useColors ? '%c ' : ' ')
	    + '+' + exports.humanize(this.diff);
	
	  if (!useColors) return args;
	
	  var c = 'color: ' + this.color;
	  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	  // the final "%c" is somewhat tricky, because there could be other
	  // arguments passed either before or after the %c, so we need to
	  // figure out the correct index to insert the CSS into
	  var index = 0;
	  var lastC = 0;
	  args[0].replace(/%[a-z%]/g, function(match) {
	    if ('%%' === match) return;
	    index++;
	    if ('%c' === match) {
	      // we only are interested in the *last* %c
	      // (the user may have provided their own)
	      lastC = index;
	    }
	  });
	
	  args.splice(lastC, 0, c);
	  return args;
	}
	
	/**
	 * Invokes `console.log()` when available.
	 * No-op when `console.log` is not a "function".
	 *
	 * @api public
	 */
	
	function log() {
	  // this hackery is required for IE8/9, where
	  // the `console.log` function doesn't have 'apply'
	  return 'object' === typeof console
	    && console.log
	    && Function.prototype.apply.call(console.log, console, arguments);
	}
	
	/**
	 * Save `namespaces`.
	 *
	 * @param {String} namespaces
	 * @api private
	 */
	
	function save(namespaces) {
	  try {
	    if (null == namespaces) {
	      exports.storage.removeItem('debug');
	    } else {
	      exports.storage.debug = namespaces;
	    }
	  } catch(e) {}
	}
	
	/**
	 * Load `namespaces`.
	 *
	 * @return {String} returns the previously persisted debug modes
	 * @api private
	 */
	
	function load() {
	  var r;
	  try {
	    r = exports.storage.debug;
	  } catch(e) {}
	  return r;
	}
	
	/**
	 * Enable namespaces listed in `localStorage.debug` initially.
	 */
	
	exports.enable(load());
	
	/**
	 * Localstorage attempts to return the localstorage.
	 *
	 * This is necessary because safari throws
	 * when a user disables cookies/localstorage
	 * and you attempt to access it.
	 *
	 * @return {LocalStorage}
	 * @api private
	 */
	
	function localstorage(){
	  try {
	    return window.localStorage;
	  } catch (e) {}
	}


/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	
	/**
	 * This is the common logic for both the Node.js and web browser
	 * implementations of `debug()`.
	 *
	 * Expose `debug()` as the module.
	 */
	
	exports = module.exports = debug;
	exports.coerce = coerce;
	exports.disable = disable;
	exports.enable = enable;
	exports.enabled = enabled;
	exports.humanize = __webpack_require__(280);
	
	/**
	 * The currently active debug mode names, and names to skip.
	 */
	
	exports.names = [];
	exports.skips = [];
	
	/**
	 * Map of special "%n" handling functions, for the debug "format" argument.
	 *
	 * Valid key names are a single, lowercased letter, i.e. "n".
	 */
	
	exports.formatters = {};
	
	/**
	 * Previously assigned color.
	 */
	
	var prevColor = 0;
	
	/**
	 * Previous log timestamp.
	 */
	
	var prevTime;
	
	/**
	 * Select a color.
	 *
	 * @return {Number}
	 * @api private
	 */
	
	function selectColor() {
	  return exports.colors[prevColor++ % exports.colors.length];
	}
	
	/**
	 * Create a debugger with the given `namespace`.
	 *
	 * @param {String} namespace
	 * @return {Function}
	 * @api public
	 */
	
	function debug(namespace) {
	
	  // define the `disabled` version
	  function disabled() {
	  }
	  disabled.enabled = false;
	
	  // define the `enabled` version
	  function enabled() {
	
	    var self = enabled;
	
	    // set `diff` timestamp
	    var curr = +new Date();
	    var ms = curr - (prevTime || curr);
	    self.diff = ms;
	    self.prev = prevTime;
	    self.curr = curr;
	    prevTime = curr;
	
	    // add the `color` if not set
	    if (null == self.useColors) self.useColors = exports.useColors();
	    if (null == self.color && self.useColors) self.color = selectColor();
	
	    var args = Array.prototype.slice.call(arguments);
	
	    args[0] = exports.coerce(args[0]);
	
	    if ('string' !== typeof args[0]) {
	      // anything else let's inspect with %o
	      args = ['%o'].concat(args);
	    }
	
	    // apply any `formatters` transformations
	    var index = 0;
	    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
	      // if we encounter an escaped % then don't increase the array index
	      if (match === '%%') return match;
	      index++;
	      var formatter = exports.formatters[format];
	      if ('function' === typeof formatter) {
	        var val = args[index];
	        match = formatter.call(self, val);
	
	        // now we need to remove `args[index]` since it's inlined in the `format`
	        args.splice(index, 1);
	        index--;
	      }
	      return match;
	    });
	
	    if ('function' === typeof exports.formatArgs) {
	      args = exports.formatArgs.apply(self, args);
	    }
	    var logFn = enabled.log || exports.log || console.log.bind(console);
	    logFn.apply(self, args);
	  }
	  enabled.enabled = true;
	
	  var fn = exports.enabled(namespace) ? enabled : disabled;
	
	  fn.namespace = namespace;
	
	  return fn;
	}
	
	/**
	 * Enables a debug mode by namespaces. This can include modes
	 * separated by a colon and wildcards.
	 *
	 * @param {String} namespaces
	 * @api public
	 */
	
	function enable(namespaces) {
	  exports.save(namespaces);
	
	  var split = (namespaces || '').split(/[\s,]+/);
	  var len = split.length;
	
	  for (var i = 0; i < len; i++) {
	    if (!split[i]) continue; // ignore empty strings
	    namespaces = split[i].replace(/\*/g, '.*?');
	    if (namespaces[0] === '-') {
	      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	    } else {
	      exports.names.push(new RegExp('^' + namespaces + '$'));
	    }
	  }
	}
	
	/**
	 * Disable debug output.
	 *
	 * @api public
	 */
	
	function disable() {
	  exports.enable('');
	}
	
	/**
	 * Returns true if the given mode name is enabled, false otherwise.
	 *
	 * @param {String} name
	 * @return {Boolean}
	 * @api public
	 */
	
	function enabled(name) {
	  var i, len;
	  for (i = 0, len = exports.skips.length; i < len; i++) {
	    if (exports.skips[i].test(name)) {
	      return false;
	    }
	  }
	  for (i = 0, len = exports.names.length; i < len; i++) {
	    if (exports.names[i].test(name)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * Coerce `val`.
	 *
	 * @param {Mixed} val
	 * @return {Mixed}
	 * @api private
	 */
	
	function coerce(val) {
	  if (val instanceof Error) return val.stack || val.message;
	  return val;
	}


/***/ },
/* 280 */
/***/ function(module, exports) {

	/**
	 * Helpers.
	 */
	
	var s = 1000;
	var m = s * 60;
	var h = m * 60;
	var d = h * 24;
	var y = d * 365.25;
	
	/**
	 * Parse or format the given `val`.
	 *
	 * Options:
	 *
	 *  - `long` verbose formatting [false]
	 *
	 * @param {String|Number} val
	 * @param {Object} options
	 * @return {String|Number}
	 * @api public
	 */
	
	module.exports = function(val, options){
	  options = options || {};
	  if ('string' == typeof val) return parse(val);
	  return options.long
	    ? long(val)
	    : short(val);
	};
	
	/**
	 * Parse the given `str` and return milliseconds.
	 *
	 * @param {String} str
	 * @return {Number}
	 * @api private
	 */
	
	function parse(str) {
	  str = '' + str;
	  if (str.length > 10000) return;
	  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	  if (!match) return;
	  var n = parseFloat(match[1]);
	  var type = (match[2] || 'ms').toLowerCase();
	  switch (type) {
	    case 'years':
	    case 'year':
	    case 'yrs':
	    case 'yr':
	    case 'y':
	      return n * y;
	    case 'days':
	    case 'day':
	    case 'd':
	      return n * d;
	    case 'hours':
	    case 'hour':
	    case 'hrs':
	    case 'hr':
	    case 'h':
	      return n * h;
	    case 'minutes':
	    case 'minute':
	    case 'mins':
	    case 'min':
	    case 'm':
	      return n * m;
	    case 'seconds':
	    case 'second':
	    case 'secs':
	    case 'sec':
	    case 's':
	      return n * s;
	    case 'milliseconds':
	    case 'millisecond':
	    case 'msecs':
	    case 'msec':
	    case 'ms':
	      return n;
	  }
	}
	
	/**
	 * Short format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function short(ms) {
	  if (ms >= d) return Math.round(ms / d) + 'd';
	  if (ms >= h) return Math.round(ms / h) + 'h';
	  if (ms >= m) return Math.round(ms / m) + 'm';
	  if (ms >= s) return Math.round(ms / s) + 's';
	  return ms + 'ms';
	}
	
	/**
	 * Long format for `ms`.
	 *
	 * @param {Number} ms
	 * @return {String}
	 * @api private
	 */
	
	function long(ms) {
	  return plural(ms, d, 'day')
	    || plural(ms, h, 'hour')
	    || plural(ms, m, 'minute')
	    || plural(ms, s, 'second')
	    || ms + ' ms';
	}
	
	/**
	 * Pluralization helper.
	 */
	
	function plural(ms, n, name) {
	  if (ms < n) return;
	  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	  return Math.ceil(ms / n) + ' ' + name + 's';
	}


/***/ },
/* 281 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function isObject(x) {
		return typeof x === "object" && x !== null;
	};


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Enhancer = __webpack_require__(283);
	
	module.exports = function (ComposedComponent /*: constructor*/) {
	  return Enhancer(ComposedComponent);
	};
	module.exports.Plugins = __webpack_require__(291);
	module.exports.PrintStyleSheet = __webpack_require__(302);
	module.exports.Style = __webpack_require__(303);
	module.exports.getState = __webpack_require__(285);
	module.exports.keyframes = __webpack_require__(306);
	module.exports.__clearStateForTests = __webpack_require__(284).__clearStateForTests;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(2);
	
	var Component = _require.Component;
	
	var resolveStyles = __webpack_require__(284);
	var printStyles = __webpack_require__(301);
	
	var KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES = ['arguments', 'callee', 'caller', 'length', 'name', 'prototype', 'type'];
	
	var copyProperties = function copyProperties(source, target) {
	  Object.getOwnPropertyNames(source).forEach(function (key) {
	    if (KEYS_TO_IGNORE_WHEN_COPYING_PROPERTIES.indexOf(key) < 0 && !target.hasOwnProperty(key)) {
	      var descriptor = Object.getOwnPropertyDescriptor(source, key);
	      Object.defineProperty(target, key, descriptor);
	    }
	  });
	};
	
	var enhanceWithRadium = function enhanceWithRadium(configOrComposedComponent /*: constructor | Function | Object*/) /*: constructor*/ {
	  var config /*:: ?: Object*/ = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  if (typeof configOrComposedComponent !== 'function') {
	    var newConfig = _extends({}, config, configOrComposedComponent);
	    return function (configOrComponent) {
	      return enhanceWithRadium(configOrComponent, newConfig);
	    };
	  }
	
	  var component /*: Function*/ = configOrComposedComponent;
	  var ComposedComponent /*: constructor*/ = component;
	
	  // Handle stateless components
	
	  if (!ComposedComponent.render && !ComposedComponent.prototype.render) {
	    ComposedComponent = (function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).apply(this, arguments);
	      }
	
	      _createClass(_class, [{
	        key: 'render',
	        value: function render() {
	          return component(this.props);
	        }
	      }]);
	
	      return _class;
	    })(Component);
	    ComposedComponent.displayName = component.displayName || component.name;
	  }
	
	  var RadiumEnhancer = (function (_ComposedComponent) {
	    _inherits(RadiumEnhancer, _ComposedComponent);
	
	    function RadiumEnhancer() {
	      _classCallCheck(this, RadiumEnhancer);
	
	      _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'constructor', this).apply(this, arguments);
	
	      this.state = this.state || {};
	      this.state._radiumStyleState = {};
	      this._radiumIsMounted = true;
	
	      if (RadiumEnhancer.printStyleClass) {
	        this.printStyleClass = RadiumEnhancer.printStyleClass;
	      }
	    }
	
	    // Class inheritance uses Object.create and because of __proto__ issues
	    // with IE <10 any static properties of the superclass aren't inherited and
	    // so need to be manually populated.
	    // See http://babeljs.io/docs/advanced/caveats/#classes-10-and-below-
	
	    _createClass(RadiumEnhancer, [{
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if (_get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this)) {
	          _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        }
	
	        this._radiumIsMounted = false;
	
	        if (this._radiumMouseUpListener) {
	          this._radiumMouseUpListener.remove();
	        }
	
	        if (this._radiumMediaQueryListenersByQuery) {
	          Object.keys(this._radiumMediaQueryListenersByQuery).forEach(function (query) {
	            this._radiumMediaQueryListenersByQuery[query].remove();
	          }, this);
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var renderedElement = _get(Object.getPrototypeOf(RadiumEnhancer.prototype), 'render', this).call(this);
	        return resolveStyles(this, renderedElement, config);
	      }
	    }]);
	
	    return RadiumEnhancer;
	  })(ComposedComponent);
	
	  copyProperties(ComposedComponent, RadiumEnhancer);
	
	  if (false) {
	    // This also fixes React Hot Loader by exposing the original components top
	    // level prototype methods on the Radium enhanced prototype as discussed in
	    // https://github.com/FormidableLabs/radium/issues/219.
	    copyProperties(ComposedComponent.prototype, RadiumEnhancer.prototype);
	  }
	
	  RadiumEnhancer.displayName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
	
	  RadiumEnhancer.printStyleClass = printStyles.addPrintStyles(RadiumEnhancer);
	
	  return RadiumEnhancer;
	};
	
	module.exports = enhanceWithRadium;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {Config} from './config';*/
	
	var _getState = __webpack_require__(285);
	var getStateKey = __webpack_require__(286);
	var mergeStyles = __webpack_require__(287);
	var Plugins = __webpack_require__(291);
	
	var ExecutionEnvironment = __webpack_require__(296);
	var React = __webpack_require__(2);
	
	var DEFAULT_CONFIG = {
	  plugins: [Plugins.mergeStyleArray, Plugins.checkProps, Plugins.resolveMediaQueries, Plugins.resolveInteractionStyles, Plugins.prefix, Plugins.checkProps]
	};
	
	// Gross
	var globalState = {};
	
	// Declare early for recursive helpers.
	var resolveStyles = ((null /*: any*/) /*: (
	                                        component: any, // ReactComponent, flow+eslint complaining
	                                        renderedElement: any,
	                                        config: Config,
	                                        existingKeyMap?: {[key: string]: bool}
	                                      ) => any*/);
	
	var _resolveChildren = function _resolveChildren(_ref) {
	  var children = _ref.children;
	  var component = _ref.component;
	  var config = _ref.config;
	  var existingKeyMap = _ref.existingKeyMap;
	
	  if (!children) {
	    return children;
	  }
	
	  var childrenType = typeof children;
	
	  if (childrenType === 'string' || childrenType === 'number') {
	    // Don't do anything with a single primitive child
	    return children;
	  }
	
	  if (childrenType === 'function') {
	    // Wrap the function, resolving styles on the result
	    return function () {
	      var result = children.apply(this, arguments);
	      if (React.isValidElement(result)) {
	        return resolveStyles(component, result, config, existingKeyMap);
	      }
	      return result;
	    };
	  }
	
	  if (React.Children.count(children) === 1 && children.type) {
	    // If a React Element is an only child, don't wrap it in an array for
	    // React.Children.map() for React.Children.only() compatibility.
	    var onlyChild = React.Children.only(children);
	    return resolveStyles(component, onlyChild, config, existingKeyMap);
	  }
	
	  return React.Children.map(children, function (child) {
	    if (React.isValidElement(child)) {
	      return resolveStyles(component, child, config, existingKeyMap);
	    }
	
	    return child;
	  });
	};
	
	// Recurse over props, just like children
	var _resolveProps = function _resolveProps(_ref2) {
	  var component = _ref2.component;
	  var config = _ref2.config;
	  var existingKeyMap = _ref2.existingKeyMap;
	  var props = _ref2.props;
	
	  var newProps = props;
	
	  Object.keys(props).forEach(function (prop) {
	    // We already recurse over children above
	    if (prop === 'children') {
	      return;
	    }
	
	    var propValue = props[prop];
	    if (React.isValidElement(propValue)) {
	      newProps = _extends({}, newProps);
	      newProps[prop] = resolveStyles(component, propValue, config, existingKeyMap);
	    }
	  });
	
	  return newProps;
	};
	
	var _buildGetKey = function _buildGetKey(renderedElement, existingKeyMap) {
	  // We need a unique key to correlate state changes due to user interaction
	  // with the rendered element, so we know to apply the proper interactive
	  // styles.
	  var originalKey = typeof renderedElement.ref === 'string' ? renderedElement.ref : renderedElement.key;
	  var key = getStateKey(originalKey);
	
	  var alreadyGotKey = false;
	  var getKey = function getKey() {
	    if (alreadyGotKey) {
	      return key;
	    }
	
	    alreadyGotKey = true;
	
	    if (existingKeyMap[key]) {
	      throw new Error('Radium requires each element with interactive styles to have a unique ' + 'key, set using either the ref or key prop. ' + (originalKey ? 'Key "' + originalKey + '" is a duplicate.' : 'Multiple elements have no key specified.'));
	    }
	
	    existingKeyMap[key] = true;
	
	    return key;
	  };
	
	  return getKey;
	};
	
	var _setStyleState = function _setStyleState(component, key, stateKey, value) {
	  if (!component._radiumIsMounted) {
	    return;
	  }
	
	  var existing = component._lastRadiumState || component.state && component.state._radiumStyleState || {};
	
	  var state = { _radiumStyleState: _extends({}, existing) };
	  state._radiumStyleState[key] = _extends({}, state._radiumStyleState[key]);
	  state._radiumStyleState[key][stateKey] = value;
	
	  component._lastRadiumState = state._radiumStyleState;
	  component.setState(state);
	};
	
	var _runPlugins = function _runPlugins(_ref3) {
	  var component = _ref3.component;
	  var config = _ref3.config;
	  var existingKeyMap = _ref3.existingKeyMap;
	  var props = _ref3.props;
	  var renderedElement = _ref3.renderedElement;
	
	  // Don't run plugins if renderedElement is not a simple ReactDOMElement or has
	  // no style.
	  if (!React.isValidElement(renderedElement) || typeof renderedElement.type !== 'string' || !props.style) {
	    return props;
	  }
	
	  var newProps = props;
	
	  var plugins = config.plugins || DEFAULT_CONFIG.plugins;
	
	  var getKey = _buildGetKey(renderedElement, existingKeyMap);
	
	  var newStyle = props.style;
	  plugins.forEach(function (plugin) {
	    var result = plugin({
	      ExecutionEnvironment: ExecutionEnvironment,
	      componentName: component.constructor.displayName || component.constructor.name,
	      config: config,
	      getComponentField: function getComponentField(key) {
	        return component[key];
	      },
	      getGlobalState: function getGlobalState(key) {
	        return globalState[key];
	      },
	      getState: function getState(stateKey, elementKey) {
	        return _getState(component.state, elementKey || getKey(), stateKey);
	      },
	      mergeStyles: mergeStyles,
	      props: newProps,
	      setState: function setState(stateKey, value, elementKey) {
	        return _setStyleState(component, elementKey || getKey(), stateKey, value);
	      },
	      style: newStyle
	    }) || {};
	
	    newStyle = result.style || newStyle;
	
	    newProps = result.props && Object.keys(result.props).length ? _extends({}, newProps, result.props) : newProps;
	
	    var newComponentFields = result.componentFields || {};
	    Object.keys(newComponentFields).forEach(function (fieldName) {
	      component[fieldName] = newComponentFields[fieldName];
	    });
	
	    var newGlobalState = result.globalState || {};
	    Object.keys(newGlobalState).forEach(function (key) {
	      globalState[key] = newGlobalState[key];
	    });
	  });
	
	  if (newStyle !== props.style) {
	    newProps = _extends({}, newProps, { style: newStyle });
	  }
	
	  return newProps;
	};
	
	// Wrapper around React.cloneElement. To avoid processing the same element
	// twice, whenever we clone an element add a special prop to make sure we don't
	// process this element again.
	var _cloneElement = function _cloneElement(renderedElement, newProps, newChildren) {
	  // Only add flag if this is a normal DOM element
	  if (typeof renderedElement.type === 'string') {
	    newProps = _extends({}, newProps, { _radiumDidResolveStyles: true });
	  }
	
	  return React.cloneElement(renderedElement, newProps, newChildren);
	};
	
	//
	// The nucleus of Radium. resolveStyles is called on the rendered elements
	// before they are returned in render. It iterates over the elements and
	// children, rewriting props to add event handlers required to capture user
	// interactions (e.g. mouse over). It also replaces the style prop because it
	// adds in the various interaction styles (e.g. :hover).
	//
	resolveStyles = function (component /*: any*/, // ReactComponent, flow+eslint complaining
	renderedElement /*: any*/, // ReactElement
	config /*: Config*/, existingKeyMap /*:: ?: {[key: string]: boolean}*/) /*: any*/ {
	  if (config === undefined) config = DEFAULT_CONFIG;
	  // ReactElement
	  existingKeyMap = existingKeyMap || {};
	
	  if (!renderedElement ||
	  // Bail if we've already processed this element. This ensures that only the
	  // owner of an element processes that element, since the owner's render
	  // function will be called first (which will always be the case, since you
	  // can't know what else to render until you render the parent component).
	  renderedElement.props && renderedElement.props._radiumDidResolveStyles) {
	    return renderedElement;
	  }
	
	  var newChildren = _resolveChildren({
	    children: renderedElement.props.children,
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap
	  });
	
	  var newProps = _resolveProps({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: renderedElement.props
	  });
	
	  newProps = _runPlugins({
	    component: component,
	    config: config,
	    existingKeyMap: existingKeyMap,
	    props: newProps,
	    renderedElement: renderedElement
	  });
	
	  // If nothing changed, don't bother cloning the element. Might be a bit
	  // wasteful, as we add the sentinal to stop double-processing when we clone.
	  // Assume benign double-processing is better than unneeded cloning.
	  if (newChildren === renderedElement.props.children && newProps === renderedElement.props) {
	    return renderedElement;
	  }
	
	  return _cloneElement(renderedElement, newProps !== renderedElement.props ? newProps : {}, newChildren);
	};
	
	// Only for use by tests
	resolveStyles.__clearStateForTests = function () {
	  globalState = {};
	};
	
	module.exports = resolveStyles;
	// ReactComponent, flow+eslint complaining

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var getStateKey = __webpack_require__(286);
	
	var getState = function getState(state /*: {_radiumStyleState: {[key: string]: {[value: string]: boolean}}}*/, elementKey /*: string*/, value /*: string*/) /*: any*/ {
	  var key = getStateKey(elementKey);
	
	  return !!state && !!state._radiumStyleState && !!state._radiumStyleState[key] && state._radiumStyleState[key][value];
	};
	
	module.exports = getState;

/***/ },
/* 286 */
/***/ function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var getStateKey = function getStateKey(elementKey /*: ?string*/) /*: string*/ {
	  return elementKey === null || elementKey === undefined ? 'main' : elementKey.toString();
	};
	
	module.exports = getStateKey;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isPlainObject = __webpack_require__(288);
	
	var shouldMerge = function shouldMerge(value) {
	  // Don't merge objects overriding toString, since they should be converted
	  // to string values.
	  return isPlainObject(value) && value.toString === Object.prototype.toString;
	};
	
	// Merge style objects. Deep merge plain object values.
	var mergeStyles = function mergeStyles(styles) {
	  var result = {};
	
	  styles.forEach(function (style) {
	    if (!style || typeof style !== 'object') {
	      return;
	    }
	
	    if (Array.isArray(style)) {
	      style = mergeStyles(style);
	    }
	
	    Object.keys(style).forEach(function (key) {
	      if (shouldMerge(style[key]) && shouldMerge(result[key])) {
	        result[key] = mergeStyles([result[key], style[key]]);
	      } else {
	        result[key] = style[key];
	      }
	    });
	  });
	
	  return result;
	};
	
	module.exports = mergeStyles;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isObject = __webpack_require__(289);
	
	function isObjectObject(o) {
	  return isObject(o) === true
	    && Object.prototype.toString.call(o) === '[object Object]';
	}
	
	module.exports = function isPlainObject(o) {
	  var ctor,prot;
	  
	  if (isObjectObject(o) === false) return false;
	  
	  // If has modified constructor
	  ctor = o.constructor;
	  if (typeof ctor !== 'function') return false;
	  
	  // If has modified prototype
	  prot = ctor.prototype;
	  if (isObjectObject(prot) === false) return false;
	  
	  // If constructor does not have an Object-specific method
	  if (prot.hasOwnProperty('isPrototypeOf') === false) {
	    return false;
	  }
	  
	  // Most likely a plain Object
	  return true;
	};


/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * isobject <https://github.com/jonschlinkert/isobject>
	 *
	 * Copyright (c) 2014-2015, Jon Schlinkert.
	 * Licensed under the MIT License.
	 */
	
	'use strict';
	
	var isArray = __webpack_require__(290);
	
	module.exports = function isObject(o) {
	  return o != null && typeof o === 'object' && !isArray(o);
	};


/***/ },
/* 290 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	/** @flow */
	/* eslint-disable block-scoped-var */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	/*:: import type {Config} from '../config';*/
	
	var checkPropsPlugin = __webpack_require__(292);
	var mergeStyleArrayPlugin = __webpack_require__(293);
	var prefixPlugin = __webpack_require__(294);
	var resolveInteractionStylesPlugin = __webpack_require__(298);
	var resolveMediaQueriesPlugin = __webpack_require__(300);
	
	/*:: export type PluginConfig = {
	  // May not be readable if code has been minified
	  componentName: string,
	
	  // The Radium configuration
	  config: Config,
	
	  // Retrieve the value of a field on the component
	  getComponentField: (key: string) => any,
	
	  // Retrieve the value of a field global to the Radium module
	  // Used so that tests can easily clear global state.
	  getGlobalState: (key: string) => any,
	
	  // Retrieve the value of some state specific to the rendered element.
	  // Requires the element to have a unique key or ref or for an element key
	  // to be passed in.
	  getState: (stateKey: string, elementKey?: string) => any,
	
	  // Access to the mergeStyles utility
	  mergeStyles: (styles: Array<Object>) => Object,
	
	  // The props of the rendered element. This can be changed by each plugin,
	  // and successive plugins will see the result of previous plugins.
	  props: Object,
	
	  // Calls setState on the component with the given key and value.
	  // By default this is specific to the rendered element, but you can override
	  // by passing in the `elementKey` parameter.
	  setState: (stateKey: string, value: any, elementKey?: string) => void,
	
	  // The style prop of the rendered element. This can be changed by each plugin,
	  // and successive plugins will see the result of previous plugins. Kept
	  // separate from `props` for ease of use.
	  style: Object,
	
	  // uses the exenv npm module
	  ExecutionEnvironment: {
	    canUseEventListeners: bool,
	    canUseDOM: bool,
	  }
	};*/
	/*:: export type PluginResult = ?{
	  // Merged into the component directly. Useful for storing things for which you
	  // don't need to re-render, event subscriptions, for instance.
	  componentFields?: Object,
	
	  // Merged into a Radium controlled global state object. Use this instead of
	  // module level state for ease of clearing state between tests.
	  globalState?: Object,
	
	  // Merged into the rendered element's props.
	  props?: Object,
	
	  // Replaces (not merged into) the rendered element's style property.
	  style?: Object,
	};*/
	
	module.exports = {
	  checkProps: checkPropsPlugin,
	  mergeStyleArray: mergeStyleArrayPlugin,
	  prefix: prefixPlugin,
	  resolveInteractionStyles: resolveInteractionStylesPlugin,
	  resolveMediaQueries: resolveMediaQueriesPlugin
	};
	
	// May not be readable if code has been minified
	
	// The Radium configuration
	
	// Retrieve the value of a field on the component
	
	// Retrieve the value of a field global to the Radium module
	// Used so that tests can easily clear global state.
	
	// Retrieve the value of some state specific to the rendered element.
	// Requires the element to have a unique key or ref or for an element key
	// to be passed in.
	
	// Access to the mergeStyles utility
	
	// The props of the rendered element. This can be changed by each plugin,
	// and successive plugins will see the result of previous plugins.
	
	// Calls setState on the component with the given key and value.
	// By default this is specific to the rendered element, but you can override
	// by passing in the `elementKey` parameter.
	
	// The style prop of the rendered element. This can be changed by each plugin,
	// and successive plugins will see the result of previous plugins. Kept
	// separate from `props` for ease of use.
	
	// uses the exenv npm module
	
	// Merged into the component directly. Useful for storing things for which you
	// don't need to re-render, event subscriptions, for instance.
	
	// Merged into a Radium controlled global state object. Use this instead of
	// module level state for ease of clearing state between tests.
	
	// Merged into the rendered element's props.
	
	// Replaces (not merged into) the rendered element's style property.

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var checkProps = (function () {} /*: any*/);
	
	if (false) {
	  // Warn if you use longhand and shorthand properties in the same style
	  // object.
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/Shorthand_properties
	
	  var shorthandPropertyExpansions = {
	    'background': ['backgroundAttachment', 'backgroundBlendMode', 'backgroundClip', 'backgroundColor', 'backgroundImage', 'backgroundOrigin', 'backgroundPosition', 'backgroundPositionX', 'backgroundPositionY', 'backgroundRepeat', 'backgroundRepeatX', 'backgroundRepeatY', 'backgroundSize'],
	    'border': ['borderBottom', 'borderBottomColor', 'borderBottomStyle', 'borderBottomWidth', 'borderColor', 'borderLeft', 'borderLeftColor', 'borderLeftStyle', 'borderLeftWidth', 'borderRight', 'borderRightColor', 'borderRightStyle', 'borderRightWidth', 'borderStyle', 'borderTop', 'borderTopColor', 'borderTopStyle', 'borderTopWidth', 'borderWidth'],
	    'borderImage': ['borderImageOutset', 'borderImageRepeat', 'borderImageSlice', 'borderImageSource', 'borderImageWidth'],
	    'borderRadius': ['borderBottomLeftRadius', 'borderBottomRightRadius', 'borderTopLeftRadius', 'borderTopRightRadius'],
	    'font': ['fontFamily', 'fontKerning', 'fontSize', 'fontStretch', 'fontStyle', 'fontVariant', 'fontVariantLigatures', 'fontWeight', 'lineHeight'],
	    'listStyle': ['listStyleImage', 'listStylePosition', 'listStyleType'],
	    'margin': ['marginBottom', 'marginLeft', 'marginRight', 'marginTop'],
	    'padding': ['paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop'],
	    'transition': ['transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction']
	  };
	
	  checkProps = function (config /*: PluginConfig*/) /*: PluginResult*/ {
	    var componentName = config.componentName;
	    var style = config.style;
	
	    if (typeof style !== 'object' || !style) {
	      return;
	    }
	
	    var styleKeys = Object.keys(style);
	    styleKeys.forEach(function (styleKey) {
	      if (shorthandPropertyExpansions[styleKey] && shorthandPropertyExpansions[styleKey].some(function (sp) {
	        return styleKeys.indexOf(sp) !== -1;
	      })) {
	        if (process.env.NODE_ENV !== 'production') {
	          /* eslint-disable no-console */
	          console.warn('Radium: property "' + styleKey + '" in style object', style, ': do not mix longhand and ' + 'shorthand properties in the same style object. Check the render ' + 'method of ' + componentName + '.', 'See https://github.com/FormidableLabs/radium/issues/95 for more ' + 'information.');
	          /* eslint-enable no-console */
	        }
	      }
	    });
	
	    styleKeys.forEach(function (k) {
	      return checkProps(_extends({}, config, { style: style[k] }));
	    });
	    return;
	  };
	}
	
	module.exports = checkProps;

/***/ },
/* 293 */
/***/ function(module, exports) {

	/* @flow */
	
	'use strict';
	
	// Convenient syntax for multiple styles: `style={[style1, style2, etc]}`
	// Ignores non-objects, so you can do `this.state.isCool && styles.cool`.
	/*:: import type {PluginConfig, PluginResult} from '.';*/var mergeStyleArrayPlugin = function mergeStyleArrayPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var style = _ref.style;
	  var mergeStyles = _ref.mergeStyles;
	
	  var newStyle = Array.isArray(style) ? mergeStyles(style) : style;
	  return { style: newStyle };
	};
	
	module.exports = mergeStyleArrayPlugin;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var Prefixer = __webpack_require__(295);
	
	var prefixPlugin = function prefixPlugin(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var componentName = _ref.componentName;
	  var style = _ref.style;
	
	  var newStyle = Prefixer.getPrefixedStyle(style, componentName);
	  return { style: newStyle };
	};
	
	module.exports = prefixPlugin;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Based on https://github.com/jsstyles/css-vendor, but without having to
	 * convert between different cases all the time.
	 *
	 * @flow
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(296);
	var arrayFind = __webpack_require__(297);
	
	var VENDOR_PREFIX_REGEX = /-(moz|webkit|ms|o)-/;
	
	var vendorPrefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	var infoByCssPrefix = {
	  '-moz-': {
	    cssPrefix: '-moz-',
	    jsPrefix: 'Moz',
	    alternativeProperties: {
	      // OLD - Firefox 19-
	      alignItems: ['MozBoxAlign'],
	      flex: ['MozBoxFlex'],
	      flexDirection: ['MozBoxOrient'],
	      justifyContent: ['MozBoxPack'],
	      order: ['MozBoxOrdinalGroup']
	    },
	    alternativeValues: {
	      // OLD - Firefox 19-
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-moz-box']
	      },
	      flexDirection: {
	        column: ['vertical'],
	        row: ['horizontal']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  },
	  '-ms-': {
	    cssPrefix: '-ms-',
	    jsPrefix: 'ms',
	    alternativeProperties: {
	      // TWEENER - IE 10
	      alignContent: ['msFlexLinePack'],
	      alignItems: ['msFlexAlign'],
	      alignSelf: ['msFlexAlignItem'],
	      justifyContent: ['msFlexPack'],
	      order: ['msFlexOrder']
	    },
	    alternativeValues: {
	      // TWEENER - IE 10
	      alignContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      },
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      alignSelf: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-ms-flexbox'],
	        'inline-flex': ['-ms-inline-flexbox']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify'],
	        'space-around': ['distribute']
	      }
	    }
	  },
	  '-o-': {
	    cssPrefix: '-o-',
	    jsPrefix: 'O'
	  },
	  '-webkit-': {
	    cssPrefix: '-webkit-',
	    jsPrefix: 'Webkit',
	    alternativeProperties: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: ['WebkitBoxAlign'],
	      flex: ['MozBoxFlex'],
	      flexDirection: ['WebkitBoxOrient'],
	      justifyContent: ['WebkitBoxPack'],
	      order: ['WebkitBoxOrdinalGroup']
	    },
	    alternativeValues: {
	      // OLD - iOS 6-, Safari 3.1-6
	      alignItems: {
	        'flex-start': ['start'],
	        'flex-end': ['end']
	      },
	      display: {
	        flex: ['-webkit-box']
	      },
	      flexDirection: {
	        row: ['horizontal'],
	        column: ['vertical']
	      },
	      justifyContent: {
	        'flex-start': ['start'],
	        'flex-end': ['end'],
	        'space-between': ['justify']
	      }
	    }
	  }
	};
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 * Copied from React core June 22, 2015.
	 * https://github.com/facebook/react/blob/
	 * ba81b60ad8e93b747be42a03b797065932c49c96/
	 * src/renderers/dom/shared/CSSProperty.js
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	var domStyle = {};
	var prefixedPropertyCache = {};
	var prefixedValueCache = {};
	var prefixInfo = {
	  cssPrefix: '',
	  jsPrefix: ''
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  domStyle = (document /*: any*/).createElement('p').style;
	
	  // older Firefox versions may have no float property in style object
	  // so we need to add it manually
	  if (domStyle.float === undefined) {
	    domStyle.float = '';
	  }
	
	  // Based on http://davidwalsh.name/vendor-prefix
	  var prefixMatch;
	  var windowStyles = window.getComputedStyle(document.documentElement, '');
	
	  // Array.prototype.slice.call(windowStyles) fails with
	  // "Uncaught TypeError: undefined is not a function"
	  // in older versions Android (KitKat) web views
	  for (var i = 0; i < windowStyles.length; i++) {
	    prefixMatch = windowStyles[i].match(VENDOR_PREFIX_REGEX);
	
	    if (prefixMatch) {
	      break;
	    }
	  }
	
	  var cssVendorPrefix = prefixMatch && prefixMatch[0];
	
	  prefixInfo = cssVendorPrefix && infoByCssPrefix[cssVendorPrefix] ? infoByCssPrefix[cssVendorPrefix] : prefixInfo;
	}
	
	var getPrefixedPropertyName = function getPrefixedPropertyName(property /*: string*/) /*: string*/ {
	  if (prefixedPropertyCache.hasOwnProperty(property)) {
	    return prefixedPropertyCache[property];
	  }
	
	  var unprefixed = property;
	
	  // Try the prefixed version first. Chrome in particular has the `filter` and
	  // `webkitFilter` properties availalbe on the style object, but only the
	  // prefixed version actually works.
	  var possiblePropertyNames = [
	  // Prefixed
	  prefixInfo.jsPrefix + property[0].toUpperCase() + property.slice(1), unprefixed];
	
	  // Alternative property names
	  if (prefixInfo.alternativeProperties && prefixInfo.alternativeProperties[property]) {
	    possiblePropertyNames = possiblePropertyNames.concat(prefixInfo.alternativeProperties[property]);
	  }
	
	  var workingProperty = arrayFind(possiblePropertyNames, function (possiblePropertyName) {
	    if (possiblePropertyName in domStyle) {
	      return possiblePropertyName;
	    }
	  }) || false;
	
	  prefixedPropertyCache[property] = workingProperty;
	
	  return prefixedPropertyCache[property];
	};
	
	// We are un-prefixing values before checking for isUnitlessNumber,
	// otherwise we are at risk of being in a situation where someone
	// explicitly passes something like `MozBoxFlex: 1` and that will
	// in turn get transformed into `MozBoxFlex: 1px`.
	var _getUnprefixedProperty = function _getUnprefixedProperty(property) {
	  var noPrefixProperty = property;
	
	  vendorPrefixes.some(function (prefix) {
	    // Let's check if the property starts with a vendor prefix
	    if (property.indexOf(prefix) === 0) {
	      noPrefixProperty = noPrefixProperty.replace(prefix, '');
	
	      // We have removed the vendor prefix, however the first
	      // character is going to be uppercase hence won't match
	      // any of the `isUnitlessNumber` keys as they all start
	      // with lower case. Let's ensure that the first char is
	      // lower case.
	      noPrefixProperty = noPrefixProperty.charAt(0).toLowerCase() + noPrefixProperty.slice(1);
	
	      return true;
	    }
	  });
	
	  return noPrefixProperty;
	};
	
	// React is planning to deprecate adding px automatically
	// (https://github.com/facebook/react/issues/1873), and if they do, this
	// should change to a warning or be removed in favor of React's warning.
	// Same goes for below.
	var _addPixelSuffixToValueIfNeeded = function _addPixelSuffixToValueIfNeeded(originalProperty, value) {
	  var unPrefixedProperty = _getUnprefixedProperty(originalProperty);
	
	  if (value !== 0 && !isNaN(value) && !isUnitlessNumber[unPrefixedProperty]) {
	    return value + 'px';
	  }
	  return value;
	};
	
	var _getPrefixedValue = function _getPrefixedValue(componentName, property, value, originalProperty) {
	  if (!Array.isArray(value)) {
	    // don't test numbers (pure or stringy), but do add 'px' prefix if needed
	    if (!isNaN(value) && value !== null) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, value);
	    }
	
	    if (typeof value !== 'string') {
	      if (value !== null && value !== undefined) {
	        value = value.toString();
	      } else {
	        return value;
	      }
	    }
	
	    // don't test numbers with units (e.g. 10em)
	    if (!isNaN(parseInt(value, 10))) {
	      return value;
	    }
	  }
	
	  var cacheKey = Array.isArray(value) ? value.join(' || ') : property + value;
	
	  if (prefixedValueCache.hasOwnProperty(cacheKey)) {
	    return prefixedValueCache[cacheKey];
	  }
	
	  var possibleValues;
	  if (Array.isArray(value)) {
	    // Add px for the same values React would, otherwise the testing below will
	    // fail and it will try to fallback.
	    possibleValues = value.map(function (v) {
	      return _addPixelSuffixToValueIfNeeded(originalProperty, v);
	    });
	
	    // Add prefixed versions
	    possibleValues = possibleValues.concat(value.filter(function (v) {
	      return !isNaN(v);
	    }) // Don't prefix numbers
	    .map(function (v) {
	      return prefixInfo.cssPrefix + v;
	    }));
	  } else {
	    possibleValues = [
	    // Unprefixed
	    value,
	    // Prefixed
	    prefixInfo.cssPrefix + value];
	  }
	
	  // Alternative values
	  if (prefixInfo.alternativeValues && prefixInfo.alternativeValues[originalProperty] && prefixInfo.alternativeValues[originalProperty][value]) {
	    possibleValues = possibleValues.concat(prefixInfo.alternativeValues[originalProperty][value]);
	  }
	
	  // Test possible value in order
	  var workingValue = arrayFind(possibleValues, function (possibleValue) {
	    domStyle[property] = '';
	    domStyle[property] = possibleValue;
	
	    // Note that we just make sure it is not an empty string. Browsers will
	    // sometimes rewrite values, but still accept them. They will set the value
	    // to an empty string if not supported.
	    // E.g. for border, "solid 1px black" becomes "1px solid black"
	    //      but "foobar" becomes "", since it is not supported.
	    return !!domStyle[property];
	  });
	
	  if (workingValue) {
	    prefixedValueCache[cacheKey] = workingValue;
	  } else {
	    // Unsupported, assume unprefixed works, but warn
	    prefixedValueCache[cacheKey] = value;
	
	    if (false) {
	      /* eslint-disable no-console */
	      if (console && console.warn) {
	        var componentContext = componentName ? ' in component "' + componentName + '"' : '';
	
	        console.warn('Unsupported CSS value "' + value + '" for property "' + property + '"' + componentContext);
	      }
	      /* eslint-enable no-console */
	    }
	  }
	
	  return prefixedValueCache[cacheKey];
	};
	
	// Returns a new style object with vendor prefixes added to property names
	// and values.
	var getPrefixedStyle = function getPrefixedStyle(style /*: Object*/, componentName /*: ?string*/) /*: Object*/ {
	  if (!ExecutionEnvironment.canUseDOM) {
	    return Object.keys(style).reduce(function (newStyle, key) {
	      var value = style[key];
	      var newValue = Array.isArray(value) ? value[0] : value;
	      newStyle[key] = newValue;
	      return newStyle;
	    }, {});
	  }
	
	  var prefixedStyle = {};
	  Object.keys(style).forEach(function (property) {
	    var value = style[property];
	
	    var newProperty = getPrefixedPropertyName(property);
	    if (!newProperty) {
	      // Ignore unsupported properties
	      if (false) {
	        /* eslint-disable no-console */
	        if (console && console.warn) {
	          var componentContext = componentName ? ' in component "' + componentName + '"' : '';
	
	          console.warn('Unsupported CSS property "' + property + '"' + componentContext);
	        }
	        /* eslint-enable no-console */
	        return;
	      }
	    }
	
	    var newValue = _getPrefixedValue(componentName, newProperty, value, property);
	
	    prefixedStyle[newProperty] = newValue;
	  });
	  return prefixedStyle;
	};
	
	module.exports = {
	  getPrefixedStyle: getPrefixedStyle,
	  cssPrefix: prefixInfo.cssPrefix,
	  jsPrefix: prefixInfo.jsPrefix
	};

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 297 */
/***/ function(module, exports) {

	'use strict';
	
	function find(array, predicate, context) {
	  if (typeof Array.prototype.find === 'function') {
	    return array.find(predicate, context);
	  }
	
	  context = context || this;
	  var length = array.length;
	  var i;
	
	  if (typeof predicate !== 'function') {
	    throw new TypeError(predicate + ' is not a function');
	  }
	
	  for (i = 0; i < length; i++) {
	    if (predicate.call(context, array[i], i, array)) {
	      return array[i];
	    }
	  }
	}
	
	module.exports = find;


/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/** @flow */
	
	'use strict';
	
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var MouseUpListener = __webpack_require__(299);
	
	var _isInteractiveStyleField = function _isInteractiveStyleField(styleFieldName) {
	  return styleFieldName === ':hover' || styleFieldName === ':active' || styleFieldName === ':focus';
	};
	
	var resolveInteractionStyles = function resolveInteractionStyles(config /*: PluginConfig*/) /*: PluginResult*/ {
	  var ExecutionEnvironment = config.ExecutionEnvironment;
	  var getComponentField = config.getComponentField;
	  var getState = config.getState;
	  var mergeStyles = config.mergeStyles;
	  var props = config.props;
	  var setState = config.setState;
	  var style = config.style;
	
	  var newComponentFields = {};
	  var newProps = {};
	
	  // Only add handlers if necessary
	  if (style[':hover']) {
	    // Always call the existing handler if one is already defined.
	    // This code, and the very similar ones below, could be abstracted a bit
	    // more, but it hurts readability IMO.
	    var existingOnMouseEnter = props.onMouseEnter;
	    newProps.onMouseEnter = function (e) {
	      existingOnMouseEnter && existingOnMouseEnter(e);
	      setState(':hover', true);
	    };
	
	    var existingOnMouseLeave = props.onMouseLeave;
	    newProps.onMouseLeave = function (e) {
	      existingOnMouseLeave && existingOnMouseLeave(e);
	      setState(':hover', false);
	    };
	  }
	
	  if (style[':active']) {
	    var existingOnMouseDown = props.onMouseDown;
	    newProps.onMouseDown = function (e) {
	      existingOnMouseDown && existingOnMouseDown(e);
	      newComponentFields._lastMouseDown = Date.now();
	      setState(':active', 'viamousedown');
	    };
	
	    var existingOnKeyDown = props.onKeyDown;
	    newProps.onKeyDown = function (e) {
	      existingOnKeyDown && existingOnKeyDown(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', 'viakeydown');
	      }
	    };
	
	    var existingOnKeyUp = props.onKeyUp;
	    newProps.onKeyUp = function (e) {
	      existingOnKeyUp && existingOnKeyUp(e);
	      if (e.key === ' ' || e.key === 'Enter') {
	        setState(':active', false);
	      }
	    };
	  }
	
	  if (style[':focus']) {
	    var existingOnFocus = props.onFocus;
	    newProps.onFocus = function (e) {
	      existingOnFocus && existingOnFocus(e);
	      setState(':focus', true);
	    };
	
	    var existingOnBlur = props.onBlur;
	    newProps.onBlur = function (e) {
	      existingOnBlur && existingOnBlur(e);
	      setState(':focus', false);
	    };
	  }
	
	  if (style[':active'] && !getComponentField('_radiumMouseUpListener') && ExecutionEnvironment.canUseEventListeners) {
	    newComponentFields._radiumMouseUpListener = MouseUpListener.subscribe(function () {
	      Object.keys(getComponentField('state')._radiumStyleState).forEach(function (key) {
	        if (getState(':active') === 'viamousedown') {
	          setState(':active', false, key);
	        }
	      });
	    });
	  }
	
	  // Merge the styles in the order they were defined
	  var interactionStyles = Object.keys(style).filter(function (name) {
	    return _isInteractiveStyleField(name) && getState(name);
	  }).map(function (name) {
	    return style[name];
	  });
	
	  var newStyle = mergeStyles([style].concat(interactionStyles));
	
	  // Remove interactive styles
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutInteractions, name) {
	    if (!_isInteractiveStyleField(name)) {
	      styleWithoutInteractions[name] = newStyle[name];
	    }
	    return styleWithoutInteractions;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    props: newProps,
	    style: newStyle
	  };
	};
	
	module.exports = resolveInteractionStyles;

/***/ },
/* 299 */
/***/ function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var _callbacks = [];
	var _mouseUpListenerIsActive = false;
	
	var _handleMouseUp = function _handleMouseUp(ev) {
	  _callbacks.forEach(function (callback) {
	    callback(ev);
	  });
	};
	
	var subscribe = function subscribe(callback /*: () => void*/) /*: {remove: () => void}*/ {
	  if (_callbacks.indexOf(callback) === -1) {
	    _callbacks.push(callback);
	  }
	
	  if (!_mouseUpListenerIsActive) {
	    window.addEventListener('mouseup', _handleMouseUp);
	    _mouseUpListenerIsActive = true;
	  }
	
	  return {
	    remove: function remove() {
	      var index = _callbacks.indexOf(callback);
	      _callbacks.splice(index, 1);
	
	      if (_callbacks.length === 0 && _mouseUpListenerIsActive) {
	        window.removeEventListener('mouseup', _handleMouseUp);
	        _mouseUpListenerIsActive = false;
	      }
	    }
	  };
	};
	
	module.exports = {
	  subscribe: subscribe
	};

/***/ },
/* 300 */
/***/ function(module, exports) {

	/** @flow */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/*:: import type {MatchMediaType} from '../config';*/
	/*:: import type {PluginConfig, PluginResult} from '.';*/
	
	var _windowMatchMedia;
	var _getWindowMatchMedia = function _getWindowMatchMedia(ExecutionEnvironment) {
	  if (_windowMatchMedia === undefined) {
	    _windowMatchMedia = !!ExecutionEnvironment.canUseDOM && !!window && !!window.matchMedia && function (mediaQueryString) {
	      return window.matchMedia(mediaQueryString);
	    } || null;
	  }
	  return _windowMatchMedia;
	};
	
	var resolveMediaQueries = function resolveMediaQueries(_ref /*: PluginConfig*/) /*: PluginResult*/ {
	  var ExecutionEnvironment = _ref.ExecutionEnvironment;
	  var getComponentField = _ref.getComponentField;
	  var getGlobalState = _ref.getGlobalState;
	  var config = _ref.config;
	  var mergeStyles = _ref.mergeStyles;
	  var setState = _ref.setState;
	  var style = _ref.style;
	
	  var newComponentFields = {};
	  var newStyle = style;
	  var matchMedia /*: ?MatchMediaType*/ = config.matchMedia || _getWindowMatchMedia(ExecutionEnvironment);
	  if (!matchMedia) {
	    return newStyle;
	  }
	
	  var mediaQueryListByQueryString = getGlobalState('mediaQueryListByQueryString') || {};
	
	  Object.keys(style).filter(function (name) {
	    return name.indexOf('@media') === 0;
	  }).map(function (query) {
	    var mediaQueryStyles = style[query];
	    query = query.replace('@media ', '');
	
	    // Create a global MediaQueryList if one doesn't already exist
	    var mql = mediaQueryListByQueryString[query];
	    if (!mql && matchMedia) {
	      mediaQueryListByQueryString[query] = mql = matchMedia(query);
	    }
	
	    var listenersByQuery = getComponentField('_radiumMediaQueryListenersByQuery');
	
	    if (!listenersByQuery || !listenersByQuery[query]) {
	      var listener = function listener() {
	        return setState(query, mql.matches, '_all');
	      };
	      mql.addListener(listener);
	      newComponentFields._radiumMediaQueryListenersByQuery = _extends({}, listenersByQuery);
	      newComponentFields._radiumMediaQueryListenersByQuery[query] = {
	        remove: function remove() {
	          mql.removeListener(listener);
	        }
	      };
	    }
	
	    // Apply media query states
	    if (mql.matches) {
	      newStyle = mergeStyles([newStyle, mediaQueryStyles]);
	    }
	  });
	
	  // Remove media queries
	  newStyle = Object.keys(newStyle).reduce(function (styleWithoutMedia, key) {
	    if (key.indexOf('@media') !== 0) {
	      styleWithoutMedia[key] = newStyle[key];
	    }
	    return styleWithoutMedia;
	  }, {});
	
	  return {
	    componentFields: newComponentFields,
	    globalState: { mediaQueryListByQueryString: mediaQueryListByQueryString },
	    style: newStyle
	  };
	};
	
	module.exports = resolveMediaQueries;

/***/ },
/* 301 */
/***/ function(module, exports) {

	/* @flow */
	
	"use strict";
	
	var allPrintStyles = {};
	var listeners = [];
	
	var subscribe = function subscribe(listener /*: () => void*/) /*: {remove: () => void}*/ {
	  if (listeners.indexOf(listener) === -1) {
	    listeners.push(listener);
	  }
	
	  return {
	    remove: function remove() {
	      var listenerIndex = listeners.indexOf(listener);
	
	      if (listenerIndex > -1) {
	        listeners.splice(listenerIndex, 1);
	      }
	    }
	  };
	};
	
	var _emitChange = function _emitChange() {
	  listeners.forEach(function (listener) {
	    return listener();
	  });
	};
	
	var _appendImportantToEachValue = function _appendImportantToEachValue(styleObj) {
	  var importantStyleObj = {};
	
	  Object.keys(styleObj).forEach(function (key) {
	    var value = styleObj[key];
	
	    // This breaks unitless values but they'll be deprecated soon anyway
	    // https://github.com/facebook/react/issues/1873
	    value = value + " !important";
	    importantStyleObj[key] = value;
	  });
	
	  return importantStyleObj;
	};
	
	var addPrintStyles = function addPrintStyles(Component /*: constructor*/) {
	  if (!Component.printStyles) {
	    return;
	  }
	
	  var printStyleClass = {};
	
	  Object.keys(Component.printStyles).forEach(function (key) {
	    var styles = Component.printStyles[key];
	    var className = "Radium-" + Component.displayName + "-" + key;
	    allPrintStyles["." + className] = _appendImportantToEachValue(styles);
	    printStyleClass[key] = className;
	  });
	
	  // Allows for lazy loading of JS that then calls Radium to update the
	  // print styles
	  _emitChange();
	  return printStyleClass;
	};
	
	var getPrintStyles = function getPrintStyles() /*: Object*/ {
	  return allPrintStyles;
	};
	
	module.exports = {
	  addPrintStyles: addPrintStyles,
	  getPrintStyles: getPrintStyles,
	  subscribe: subscribe
	};

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	
	var Style = __webpack_require__(303);
	var printStyles = __webpack_require__(301);
	
	var PrintStyle = React.createClass({
	  displayName: 'PrintStyle',
	
	  getInitialState: function getInitialState() {
	    return this._getStylesState();
	  },
	
	  componentDidMount: function componentDidMount() {
	    this.subscription = printStyles.subscribe(this._onChange);
	  },
	
	  componentWillUnmount: function componentWillUnmount() {
	    this.subscription.remove();
	  },
	
	  _onChange: function _onChange() {
	    this.setState(this._getStylesState());
	  },
	
	  _getStylesState: function _getStylesState() {
	    return {
	      styles: printStyles.getPrintStyles()
	    };
	  },
	
	  render: function render() {
	    return React.createElement(Style, { rules: {
	        mediaQueries: {
	          print: this.state.styles
	        }
	      } });
	  }
	});
	
	module.exports = PrintStyle;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var camelCasePropsToDashCase = __webpack_require__(304);
	var createMarkupForStyles = __webpack_require__(305);
	var Prefixer = __webpack_require__(295);
	
	var React = __webpack_require__(2);
	
	var buildCssString = function buildCssString(selector /*: string*/, rules /*: Object*/, prefix /*: (rules: Object, componentName: string) => Object*/) /*: ?string*/ {
	  if (!selector || !rules) {
	    return null;
	  }
	
	  var prefixedRules = prefix(rules, 'Style');
	  var cssPrefixedRules = camelCasePropsToDashCase(prefixedRules);
	  var serializedRules = createMarkupForStyles(cssPrefixedRules);
	
	  return selector + '{' + serializedRules + '}';
	};
	
	var Style = React.createClass({
	  displayName: 'Style',
	
	  propTypes: {
	    prefix: React.PropTypes.func.isRequired,
	
	    rules: React.PropTypes.object,
	    scopeSelector: React.PropTypes.string
	  },
	
	  getDefaultProps: function getDefaultProps() /*: {scopeSelector: string}*/ {
	    return {
	      prefix: Prefixer.getPrefixedStyle,
	      scopeSelector: ''
	    };
	  },
	
	  _buildStyles: function _buildStyles(styles /*: Object*/) /*: string*/ {
	    var _this = this;
	
	    return Object.keys(styles).reduce(function (accumulator, selector) {
	      var rules = styles[selector];
	
	      if (selector === 'mediaQueries') {
	        accumulator += _this._buildMediaQueryString(rules);
	      } else {
	        var completeSelector = (_this.props.scopeSelector ? _this.props.scopeSelector + ' ' : '') + selector;
	        accumulator += buildCssString(completeSelector, rules, _this.props.prefix) || '';
	      }
	
	      return accumulator;
	    }, '');
	  },
	
	  _buildMediaQueryString: function _buildMediaQueryString(stylesByMediaQuery /*: {[mediaQuery: string]: Object}*/) /*: string*/ {
	    var _this2 = this;
	
	    var contextMediaQueries = this._getContextMediaQueries();
	    var mediaQueryString = '';
	
	    Object.keys(stylesByMediaQuery).forEach(function (query) {
	      var completeQuery = contextMediaQueries[query] ? contextMediaQueries[query] : query;
	      mediaQueryString += '@media ' + completeQuery + '{' + _this2._buildStyles(stylesByMediaQuery[query]) + '}';
	    });
	
	    return mediaQueryString;
	  },
	
	  _getContextMediaQueries: function _getContextMediaQueries() /*: {[mediaQuery: string]: Object}*/ {
	    var contextMediaQueries = {};
	    if (this.context && this.context.mediaQueries) {
	      Object.keys(this.context.mediaQueries).forEach((function (query) {
	        contextMediaQueries[query] = this.context.mediaQueries[query].media;
	      }).bind(this));
	    }
	
	    return contextMediaQueries;
	  },
	
	  render: function render() /*: ?ReactElement*/ {
	    if (!this.props.rules) {
	      return null;
	    }
	
	    var styles = this._buildStyles(this.props.rules);
	
	    return React.createElement('style', { dangerouslySetInnerHTML: { __html: styles } });
	  }
	});
	
	module.exports = Style;

/***/ },
/* 304 */
/***/ function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var _camelCaseRegex = /([a-z])?([A-Z])/g;
	var _camelCaseReplacer = function _camelCaseReplacer(match, p1, p2) {
	  return (p1 || '') + '-' + p2.toLowerCase();
	};
	var _camelCaseToDashCase = function _camelCaseToDashCase(s) {
	  return s.replace(_camelCaseRegex, _camelCaseReplacer);
	};
	
	var camelCasePropsToDashCase = function camelCasePropsToDashCase(prefixedStyle /*: Object*/) /*: Object*/ {
	  // Since prefix is expected to work on inline style objects, we must
	  // translate the keys to dash case for rendering to CSS.
	  return Object.keys(prefixedStyle).reduce(function (result, key) {
	    result[_camelCaseToDashCase(key)] = prefixedStyle[key];
	    return result;
	  }, {});
	};
	
	module.exports = camelCasePropsToDashCase;

/***/ },
/* 305 */
/***/ function(module, exports) {

	/* @flow */
	
	'use strict';
	
	var createMarkupForStyles = function createMarkupForStyles(style /*: Object*/) /*: string*/ {
	  var spaces /*: string*/ = arguments.length <= 1 || arguments[1] === undefined ? '' : arguments[1];
	
	  return Object.keys(style).map(function (property) {
	    return spaces + property + ': ' + style[property] + ';';
	  }).join('\n');
	};
	
	module.exports = createMarkupForStyles;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/* @flow */
	
	'use strict';
	
	var camelCasePropsToDashCase = __webpack_require__(304);
	var createMarkupForStyles = __webpack_require__(305);
	var Prefixer = __webpack_require__(295);
	
	var ExecutionEnvironment = __webpack_require__(296);
	
	var isAnimationSupported = false;
	var keyframesPrefixed = 'keyframes';
	
	if (ExecutionEnvironment.canUseDOM) {
	  // Animation feature detection and keyframes prefixing from MDN:
	  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Detecting_CSS_animation_support
	  var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
	  var element = (document.createElement('div') /*: any*/);
	
	  if (element.style.animationName !== undefined) {
	    isAnimationSupported = true;
	  } else {
	    domPrefixes.some(function (prefix) {
	      if (element.style[prefix + 'AnimationName'] !== undefined) {
	        keyframesPrefixed = '-' + prefix.toLowerCase() + '-keyframes';
	        isAnimationSupported = true;
	        return true;
	      }
	      return false;
	    });
	  }
	}
	
	var animationIndex = 1;
	var animationStyleSheet = null;
	
	if (isAnimationSupported) {
	  animationStyleSheet = (document.createElement('style') /*: any*/);
	  document.head.appendChild(animationStyleSheet);
	}
	
	// Simple animation helper that injects CSS into a style object containing the
	// keyframes, and returns a string with the generated animation name.
	var keyframes = function keyframes(keyframeRules /*: {[percentage: string]: {[key: string]: string|number}}*/, componentName /*:: ?: string*/) /*: string*/ {
	  var prefix /*: (style: Object, componentName: ?string) => Object*/ = arguments.length <= 2 || arguments[2] === undefined ? Prefixer.getPrefixedStyle : arguments[2];
	
	  var name = 'Animation' + animationIndex;
	  animationIndex += 1;
	
	  if (!isAnimationSupported) {
	    return name;
	  }
	
	  var rule = '@' + keyframesPrefixed + ' ' + name + ' {\n' + Object.keys(keyframeRules).map(function (percentage) {
	    var props = keyframeRules[percentage];
	    var prefixedProps = prefix(props, componentName);
	    var cssPrefixedProps = camelCasePropsToDashCase(prefixedProps);
	    var serializedProps = createMarkupForStyles(cssPrefixedProps, '  ');
	    return '  ' + percentage + ' {\n  ' + serializedProps + '\n  }';
	  }).join('\n') + '\n}\n';
	
	  // for flow
	  /* istanbul ignore next */
	  if (!animationStyleSheet) {
	    throw new Error('keyframes not initialized properly');
	  }
	
	  animationStyleSheet.sheet.insertRule(rule, animationStyleSheet.sheet.cssRules.length);
	  return name;
	};
	
	module.exports = keyframes;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(155);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var DEFAULT_WIDTH = 171;
	var DEFAULT_HEIGHT = 45;
	
	var Link = (0, _radium2['default'])(_reactRouter.Link);
	
	var Logo = (function (_React$Component) {
	  _inherits(Logo, _React$Component);
	
	  function Logo() {
	    _classCallCheck(this, Logo);
	
	    _get(Object.getPrototypeOf(Logo.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Logo, [{
	    key: 'render',
	    value: function render() {
	      var width = this.props.width || 171;
	      var height = 45 * width / 171;
	      if (this.props.width) {
	        width = this.props.width;
	        height = DEFAULT_HEIGHT * width / DEFAULT_WIDTH;
	      } else if (this.props.height) {
	        height = this.props.height;
	        width = DEFAULT_WIDTH * height / DEFAULT_HEIGHT;
	      }
	      return _react2['default'].createElement(
	        Link,
	        {
	          to: '/',
	          style: {
	            textDecoration: 'none',
	            backgroundImage: this.props.dark ? 'url(/logo-dark.svg)' : 'url(/logo.svg)',
	            backgroundSize: width + 'px ' + height + 'px',
	            width: width,
	            height: height,
	            display: 'block',
	            textIndent: -9999,
	            overflow: 'hidden',
	            '@media (max-width: 700px)': {
	              width: width > 100 ? height : width
	            }
	          } },
	        'Reindex'
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      width: _react2['default'].PropTypes.number
	    },
	    enumerable: true
	  }]);
	
	  return Logo;
	})(_react2['default'].Component);
	
	exports['default'] = Logo;
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _typography = __webpack_require__(309);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var fontFamily = '"Raleway", Helvetica, Arial, sans-serif';
	var ReindexTypography = new _typography2['default']({
	  baseFontSize: '16px',
	  baseLineHeight: '22.5px',
	  bodyFontFamily: fontFamily,
	  headerFontFamily: fontFamily,
	  bodyWeight: 300,
	  headerWeight: 500,
	  boldWeight: 500,
	  modularScales: ['minor third'],
	  googleFonts: [{
	    name: 'Raleway',
	    styles: ['200', '300', '500']
	  }, {
	    name: 'PT Sans',
	    styles: ['400']
	  }]
	});
	
	exports['default'] = ReindexTypography;
	module.exports = exports['default'];

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var React, VerticalRhythm, isArray, ms, objectAssign;
	
	React = __webpack_require__(2);
	
	objectAssign = __webpack_require__(39);
	
	VerticalRhythm = __webpack_require__(310);
	
	ms = __webpack_require__(314);
	
	isArray = __webpack_require__(316);
	
	module.exports = function(options) {
	  var defaults, styles, vr;
	  defaults = {
	    baseFontSize: '18px',
	    baseLineHeight: '28.5px',
	    modularScales: ['diminished fourth', ['768px', 'minor third']],
	    googleFonts: [],
	    headerFontFamily: '"Avenir Next", "Helvetica Neue", "Segoe UI", Helvetica, Arial, sans-serif',
	    bodyFontFamily: 'georgia, serif',
	    headerGray: 20,
	    headerGrayHue: 0,
	    bodyGray: 20,
	    bodyGrayHue: 0,
	    headerWeight: 700,
	    bodyWeight: 400,
	    boldWeight: 700,
	    fontFaces: []
	  };
	  options = objectAssign(defaults, options);
	  if (!isArray(options.modularScales)) {
	    options.modularScales = [options.modularScales];
	  }
	  vr = VerticalRhythm(options);
	  styles = __webpack_require__(317)(vr, options);
	  return {
	    options: options,
	    GoogleFont: __webpack_require__(323)(options),
	    TypographyStyle: __webpack_require__(324)(vr, options),
	    rhythm: vr.rhythm,
	    styles: styles,
	    fontSizeToPx: vr.adjustFontSizeTo,
	    fontSizeToMS: function(scaler) {
	      var baseFont, newFontSize;
	      baseFont = options.baseFontSize.slice(0, -2);
	      newFontSize = ms(scaler, options.modularScales[0]) * baseFont + "px";
	      return vr.adjustFontSizeTo(newFontSize);
	    },
	    injectStyles: function() {
	      var node;
	      node = document.createElement('style');
	      node.innerHTML = styles;
	      return document.head.appendChild(node);
	    }
	  };
	};


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var adjustFontSizeTo, convertLength, defaults, establishBaseline, linesForFontSize, objectAssign, parseUnit, rhythm, unit, unitLess;
	
	objectAssign = __webpack_require__(162);
	
	convertLength = __webpack_require__(311);
	
	parseUnit = __webpack_require__(312);
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	defaults = {
	  baseFontSize: '16px',
	  baseLineHeight: '24px',
	  rhythmUnit: 'rem',
	  defaultRhythmBorderWidth: '1px',
	  defaultRhythmBorderStyle: 'solid',
	  roundToNearestHalfLine: true,
	  minLinePadding: '2px'
	};
	
	linesForFontSize = function(fontSize, options) {
	  var baseLineHeightInPx, convert, fontInPx, lines, minLinePadding;
	  convert = convertLength(options.baseFontSize);
	  fontInPx = unitLess(convert(fontSize, 'px'));
	  baseLineHeightInPx = unitLess(convert(options.baseLineHeight, 'px'));
	  minLinePadding = unitLess(convert(options.minLinePadding, 'px'));
	  if (options.roundToNearestHalfLine) {
	    lines = Math.ceil(2 * fontInPx / baseLineHeightInPx) / 2;
	  } else {
	    lines = Math.ceil(fontInPx / baseLineHeightInPx);
	  }
	  if ((lines * baseLineHeightInPx - fontInPx) < (minLinePadding * 2)) {
	    if (options.roundToNearestHalfLine) {
	      lines += 0.5;
	    } else {
	      lines += 1;
	    }
	  }
	  return lines;
	};
	
	rhythm = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return function(lines, fontSize, offset) {
	    var length, rhythmLength;
	    if (lines == null) {
	      lines = 1;
	    }
	    if (fontSize == null) {
	      fontSize = options.baseFontSize;
	    }
	    if (offset == null) {
	      offset = 0;
	    }
	    length = (lines * unitLess(options.baseLineHeight)) - offset;
	    length = length + unit(options.baseLineHeight);
	    rhythmLength = convert(length, options.rhythmUnit, fontSize);
	    if (unit(rhythmLength) === "px") {
	      rhythmLength = Math.floor(unitLess(rhythmLength)) + unit(rhythmLength);
	    }
	    return parseFloat(unitLess(rhythmLength).toFixed(5)) + unit(rhythmLength);
	  };
	};
	
	establishBaseline = function(options) {
	  var convert;
	  convert = convertLength(options.baseFontSize);
	  return {
	    fontSize: (unitLess(options.baseFontSize) / 16) * 100 + "%",
	    lineHeight: convert(options.baseLineHeight, 'em')
	  };
	};
	
	adjustFontSizeTo = function(toSize, lines, fromSize, options) {
	  var convert, r;
	  if (fromSize == null) {
	    fromSize = options.baseFontSize;
	  }
	  if (unit(toSize) === "%") {
	    toSize = unitLess(options.baseFontSize) * (unitLess(toSize) / 100) + "px";
	  }
	  convert = convertLength(options.baseFontSize);
	  fromSize = convert(fromSize, 'px');
	  toSize = convert(toSize, 'px', fromSize);
	  r = rhythm(options);
	  if (lines === "auto") {
	    lines = linesForFontSize(toSize, options);
	  }
	  return {
	    fontSize: convert(toSize, options.rhythmUnit, fromSize),
	    lineHeight: r(lines, fromSize)
	  };
	};
	
	module.exports = function(options) {
	  var defaultsCopy;
	  defaultsCopy = JSON.parse(JSON.stringify(defaults));
	  options = objectAssign(defaultsCopy, options);
	  return {
	    rhythm: rhythm(options),
	    establishBaseline: function() {
	      return establishBaseline(options);
	    },
	    linesForFontSize: function(fontSize) {
	      return linesForFontSize(fontSize, options);
	    },
	    adjustFontSizeTo: function(toSize, lines, fromSize) {
	      if (lines == null) {
	        lines = "auto";
	      }
	      return adjustFontSizeTo(toSize, lines, fromSize, options);
	    }
	  };
	};


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.0
	var baseFontSize, parseUnit, unit, unitLess;
	
	parseUnit = __webpack_require__(312);
	
	__webpack_require__(313);
	
	baseFontSize = "16px";
	
	unit = function(length) {
	  return parseUnit(length)[1];
	};
	
	unitLess = function(length) {
	  return parseUnit(length)[0];
	};
	
	module.exports = function(baseFontSize) {
	  if (baseFontSize == null) {
	    baseFontSize = baseFontSize;
	  }
	  return function(length, toUnit, fromContext, toContext) {
	    var fromUnit, outputLength, pxLength;
	    if (fromContext == null) {
	      fromContext = baseFontSize;
	    }
	    if (toContext == null) {
	      toContext = fromContext;
	    }
	    fromUnit = unit(length);
	    if (fromUnit === toUnit) {
	      return length;
	    }
	    pxLength = unitLess(length);
	    if (unit(fromContext) !== "px") {
	      console.warn("Parameter fromContext must resolve to a value in pixel units.");
	    }
	    if (unit(toContext) !== "px") {
	      console.warn("Parameter toContext must resolve to a value in pixel units.");
	    }
	    if (fromUnit !== "px") {
	      if (fromUnit === "em") {
	        pxLength = unitLess(length) * unitLess(fromContext);
	      } else if (fromUnit === "rem") {
	        pxLength = unitLess(length) * unitLess(baseFontSize);
	      } else if (fromUnit === "ex") {
	        pxLength = unitLess(length) * unitLess(fromContext) * 2;
	      } else if (fromUnit === "ch" || fromUnit === "vw" || fromUnit === "vh" || fromUnit === "vmin") {
	        console.warn(fromUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(fromUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    outputLength = pxLength;
	    if (toUnit !== "px") {
	      if (toUnit === "em") {
	        outputLength = pxLength / unitLess(toContext);
	      } else if (toUnit === "rem") {
	        outputLength = pxLength / unitLess(baseFontSize);
	      } else if (toUnit === "ex") {
	        outputLength = pxLength / unitLess(toContext) / 2;
	      } else if (toUnit === "ch" || toUnit === "vw" || toUnit === "vh" || toUnit === "vmin") {
	        console.warn(toUnit + " units can't be reliably converted; Returning original value.");
	        return length;
	      } else {
	        console.warn(toUnit + " is an unknown or unsupported length unit; Returning original value.");
	        return length;
	      }
	    }
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	};


/***/ },
/* 312 */
/***/ function(module, exports) {

	module.exports = function parseUnit(str, out) {
	    if (!out)
	        out = [ 0, '' ]
	
	    str = String(str)
	    var num = parseFloat(str, 10)
	    out[0] = num
	    out[1] = str.match(/[\d.\-\+]*\s*(.*)/)[1] || ''
	    return out
	}

/***/ },
/* 313 */
/***/ function(module, exports) {

	// Console-polyfill. MIT license.
	// https://github.com/paulmillr/console-polyfill
	// Make it safe to do console.log() always.
	(function(con) {
	  'use strict';
	  var prop, method;
	  var empty = {};
	  var dummy = function() {};
	  var properties = 'memory'.split(',');
	  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
	     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
	     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
	  while (prop = properties.pop()) con[prop] = con[prop] || empty;
	  while (method = methods.pop()) con[method] = con[method] || dummy;
	})(this.console = this.console || {}); // Using `this` for web workers.


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.1
	var isNumber, ratios;
	
	isNumber = __webpack_require__(315);
	
	ratios = {
	  "minor second": 16 / 15,
	  "major second": 9 / 8,
	  "minor third": 6 / 5,
	  "major third": 4 / 3,
	  "diminished fourth": Math.sqrt(2),
	  "perfect fifth": 3 / 2,
	  "minor sixth": 8 / 5,
	  "golden": 1.61803398875,
	  "phi": 1.61803398875,
	  "major sixth": 5 / 3,
	  "minor seventh": 16 / 9,
	  "major seventh": 15 / 8,
	  "octave": 2,
	  "major tenth": 5 / 2,
	  "major eleventh": 8 / 3,
	  "major twelfth": 3,
	  "double octave": 4
	};
	
	module.exports = function(value, ratio) {
	  var r;
	  if (value == null) {
	    value = 0;
	  }
	  if (ratio == null) {
	    ratio = "golden";
	  }
	  if (isNumber(ratio)) {
	    r = ratio;
	  } else if (ratios[ratio] != null) {
	    r = ratios[ratio];
	  } else {
	    r = ratios['golden'];
	  }
	  return Math.pow(r, value);
	};


/***/ },
/* 315 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.2 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var numberTag = '[object Number]';
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Number` primitive or object.
	 *
	 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	 * as numbers, use the `_.isFinite` method.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isNumber(8.4);
	 * // => true
	 *
	 * _.isNumber(NaN);
	 * // => true
	 *
	 * _.isNumber('8.4');
	 * // => false
	 */
	function isNumber(value) {
	  return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	}
	
	module.exports = isNumber;


/***/ },
/* 316 */
/***/ function(module, exports) {

	
	/**
	 * isArray
	 */
	
	var isArray = Array.isArray;
	
	/**
	 * toString
	 */
	
	var str = Object.prototype.toString;
	
	/**
	 * Whether or not the given `val`
	 * is an array.
	 *
	 * example:
	 *
	 *        isArray([]);
	 *        // > true
	 *        isArray(arguments);
	 *        // > false
	 *        isArray('');
	 *        // > false
	 *
	 * @param {mixed} val
	 * @return {bool}
	 */
	
	module.exports = isArray || function (val) {
	  return !! val && '[object Array]' == str.call(val);
	};


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var decamelize, generateFontFaceRules, generateHeaderStyles, gray, isString, ms, normalize;
	
	ms = __webpack_require__(314);
	
	normalize = __webpack_require__(318);
	
	gray = __webpack_require__(319);
	
	isString = __webpack_require__(320);
	
	decamelize = __webpack_require__(321);
	
	generateHeaderStyles = function(vr, options) {
	  var baseFontSize, h1, h2, h3, h4, h5, h6, i, len, maxWidth, modularScale, ref, scale, styles;
	  styles = "";
	  baseFontSize = options.baseFontSize.slice(0, -2);
	  ref = options.modularScales;
	  for (i = 0, len = ref.length; i < len; i++) {
	    modularScale = ref[i];
	    if (isString(modularScale)) {
	      maxWidth = false;
	      scale = modularScale;
	    } else {
	      maxWidth = "@media only screen and (max-width: " + modularScale[0] + ") {\n";
	      scale = modularScale[1];
	    }
	    h1 = vr.adjustFontSizeTo(ms(3, scale) * baseFontSize + "px");
	    h2 = vr.adjustFontSizeTo(ms(2, scale) * baseFontSize + "px");
	    h3 = vr.adjustFontSizeTo(ms(1, scale) * baseFontSize + "px");
	    h4 = vr.adjustFontSizeTo(ms(2 / 3, scale) * baseFontSize + "px");
	    h5 = vr.adjustFontSizeTo(ms(1 / 3, scale) * baseFontSize + "px");
	    h6 = vr.adjustFontSizeTo(ms(0, scale) * baseFontSize + "px");
	    if (maxWidth) {
	      styles += maxWidth;
	    }
	    styles += "h1 {\n  font-size: " + h1.fontSize + ";\n  line-height: " + h1.lineHeight + ";\n}\n\nh2 {\n  font-size: " + h2.fontSize + ";\n  line-height: " + h2.lineHeight + ";\n}\n\nh3 {\n  font-size: " + h3.fontSize + ";\n  line-height: " + h3.lineHeight + ";\n}\n\nh4 {\n  font-size: " + h4.fontSize + ";\n  line-height: " + h4.lineHeight + ";\n}\n\nh5 {\n  font-size: " + h5.fontSize + ";\n  line-height: " + h5.lineHeight + ";\n}\n\nh6 {\n  font-size: " + h6.fontSize + ";\n  line-height: " + h6.lineHeight + ";\n}";
	    if (maxWidth) {
	      styles += "}\n";
	    }
	  }
	  return styles;
	};
	
	generateFontFaceRules = function(vr, options) {
	  var fontFace, i, k, len, properties, ref, s, srcs, styles, v;
	  styles = "";
	  properties = "";
	  if (!(options.fontFaces.length > 0)) {
	    return styles;
	  }
	  ref = options.fontFaces;
	  for (i = 0, len = ref.length; i < len; i++) {
	    fontFace = ref[i];
	    srcs = (function() {
	      var j, len1, ref1, results;
	      ref1 = fontFace.src;
	      results = [];
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        s = ref1[j];
	        results.push("src: " + s + ";");
	      }
	      return results;
	    })();
	    for (k in fontFace) {
	      v = fontFace[k];
	      if (k !== "src") {
	        properties += (decamelize(k, '-')) + ": " + v + ";\n";
	      }
	    }
	    styles += "@font-face {\n  " + properties + "\n  " + (srcs.join("\n")) + "\n}";
	  }
	  return styles;
	};
	
	module.exports = function(vr, options) {
	  var styles;
	  styles = normalize + "\n\nhtml {\n  box-sizing: border-box;\n  font-size: " + (vr.establishBaseline().fontSize) + ";\n  line-height: " + (vr.establishBaseline().lineHeight) + ";\n  overflow-y: scroll;\n}\n\n*, *:before, *:after {\n  box-sizing: inherit;\n}\n\nbody {\n  color: " + (gray(options.bodyGray, options.bodyGrayHue)) + ";\n  font-family: " + options.bodyFontFamily + ";\n  font-weight: " + options.bodyWeight + ";\n  word-wrap: break-word;\n}\n\n/* Make image responsive by default */\nimg {\n  max-width: 100%;\n}\n\n/* All block elements get one rhythm of bottom margin. */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhgroup,\nul,\nol,\ndl,\ndd,\np,\nfigure,\npre,\ntable,\nfieldset,\nblockquote,\nform,\nnoscript,\niframe,\nimg,\nhr {\n  margin: 0;\n  margin-bottom: " + (vr.rhythm(1)) + ";\n  padding: 0;\n}\n\nblockquote {\n  margin: " + (vr.rhythm(1)) + " " + (vr.rhythm(2.5)) + ";\n}\n\nb,\nstrong {\n  font-weight: " + options.boldWeight + "\n}\n\nhr {\n  background: " + (gray(80, options.bodyGrayHue)) + ";\n  border: none;\n  height: 1px;\n  margin-bottom: calc(" + (vr.rhythm(1)) + " - 1px);\n}\n\nol,\nul {\n  list-style-position: outside;\n  margin-left: " + (vr.rhythm(1)) + ";\n}\n\nul li,\nol li {\n  padding-left: 0;\n}\n\ncode,\nkbd,\npre,\nsamp {\n  font-size: " + (vr.adjustFontSizeTo('85%').fontSize) + ";\n  line-height: " + (vr.adjustFontSizeTo('85%').lineHeight) + ";\n}\n\ntable {\n  font-size: " + (vr.adjustFontSizeTo(options.baseFontSize).fontSize) + ";\n  line-height: " + (vr.adjustFontSizeTo(options.baseLineHeight).lineHeight) + ";\n  width: 100%;\n}\n\nthead {\n  text-align: left;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: " + (gray(options.headerGray, options.headerGrayHue)) + ";\n  font-family: " + options.headerFontFamily + ";\n  font-weight: " + options.headerWeight + ";\n}\n\n" + (generateHeaderStyles(vr, options)) + "\n" + (generateFontFaceRules(vr, options));
	  return styles;
	};


/***/ },
/* 318 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.9.3
	module.exports = "/*! normalize.css v3.0.2 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{-moz-box-sizing:content-box;box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}";


/***/ },
/* 319 */
/***/ function(module, exports) {

	function isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	module.exports = function(lightness, hue) {
	  if (typeof hue === "undefined") {
	    hue = 0;
	  }
	
	  if (lightness > 100) {
	    lightness = 100;
	  }
	  if (lightness < 0) {
	    lightness = 0;
	  }
	
	  // Converted named hues into numeric lightness value.
	  if (hue === "cool") {
	    hue = 237;
	  }
	  else if (hue === "slate") {
	    hue = 122;
	  }
	  else if (hue === "warm") {
	    hue = 69;
	  }
	
	  if (!isNumeric(hue)) {
	    throw new Error("Hue is not a number");
	  }
	
	  if (!isNumeric(lightness)) {
	    throw new Error("Lightness is not a number");
	  }
	
	  var saturation = 0;
	  if (hue !== 0) {
	    var a = 19.92978;
	    var b = -0.3651759;
	    var c = 0.001737214;
	    saturation = a + b * lightness + c * Math.pow(lightness, 2);
	  }
	
	  return "hsl(" + hue + "," + saturation + "%," + lightness + "%)";
	};


/***/ },
/* 320 */
/***/ function(module, exports) {

	'use strict';
	
	var strValue = String.prototype.valueOf;
	var tryStringObject = function tryStringObject(value) {
		try {
			strValue.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var strClass = '[object String]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isString(value) {
		if (typeof value === 'string') { return true; }
		if (typeof value !== 'object') { return false; }
		return hasToStringTag ? tryStringObject(value) : toStr.call(value) === strClass;
	};


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var escapeStringRegexp = __webpack_require__(322);
	
	module.exports = function (str, sep) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		sep = typeof sep === 'undefined' ? '_' : sep;
	
		var reSep = escapeStringRegexp(sep);
	
		return str.replace(/([a-z\d])([A-Z])/g, '$1' + sep + '$2')
						.replace(new RegExp('(' + reSep + '[A-Z])([A-Z])', 'g'), '$1' + reSep + '$2')
						.toLowerCase();
	};


/***/ },
/* 322 */
/***/ function(module, exports) {

	'use strict';
	
	var matchOperatorsRe = /[|\\{}()[\]^$+*?.]/g;
	
	module.exports = function (str) {
		if (typeof str !== 'string') {
			throw new TypeError('Expected a string');
		}
	
		return str.replace(matchOperatorsRe, '\\$&');
	};


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var React;
	
	React = __webpack_require__(2);
	
	module.exports = function(options) {
	  return React.createClass({
	    displayName: "GoogleFont",
	    render: function() {
	      var fonts, fontsStr;
	      fontsStr = "";
	      fonts = options.googleFonts.map(function(font) {
	        var str;
	        str = "";
	        str += font.name.split(' ').join('+');
	        str += ":";
	        str += font.styles.join(',');
	        return str;
	      });
	      fontsStr = fonts.join('|');
	      if (fontsStr) {
	        return React.createElement("link", {
	          "href": "//fonts.googleapis.com/css?family=" + fontsStr,
	          "rel": "stylesheet",
	          "type": "text/css"
	        });
	      } else {
	        return null;
	      }
	    }
	  });
	};


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.9.3
	var React, createStyles;
	
	React = __webpack_require__(2);
	
	createStyles = __webpack_require__(317);
	
	module.exports = function(vr, options) {
	  return React.createClass({
	    displayName: "TypographyStyle",
	    render: function() {
	      var styles;
	      styles = createStyles(vr, options);
	      return React.createElement("style", {
	        "id": "react-typography",
	        "dangerouslySetInnerHTML": {
	          __html: styles
	        }
	      });
	    }
	  });
	};


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(326);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(328)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./github.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./github.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(327)();
	// imports
	
	
	// module
	exports.push([module.id, ".hljs{display:block;overflow-x:auto;padding:.5em;color:#333;background:#f8f8f8;-webkit-text-size-adjust:none}.diff .hljs-header,.hljs-comment{color:#998;font-style:italic}.css .rule .hljs-keyword,.hljs-keyword,.hljs-request,.hljs-status,.hljs-subst,.hljs-winutils,.nginx .hljs-title{color:#333;font-weight:700}.hljs-hexcolor,.hljs-number,.ruby .hljs-constant{color:teal}.hljs-doctag,.hljs-string,.hljs-tag .hljs-value,.tex .hljs-formula{color:#d14}.hljs-id,.hljs-title,.scss .hljs-preprocessor{color:#900;font-weight:700}.hljs-list .hljs-keyword,.hljs-subst{font-weight:400}.hljs-class .hljs-title,.hljs-type,.tex .hljs-command,.vhdl .hljs-literal{color:#458;font-weight:700}.django .hljs-tag .hljs-keyword,.hljs-rule .hljs-property,.hljs-tag,.hljs-tag .hljs-title{color:navy;font-weight:400}.hljs-attribute,.hljs-name,.hljs-variable,.lisp .hljs-body{color:teal}.hljs-regexp{color:#009926}.clojure .hljs-keyword,.hljs-prompt,.hljs-symbol,.lisp .hljs-keyword,.ruby .hljs-symbol .hljs-string,.scheme .hljs-keyword,.tex .hljs-special{color:#990073}.hljs-built_in{color:#0086b3}.hljs-cdata,.hljs-doctype,.hljs-pi,.hljs-pragma,.hljs-preprocessor,.hljs-shebang{color:#999;font-weight:700}.hljs-deletion{background:#fdd}.hljs-addition{background:#dfd}.diff .hljs-change{background:#0086b3}.hljs-chunk{color:#aaa}", ""]);
	
	// exports


/***/ },
/* 327 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(true) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var media = obj.media;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashCollectionSortByOrder = __webpack_require__(330);
	
	var _lodashCollectionSortByOrder2 = _interopRequireDefault(_lodashCollectionSortByOrder);
	
	var _reactRouter = __webpack_require__(155);
	
	var _gatsbyHelpers = __webpack_require__(259);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var styles = {
	  container: {
	    display: 'flex',
	    maxWidth: 960,
	    marginLeft: 'auto',
	    marginRight: 'auto'
	  },
	  content: {
	    flex: 1,
	    minWidth: 0,
	    padding: '0 ' + rhythm(1)
	  },
	  sidebar: {
	    width: 100 * 3 / 12 + '%',
	    marginLeft: 100 * 1 / 12 + '%',
	    '@media (max-width: 700px)': {
	      display: 'none'
	    }
	  }
	};
	
	var BlogPage = _react2['default'].createClass({
	  displayName: 'BlogPage',
	
	  mixins: [_reactRouter.State],
	
	  render: function render() {
	    var _this = this;
	
	    var childPages = (0, _gatsbyHelpers.templateChildrenPages)(__filename, this.props.state).filter(function (child) {
	      return child.data;
	    }).map(function (child) {
	      return {
	        title: child.data.title,
	        path: child.path,
	        date: child.data.date
	      };
	    });
	    childPages = (0, _lodashCollectionSortByOrder2['default'])(childPages, ['date'], ['desc']);
	
	    var posts = childPages.map(function (child) {
	      return _react2['default'].createElement(
	        'li',
	        {
	          key: child.path,
	          style: {
	            marginBottom: rhythm(1 / 2)
	          } },
	        _react2['default'].createElement(
	          _reactRouter.Link,
	          { to: child.path },
	          _this.isActive(child.path) ? _react2['default'].createElement(
	            'strong',
	            null,
	            child.title
	          ) : child.title
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      'div',
	      { style: styles.container },
	      _react2['default'].createElement(
	        'div',
	        { style: styles.content },
	        _react2['default'].createElement(_reactRouter.RouteHandler, this.props)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: styles.sidebar },
	        _react2['default'].createElement(
	          'h3',
	          null,
	          'Reindex Blog'
	        ),
	        _react2['default'].createElement(
	          'ul',
	          { style: { listStyle: 'none', margin: 0 } },
	          posts
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = (0, _radium2['default'])(BlogPage);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, "blog/_template.jsx"))

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var baseSortByOrder = __webpack_require__(331),
	    isArray = __webpack_require__(215),
	    isIterateeCall = __webpack_require__(255);
	
	/**
	 * This method is like `_.sortByAll` except that it allows specifying the
	 * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	 * values are sorted in ascending order. Otherwise, a value is sorted in
	 * ascending order if its corresponding order is "asc", and descending if "desc".
	 *
	 * If a property name is provided for an iteratee the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If an object is provided for an iteratee the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 42 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // sort by `user` in ascending order and by `age` in descending order
	 * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	 * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	 */
	function sortByOrder(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (guard && isIterateeCall(iteratees, orders, guard)) {
	    orders = undefined;
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseSortByOrder(collection, iteratees, orders);
	}
	
	module.exports = sortByOrder;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(332),
	    baseCallback = __webpack_require__(220),
	    baseMap = __webpack_require__(251),
	    baseSortBy = __webpack_require__(252),
	    compareMultiple = __webpack_require__(333);
	
	/**
	 * The base implementation of `_.sortByOrder` without param guards.
	 *
	 * @private
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {boolean[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseSortByOrder(collection, iteratees, orders) {
	  var index = -1;
	
	  iteratees = arrayMap(iteratees, function(iteratee) { return baseCallback(iteratee); });
	
	  var result = baseMap(collection, function(value) {
	    var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseSortByOrder;


/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	var baseCompareAscending = __webpack_require__(254);
	
	/**
	 * Used by `_.sortByOrder` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	 * a value is sorted in ascending order if its corresponding order is "asc", and
	 * descending if "desc".
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * ((order === 'asc' || order === true) ? 1 : -1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "58d37f6d735f2737e2fe594d2bc1e9c1.png";

/***/ },
/* 335 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Using Auth0 with Reindex","author":{"name":"Mikhail Novikov","image":"https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg","link":"https://twitter.com/freiksenet","twitter":"freiksenet","bio":"CTO & Co-founder"},"date":"2016-05-24T12:39:00.000Z","categories":["React","React Native","Auth0"],"excerpt":"Auth0 is a great service to handle your authentication. In this arcticle we will show how to use Auth0 with Reindex, React and React Native","image":"/blog/auth0-and-reindex/auth0-and-reindex.png","body":"<p><img src=\"auth0-and-reindex.png\" alt=\"\"></p>\n<p><a href=\"https://auth0.com/\">Auth0</a> is an amazing service for handling authentication\nin your apps. It not only supports many popular social login APIs, but\nalso has ready-made libraries and UI components to really speed up your\napplication development. Reindex supports Auth0 as an <a href=\"/docs/security/authentication/#social-login-authentication-providers\">authentication\nprovider</a>,\nand we actually use it for our own dashboard app. In this blog post, I’ll describe\nvarious ways to use Auth0 with Reindex.</p>\n<p>First, I’ll cover how to set up Auth0 in Reindex. Then I’ll continue to basic\nuse cases using the Lock component in React and React Native. Finally, I\nwill cover common patterns for using Auth0 in Reindex—copying the profile info\nand using the Auth0 API.</p>\n<h2 id=\"basic-configuration\">Basic Configuration <a class=\"hash-link\" href=\"#basic-configuration\" aria-hidden=\"true\">#</a></h2>\n<p>Once you are registered in both Reindex and Auth0, take note of the Auth0\n<code>domain</code>, <code>Client ID</code>, and <code>Client Secret</code>. Then go to the\n<a href=\"https://accounts.reindex.io\">Reindex Dashboard</a> and click <code>Open GraphiQL</code> on your app.\nAlternatively, you can run <code>reindex graphiql</code> at the\n<a href=\"https://www.github.com/reindexio/reindex-cli\">Reindex CLI</a>.</p>\n<p>In GraphiQL, run the following command, replacing the dummy values with your Auth0\ncredentials:</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-name\">mutation</span> {\n  createReindexAuthenticationProvider(input: {\n    <span class=\"hljs-built_in\">type</span>: auth<span class=\"hljs-number\">0</span>,\n    isEnabled: <span class=\"hljs-keyword\">true</span>,\n    <span class=\"hljs-built_in\">domain</span>: <span class=\"hljs-string\">\"YOUR-AUTH0-DOMAIN.auth0.com\"</span>,\n    clientId: <span class=\"hljs-string\">\"YOUR-AUTH0-CLIENT-ID\"</span>,\n    clientSecret: <span class=\"hljs-string\">\"YOUR-AUTH0-CLIENT-SECRET\"</span>,\n  }) {\n    id\n  }\n}\n</code></pre>\n<p>Now Reindex is configured to accept Auth0 as an authentication provider.</p>\n<h2 id=\"react-example-with-auth0-lock\">React Example with Auth0 Lock <a class=\"hash-link\" href=\"#react-example-with-auth0-lock\" aria-hidden=\"true\">#</a></h2>\n<p>First, you need to install dependencies:</p>\n<pre><code class=\"language-shell\">npm <span class=\"hljs-operator\"><span class=\"hljs-keyword\">install</span> <span class=\"hljs-comment\">--save reindex-js auth0-lock</span>\n</span></code></pre>\n<p>Note that if you are using webpack, you will need to <a href=\"https://github.com/auth0/lock#webpack\">add transforms</a>\nfor the Auth0 lock.</p>\n<p>Let’s write a function that opens the Auth0 lock and logs the user into Reindex.\nYou can put it in the file <code>login.js</code>. It will accept an instance of Reindex from\n<code>reindex-js</code> and perform a login.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Auth0Lock <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'auth0-lock'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">login</span>(<span class=\"hljs-params\">auth0Options, reindex</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> lock = <span class=\"hljs-keyword\">new</span> Auth0Lock(<span class=\"hljs-string\">'YOUR-AUTH0-CLIENT-ID'</span>, <span class=\"hljs-string\">'YOUR-AUTH0-SECRET'</span>);\n  lock.show(auth0Options, (err, profile, idToken) =&gt; {\n    <span class=\"hljs-keyword\">if</span> (err) {\n      <span class=\"hljs-built_in\">console</span>.log(err);\n      <span class=\"hljs-keyword\">return</span>;\n    }\n    reindex.loginWithToken(<span class=\"hljs-string\">'auth0'</span>, idToken)\n      .catch((err) =&gt; {\n        <span class=\"hljs-built_in\">console</span>.log(err)\n      });\n  });\n}\n</code></pre>\n<p>You can use this function in your main React component. The function will listen\nfor the the Reindex library’s <code>tokenChange</code> event (which indicates whether the\nuser is logged in or not) and provide a link for logging in or out.\nThe Reindex library stores the token locally and will automatically load it\nduring initialization, so you don’t need to do any additional work there.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> React, { Component } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> ReactDOM <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-dom'</span>;\n<span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'reindex-js'</span>;\n\n<span class=\"hljs-keyword\">import</span> login <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./login'</span>;\n\n<span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(<span class=\"hljs-string\">'https://YOUR-REINDEX-APP.myreindex.com'</span>);\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Main</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  constructor() {\n    <span class=\"hljs-keyword\">super</span>();\n    <span class=\"hljs-keyword\">this</span>.state = {\n      isLoggedIn: reindex.isLoggedIn(),\n    };\n  }\n\n  componentDidMount() {\n    reindex.addListener(<span class=\"hljs-string\">'tokenChange'</span>, <span class=\"hljs-keyword\">this</span>.handleTokenChange);\n  }\n\n  componentWillUnmount() {\n    reindex.removeListener(<span class=\"hljs-string\">'tokenChange'</span>, <span class=\"hljs-keyword\">this</span>.handleTokenChange);\n  }\n\n  handleTokenChange = () =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({ isLoggedIn: reindex.isLoggedIn() });\n  };\n\n  handleLogin = () =&gt; {\n    login({}, reindex);\n  }\n\n  handleLogout = () =&gt; {\n    reindex.logout();\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.state.isLoggedIn) {\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">button</span> <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{this.handleLogout}</span>&gt;</span>Logout<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">button</span>&gt;</span>\n      )</span>;\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">button</span> <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{this.handleLogin}</span>&gt;</span>Login<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">button</span>&gt;</span>\n      )</span>;\n    }\n  }\n}\n</code></pre>\n<p>You can use the <a href=\"https://github.com/reindexio/reindex-starter-kit-react-auth0/\">Reindex Starter Kit with Auth0</a>,\nwhich already implements the solution above.</p>\n<h2 id=\"react-native-example-with-auth0-lock\">React Native Example with Auth0 Lock <a class=\"hash-link\" href=\"#react-native-example-with-auth0-lock\" aria-hidden=\"true\">#</a></h2>\n<p>Unlike browsers, React Native doesn’t have a synchronous <code>LocalStorage</code>, so it\ncan’t incorporate the solution above. You can use the <code>AsyncStorage</code>\nAPI, which is similar to <code>LocalStorage</code>, but asynchronous. In\naddition, a Auth0 React Native lock should be used instead of a browser-based\none.</p>\n<p>First, let’s install the dependencies:</p>\n<pre><code class=\"language-shell\">npm <span class=\"hljs-operator\"><span class=\"hljs-keyword\">install</span> <span class=\"hljs-comment\">--save reindex-js react-native-lock</span>\nrnpm <span class=\"hljs-keyword\">link</span> react-<span class=\"hljs-keyword\">native</span>-<span class=\"hljs-keyword\">lock</span>\n</span></code></pre>\n<p>On Android, you also need to <a href=\"https://github.com/auth0/react-native-lock#rnpm-1\">add information about the lock</a>\nto <code>Manifest.xml</code>.</p>\n<p>The login function will change a bit to accommodate the <code>AsyncStorage</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Auth0Lock <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-native-lock'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">login</span>(<span class=\"hljs-params\">auth0Options, reindex</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> reindexToken = <span class=\"hljs-keyword\">await</span> AsyncStorage.getItem(<span class=\"hljs-string\">'REINDEX_TOKEN'</span>);\n  <span class=\"hljs-keyword\">if</span> (reindexToken) {\n    reindex.setToken(reindexToken);\n    <span class=\"hljs-keyword\">return</span>;\n  }\n\n  <span class=\"hljs-keyword\">const</span> lock = <span class=\"hljs-keyword\">new</span> Auth0Lock({\n    clientId: <span class=\"hljs-string\">'YOUR-AUTH0-CLIENT-ID'</span>,\n    domain: <span class=\"hljs-string\">'YOUR-AUTH0-DOMAIN'</span>,\n  });\n  lock.show(auth0Options, <span class=\"hljs-keyword\">async</span> (err, profile, idToken) =&gt; {\n    <span class=\"hljs-keyword\">if</span> (err) {\n      <span class=\"hljs-built_in\">console</span>.log(err);\n      <span class=\"hljs-keyword\">return</span>;\n    }\n    <span class=\"hljs-keyword\">const</span> reindexResponse = <span class=\"hljs-keyword\">await</span> reindex.loginWithToken(<span class=\"hljs-string\">'auth0'</span>, idToken);\n    <span class=\"hljs-keyword\">await</span> AsyncStorage.setItem(<span class=\"hljs-string\">'REINDEX_TOKEN'</span>, reindexResponse.token);    \n  });\n}\n</code></pre>\n<p>Your main component can stay mostly the same; the only difference is that you\nneed to replace DOM components in <code>render()</code> with relevant Native components.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Main</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n\n  render() {\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.state.isLoggedIn) {\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TouchableHighlight</span> <span class=\"hljs-attribute\">onPress</span>=<span class=\"hljs-value\">{this.handleLogout}</span>&gt;</span>\n          <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Text</span>&gt;</span>\n            Logout\n          <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">Text</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">TouchableHighlight</span>&gt;</span>\n      )</span>;\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TouchableHighlight</span> <span class=\"hljs-attribute\">onPress</span>=<span class=\"hljs-value\">{this.handleLogin}</span>&gt;</span>\n          <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Text</span>&gt;</span>\n            Login\n          <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">Text</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">TouchableHighlight</span>&gt;</span>\n      )</span>;\n    }\n  }\n}\n</code></pre>\n<h2 id=\"copying-auth0-profile-into-reindex-user\">Copying Auth0 Profile into Reindex User <a class=\"hash-link\" href=\"#copying-auth0-profile-into-reindex-user\" aria-hidden=\"true\">#</a></h2>\n<p>When you call <code>reindex.loginWithToken</code>, Reindex will check that the Auth0\n<code>id_token</code> is valid and save the Auth0 id and profile information in the user’s\n<code>credentials.auth0</code> field. To maintain privacy, only the user can read this\nfield, so, if you want to reveal some of the profile info to other users, you\nneed to copy it. First, you need to add fields to the User profile in your\nReindex Schema:</p>\n<pre><code class=\"language-js\">[\n  {\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        <span class=\"hljs-string\">\"name\"</span>: <span class=\"hljs-string\">\"id\"</span>,\n        <span class=\"hljs-string\">\"type\"</span>: <span class=\"hljs-string\">\"ID\"</span>,\n        <span class=\"hljs-string\">\"nonNull\"</span>: <span class=\"hljs-literal\">true</span>,\n        <span class=\"hljs-string\">\"unique\"</span>: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        <span class=\"hljs-string\">\"name\"</span>: <span class=\"hljs-string\">\"username\"</span>,\n        <span class=\"hljs-string\">\"type\"</span>: <span class=\"hljs-string\">\"String\"</span>\n      },\n      {\n        <span class=\"hljs-string\">\"name\"</span>: <span class=\"hljs-string\">\"email\"</span>,\n        <span class=\"hljs-string\">\"type\"</span>: <span class=\"hljs-string\">\"String\"</span>\n      },\n      {\n        <span class=\"hljs-string\">\"name\"</span>: <span class=\"hljs-string\">\"avatarUrl\"</span>,\n        <span class=\"hljs-string\">\"type\"</span>: <span class=\"hljs-string\">\"String\"</span>\n      },\n      <span class=\"hljs-comment\">// ... Other fields</span>\n    ],\n  <span class=\"hljs-comment\">// ... Other types</span>\n]\n</code></pre>\n<p>Remember to push your schema with <code>reindex schema-push</code>.</p>\n<p>There are two ways to copy the data from Auth0 profile to publicly readable\nfields in User type. You can call the mutation manually in your login function or\nuse a Relay Mutation.</p>\n<h3 id=\"in-login-function\">In Login Function <a class=\"hash-link\" href=\"#in-login-function\" aria-hidden=\"true\">#</a></h3>\n<p>After you’ve logged in with the <code>loginWithToken</code>, you can issue a GraphQL\nmutation to update the user.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">login</span>(<span class=\"hljs-params\">auth0Options, reindex</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> lock = <span class=\"hljs-keyword\">new</span> Auth0Lock(<span class=\"hljs-string\">'YOUR-AUTH0-CLIENT-ID'</span>, <span class=\"hljs-string\">'YOUR-AUTH0-SECRET'</span>);\n  lock.show(auth0Options, <span class=\"hljs-keyword\">async</span> (err, profile, idToken) =&gt; {\n    <span class=\"hljs-keyword\">if</span> (err) {\n      <span class=\"hljs-built_in\">console</span>.log(err);\n      <span class=\"hljs-keyword\">return</span>;\n    }\n    <span class=\"hljs-keyword\">await</span> reindex.loginWithToken(<span class=\"hljs-string\">'auth0'</span>, idToken)\n      .catch((err) =&gt; {\n        <span class=\"hljs-built_in\">console</span>.log(err)\n      });\n    <span class=\"hljs-keyword\">await</span> reindex.query(<span class=\"hljs-string\">`\n      mutation($input: _UpdateUserInput!) {\n        updateUser(input: $input) {\n          id\n        }\n      }\n    `</span>, {\n      input: {\n        id: reindexResponse.user.id,\n        username: profile.nickname,\n        avatarUrl: profile.picture,\n        email: profile.email,\n      },\n    });\n  });\n}\n</code></pre>\n<h3 id=\"in-relay-mutation\">In Relay Mutation <a class=\"hash-link\" href=\"#in-relay-mutation\" aria-hidden=\"true\">#</a></h3>\n<p>Alternatively, you can update the user with a Relay mutation.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>\n\nexport default class UpdateUserInfoMutation extends Relay.Mutation {\n  static fragments = {\n    user: () =&gt; Relay.QL`\n      fragment on User {\n        id\n        credentials {\n          auth0 {\n            displayName\n            picture\n            email            \n          }\n        }\n      }\n    `\n  };\n\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation { updateUser }`</span>\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.user.id,\n      username: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.displayName,\n      email: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.email,\n      avatarUrl: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.picture,\n    };\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _UserPayload {\n        changedUser {\n          username\n          email\n          avatarUrl\n        }\n      }\n    `</span>\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [\n      {\n        type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n        fieldIDs: {\n          changedUser: <span class=\"hljs-keyword\">this</span>.props.user.id,\n        },\n      },\n    ]\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      changedUser: {\n        username: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.displayName,\n        email: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.email,\n        avatarUrl: <span class=\"hljs-keyword\">this</span>.props.user.credentials.auth0.picture,\n      }\n    }\n  }\n}\n</code></pre>\n<p>You can run this mutation in <code>componentDidMount</code> of your main component.</p>\n<h2 id=\"using-auth0-api\">Using Auth0 API <a class=\"hash-link\" href=\"#using-auth0-api\" aria-hidden=\"true\">#</a></h2>\n<p>The user’s Auth0 access token is stored inside\n<code>credentials.auth0.accessToken</code>. It can be used to access calls in the\n<a href=\"https://auth0.com/docs/api/authentication\">Auth0 Authentication API</a>,\nsuch as retrieving the User Profile.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">getProfile</span>(<span class=\"hljs-params\">user</span>)\n  <span class=\"hljs-title\">const</span> <span class=\"hljs-title\">profileResponse</span> = <span class=\"hljs-title\">await</span> <span class=\"hljs-title\">fetch</span>(<span class=\"hljs-params\">\n    `https:<span class=\"hljs-comment\">//YOUR-AUTH0-DOMAIN/userinfo`,</span>\n    {\n      method: 'POST',\n      headers: {\n        Authorization: `Bearer ${user.credentials.auth0.accessToken}`,\n      },\n    }\n  </span>);\n  <span class=\"hljs-title\">return</span> <span class=\"hljs-title\">profileResponse</span>.<span class=\"hljs-title\">json</span>(<span class=\"hljs-params\"></span>);\n}\n</span></code></pre>\n<h2 id=\"conclusion\">Conclusion <a class=\"hash-link\" href=\"#conclusion\" aria-hidden=\"true\">#</a></h2>\n<p>At Reindex, we want to empower product developers to build their apps better and\nfaster. We believe that Auth0 is a technology that immensely helps developers\nwith that. With Reindex and Auth0, you don’t need to worry about your backend\nor authentication because they are handled for you.</p>\n<h2 id=\"further-reading\">Further Reading <a class=\"hash-link\" href=\"#further-reading\" aria-hidden=\"true\">#</a></h2>\n<ul>\n<li><a href=\"/docs/security/authentication\">Reindex authentication docs</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-starter-kit-react-auth0/\">Reindex starter kit with Auth0 and React</a></li>\n<li><a href=\"https://auth0.com/docs\">Auth0 docs</a></li>\n<li><a href=\"https://auth0.com/docs/libraries/lock\">Auth0 docs for Lock</a></li>\n<li><a href=\"https://github.com/auth0/react-native-lock\">Auth0 docs for React Native</a></li>\n</ul>\n"}

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6274da9edcaa39ecbb57395ebd6b5a79.png";

/***/ },
/* 337 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Building a GraphQL Server with Node.js and SQL","author":{"name":"Mikhail Novikov","image":"https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg","link":"https://twitter.com/freiksenet","twitter":"freiksenet","bio":"CTO & Co-founder"},"date":"2015-08-03T08:51:55.000Z","categories":["GraphQL","JavaScript","Open Source"],"excerpt":"GraphQL is a new technology from Facebook. It aims to replace REST as a go-to API standard for developing rich applications. In this article we'll build a simple GraphQL server using Node.js and an SQL database.","image":"/blog/building-a-graphql-server-with-node-js-and-sql/GraphQL_NodeJS.png","body":"<p><img src=\"GraphQL_NodeJS.png\" alt=\"\"></p>\n<p>GraphQL is a new technology from Facebook. It aims to replace REST as a go-to API standard for developing rich applications. In this article we’ll build a simple GraphQL server using Node.js and an SQL database.</p>\n<p>In this blog post we are going to build a GraphQL backend server for a news feed like the one described in <a href=\"http://facebook.github.io/react/blog/2015/03/19/building-the-facebook-news-feed-with-relay.html\">the blog post about building a news feed with Relay</a>. Our server will be very simple – we will only have one endpoint that runs GraphQL queries. Data models available through it will be User and Story, where each story will have an author. (In Facebook’s blog post “stories” are from user’s news feed, not his own stories. This article will use a simpler model for clarity.)</p>\n<p>We will use:</p>\n<ul>\n<li>Node.js</li>\n<li>GraphQL.js library</li>\n<li>SQLite3 database for storage – it’s simple and doesn’t require separate server</li>\n<li>Hapi as an HTTP server – there is only going to be one endpoint, so in this<br>\nexample there would be little difference between server APIs. We use Hapi as<br>\nHTTP server ourselves, so we’ll use that.</li>\n<li>Babel – we’ll write in ES6/7, because it’s awesome 😉</li>\n</ul>\n<p>This article assumes some understanding of GraphQL (<a href=\"http://facebook.github.io/react/blog/2015/05/01/graphql-introduction.html\">GraphQL Introduction</a> should be enough), so it won’t cover the basics for brevity.</p>\n<p>Full code is available on <a href=\"https://github.com/reindexio/graphql-nodejs-newsfeed\">GitHub</a>.</p>\n<h2 id=\"anatomy-of-graphql\">Anatomy of GraphQL <a class=\"hash-link\" href=\"#anatomy-of-graphql\" aria-hidden=\"true\">#</a></h2>\n<p>GraphQL consists of two parts: a type system that allows one to describe the schema of data that is available on the server and a query language that allows the client to describe the data it needs and its shape. An important thing about the schema is that it makes no assumptions about how the data is stored, it only describes what the consumer of the API can use.</p>\n<p>A one-to-many relationship is a relationship where a parent record can be linked to many children. For example, a user can be an author of many stories. In our SQL database it means the <code>Story</code> table will have an <code>author</code> column, storing an <code>id</code> of a <code>User</code> as a foreign key. The <code>User</code> table will not need to store any references to stories in the SQL schema.</p>\n<p>However in the GraphQL schema, <code>Story</code> will have an <code>author</code> field of type <code>User</code> and <code>User</code> will have <code>stories</code>. This allows queries to follow relationships (connections) from both sides, regardless of the underlying SQL schema. The way the data is stored and represented in the database is an implementation detail.</p>\n<p>Basic building block of the GraphQL schema is Object. Object has a name and a map of fields. In their simplest form, fields will only have a type. Here is a simple example <code>User</code> object type, with fields <code>id</code> and <code>name</code>.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> User = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'User'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: GraphQLID\n    },\n    name: {\n      type: GraphQLString\n    }\n  })\n});\n</code></pre>\n<p>All fields can accept arguments and have a <code>resolve</code> method. <code>resolve</code> is a key part of hooking the schema and types up with an actual data storage and defines which data the field will return. The GraphQL executor calls <code>resolve</code> method for each field it traverses. By default, <code>resolve</code> just returns the matching property of the parent (so for the field <code>id</code> it returns <code>parent['id']</code>).</p>\n<p>To use that type we’ve just defined, GraphQL schema requires a special object type, <code>query</code>, to be defined. <code>query</code> fields will serve as an entry point for the GraphQL queries.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Query = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Query'</span>,\n  fields: () =&gt; ({\n    viewer: {\n      type: User,\n      resolve() {\n        <span class=\"hljs-keyword\">return</span> {\n          id: <span class=\"hljs-string\">'123'</span>,\n          name: <span class=\"hljs-string\">'freiksenet'</span>\n        }\n      }\n    }\n  })\n});\n\n<span class=\"hljs-keyword\">const</span> Schema = <span class=\"hljs-keyword\">new</span> GraphQLSchema({\n  query: Query\n});\n</code></pre>\n<p>We can test it by calling the <code>graphql</code> function with a query.</p>\n<pre><code class=\"language-javascript\">graphql(Schema, <span class=\"hljs-string\">`{\n  viewer {\n    id,\n    text\n  }\n}`</span>).then((result) =&gt; <span class=\"hljs-built_in\">console</span>.log(result));\n<span class=\"hljs-comment\">// ==&gt;</span>\n{\n  data: {\n    viewer: {\n      id: <span class=\"hljs-string\">'123'</span>,\n      name: <span class=\"hljs-string\">'freiksenet'</span>\n    }\n  }\n}\n</code></pre>\n<p><code>resolve</code> is passed some additional arguments. The most important ones are the first three:</p>\n<ol>\n<li>a result of the parent <code>resolve</code> (if it was a promise, then it is fulfilled<br>\nfirst)</li>\n<li>arguments passed to the field, like <code>format</code> passed to <code>text</code> in this example query</li>\n</ol>\n<pre><code class=\"language-javascript\">{\n  viewer {\n    id,\n    text(format: <span class=\"hljs-string\">\"markdown\"</span>)\n  }\n}\n</code></pre>\n<ol start=\"3\">\n<li>global context passed to <code>graphql</code> function call as the third argument. This can be used to pass the data that <code>resolve</code> on any level might need. It can be, for instance, a database connection, a user session or a reference to a cache.</li>\n</ol>\n<p>As there is a default <code>resolve</code> implementation, we don’t need to provide an implementation for all fields.</p>\n<h2 id=\"connecting-to-the-database\">Connecting to the database <a class=\"hash-link\" href=\"#connecting-to-the-database\" aria-hidden=\"true\">#</a></h2>\n<p>Let’s create a small SQLite3 database and fill it in with data. We’ll start with one table: <code>Story</code> (you’ll find the script in <a href=\"https://github.com/reindexio/graphql-nodejs-newsfeed/blob/634d265f086fcdff9bb0b4392b545c6717b5373a/scripts/createdb.sql\">./scripts/createdb.sql</a>).</p>\n<pre><code class=\"language-sql\"><span class=\"hljs-operator\"><span class=\"hljs-keyword\">CREATE</span> <span class=\"hljs-keyword\">TABLE</span> <span class=\"hljs-keyword\">User</span>\n(\n  <span class=\"hljs-keyword\">id</span> <span class=\"hljs-built_in\">INTEGER</span> PRIMARY <span class=\"hljs-keyword\">KEY</span>,\n  <span class=\"hljs-keyword\">name</span> <span class=\"hljs-built_in\">VARCHAR</span>(<span class=\"hljs-number\">255</span>)\n);</span>\n\n<span class=\"hljs-operator\"><span class=\"hljs-keyword\">INSERT</span> <span class=\"hljs-keyword\">INTO</span> <span class=\"hljs-keyword\">User</span>(<span class=\"hljs-string\">'name'</span>)\n<span class=\"hljs-keyword\">VALUES</span>\n(<span class=\"hljs-string\">'freiksenet'</span>),\n(<span class=\"hljs-string\">'fson'</span>),\n(<span class=\"hljs-string\">'Hallie'</span>),\n(<span class=\"hljs-string\">'Sophia'</span>),\n(<span class=\"hljs-string\">'Riya'</span>),\n(<span class=\"hljs-string\">'Kari'</span>),\n(<span class=\"hljs-string\">'Estrid'</span>),\n(<span class=\"hljs-string\">'Burwenna'</span>),\n(<span class=\"hljs-string\">'Emma'</span>),\n(<span class=\"hljs-string\">'Kaia'</span>),\n(<span class=\"hljs-string\">'Halldora'</span>),\n(<span class=\"hljs-string\">'Dorte'</span>);</span>\n</code></pre>\n<p>Then we’ll add an open database connection to our GraphQL context. Unfortunately, <code>sqlite3</code> node library doesn’t return promises, so we have to use Bluebird’s <code>promisify</code> to monkey patch it.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">import</span> sqlite3 <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'sqlite3'</span>;\n<span class=\"hljs-keyword\">import</span> {promisify} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'bluebird'</span>;\n\n<span class=\"hljs-keyword\">const</span> db = <span class=\"hljs-keyword\">new</span> sqlite3.Database(<span class=\"hljs-string\">'db.sqlite3'</span>);\n\ndb.get = promisify(db.get);\ndb.all = promisify(db.all);\n\ngraphql(Schema, <span class=\"hljs-string\">`{\n  viewer {\n    id,\n    name\n  }\n}`</span>, {db}).then((result) =&gt; <span class=\"hljs-built_in\">console</span>.log(result));\n</code></pre>\n<p>The result won’t change yet, but now our <code>resolve</code> will have an open database connection available to it. Time to use it.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Query = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Query'</span>,\n  fields: () =&gt; ({\n    viewer: {\n      type: User,\n      resolve(parent, args, {db}) {\n        <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n          SELECT * FROM User WHERE name = 'freiksenet'\n        `</span>);\n      }\n    }\n  })\n});\n</code></pre>\n<p>If we call our <code>graphql</code> example again we get a new result.</p>\n<pre><code class=\"language-javascript\">{\n  data: {\n    viewer: {\n      id: <span class=\"hljs-string\">\"1\"</span>,\n      name: <span class=\"hljs-string\">\"freiksenet\"</span>\n    }\n  }\n}\n</code></pre>\n<p><code>viewer</code> root field is used at Facebook to retrieve currently logged-in user. One can replicate such functionality by passing, e.g., user id from session to GraphQL context and using it in the <code>viewer</code> query. We can modify our Query to use the context, but in this example we will pass the same logged-in user all the time.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Query = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Query'</span>,\n  fields: () =&gt; ({\n    viewer: {\n      type: User,\n      resolve(parent, args, {db, userId}) {\n        <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n          SELECT * FROM User WHERE id = $id\n        `</span>, {id: userId});\n      }\n    }\n  })\n});\n\ngraphql(Schema, <span class=\"hljs-string\">`{\n  viewer {\n    id,\n    name\n  }\n}`</span>, {db, userId: <span class=\"hljs-number\">1</span>}).then((result) =&gt; <span class=\"hljs-built_in\">console</span>.log(result));\n</code></pre>\n<h3 id=\"using-arguments\">Using arguments <a class=\"hash-link\" href=\"#using-arguments\" aria-hidden=\"true\">#</a></h3>\n<p>Let’s add a root field that allows us to retrieve any <code>User</code> by <code>id</code>. Note how we will use <code>GraphQLNonNull</code> modifier to make the argument required.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Query = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Query'</span>,\n  fields: () =&gt; ({\n    viewer: {\n      type: User,\n      resolve(parent, args, {db, userId}) {\n        <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n          SELECT * FROM User WHERE id = $id\n        `</span>, {id: userId});\n      }\n    },\n    user: {\n      type: User,\n      args: {\n        id: {\n          type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID)\n        }\n      },\n      resolve(parent, {id}, {db}) {\n        <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n          SELECT * FROM User WHERE id = $id\n          `</span>, {$id: id});\n      }\n    },\n  })\n});\n</code></pre>\n<p>We’ll use the following query to test this:</p>\n<pre><code class=\"language-graphql\">{\n  <span class=\"hljs-tag\">user</span>(<span class=\"hljs-attribute\">id</span>: <span class=\"hljs-string\">\"2\"</span>) {\n    <span class=\"hljs-tag\">id</span>,\n    <span class=\"hljs-tag\">text</span>\n  }\n}\n<span class=\"hljs-comment\">// ==&gt;</span>\n{\n  <span class=\"hljs-tag\">data</span>: {\n    <span class=\"hljs-tag\">user</span>: {\n      <span class=\"hljs-attribute\">id</span>: <span class=\"hljs-string\">\"2\"</span>,\n      <span class=\"hljs-attribute\">name</span>: <span class=\"hljs-string\">\"fson\"</span>\n    }\n  }\n}\n</code></pre>\n<h2 id=\"relationships\">Relationships <a class=\"hash-link\" href=\"#relationships\" aria-hidden=\"true\">#</a></h2>\n<p>To add some stories for the users, we’ll first create a database table.</p>\n<pre><code class=\"language-sql\"><span class=\"hljs-operator\"><span class=\"hljs-keyword\">CREATE</span> <span class=\"hljs-keyword\">TABLE</span> Story\n(\n  <span class=\"hljs-keyword\">id</span> <span class=\"hljs-built_in\">INTEGER</span> PRIMARY <span class=\"hljs-keyword\">KEY</span>,\n  <span class=\"hljs-built_in\">text</span> <span class=\"hljs-built_in\">TEXT</span>,\n  author <span class=\"hljs-built_in\">INTEGER</span>,\n  FOREIGN <span class=\"hljs-keyword\">KEY</span>(author) <span class=\"hljs-keyword\">REFERENCES</span> <span class=\"hljs-keyword\">User</span>(<span class=\"hljs-keyword\">id</span>)\n);</span>\n\n<span class=\"hljs-operator\"><span class=\"hljs-keyword\">INSERT</span> <span class=\"hljs-keyword\">INTO</span> Story(<span class=\"hljs-string\">'text'</span>, <span class=\"hljs-string\">'author'</span>)\n<span class=\"hljs-keyword\">VALUES</span> ... # see scripts/createdb.<span class=\"hljs-keyword\">sql</span>\n</span></code></pre>\n<p>Now we can define <code>Story</code> in our schema.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Story = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Story'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: GraphQLID\n    },\n    text: {\n      type: GraphQLString\n    },\n    author: {\n      type: User,\n    }\n  })\n});\n</code></pre>\n<p>Unlike SQL, we define author to be of actual <code>User</code> type, instead of a foreign key. We also want to be able to get stories from the <code>User</code> side, so we modify the type accordingly.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> User = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'User'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: GraphQLID\n    },\n    name: {\n      type: GraphQLString\n    },\n    stories: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLList(Story),\n    }\n  })\n});\n</code></pre>\n<p>We’ll also add a <code>story</code> root field for convenience.</p>\n<pre><code class=\"language-javascript\">story: {\n  type: Story,\n  args: {\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID)\n    }\n  },\n  resolve(parent, {id}, {db}) {\n    <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n      SELECT * FROM Story WHERE id = $id\n      `</span>, {$id: id});\n  }\n}\n</code></pre>\n<p>So far so good. However, GraphQL doesn’t know anything about our storage system, so if we try to retrieve <code>stories</code> from <code>User</code> or <code>author</code> from <code>Story</code>, we won’t be able to get what we want – after all, <code>author</code> is a foreign key id in our database and <code>stories</code> are not in our database at all. Luckily, we can define a custom <code>resolve</code> for those fields to fix that.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> Story = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Story'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: GraphQLID\n    },\n    text: {\n      type: GraphQLString\n    },\n    author: {\n      type: User,\n      resolve(parent, args, {db}) {\n        <span class=\"hljs-keyword\">return</span> db.get(<span class=\"hljs-string\">`\n          SELECT * FROM User WHERE id = $id\n        `</span>, {$id: parent.author});\n      }\n    }\n  })\n});\n\n<span class=\"hljs-keyword\">const</span> User = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'User'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: GraphQLID\n    },\n    name: {\n      type: GraphQLString\n    },\n    stories: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLList(Story),\n      resolve(parent, args, {db}) {\n        <span class=\"hljs-keyword\">return</span> db.all(<span class=\"hljs-string\">`\n          SELECT * FROM Story WHERE author = $user\n        `</span>, {$user: parent.id});\n      }\n    }\n  })\n});\n</code></pre>\n<p>Now everything should work as expected.</p>\n<pre><code class=\"language-javascript\">{\n  user(id: <span class=\"hljs-string\">\"4\"</span>) {\n    id,\n    name,\n    stories {\n      id,\n      text\n    }\n  }\n}\n<span class=\"hljs-comment\">// ==&gt;</span>\n{\ndata: {\n  user: {\n    id: <span class=\"hljs-string\">\"4\"</span>\n    name: <span class=\"hljs-string\">\"Sophia\"</span>\n    stories: [\n      {\n        id: <span class=\"hljs-string\">\"8\"</span>\n        text: <span class=\"hljs-string\">\"\\\"How about if I sleep a little bit longer and forget all this nonsense\\\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn't get into that position.\"</span>\n      }\n    ]\n  }\n}\n</code></pre>\n<pre><code class=\"language-javascript\">{\n  story(id: <span class=\"hljs-string\">\"1\"</span>) {\n    id,\n    text,\n    author {\n      id,\n      name\n    }\n  }\n}\n<span class=\"hljs-comment\">// ==&gt;</span>\n{\n  data: {\n    story: {\n      id: <span class=\"hljs-string\">\"1\"</span>\n      text: <span class=\"hljs-string\">\"One morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin.\"</span>\n      author: {\n        id: <span class=\"hljs-string\">\"1\"</span>\n        name: <span class=\"hljs-string\">\"freiksenet\"</span>\n      }\n    }\n  }\n}\n</code></pre>\n<h2 id=\"hooking-up-with-the-server\">Hooking up with the server <a class=\"hash-link\" href=\"#hooking-up-with-the-server\" aria-hidden=\"true\">#</a></h2>\n<p>GraphQL needs only one endpoint, so it’s extremely easy to add it to the server. It’s usually a POST endpoint that accept a JSON payload with two keys – <code>query</code> and <code>variables</code>. If we parse JSON, we can pass it to GraphQL function like we did in our tests. You can see whole server code at <a href=\"https://github.com/reindexio/graphql-nodejs-newsfeed/blob/634d265f086fcdff9bb0b4392b545c6717b5373a/server.js\">./server.js</a>, The handler is shown here.</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">graphQLHandler</span>(<span class=\"hljs-params\">request, reply</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> {query, variables = {}} = request.payload;\n  <span class=\"hljs-keyword\">const</span> result = <span class=\"hljs-keyword\">await</span> graphql(\n    Schema,\n    query,\n    {db: request.db},\n    variables\n  );\n  <span class=\"hljs-keyword\">return</span> reply(result);\n}\n\nserver.route({\n  method: <span class=\"hljs-string\">'POST'</span>,\n  path: <span class=\"hljs-string\">'/'</span>,\n  handler: graphQLHandler\n});\n</code></pre>\n<h2 id=\"going-forward\">Going forward <a class=\"hash-link\" href=\"#going-forward\" aria-hidden=\"true\">#</a></h2>\n<p>There аrе so many ways we can expand our server and it’s obviously out of scope of a single blog post. Topics we are likely to cover in follow-up posts include:</p>\n<ul>\n<li>Connections – our relationships are quite primitive; one can’t paginate or filter<br>\nthem, and there is no way to find the number of related items. We’ll cover<br>\nConnection pattern, that is used to solve this at Facebook in more depth. This<br>\npattern is used by Relay to implement pagination on the client.</li>\n<li>Mutations – operations with side effects are called mutations in GraphQL. They<br>\ncan be used to modify the data stored in the database. For those operations,<br>\none would often want to do data validation, preferably without much extra<br>\nwork. We already have Object definitions, which include information about their<br>\nfields and thus can be used for validation. Unfortunately, it’s not possible<br>\nto pass Objects as arguments in GraphQL, because they can have circular<br>\ndependencies and so are unrepresentable as JSON. However, there is an<br>\nalternative called InputObject that can be used in arguments. We’ll cover how to use them in<br>\nmutations and their automatic generation from Object definitions.<br>\nWe will also cover some of InputObject use cases outside of the mutations.</li>\n<li>Users and permissions</li>\n</ul>\n<h2 id=\"further-reading\">Further reading <a class=\"hash-link\" href=\"#further-reading\" aria-hidden=\"true\">#</a></h2>\n<p><a href=\"https://medium.com/@clayallsopp/your-first-graphql-server-3c766ab4f0a2\">Several</a> <a href=\"http://davidandsuzi.com/writing-a-basic-api-with-graphql/\">tutorials</a> <a href=\"https://blog.risingstack.com/tag/graphql-server/\">have been</a> published lately about GraphQL and GraphQL.js. Our co-founder Ville has <a href=\"/blog/how-facebooks-graphql-will-change-backend-development/\">covered why we are so excited about it</a>.</p>\n<p><a href=\"https://github.com/facebook/graphql\">GraphQL spec</a> is a great reference, while GraphQL <a href=\"https://github.com/graphql/graphql-js\">implementation</a> and especially <a href=\"https://github.com/graphql/graphql-js/tree/master/src/__tests__\">tests</a> provide good examples of GraphQL schemas. Finally, conference talks from Facebook are worth watching: (<a href=\"https://www.youtube.com/watch?v=WQLzZf34FJ8\">Exploring GraphQL</a>, <a href=\"https://www.youtube.com/watch?v=9sc8Pyc51uU\">Data fetching for React applications</a>, <a href=\"https://www.youtube.com/watch?v=gY48GW87Feo\">Creating a GraphQL Server</a> and <a href=\"https://speakerdeck.com/laneyk/mutations-in-relay\">Mutations in Relay</a>)</p>\n<p><a href=\"https://news.ycombinator.com/item?id=9994307\" target=\"_blank\">Discuss this post on Hacker News.</a></p>\n"}

/***/ },
/* 338 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Discontinuing Reindex Backend as a Service","author":{"name":"Ville Immonen","image":"https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg","link":"https://twitter.com/VilleImmonen","twitter":"VilleImmonen","bio":"CEO & Co-founder"},"date":"2017-09-20T11:30:00.000Z","categories":["Reindex","GraphQL","News"],"excerpt":"Two and half years ago we started developing Reindex, the first backend as a service with a GraphQL API. Now we're moving on.","body":"<p>Two and half years ago we started developing Reindex, the first backend as a service with a GraphQL API. Today, it’s with nostalgia that we’re announcing that we are discontinuing the hosted service on 20th of October 2017.</p>\n<p>We are also making the <a href=\"https://github.com/reindexio/reindex-api\">source code of the Reindex backend</a> available under an open source license on GitHub.</p>\n<p>When we launched the beta of Reindex in September 2016, there were no other GraphQL based BaaS providers on the market. Today, there are services such as Graphcool and GraphCMS, which make it easy to set up a backend with a GraphQL API quickly and also provide a polished admin interface to manage your data and schemas. We believe these services will be successful in helping developers build better apps faster – the reason we built Reindex in the first place.</p>\n<p>Our company, Reindex Software, will continue its vision to help developers and we’re focusing our efforts on open source developer tooling in this space.</p>\n<p>Thank you to all the friends, early adopters and supporters we have met on the way. The community around GraphQL and related open source technologies is a great place to be in.</p>\n"}

/***/ },
/* 339 */
/***/ function(module, exports) {

	// empty (null-loader)

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4d85b12bd9361a8a4ddb31e8a02c8d84.png";

/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Build a GraphQL shopping cart API with Reindex","author":{"name":"Ville Immonen","image":"https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg","link":"https://twitter.com/VilleImmonen","twitter":"VilleImmonen","bio":"CEO & Co-founder"},"date":"2016-05-11T12:40:00.000Z","categories":["Reindex","tutorial","e-commerce","permissions"],"excerpt":"Build a secure shopping cart API with server-side storage and permissions using Reindex.","image":"/blog/graphql-shopping-cart-api/graphql-shopping-cart.png","body":"<img src=\"graphql-shopping-cart.png\" style=\"width: 100%; max-width: 800px;\">\n<p>Reindex is a great service for quickly prototyping and building a GraphQL API for your app. But it also simplifies moving from a prototype to a production system and scaling your app. Authorization, an essential feature for secure production apps, determines which resources each user can access and perform operations on.\nWe’ve built a flexible <a href=\"/docs/security/authorization/\">permission system</a> into Reindex for implementing authorization.</p>\n<p>In this tutorial, we’ll explore the Reindex permissions by building a shopping\ncart API with sophisticated access controls. We’ll then have a GraphQL API\nwith data storage and authentication on which we can build a client-side shopping\napp (with React Native and Relay, for example).</p>\n<h3 id=\"the-data-model-of-the-shopping-cart\">The Data Model of The Shopping Cart <a class=\"hash-link\" href=\"#the-data-model-of-the-shopping-cart\" aria-hidden=\"true\">#</a></h3>\n<p>We’ll start by sketching the data model. It comprises all the data types used to create the app and will be the basis of the app’s schema.</p>\n<ul>\n<li>\n<p><strong>Shop:</strong> Represents a shop, which has an <em>owner</em>, <em>staff</em>, and lists of <em>products</em> and <em>orders</em>.</p>\n</li>\n<li>\n<p><strong>User:</strong> Represents any person using the app, including customers, shop <em>owners</em> and <em>staff</em>.</p>\n</li>\n<li>\n<p><strong>Order:</strong> Belongs to a <em>user</em> and a <em>shop</em>, and has a bunch of <em>line items</em>.</p>\n</li>\n<li>\n<p><strong>Line Item:</strong> Has a quantity of some <em>product</em> in the <em>order</em>.</p>\n</li>\n<li>\n<p><strong>Product:</strong> Belongs to a <em>shop</em> and can be included in <em>line items</em>.</p>\n</li>\n</ul>\n<p>Below is a chart of this data model.</p>\n<p><img src=\"data-model.svg\" alt=\"A diagram of the data model\"></p>\n<h3 id=\"defining-the-schema\">Defining the Schema <a class=\"hash-link\" href=\"#defining-the-schema\" aria-hidden=\"true\">#</a></h3>\n<p>Now we can express the data model as a Reindex schema. The schema is simply a machine\nreadable representation of the data model, which Reindex uses to create a GraphQL API for your app. Let’s begin with the <code>Shop</code> and <code>User</code> types.</p>\n<h4 id=\"shop-and-user\">Shop and User <a class=\"hash-link\" href=\"#shop-and-user\" aria-hidden=\"true\">#</a></h4>\n<pre><code class=\"language-js\">[\n  {\n    name: <span class=\"hljs-string\">'Shop'</span>,\n    kind: <span class=\"hljs-string\">'OBJECT'</span>,\n    interfaces: [<span class=\"hljs-string\">'Node'</span>],\n    fields: [\n      { name: <span class=\"hljs-string\">'id'</span>, type: <span class=\"hljs-string\">'ID'</span>, nonNull: <span class=\"hljs-literal\">true</span>, unique: <span class=\"hljs-literal\">true</span> },\n      { name: <span class=\"hljs-string\">'owner'</span>, type: <span class=\"hljs-string\">'User'</span>, reverseName: <span class=\"hljs-string\">'ownShops'</span> },\n      { name: <span class=\"hljs-string\">'staff'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'User'</span>,\n        reverseName: <span class=\"hljs-string\">'staffShops'</span> },\n    ],\n  },\n  {\n    name: <span class=\"hljs-string\">'User'</span>,\n    kind: <span class=\"hljs-string\">'OBJECT'</span>,\n    interfaces: [<span class=\"hljs-string\">'Node'</span>],\n    fields: [\n      { name: <span class=\"hljs-string\">'id'</span>, type: <span class=\"hljs-string\">'ID'</span>, nonNull: <span class=\"hljs-literal\">true</span>, unique: <span class=\"hljs-literal\">true</span> },\n      { name: <span class=\"hljs-string\">'ownShops'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'Shop'</span>,\n        reverseName: <span class=\"hljs-string\">'owner'</span> },\n      { name: <span class=\"hljs-string\">'staffShops'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'Shop'</span>,\n        reverseName: <span class=\"hljs-string\">'staff'</span> },\n    ],\n  }\n]\n</code></pre>\n<p>Both types implement the <code>Node</code> interface, so they must have an <code>id</code> field. <code>owner</code> and <code>ownShops</code> form a one-to-many relationship between a <code>User</code> and several <code>Shop</code>s, and <code>staff</code> and <code>staffShops</code> form a many-to-many relationship.</p>\n<h4 id=\"order-lineitem-and-product\">Order, LineItem, and Product <a class=\"hash-link\" href=\"#order-lineitem-and-product\" aria-hidden=\"true\">#</a></h4>\n<p>The types of orders, line items, and products can be defined similarly:</p>\n<pre><code class=\"language-js\">[\n  <span class=\"hljs-comment\">// ...</span>\n  {\n    name: <span class=\"hljs-string\">'Order'</span>,\n    kind: <span class=\"hljs-string\">'OBJECT'</span>,\n    interfaces: [<span class=\"hljs-string\">'Node'</span>],\n    fields: [\n      { name: <span class=\"hljs-string\">'id'</span>, type: <span class=\"hljs-string\">'ID'</span>, nonNull: <span class=\"hljs-literal\">true</span>, unique: <span class=\"hljs-literal\">true</span> },\n      { name: <span class=\"hljs-string\">'status'</span>, type: <span class=\"hljs-string\">'String'</span> },\n      { name: <span class=\"hljs-string\">'customer'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'User'</span>,\n        reverseName: <span class=\"hljs-string\">'orders'</span> },\n      { name: <span class=\"hljs-string\">'shop'</span>, type: <span class=\"hljs-string\">'Shop'</span>, reverseName: <span class=\"hljs-string\">'orders'</span> },\n      { name: <span class=\"hljs-string\">'lineItems'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'LineItem'</span>,\n        reverseName: <span class=\"hljs-string\">'order'</span> },\n    ],\n  },\n  {\n    name: <span class=\"hljs-string\">'LineItem'</span>,\n    kind: <span class=\"hljs-string\">'OBJECT'</span>,\n    interfaces: [<span class=\"hljs-string\">'Node'</span>],\n    fields: [\n      { name: <span class=\"hljs-string\">'id'</span>, type: <span class=\"hljs-string\">'ID'</span>, nonNull: <span class=\"hljs-literal\">true</span>, unique: <span class=\"hljs-literal\">true</span> },\n      { name: <span class=\"hljs-string\">'order'</span>, type: <span class=\"hljs-string\">'Order'</span>, reverseName: <span class=\"hljs-string\">'lineItems'</span> },\n      { name: <span class=\"hljs-string\">'product'</span>, type: <span class=\"hljs-string\">'Product'</span>, reverseName: <span class=\"hljs-string\">'lineItems'</span> },\n      { name: <span class=\"hljs-string\">'quantity'</span>, type: <span class=\"hljs-string\">'Int'</span> },\n    ],\n  },\n  {\n    name: <span class=\"hljs-string\">'Product'</span>,\n    kind: <span class=\"hljs-string\">'OBJECT'</span>,\n    interfaces: [<span class=\"hljs-string\">'Node'</span>],\n    fields: [\n      { name: <span class=\"hljs-string\">'id'</span>, type: <span class=\"hljs-string\">'ID'</span>, nonNull: <span class=\"hljs-literal\">true</span>, unique: <span class=\"hljs-literal\">true</span> },\n      { name: <span class=\"hljs-string\">'name'</span>, type: <span class=\"hljs-string\">'String'</span> },\n      { name: <span class=\"hljs-string\">'shop'</span>, type: <span class=\"hljs-string\">'Shop'</span>, reverseName: <span class=\"hljs-string\">'products'</span> },\n      { name: <span class=\"hljs-string\">'lineItems'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'LineItem'</span>,\n        reverseName: <span class=\"hljs-string\">'product'</span> },\n    ],\n  },\n]\n</code></pre>\n<p>Finally, we must add the reverse fields, which refer to these types in <code>Shop</code>:</p>\n<pre><code class=\"language-js\">{ name: <span class=\"hljs-string\">'orders'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'Order'</span>,\n  reverseName: <span class=\"hljs-string\">'shop'</span> },\n{ name: <span class=\"hljs-string\">'products'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'Product'</span>,\n  reverseName: <span class=\"hljs-string\">'shop'</span> },\n</code></pre>\n<p>as well as the <code>orders</code> field in <code>User</code>:</p>\n<pre><code class=\"language-js\">{ name: <span class=\"hljs-string\">'orders'</span>, type: <span class=\"hljs-string\">'Connection'</span>, ofType: <span class=\"hljs-string\">'Order'</span>,\n  reverseName: <span class=\"hljs-string\">'customer'</span> },\n</code></pre>\n<p>We’ll save this schema in a file named <code>ReindexSchema.json</code>, then push it to Reindex with the CLI. (If you don’t have a Reindex app yet, you can get one <a href=\"/\">here</a> for free.)</p>\n<pre><code class=\"language-sh\">reindex login\nreindex schema-push\n</code></pre>\n<p>When you run the <code>schema-push</code> command, the Reindex service reads the data model\nyou’ve defined in the schema file and creates a GraphQL API for it, including\npaginated lists and mutations for updating the data. You get a fully functional\nRelay-compatible GraphQL API that stores data in a hosted MongoDB database.</p>\n<p>We can now open the app in GraphiQL (an in-browser GraphQL IDE) with the\n<code>reindex graphiql</code> command, play with the API, and make some queries.</p>\n<p>We haven’t yet defined any of the permissions that will allow all users to access the data. Let’s add those permissions next.</p>\n<h3 id=\"permissions\">Permissions <a class=\"hash-link\" href=\"#permissions\" aria-hidden=\"true\">#</a></h3>\n<p>The permissions of Reindex correspond to the graph-like structure of the data stored in\nReindex: if a type has a field that contains a <code>User</code> type or is otherwise related to a user (even if through a long chain of relationships), you can grant permissions to the related user.</p>\n<p>For example, an order is related to a user, not only through the <code>customer</code> field, but\nalso indirectly, through the <code>owner</code> and <code>staff</code> fields of the shop associated with the order. All these relationships can be the basis of permissions. For example, to allow the shop owners to update their shops’ orders, we can create and add to the <code>Order</code> type the following permission:</p>\n<pre><code class=\"language-js\">{\n  name: <span class=\"hljs-string\">'Order'</span>,\n  <span class=\"hljs-comment\">// ...</span>\n  permissions: [\n    { grantee: <span class=\"hljs-string\">'USER'</span>, userPath: [<span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'owner'</span>], update: <span class=\"hljs-literal\">true</span> },\n  ],\n}\n</code></pre>\n<p>The chain of field names, or <code>userPath</code>, can be as long as necessary, as long as it begins with a field of the type we’re defining a permission for and ends with a <code>User</code> or <code>UserConnection</code> field. This is quite a powerful feature. Specifying permissions through chains of fields allows us to model fairly complex permissions without writing complex code or maintaining separate access control lists or roles—it’s\nall declarative and all defined in terms of the data.</p>\n<h4 id=\"permissions-for-all-users\">Permissions for All Users <a class=\"hash-link\" href=\"#permissions-for-all-users\" aria-hidden=\"true\">#</a></h4>\n<p>Everyone should be able to see the shops and their products, so we’ll start by adding this permission to both <code>Product</code> and <code>Shop</code>:</p>\n<pre><code class=\"language-js\">{ grantee: <span class=\"hljs-string\">'EVERYONE'</span>, read: <span class=\"hljs-literal\">true</span> }\n</code></pre>\n<p>We also want to allow authenticated users to see other users’ public information, so we’ll add this permission to <code>User</code>:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'AUTHENTICATED'</span>,\n  read: <span class=\"hljs-literal\">true</span>,\n}\n</code></pre>\n<h4 id=\"shop\">Shop <a class=\"hash-link\" href=\"#shop\" aria-hidden=\"true\">#</a></h4>\n<p>A shop should only be created, updated, and deleted by its owner. Adding to <code>Shop</code> a permission that refers to the <code>owner</code> field and grants these rights creates the restrictions:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'owner'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n  <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>\n}\n</code></pre>\n<h4 id=\"permissions-and-relationships\">Permissions and Relationships <a class=\"hash-link\" href=\"#permissions-and-relationships\" aria-hidden=\"true\">#</a></h4>\n<p>We also want to allow users to add staff to their own shops. To add a relationship between nodes, the user must have access to the fields on both sides of the relationship. Therefore, we must add a permission to <code>User</code> that allows other authenticated users to update the <code>staffShops</code> field:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'AUTHENTICATED'</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n  permittedFields: [<span class=\"hljs-string\">'staffShops'</span>],\n}\n</code></pre>\n<p>Now, when a user wants to add or remove an employee, Reindex verifies that the user\nhas a permission to update the <code>staff</code> field of <code>Shop</code> and <code>staffShops</code> field of <code>User</code>. This ensures that users can only add staff to their own shop. The permission we added above will make the <code>staff</code> field available to users who are adding themselves as <code>owner</code>s and not attempting to create a shop on someone else’s account. <code>staffShops</code> permission is granted to authenticated users.</p>\n<p>The list of a shop’s orders must be updated when a new order is placed, so we’ll add this to the <code>Shop</code> permissions:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'AUTHENTICATED'</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n  permittedFields: [<span class=\"hljs-string\">'orders'</span>],\n},\n</code></pre>\n<p>Authenticated users need a permission to update <code>Product.lineItems</code> so that the user who is creating a line item can add a product to it:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'AUTHENTICATED'</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n  permittedFields: [<span class=\"hljs-string\">'lineItems'</span>],\n},\n</code></pre>\n<h4 id=\"permissions-for-product\">Permissions for Product <a class=\"hash-link\" href=\"#permissions-for-product\" aria-hidden=\"true\">#</a></h4>\n<p>We want to allow shop owners to <em>create</em>, <em>update</em>, and <em>delete</em> products that belong to their shops (i.e., products with a value of <code>shop</code> that corresponds to their shops).\nNothing new here, let’s simply add this to the permissions of <code>Shop</code>:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'owner'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n  <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>,\n}\n</code></pre>\n<h4 id=\"permissions-for-order-and-lineitem\">Permissions for Order and LineItem <a class=\"hash-link\" href=\"#permissions-for-order-and-lineitem\" aria-hidden=\"true\">#</a></h4>\n<p>Finally, let’s define the permissions for <code>Order</code> and <code>LineItem</code>.</p>\n<p>We want the shop owner to be able to change the orders and line items.\nCustomers should be able to create orders and see their own orders. In addition, the staff should be able to see the orders and update order status.</p>\n<p>Let’s add these privileges. Here are the permissions to be added to <code>Order</code>:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// The shop owner can read, create and update orders.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'owner'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  read: <span class=\"hljs-literal\">true</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n},\n<span class=\"hljs-comment\">// The shop staff can read the orders of the shop.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'staff'</span>],\n  read: <span class=\"hljs-literal\">true</span>,\n},\n<span class=\"hljs-comment\">// The shop staff can update the status of an order.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'staff'</span>],\n  update: <span class=\"hljs-literal\">true</span>,\n  permittedFields: [<span class=\"hljs-string\">'status'</span>],\n},\n<span class=\"hljs-comment\">// The customer can create orders and read their own orders.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'customer'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  read: <span class=\"hljs-literal\">true</span>,\n},\n</code></pre>\n<p>The permissions for <code>LineItem</code> are similar:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// The shop owner can create, read and update line items.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'order'</span>, <span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'owner'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  read: <span class=\"hljs-literal\">true</span>,\n  update: <span class=\"hljs-literal\">true</span>,\n},\n<span class=\"hljs-comment\">// The shop staff can read the line items of the orders of the shop.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'order'</span>, <span class=\"hljs-string\">'shop'</span>, <span class=\"hljs-string\">'staff'</span>],\n  read: <span class=\"hljs-literal\">true</span>,\n},\n<span class=\"hljs-comment\">// The customer can create and read line items in their own orders.</span>\n{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'order'</span>, <span class=\"hljs-string\">'customer'</span>],\n  create: <span class=\"hljs-literal\">true</span>,\n  read: <span class=\"hljs-literal\">true</span>,\n},\n</code></pre>\n<p>That’s all. We can now add all the permissions to the schema and push the schema to Reindex again to make our API secure.</p>\n<pre><code class=\"language-sh\">reindex schema-push\n</code></pre>\n<p>You can find the final schema here:\n<a href=\"https://gist.github.com/fson/4334a6de53e9403ed855eed8d97e4c42\">shopping cart schema with permissions\n.</a></p>\n<h3 id=\"conclusion\">Conclusion <a class=\"hash-link\" href=\"#conclusion\" aria-hidden=\"true\">#</a></h3>\n<p>Hopefully, I’ve given you a taste of what Reindex permissions are capable of. In this tutorial, we used the shopping cart as an example, but these simple permissions allow you to create sophisticated access control rules for\nany data model. Automatic permission checks occur when you read or update the data using the GraphQL API of Reindex;  you don’t have to write any complicated code to perform them.</p>\n<p>We would love to hear what you’re building and whether you found this tutorial useful! Say hello: <a href=\"mailto:hello@reindex.io\">hello@reindex.io</a>.</p>\n<p><a href=\"https://news.ycombinator.com/item?id=11674364\">Discuss this post on Hacker News.</a></p>\n"}

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "44483b6c4083f9503e075863fa67f786.png";

/***/ },
/* 343 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"How Facebook's GraphQL Will Change Backend Development","author":{"name":"Ville Immonen","image":"https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg","link":"https://twitter.com/VilleImmonen","twitter":"VilleImmonen","bio":"CEO & Co-founder"},"date":"2015-04-27T15:45:26.000Z","categories":["GraphQL","Open Source","Web"],"excerpt":"Why we're excited about GraphQL, the data query language for fetching data in mobile and web apps?","image":"/blog/how-facebooks-graphql-will-change-backend-development/GraphQL_logo.png","body":"<p><img src=\"GraphQL_logo.png\" alt=\"\"></p>\n<p>In the early days of web the pages sent to the client were just static HTML, but some interactivity was soon built by generating those pages on the fly for each request. JavaScript was released and we started adding snippets of it on those pages. The release of XMLHttpRequest enabled pages to easily fetch more data from the server and, as time passed, people started to built single-page applications, where the backend became just a JSON API for the app running fully in the browser.</p>\n<p><a href=\"https://facebook.github.io/react/\" target=\"_blank\">Awesome libraries like React</a> emerged and made building these single-page apps with JavaScript faster than ever before and easy to reason about the flow of data, resulting in maintainable and blazing fast user interfaces.</p>\n<p>But someone still had to build, test and maintain that backend, deploy it to a server, monitor it and keep it running. The backend was often built using different languages and tools by a separate group of developers, leading to communication overhead and knowledge silos. Complex code was required to integrate the backend API with the apps running on the client. The inception of backend as a service (BaaS) brought some help to the situation on the server: the provider of the BaaS would give you access to their generic backend that would store your data and let you access it, typically using a REST API. This reduced the amount of work required to get an app running and deployed.</p>\n<p>But even though client-side libraries were usually provided by the vendor, building the app on top of any backend, including BaaS, still required lots of custom (and typically vendor specific) code on the client to integrate with it.</p>\n<h3 id=\"facebook-leading-the-way\">Facebook Leading the Way <a class=\"hash-link\" href=\"#facebook-leading-the-way\" aria-hidden=\"true\">#</a></h3>\n<p>Fast forward to 2015, <a href=\"https://facebook.github.io/react/blog/2015/02/20/introducing-relay-and-graphql.html\" target=\"_blank\">Relay and GraphQL are introduced</a> by Facebook. The soon-to-be-open-sourced library Relay manages the data of an application on the client and automatically fetches data from the server. It uses a new query language called GraphQL to build a query that fetches exactly the data that the components of the application need, by combining the queries defined in each component. The generic data store in Relay makes it unnecessary to write custom code for each type of data and handles many common patterns like pagination and optimistic updates.</p>\n<h3 id=\"relay-the-only-store-you-need-on-the-client\">Relay – the Only Store You Need on the Client <a class=\"hash-link\" href=\"#relay-the-only-store-you-need-on-the-client\" aria-hidden=\"true\">#</a></h3>\n<p><a title=\"Flux\" href=\"https://facebook.github.io/flux/docs/overview.html\" target=\"_blank\">Flux</a> is a nice way to structure large applications with its dispatcher, stores and actions. Its simple data flow really makes applications easier to reason about, even for new people joining a project. But it leaves many questions open that you need to solve yourself, particularly around how to talk to a backend. This is a lot of work to implement correctly and things like server-side rendering complicate things further. There is a proliferation of Flux implementations, and while great for the innovation in the community, this can also be overwhelming while starting a project. The different implementations solve different problems and to solve all the problems of you easily end up rolling out yet another flavor of Flux.</p>\n<p><em>Relay</em> is the next evolution of Flux. In apps using Relay, the components define their data fetching needs. Relay does to data fetching what React did to UI: it makes it declarative. Components defining their data queries inline enables Relay to merge together the queries from all the components, fetch all the data required before the app is rendered and manage the data and updates to it.</p>\n<p>Instead of you writing a new store for each type of data, Relay has one store for all your data. This lets Relay handle many common tasks. For example optimistic updates: it’s desirable to update the application state optimistically when doing mutations to data, so the UI updates immediately. Using Flux, this is typically handled in stores by storing the new value there, possibly keeping a reference to the previous value in an immutable data structure to enable rolling back, if something goes wrong. This is not trivial and there aren’t too many generic solutions, resulting in more code to build, test and maintain. Relay takes care of this for us in its store using a queue for pending updates and automatically handles errors.</p>\n<p>There is a bunch of these benefits that you get for free by using Relay to manage the data. It handles paginated queries, wires up the store to your components etc. And it’s going to be a battle tested chunk of code like React is: Facebook is already using it in their production apps such as Ads for iOS (a React Native app) with more coming. It’s in their best interest to make it as robust as possible.</p>\n<h3 id=\"graphql-simple-and-declarative-query-language\">GraphQL – Simple and Declarative Query Language <a class=\"hash-link\" href=\"#graphql-simple-and-declarative-query-language\" aria-hidden=\"true\">#</a></h3>\n<p>The data fetching needs of components are defined using GraphQL – a new query language that Relay uses to talk to the server. The syntax is very simple. Let’s we have a component that shows a photo posted by a user. It needs some data like this:</p>\n<pre><code class=\"language-json\">{\n  \"<span class=\"hljs-attribute\">id</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"c49bc1e1-26c1-49c5-b9c5-c89e24be0ac4\"</span></span>,\n  \"<span class=\"hljs-attribute\">url</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"https://pics.example.com/dog\"</span></span>,\n  \"<span class=\"hljs-attribute\">caption</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"My Dog\"</span></span>,\n  \"<span class=\"hljs-attribute\">author</span>\": <span class=\"hljs-value\">{\n    \"<span class=\"hljs-attribute\">id</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"5a0cba48-c014-4cf0-b6fb-0bf7514b8165\"</span></span>,\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Alice\"</span>\n  </span>}\n</span>}\n</code></pre>\n<p>To write a GraphQL query to fetch that you can simply imagine taking this JSON object and removing all the values and adding what is called a “root call” in the beginning, ending up with this query:</p>\n<pre><code class=\"language-graphql\">node(<span class=\"hljs-property\">id</span>: <span class=\"hljs-string\">\"c49bc1e1-26c1-49c5-b9c5-c89e24be0ac4\"</span>) {\n  <span class=\"hljs-property\">id</span>,\n  url,\n  caption,\n  author {\n    <span class=\"hljs-property\">id</span>,\n    <span class=\"hljs-property\">name</span>\n  }\n}\n</code></pre>\n<p>This is GraphQL. Relay combines GraphQL queries from your components and sends the combined query for fetching all the necessary data to the server. The server simply responds with a JSON object with data.</p>\n<p>Writing queries like this has a number of benefits. First of all, your backend doesn’t end up having custom endpoints for all different kinds of data. That means less code for adding new features. There is just the GraphQL endpoint and it can be optimized and cached heavily.</p>\n<p>The client only fetches what it needs. Making changes to an application results in new fields being added and removed. After a while it’s very hard to tell if some field is used in some part of the app or if it could be removed. Removing a field from one component can subtly break another component that implicitly depended on it. Over-fetching (bloating the size of responses) and under-fetching (breaking the app) happens easily. With each component declaring the data it depends on this problem goes away.</p>\n<h4 id=\"why-rest-is-not-enough\">Why REST Is Not Enough? <a class=\"hash-link\" href=\"#why-rest-is-not-enough\" aria-hidden=\"true\">#</a></h4>\n<p>A common way to structure a backend API these days is with REST, specifying endpoints for each type, or <em>resource</em>. Where this breaks down however, is when we want to build any view in our app that requires a tree of related resources, e.g. a feed of shared photos with some comments on each photo and the users who commented. You have to make multiple requests, which can be very slow especially when those requests can not be made in parallel. The code to perform these fetches can also become quite complex, adding to the burden of integrating the frontend with an API. Alternatively you end up creating custom endpoints for the specific needs of your apps, with more backend code to write and maintain. Especially hard, if you have more than one app using the same API. Making even small changes in a backend like this can be a lot of work and have unexpected effects on the apps using it, requiring lots of coordination between different developers and teams.</p>\n<p>A GraphQL backend has a schema that defines which fields and calls are available for each type of data. This means adding new models or fields becomes a simple task of adding or modifying types in the schema. When a field has been added in the schema it can be queried. A frontend developer can then go and make a change in just the component that actually uses the data and it works. GraphQL makes it possible to build a backend and integrate it with the frontend with much less custom plumbing than before and to make fast changes with less fear of breaking things.</p>\n<p>Making queries becomes even easier with tools that provide autocomplete for queries based on the schema (the schema can be queried with GraphQL queries too). One such tool is GraphiQL, used internally at Facebook and we expect many open source tools to become available after GraphQL is released.</p>\n<h3 id=\"this-is-where-the-magic-happens\">This Is Where the Magic Happens <a class=\"hash-link\" href=\"#this-is-where-the-magic-happens\" aria-hidden=\"true\">#</a></h3>\n<blockquote class=\"twitter-tweet\" lang=\"en\"><p lang=\"en\" dir=\"ltr\">Spent the afternoon with the relay team at facebook today. Their new office is amazing but the team is even better :) <a href=\"http://t.co/QO3NlUyCDx\">pic.twitter.com/QO3NlUyCDx</a></p>&mdash; Ryan Florence (@ryanflorence) <a href=\"https://twitter.com/ryanflorence/status/591039205721047040\">April 23, 2015</a></blockquote>\n<p>With React, Facebook revolutionized how UI is built for web and mobile apps. Now they are revolutionizing data fetching for those apps. We are looking forward to the open source release of Relay and GraphQL by the amazing team of Facebook engineers and everything the community comes up with after that happens. The future looks bright.</p>\n<h3 id=\"stay-tuned\">Stay Tuned <a class=\"hash-link\" href=\"#stay-tuned\" aria-hidden=\"true\">#</a></h3>\n<p><em>We think Relay and GraphQL can change how apps are built. That’s by why we are building <a href=\"https://www.reindex.io/\">Reindex</a> – the first backend as a service optimized for React and Relay. More details coming in the next few weeks!</em></p>\n<p><a href=\"https://news.ycombinator.com/item?id=9446731\" target=\"_blank\">Discuss this post on Hacker News.</a></p>\n"}

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reactDocumentTitle = __webpack_require__(262);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _moment = __webpack_require__(266);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashCollectionSortByOrder = __webpack_require__(330);
	
	var _lodashCollectionSortByOrder2 = _interopRequireDefault(_lodashCollectionSortByOrder);
	
	var _reactRouter = __webpack_require__(155);
	
	var _gatsbyHelpers = __webpack_require__(259);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var mutedColor = '#848484';
	var styles = {
	  post: {
	    display: 'flex',
	    marginBottom: rhythm(1)
	  },
	  postContent: {
	    flex: 1
	  },
	  postLink: {
	    textDecoration: 'none'
	  },
	  authorImage: {
	    borderRadius: '50%',
	    width: 64,
	    height: 64,
	    margin: '0 20px 0 0'
	  },
	  meta: {
	    color: mutedColor,
	    fontSize: '13px',
	    textTransform: 'uppercase',
	    marginBottom: '0.3em',
	    fontWeight: 300,
	    letterSpacing: '1px'
	  }
	};
	
	var BlogIndex = _react2['default'].createClass({
	  displayName: 'BlogIndex',
	
	  mixins: [_reactRouter.State],
	
	  render: function render() {
	    var childPages = (0, _gatsbyHelpers.templateChildrenPages)(__filename, this.props.state).filter(function (child) {
	      return child.data;
	    }).map(function (child) {
	      return _extends({}, child.data, {
	        path: child.path
	      });
	    });
	    childPages = (0, _lodashCollectionSortByOrder2['default'])(childPages, ['date'], ['desc']);
	
	    var posts = childPages.map(function (post) {
	      var author = post.author;
	
	      var date = (0, _moment2['default'])(post.date).locale('en');
	      return _react2['default'].createElement(
	        'div',
	        { style: styles.post, key: post.path },
	        _react2['default'].createElement('img', { src: author.image, style: styles.authorImage }),
	        _react2['default'].createElement(
	          'div',
	          { style: styles.postContent },
	          _react2['default'].createElement(
	            'h2',
	            null,
	            _react2['default'].createElement(
	              _reactRouter.Link,
	              { to: post.path, style: styles.postLink },
	              post.title
	            )
	          ),
	          _react2['default'].createElement(
	            'p',
	            null,
	            post.excerpt
	          ),
	          _react2['default'].createElement(
	            'div',
	            { style: styles.meta },
	            'By ',
	            author.name,
	            ' —',
	            ' ',
	            _react2['default'].createElement(
	              'time',
	              { pubdate: true, dateTime: date.toISOString() },
	              date.format('MMMM Do, YYYY')
	            )
	          )
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      _reactDocumentTitle2['default'],
	      {
	        title: 'Blog | Reindex' },
	      _react2['default'].createElement(
	        'ul',
	        { style: { margin: 0 } },
	        posts
	      )
	    );
	  }
	});
	
	exports['default'] = BlogIndex;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, "blog/index.jsx"))

/***/ },
/* 345 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Comparing Redux and Relay","author":{"name":"Mikhail Novikov","image":"https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg","link":"https://twitter.com/freiksenet","twitter":"freiksenet","bio":"CTO & Co-founder"},"date":"2016-04-29T22:59:00.000Z","categories":["React","Relay","Flux","Redux","JavaScript","GraphQL"],"excerpt":"Relay and Redux are both state-of-the-art client-side state management libraries for React. In this article we compare the approaches Relay and Redux take and their strengths and weaknesses.","image":"/blog/redux-and-relay/redux-and-relay.png","body":"<p><img src=\"redux-and-relay.png\" alt=\"\"></p>\n<p>When developing modern React applications, at some point you need to solve the\nproblem of managing your client-side state. Modern applications can’t\nafford to wait for the server to react, can’t always refetch when changing\npages – they need to be reactive and feel as if everything is happening as fast\nas possible. The state management layer of your application is responsible for\nthis. You can also call it your caching layer or a model layer.</p>\n<p>Redux and Relay are libraries for implementing this layer in your application.\nIn this article I’ll compare how those two libraries work with some code\nexamples for common problems.</p>\n<h2 id=\"architectural-overview\">Architectural overview <a class=\"hash-link\" href=\"#architectural-overview\" aria-hidden=\"true\">#</a></h2>\n<p>Both Redux and Relay were inspired by Flux, an architectural pattern for\ndesigning your applications. The basic idea of Flux is to always make your data\nflow in one direction in the application, from your <em>Stores</em> to your (React)\n<em>Components</em>. <em>Components</em> call <em>Action Creators</em>, they dispatch <em>Actions</em>\nthat your <em>Stores</em> react to. Flux was originally presented by Facebook, but they\ndidn’t provide a library with it. However, very soon many Flux implementations\nappeared in the community and many more custom implementations\nare hidden inside closed-source codebases :). Flux matches the model of\nReact very well, because it tries to prevent data from flowing upward from\nchildren to stores, by moving that chain out to action dispatch.</p>\n<h3 id=\"redux\">Redux <a class=\"hash-link\" href=\"#redux\" aria-hidden=\"true\">#</a></h3>\n<p>Redux was born as a very minimal implementation of the Flux pattern. Eschewing\nthe multiple Store pattern from Flux, it has one central store. Store data can\nbe mapped to components via transformation functions. Store can handle actions\nvia <em>reducers</em>. The biggest difference is that a reducer should always be a pure\nfunction that takes the old state and an action and returns a new state. In the\noriginal Flux, the stores usually mutate their state as a reaction to Actions,\nin Redux it’s always a functional transformation. Any data can be stored in a\nRedux store, Redux has no opinion about the data source.</p>\n<p>Redux is a very minimal library. Actions can be intercepted and transformed\nvia <em>middlewares</em> and many of them are available from the community, both to\nmake it easier to write your applications in Redux and to provide some complete\nfunctionality.</p>\n<h3 id=\"relay\">Relay <a class=\"hash-link\" href=\"#relay\" aria-hidden=\"true\">#</a></h3>\n<p>Relay is in many ways inspired by Flux too. There is a central store, changes to\nit are made through actions (called <em>Mutations</em> in Relay). However, Relay\ndoesn’t give developers control over the contents of the Store. Rather, Relay\nleverages GraphQL query language to automatically decompose, store and modify\nthe data received from the server. Components declare their data requirements\nvia GraphQL query <em>fragments</em> and Relay automatically composes the query that\nfulfills the requirements of all components in the current component tree.\nModifications to the Store can be done through a declarative mutation API, but\nall mutations correspond to server-side mutations. Unlike Redux, you can only\nstore data that has corresponding data on the server in Relay and the server\nmust have a GraphQL API.</p>\n<p>Relay provides many features out of the box. Relay handles all the data fetching\nand makes sure that all (and only) the required data is fetched. Relay has rich\nsupport for pagination, especially for use cases isomorphic to infinite\nscrolling. Relay mutations can perform optimistic updates, report their status\nand rollback.</p>\n<h2 id=\"component-integration\">Component integration <a class=\"hash-link\" href=\"#component-integration\" aria-hidden=\"true\">#</a></h2>\n<h3 id=\"redux-2\">Redux <a class=\"hash-link\" href=\"#redux-2\" aria-hidden=\"true\">#</a></h3>\n<p>Both Relay and Redux provide a very good React integration. Redux is less\ndependent on React and can be used with other frameworks without a problem.\nRelay currently can only be used with React (or React Native). However, work is\nbeing done on extracting the component layer from Relay, so that it can be used\noutside React.</p>\n<p>Redux encourages separating the presentation and data logic through a concept of\n<em>smart</em> and <em>dumb</em> components. Usually smart components are created by Redux,\nthey subscribe to a store and can dispatch actions. Dumb components are just\nnormal React components. Smart components describe the data that they require by\ndefining a function that maps store state to their props. Multiple smart\ncomponents can exists, but usually the component hierarchy should be kept dumb\nand it should get the data through props.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> { connect } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-redux'</span>\n\nconst getVisibleTodos = (todos, filter) =&gt; {\n  switch (filter) {\n    case <span class=\"hljs-string\">'SHOW_ALL'</span>:\n      return todos\n    case <span class=\"hljs-string\">'SHOW_COMPLETED'</span>:\n      return todos.filter(t =&gt; t.completed)\n    case <span class=\"hljs-string\">'SHOW_ACTIVE'</span>:\n      return todos.filter(t =&gt; !t.completed)\n  }\n}\n\nconst mapStateToProps = (state) =&gt; {\n  return {\n    todos: getVisibleTodos(state.todos, state.visibilityFilter)\n  }\n}\n\nconst VisibleTodoList = connect(\n  mapStateToProps,\n)(TodoList)\n\nexport default VisibleTodoList\n</code></pre>\n<p>Redux requires a top level component called <em>Provider</em> that will pass all the\nprops needed by Redux smart components into the React context.</p>\n<pre><code class=\"language-js\">render(\n  <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Provider</span> <span class=\"hljs-attribute\">store</span>=<span class=\"hljs-value\">{store}</span>&gt;</span>\n    <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">App</span> /&gt;</span>\n  <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">Provider</span>&gt;</span>,\n  document.getElementById('root')\n)\n</span></code></pre>\n<h3 id=\"relay-2\">Relay <a class=\"hash-link\" href=\"#relay-2\" aria-hidden=\"true\">#</a></h3>\n<p>In Relay most components are <em>smart</em>. Relay wraps React components in Relay\nContainers. Containers declare what data they need to render with a GraphQL\nfragment. Containers can compose fragments from their child components, but the\nactual requirements are opaque. This way containers are isolated from each\nother and it’s possible to reuse or change them without worrying about data\nnot being available. Resolved fragments are passed to the component as simple\nprops.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Todo</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">React</span>.<span class=\"hljs-title\">Component</span> </span>{\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">div</span>&gt;</span>{this.props.todo.id} {this.props.todo.text}<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">div</span>&gt;</span>\n    )</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">const</span> TodoContainer = Relay.createContainer(Todo, {\n  fragments: {\n    todos: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on Todo {\n        id,\n        text\n      }\n    `</span>,\n  }\n})\n</code></pre>\n<p>Fragments from the whole component tree are composed together into one query.\nData that has already been fetched before will be subtracted from the query and\nif all the data is available, no query will be made.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> TodoListContainer = Relay.createContainer(Todo, {\n  fragments: {\n    todoList: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on TodoConnection {\n        count,\n        edges {\n          node {\n            <span class=\"hljs-subst\">${TodoContainer.getFragment('todo')}</span>\n          }\n        }\n      }\n    `</span>,\n  },\n})\n</code></pre>\n<p>Relay has a root level component called <em>RootContainer</em> that acts like an entry\npoint. RootContainer requires a Container and a <em>Route</em>. Relay Routes define the\n<em>start</em> of the query, the actual query root into which the fragments from the\nwhole component tree will be composed into. Route is needed because similar\ncomponent trees might have different initial source, for example we can imagine\na <code>&lt;TodoList /&gt;</code> component that can be rendered both as a list of tasks of the\nwhole team or only as tasks of one person. Routes can also have parameters, for\nexample to be able to pass an object id.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoRoute</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Route</span> </span>{\n  static routeName = <span class=\"hljs-string\">'TodoRoute'</span>;\n\n  static queries = {\n    todoById: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      query {\n        todoById(id: $id)\n      }\n    `</span>\n  };\n\n  static paramDefinitions = {\n    id: { required: <span class=\"hljs-literal\">true</span> }\n  };\n}\n\nrender(\n  <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Relay.RootContainer</span>\n    <span class=\"hljs-attribute\">Component</span>=<span class=\"hljs-value\">{SingleTodoContainer}</span>\n    <span class=\"hljs-attribute\">route</span>=<span class=\"hljs-value\">{new</span> <span class=\"hljs-attribute\">TodoListRoute</span>} /&gt;</span>,\n  document.getElementById('root')\n)\n</span></code></pre>\n<h2 id=\"mutations\">Mutations <a class=\"hash-link\" href=\"#mutations\" aria-hidden=\"true\">#</a></h2>\n<p>Changing the data in the store is another common task for a client-side data\nmanagement layer. Often we want to react to user actions fast, to do so-called\noptimistic updates. After that we will wait for the server to return the result\nof the actual server call, and if the result is successful, we will confirm our\nchanges.</p>\n<p>Let’s make a mutation that changes the text of a TODO item, updates it on the\nserver, and rolls back the change, if it fails.</p>\n<h3 id=\"redux-3\">Redux <a class=\"hash-link\" href=\"#redux-3\" aria-hidden=\"true\">#</a></h3>\n<p>We will use the <a href=\"http://redux.js.org/docs/advanced/AsyncActions.html\">thunk\nmiddleware</a> to perform\nasync actions. We will dispatch an optimistic change first, then either roll it\nback or confirm it.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">todoChange</span>(<span class=\"hljs-params\">id, text, isOptimistic</span>) </span>{\n  <span class=\"hljs-keyword\">return</span> {\n    type: TODO_CHANGE,\n    todo: { id, text, isOptimistic }\n  };\n}\n\n<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">editTodo</span>(<span class=\"hljs-params\">id, text</span>) </span>{\n  <span class=\"hljs-keyword\">return</span> (dispatch, getState) =&gt; {\n    <span class=\"hljs-keyword\">const</span> oldTodo = getState().todos[id];\n    <span class=\"hljs-comment\">// Perform optimistic update</span>\n    dispatch(todoChange(id, text, <span class=\"hljs-literal\">true</span>))\n    fetch(<span class=\"hljs-string\">`/todo/<span class=\"hljs-subst\">${id}</span>`</span>, {\n      method: <span class=\"hljs-string\">'POST'</span>\n    }).then((result) =&gt; {\n      <span class=\"hljs-keyword\">if</span> (result.code === <span class=\"hljs-string\">'200'</span>) {\n        <span class=\"hljs-comment\">// Confirm update</span>\n        dispatch(todoChange(id, text, <span class=\"hljs-literal\">false</span>))\n      } <span class=\"hljs-keyword\">else</span> {\n        dispatch(todoChange(oldTodo.id, oldTodo.text, <span class=\"hljs-literal\">false</span>))\n      }\n    })\n  }\n}\n\n<span class=\"hljs-comment\">// In the store handler</span>\n<span class=\"hljs-keyword\">case</span> TODO_CHANGE:\n  <span class=\"hljs-keyword\">return</span> {\n    ...state,\n    todos: {\n      ...state.todos,\n      [id]: {\n        id,\n        text,\n        isOptimistic\n      }\n    }\n  }\n)\n\n<span class=\"hljs-comment\">// Now we can dispatch it</span>\n\nstore.dispatch(editTodo(todo.id, todo.text));\n</code></pre>\n<h3 id=\"relay-3\">Relay <a class=\"hash-link\" href=\"#relay-3\" aria-hidden=\"true\">#</a></h3>\n<p>There are no custom actions in Relay. Instead, we will need to define a\n<em>Mutation</em> using Relay mutation DSL. I should note that GraphQL\nmutations work in an interesting way – mutation is an operation and then a\nquery, so we can request the data with GraphQL mutations in a similar way as\nwith a GraphQL query. This way we can request the data that changed, so that\nRelay knows what to update.</p>\n<p>I’ll go through every element in mutation class in the comments.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">ChangeTodoTextMutation</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Mutation</span> </span>{\n  <span class=\"hljs-comment\">// Get the name of the mutation on server, so that we can call the server</span>\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation{ updateTodo }`</span>;\n  }\n\n  <span class=\"hljs-comment\">// Map the props passed to mutation to the server input object</span>\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.id,\n      text: <span class=\"hljs-keyword\">this</span>.props.text,\n    };\n  }\n\n  <span class=\"hljs-comment\">// Define a query on the resulting payload, with all the data that changed</span>\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoPayload {\n        changedTodo {\n          id\n          text\n        }\n      }\n    `</span>;\n  }\n\n  <span class=\"hljs-comment\">// Define what exactly Relay should change in the store. In this case</span>\n  <span class=\"hljs-comment\">// we say that it should match the item from `changedTodo` element in the</span>\n  <span class=\"hljs-comment\">// result with an item in the store by id and then update the item in the</span>\n  <span class=\"hljs-comment\">// store</span>\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [{\n      type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n      fieldIDs: {\n        changedTodo: <span class=\"hljs-keyword\">this</span>.props.id,\n      },\n    }];\n  }\n\n  <span class=\"hljs-comment\">// To make Relay make an optimistic update, we need to \"fake\" the response</span>\n  <span class=\"hljs-comment\">// from the server. Here it's pretty easy.</span>\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      changedTodo: {\n        id: <span class=\"hljs-keyword\">this</span>.props.id,\n        text: <span class=\"hljs-keyword\">this</span>.props.text,\n      },\n    };\n  }\n}\n</code></pre>\n<p>Now this mutation can be dispatched in a similar way as an action.</p>\n<pre><code class=\"language-js\">Relay.Store.commitUpdate(\n  <span class=\"hljs-keyword\">new</span> ChangeTodoTextMutation({\n    id: <span class=\"hljs-keyword\">this</span>.props.todo.id,\n    text: text,\n  }),\n);\n</code></pre>\n<p>We can also pass callbacks to <code>commitUpdate</code> to react to the failure or success\nof the mutation. However, in any case, the rollback will happen automatically,\nif the request fails.</p>\n<pre><code class=\"language-js\">Relay.Store.commitUpdate(\n  <span class=\"hljs-keyword\">new</span> ChangeTodoTextMutation({\n    id: <span class=\"hljs-keyword\">this</span>.props.todo.id,\n    text: text,\n  }), {\n   onFailure: () =&gt; {\n     <span class=\"hljs-built_in\">console</span>.error(<span class=\"hljs-string\">'error!'</span>);\n   },\n   onSuccess: (response) =&gt; {\n     <span class=\"hljs-built_in\">console</span>.log(<span class=\"hljs-string\">'success!'</span>)\n   }\n});\n</code></pre>\n<p>Mutation DSL is considered by some a weak spot of Relay. Sometimes it’s not\neasy to figure out all the parameters and which exact query Relay expects. It\nshould be noted that Relay can do some pretty complicated things, like doing\nmutations on items that are members of some paginated list data. However,\nRelay maintainers are currently working on a new lower level API that\nwill, hopefully, improve the experience of writing mutations.</p>\n<h2 id=\"working-with-paginated-data\">Working with paginated data <a class=\"hash-link\" href=\"#working-with-paginated-data\" aria-hidden=\"true\">#</a></h2>\n<h3 id=\"redux-4\">Redux <a class=\"hash-link\" href=\"#redux-4\" aria-hidden=\"true\">#</a></h3>\n<p>There is no one way to do pagination in Redux – just as much as there is no one\nway to do it in RESTful APIs. To implement pagination in Redux you need to\ncreate a reducer that keeps track of what has been fetched so far, what’s the\ncursor (or a URL or page number) of the next page to fetch and if more data is\ncurrently being fetched.</p>\n<p>There is an example implementation of pagination with Redux in the\n<a href=\"https://github.com/reactjs/redux/tree/master/examples/real-world\">real-world</a>\nexample app, which paginates responses from the GitHub API.</p>\n<p>Redux is at disadvantage here, because the lack of standardized server API means\nthe framework can not handle pagination automatically. However, this also means\nthat by manually implementing pagination, you can work with APIs with various\nconventions and store the data in Redux.</p>\n<h3 id=\"relay-4\">Relay <a class=\"hash-link\" href=\"#relay-4\" aria-hidden=\"true\">#</a></h3>\n<p>Relay compatible GraphQL APIs have a concept of a\n<a href=\"https://facebook.github.io/relay/docs/graphql-connections.html#content\"><em>Connection</em></a>,\nan abstraction over listed data. The key part of that is that all connections in\nRelay GraphQL accept pagination parameters and all items of a connection have a\n<em>cursor</em>, which serves as a pointer to paginate the connection in relation to\nthe item. In addition, connections have a <code>pageInfo</code> field that contains\ninformation whether there is a next page available.</p>\n<p>The benefit of having a standardized API for pagination is that Relay will do\nmost of the hard work for us. We simply update the parameters, and it will\nfetch the items we don’t have yet.</p>\n<p>To use a cursor, we’ll use variables of the Relay Containers, which can be\nchanged from within the Container. Variables can be passed to the GraphQL\nfragments.</p>\n<p>Let’s consider a simple PaginatedTodoList component and a Container.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">PaginatedTodoList</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">React</span>.<span class=\"hljs-title\">Component</span> </span>{\n  nextPage() {\n    <span class=\"hljs-keyword\">const</span> lastElement = <span class=\"hljs-keyword\">this</span>.props.user.todos.edges.length - <span class=\"hljs-number\">1</span>;\n    <span class=\"hljs-keyword\">this</span>.setVariables({\n      after: <span class=\"hljs-keyword\">this</span>.props.user.todos.edges[lastElement].cursor;\n    });\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">div</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TodoList</span> <span class=\"hljs-attribute\">todos</span>=<span class=\"hljs-value\">{this.props.user.todos}</span> /&gt;</span>\n        {this.props.user.todos.pageInfo.hasNextPage ?\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">button</span> <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{this.nextPage}</span> <span class=\"hljs-attribute\">:</span>\n        &lt;<span class=\"hljs-attribute\">div</span>&gt;</span>Last page<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">div</span>&gt;</span>}\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">div</span>&gt;</span>\n    )</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">const</span> PaginatedTodoListContainer = Relay.createContainer(PaginatedTodoList, {\n  fragments: {\n    user: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on User {\n        todos(first: 10, after: $after) {\n          edges {\n            cursor\n          }\n          <span class=\"hljs-subst\">${TodoList.getFragment('todos')}</span>\n          pageInfo {\n            hasNextPage\n          }\n        }\n      }\n    `</span>,\n  },\n  initialVariables: {\n    after: <span class=\"hljs-literal\">null</span>,\n  },\n});\n</code></pre>\n<p>When the user clicks the button to load more items, we just update the <code>after</code>\nvariable, Relay will fetch any missing data and the list will be updated.</p>\n<h2 id=\"conclusions\">Conclusions <a class=\"hash-link\" href=\"#conclusions\" aria-hidden=\"true\">#</a></h2>\n<p>Both Redux and Relay are mature, industry tested libraries. Relay provides more\nout of the box, but because of this, is much more restrictive about the backend,\nrequiring a Relay compatible GraphQL API. Redux is very flexible, but this means\nyou have to write much more code yourself.</p>\n<p>If you want to give Relay a quick try, you should consider doing it with\n<a href=\"https://www.reindex.io/\">Reindex</a>, our Relay-compatible GraphQL implementation.\nWe believe it’s a great and simple way to get started with Relay.</p>\n<h2 id=\"further-reading\">Further reading <a class=\"hash-link\" href=\"#further-reading\" aria-hidden=\"true\">#</a></h2>\n<ul>\n<li><a href=\"http://redux.js.org/index.html\">Redux documentation</a> -\none of the best documentations I’ve seen</li>\n<li><a href=\"https://egghead.io/series/getting-started-with-redux\">Video course to get started with Redux</a> -\na great course by Redux creator Dan Abramov</li>\n<li><a href=\"https://facebook.github.io/relay/docs/getting-started.html#content\">Relay documentation</a></li>\n<li><a href=\"https://www.reindex.io/docs/tutorial/\">Reindex Tutorial</a> -\ncovers building a Todo app with Relay, including mutations</li>\n<li><a href=\"https://www.youtube.com/watch?v=oPSuvaYmXBY\">Relay Deep Dive</a> -\nan amazing talk about how Relay works and the philosophy behind it</li>\n<li><a href=\"https://github.com/reactjs/redux/blob/master/docs/introduction/Examples.md\">Redux examples</a> -\nthe official Redux example projects</li>\n<li><a href=\"https://github.com/reindexio/reindex-examples\">Reindex examples</a> - examples\nfor Reindex, all built using Relay</li>\n</ul>\n<p><a href=\"https://news.ycombinator.com/item?id=11599113\" target=\"_blank\">Discuss this post on Hacker News.</a></p>\n"}

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "9fa7c85524132235ada309104dca1dc9.png";

/***/ },
/* 347 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Relay-compatible GraphQL pagination with MongoDB","author":{"name":"Mikhail Novikov","image":"https://www.gravatar.com/avatar/811bcaa26aa7e2af0587b9d170138ff0.jpg","link":"https://twitter.com/freiksenet","twitter":"freiksenet","bio":"CTO & Co-founder"},"date":"2016-07-26T12:39:00.000Z","categories":["Relay","GraphQL","MongoDB"],"excerpt":"In this article I will show how to create a GraphQL server with Relay-compatible pagination using MongoDB","body":"<p>Relay is an amazing framework for building modern applications cleanly and efficiently. Its built-in solution for client-side storage automatically handles many things that are otherwise difficult to implement. Relay is designed to be used with a GraphQL API; however, not all GraphQL APIs are Relay-compatible. To become compatible with Relay, a GraphQL API must implement several <a href=\"https://facebook.github.io/relay/docs/graphql-relay-specification.html#content\">interfaces</a>. In this article, I will demonstrate how to satisfy the <em>Connection</em> interface, which represents paginated data. I will be using MongoDB for backend storage, and Node.js with Express as a server.</p>\n<p>In this example, I will demonstrate how to create a paginated news list API in GraphQL.</p>\n<h2 id=\"relay-connections\">Relay Connections <a class=\"hash-link\" href=\"#relay-connections\" aria-hidden=\"true\">#</a></h2>\n<p>Connection combines an abstraction of list-like data with pagination support. Because it is <em>cursor-based</em> rather than offset-based, it’s especially good for tasks like infinite scrolling and pull-to-refresh.</p>\n<p>The Relay pagination system is based on the concept of a <em>cursor</em>, an opaque\npointer to some element of a paginated result. Users can request all items that precede or succeed this element by passing the pointer to the connection arguments <code>before</code> or <code>after</code>. Users can also limit the result from the beginning or the end of the page with the arguments <code>first</code> and <code>last</code>, which accept integers.</p>\n<p>Connections must include at least two fields: <code>edges</code> and <code>pageInfo</code>. Edges includes the fields <code>cursor</code> and <code>node</code>: a cursor for the element and an actual element’s data, respectively. <code>pageInfo</code> specifies whether there is more data after the last (or before the first) element of the resulting page.</p>\n<p>The <a href=\"https://facebook.github.io/relay/docs/graphql-connections.html#content\">Relay docs</a> describe the Connection interface in detail.</p>\n<h2 id=\"basic-project-setup\">Basic project setup <a class=\"hash-link\" href=\"#basic-project-setup\" aria-hidden=\"true\">#</a></h2>\n<p>I will not cover basic setup, which includes creating an npm project,\ninstalling Babel for ES2015 support, and organizing linting. The source code for\nthis example is at <a href=\"https://github.com/reindexio/graphql-relay-mongodb-pagination\">GitHub</a>.</p>\n<p>Install the dependencies after basic setup. We will use Express middleware <code>express-graphql</code> to save us the time of implementing the endpoint ourselves.</p>\n<pre><code>npm <span class=\"hljs-operator\"><span class=\"hljs-keyword\">install</span> <span class=\"hljs-comment\">--save express graphql express-graphql mongodb</span>\n</span></code></pre>\n<p>We will create our basic schema in <code>src/Schema.js</code>. We will start with the\ndefinition of an Article type for our newsfeed.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> Article = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Article'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n      resolve(parent) {\n        <span class=\"hljs-keyword\">return</span> parent._id.toString();\n      },\n    },\n    text: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLString),\n    },\n  }),\n});\n</code></pre>\n<p>To convert the MongoDB ObjectID into a normal id, we defined a <code>resolve</code> function for our <code>id</code>. Relay requires node IDs to be globally unique. For simplicity,\nwe will use plain MongoDB ObjectIDs in this tutorial. However, encoding the type name in your IDs may be useful for implementing the <a href=\"https://facebook.github.io/relay/docs/graphql-object-identification.html\">Node interface for Relay</a>. One way to do it would be to concatenate the type name with your internal ID and then to encode it with Base64.</p>\n<p>Besides the <code>Article</code> type, we need <em>Edge</em> and <em>Connection</em> types to satisfy the Connection interface. We won’t add actual code to their resolve functions yet. We will also add a PageInfo type for generic PageInfo information.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">const</span> PageInfo = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'PageInfo'</span>,\n  fields: {\n    hasNextPage: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLBoolean),\n    },\n    hasPreviousPage: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLBoolean),\n    },\n  },\n});\n\n<span class=\"hljs-keyword\">const</span> ArticleConnection = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'ArticleConnection'</span>,\n  fields: () =&gt; ({\n    edges: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLList(ArticleEdge),\n      resolve() {\n        <span class=\"hljs-keyword\">return</span> [];\n      },\n    },\n    pageInfo: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(PageInfo),\n    },\n  }),\n});\n\n<span class=\"hljs-keyword\">const</span> ArticleEdge = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'ArticleEdge'</span>,\n  fields: () =&gt; ({\n    cursor: {\n      type: GraphQLString,\n    },\n    node: {\n      type: Article,\n    },\n  }),\n});\n</code></pre>\n<p>Finally, we need to add a connection to our schema. Relay doesn’t accept root fields that return Connections, so we need to wrap our field in a <em>Viewer</em> object, which will hold our Connection. Top-level Viewer nodes are common with Relay.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> Viewer = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Viewer'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n    },\n    allArticles: {\n      type: ArticleConnection,\n      resolve() {\n        <span class=\"hljs-keyword\">return</span> {};\n      },\n    },\n  }),\n});\n\n<span class=\"hljs-keyword\">const</span> Schema = <span class=\"hljs-keyword\">new</span> GraphQLSchema({\n  query: <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n    name: <span class=\"hljs-string\">'RootQueryType'</span>,\n    fields: {\n      viewer: {\n        type: Viewer,\n        resolve() {\n          <span class=\"hljs-keyword\">return</span> {\n            id: <span class=\"hljs-string\">'VIEWER_ID'</span>,\n          };\n        },\n      },\n    },\n  }),\n});\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Schema\n</code></pre>\n<p>Now we can import this schema to our main file (<code>src/index.js</code>) and start our\nexpress server.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> express <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'express'</span>;\n<span class=\"hljs-keyword\">import</span> graphqlHTTP <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'express-graphql'</span>;\n<span class=\"hljs-keyword\">import</span> Schema <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./Schema'</span>;\n\n<span class=\"hljs-keyword\">const</span> app = express();\n\napp.use(<span class=\"hljs-string\">'/graphql'</span>, graphqlHTTP({\n  schema: Schema,\n  graphiql: <span class=\"hljs-literal\">true</span>,\n}));\n\napp.listen(<span class=\"hljs-number\">3000</span>);\n</code></pre>\n<p>If you navigate to <code>http://localhost:3000/graphql</code>, you should be able to query the GraphiQL interface.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allArticles <span class=\"hljs-collection\">{\n      edges <span class=\"hljs-collection\">{\n        node <span class=\"hljs-collection\">{\n          id\n          text\n        }</span>\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<p>As per our resolve function, edges will be returned as an empty list.</p>\n<h2 id=\"adding-mongodb\">Adding MongoDB <a class=\"hash-link\" href=\"#adding-mongodb\" aria-hidden=\"true\">#</a></h2>\n<p>Now we can add MongoDB to the fray. In GraphQL, we pass context information (such as database connections) in a <code>context</code> variable. Let’s modify <code>src/index.js</code> to pass a MongoDB connection to the GraphQL context.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> express <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'express'</span>;\n<span class=\"hljs-keyword\">import</span> graphqlHTTP <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'express-graphql'</span>;\n<span class=\"hljs-keyword\">import</span> { MongoClient } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'mongodb'</span>;\n<span class=\"hljs-keyword\">import</span> Schema <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./Schema'</span>;\n\n<span class=\"hljs-keyword\">const</span> app = express();\n<span class=\"hljs-keyword\">const</span> mongodb = MongoClient.connect(\n  <span class=\"hljs-string\">'mongodb://localhost:27017/relaypagination'</span>\n);\n\napp.use(<span class=\"hljs-string\">'/graphql'</span>, graphqlHTTP(<span class=\"hljs-keyword\">async</span> () =&gt; ({\n  schema: Schema,\n  graphiql: <span class=\"hljs-literal\">true</span>,\n  context: {\n    mongodb: <span class=\"hljs-keyword\">await</span> mongodb,\n  },\n})));\n\napp.listen(<span class=\"hljs-number\">3000</span>);\n</code></pre>\n<p>Now <code>mongodb</code> is available as a property of the third variable of the resolve function. We will perform an actual query in the ‘allArticles’ resolve and use a generic edge-creating resolve with the Connection. This will ensure that the connection will be able to return edges correctly as long as whatever returns the connection satisfies the API (the “object with field query” in this case).</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> ArticleConnection = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'ArticleConnection'</span>,\n  fields: () =&gt; ({\n    edges: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLList(ArticleEdge),\n      resolve(parent) {\n        <span class=\"hljs-keyword\">return</span> parent.query.toArray();\n      },\n    },\n  }),\n});\n\n<span class=\"hljs-keyword\">const</span> ArticleEdge = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'ArticleEdge'</span>,\n  fields: () =&gt; ({\n    cursor: {\n      type: GraphQLString,\n    },\n    node: {\n      type: Article,\n      resolve(parent) {\n        <span class=\"hljs-keyword\">return</span> parent;\n      }\n    },\n  }),\n});\n\n<span class=\"hljs-keyword\">const</span> Viewer = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Viewer'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n    },\n    allArticles: {\n      type: ArticleConnection,\n      resolve(parent, args, { mongodb }) {\n        <span class=\"hljs-keyword\">return</span> {\n          query: mongodb.collection(<span class=\"hljs-string\">'Articles'</span>),\n        };\n      },\n    },\n  }),\n});\n</code></pre>\n<p>Let’s insert some data into MongoDB and try the query in GraphiQL again.</p>\n<pre><code>$ mongo\n&gt; <span class=\"hljs-keyword\">use</span> relaypagination\n&gt; <span class=\"hljs-keyword\">for</span> (<span class=\"hljs-keyword\">var</span> i = 0; i &lt; 1000; i++) { <span class=\"hljs-keyword\">db</span>.Articles.insert({text: i.<span class=\"hljs-keyword\">toString</span>()}) }\n</code></pre>\n<p>In the GraphiQL results, you should now be able to see 1000 items from\nMongoDB.</p>\n<h2 id=\"adding-first-and-last\">Adding first and last <a class=\"hash-link\" href=\"#adding-first-and-last\" aria-hidden=\"true\">#</a></h2>\n<p>Let’s abstract out our code a bit. In a real application, there can be many fields that require a certain type of Connection. In order to avoid repetition, it’s possible to abstract out the code in their resolve functions. Usually, this code lives in the <em>Model</em> application layer. Let’s create our Article model layer in\n<code>src/Article.js</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">getArticles</span>(<span class=\"hljs-params\">mongodb</span>) </span>{\n  <span class=\"hljs-keyword\">return</span> mongodb.collection(<span class=\"hljs-string\">'Articles'</span>).find();\n}\n</code></pre>\n<p>Now we can use this function in the resolve method of our field.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> { getArticles } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./Article'</span>;\n\n...\n\n<span class=\"hljs-keyword\">const</span> Viewer = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Viewer'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n    },\n    allArticles: {\n      type: ArticleConnection,\n      resolve(parent, args, { mongodb }) {\n        <span class=\"hljs-keyword\">return</span> {\n          query: getArticles(mongodb),\n        };\n      },\n    },\n  }),\n});\n</code></pre>\n<p>Now we can add <code>first</code> and <code>last</code> parameters to getArticles and pass them from the allArticles arguments to the model layer.</p>\n<p><code>first</code> is a fairly straightforward limit, so we can simply use <code>.limit</code> in MongoDB. However, it order to determine whether there is a next page, we need to know the number of items in the entire query. <code>last</code> is trickier because we need to skip a number of items equal to the total minus the count. If both <code>first</code> and <code>last</code> are provided, we will apply <code>first</code> and then apply <code>last</code> to the result, provided there are enough items in it.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">getArticles</span>(<span class=\"hljs-params\">mongodb, { first, last }</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> query = mongodb.collection(<span class=\"hljs-string\">'Articles'</span>).find();\n  <span class=\"hljs-keyword\">const</span> pageInfo = <span class=\"hljs-keyword\">await</span> applyPagination(\n    query, first, last\n  );\n  <span class=\"hljs-keyword\">return</span> {\n    query,\n    pageInfo,\n  }\n}\n\n<span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">applyPagination</span>(<span class=\"hljs-params\">query, first, last</span>) </span>{\n  <span class=\"hljs-keyword\">let</span> count;\n\n  <span class=\"hljs-keyword\">if</span> (first || last) {\n    count = <span class=\"hljs-keyword\">await</span> query.clone().count();\n    <span class=\"hljs-keyword\">let</span> limit;\n    <span class=\"hljs-keyword\">let</span> skip;\n\n    <span class=\"hljs-keyword\">if</span> (first &amp;&amp; count &gt; first) {\n      limit = first;\n    }\n\n    <span class=\"hljs-keyword\">if</span> (last) {\n      <span class=\"hljs-keyword\">if</span> (limit &amp;&amp; limit &gt; last) {\n        skip = limit - last;\n        limit = limit - skip;\n      } <span class=\"hljs-keyword\">else</span> <span class=\"hljs-keyword\">if</span> (!limit &amp;&amp; count &gt; last) {\n        skip = count - last;\n      }\n    }\n\n    <span class=\"hljs-keyword\">if</span> (skip) {\n      query.skip(skip);\n    }\n\n    <span class=\"hljs-keyword\">if</span> (limit) {\n      query.limit(limit);\n    }\n  }\n\n  <span class=\"hljs-keyword\">return</span> {\n    hasNextPage: <span class=\"hljs-built_in\">Boolean</span>(first &amp;&amp; count &gt; first),\n    hasPreviousPage: <span class=\"hljs-built_in\">Boolean</span>(last &amp;&amp; count &gt; last),\n  };\n}\n</code></pre>\n<p>The last step is to add the arguments to our connection. Let’s create a generic function that creates pagination parameters for connections.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">createConnectionArguments</span>(<span class=\"hljs-params\"></span>) </span>{\n  <span class=\"hljs-keyword\">return</span> {\n    first: {\n      type: GraphQLInt,\n    },\n    last: {\n      type: GraphQLInt,\n    },\n  };\n}\n\n<span class=\"hljs-keyword\">const</span> Viewer = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Viewer'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n    },\n    allArticles: {\n      type: ArticleConnection,\n      args: createConnectionArguments(),\n      resolve (parent, args, { mongodb }) {\n        <span class=\"hljs-keyword\">return</span>  getArticles(mongodb, args);\n      },\n    },\n  }),\n});\n</code></pre>\n<p>Let’s test these features in GraphiQL.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allArticles<span class=\"hljs-list\">(<span class=\"hljs-keyword\">first:10</span>)</span> <span class=\"hljs-collection\">{\n      edges <span class=\"hljs-collection\">{\n        node <span class=\"hljs-collection\">{\n          id\n          text\n        }</span>\n      }</span>\n      pageInfo <span class=\"hljs-collection\">{\n        hasNextPage\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<p>Now the result has been limited.</p>\n<h2 id=\"cursors\">Cursors <a class=\"hash-link\" href=\"#cursors\" aria-hidden=\"true\">#</a></h2>\n<p>Cursors are opaque objects used for pagination. You can encode different information inside a cursor as long as it is opaque to the API user. We are only going to store the item’s Base64-encoded id. The Cursor is going to be a String-like custom Scalar type that we will decode internally as an object with one field: <code>value</code>. Let’s create it in <code>src/Cursor.js</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Base64URL <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'base64-url'</span>;\n<span class=\"hljs-keyword\">import</span> { GraphQLScalarType } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'graphql'</span>;\n<span class=\"hljs-keyword\">import</span> { Kind } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'graphql/language'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">toCursor</span>(<span class=\"hljs-params\">{ value }</span>) </span>{\n  <span class=\"hljs-keyword\">return</span> Base64URL.encode(value.toString());\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">fromCursor</span>(<span class=\"hljs-params\">string</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> value = Base64URL.decode(string);\n  <span class=\"hljs-keyword\">if</span> (value) {\n    <span class=\"hljs-keyword\">return</span> { value };\n  } <span class=\"hljs-keyword\">else</span> {\n    <span class=\"hljs-keyword\">return</span> <span class=\"hljs-literal\">null</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">const</span> CursorType = <span class=\"hljs-keyword\">new</span> GraphQLScalarType({\n  name: <span class=\"hljs-string\">'Cursor'</span>,\n  serialize(value) {\n    <span class=\"hljs-keyword\">if</span> (value.value) {\n      <span class=\"hljs-keyword\">return</span> toCursor(value);\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> <span class=\"hljs-literal\">null</span>;\n    }\n  },\n  parseLiteral(ast) {\n    <span class=\"hljs-keyword\">if</span> (ast.kind === Kind.STRING) {\n      <span class=\"hljs-keyword\">return</span> fromCursor(ast.value);\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> <span class=\"hljs-literal\">null</span>;\n    }\n  },\n  parseValue(value) {\n    <span class=\"hljs-keyword\">return</span> fromCursor(value);\n  },\n});\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> CursorType;\n</code></pre>\n<p>Now we can use this type in the Edge type as well in field arguments.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">createConnectionArguments</span>(<span class=\"hljs-params\"></span>) </span>{\n  <span class=\"hljs-keyword\">return</span> {\n    first: {\n      type: GraphQLInt,\n    },\n    last: {\n      type: GraphQLInt,\n    },\n    before: {\n      type: Cursor,\n    },\n    after: {\n      type: Cursor,\n    },\n  };\n}\n\n<span class=\"hljs-keyword\">const</span> ArticleEdge = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'ArticleEdge'</span>,\n  fields: () =&gt; ({\n    cursor: {\n      type: Cursor,\n      resolve(parent) {\n        <span class=\"hljs-keyword\">return</span> {\n          value: parent._id.toString(),\n        };\n      },\n    },\n    node: {\n      type: Article,\n      resolve(parent) {\n        <span class=\"hljs-keyword\">return</span> parent;\n      },\n    },\n  }),\n});\n</code></pre>\n<p>We can test whether the cursor is being returned in GraphiQL.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allArticles<span class=\"hljs-list\">(<span class=\"hljs-keyword\">first:10</span>)</span> <span class=\"hljs-collection\">{\n      edges <span class=\"hljs-collection\">{\n        cursor\n        node <span class=\"hljs-collection\">{\n          id\n          text\n        }</span>\n      }</span>\n      pageInfo <span class=\"hljs-collection\">{\n        hasNextPage\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<p>Perfect! Now we need to update the model layer to use the cursors. There is no way to skip and limit with a value in MongoDB, so we will use a filter.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">getArticles</span>(<span class=\"hljs-params\">mongodb, { first, last, before, after }</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> query = limitQueryWithId(\n    mongodb.collection(<span class=\"hljs-string\">'Articles'</span>).find(),\n    before,\n    after\n  );\n  <span class=\"hljs-keyword\">const</span> pageInfo = <span class=\"hljs-keyword\">await</span> applyPagination(\n    query, first, last\n  );\n  <span class=\"hljs-keyword\">return</span> {\n    query,\n    pageInfo,\n  }\n}\n\n\n<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">limitQueryWithId</span>(<span class=\"hljs-params\">query, before, after</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> filter = {\n    _id: {},\n  };\n\n  <span class=\"hljs-keyword\">if</span> (before) {\n    filter._id.$lt = ObjectId(before.value);\n  }\n\n  <span class=\"hljs-keyword\">if</span> (after) {\n    filter._id.$gt = ObjectId(after.value);\n  }\n\n  <span class=\"hljs-keyword\">return</span> query.filter(filter);\n}\n</code></pre>\n<p>If you take the value of an item’s cursor and pass it as <code>after</code> argument, you can see the next page of data.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allArticles<span class=\"hljs-list\">(<span class=\"hljs-keyword\">first:10</span>, after: <span class=\"hljs-string\">\"YOUR-CURSOR\"</span>)</span> <span class=\"hljs-collection\">{\n      edges <span class=\"hljs-collection\">{\n        cursor\n        node <span class=\"hljs-collection\">{\n          id\n          text\n        }</span>\n      }</span>\n      pageInfo <span class=\"hljs-collection\">{\n        hasNextPage\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<h2 id=\"ordering\">Ordering <a class=\"hash-link\" href=\"#ordering\" aria-hidden=\"true\">#</a></h2>\n<p>Connection data is always ordered. Sometimes, the API even allows the ordering to be defined through additional arguments. We will cover only fixed ordering predefined inside the schema.</p>\n<p>We will sort items by descending order of their <code>text</code> field. Our <code>getArticles</code> function will\naccept two new parameters: <code>orderField</code> and <code>order</code>. <code>order</code> can be 1 for ascending sort and -1 for descending.</p>\n<p>When limiting ordering results with <code>before</code> and <code>after</code>, an object in the database should be in the result set if one of the following is true:</p>\n<ul>\n<li>The Object is between items pointed by <code>before</code> and <code>after</code> cursors, non-inclusive.</li>\n<li>The Object has the same sort field value as the item pointed to by <code>before</code> cursor, but is stably sorted to be after it.</li>\n<li>The Object has the same sort field value as the item pointed to by <code>after</code> cursor, but is stably sorted to be before it.</li>\n</ul>\n<p>In order to have stable sorting in the last two cases, we will always also sort the result by <code>_id</code>, in addition to any other ordering required. We will filter by <code>_id</code> in the last two cases.</p>\n<p>In code, the path when sorting by just <code>_id</code> is simpler than sorting by other fields, so we will keep two separate code paths.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> { ObjectId } <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'mongodb'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">getArticles</span>(<span class=\"hljs-params\">mongodb, {\n  first,\n  last,\n  before,\n  after,\n}, orderField, order</span>) </span>{\n  <span class=\"hljs-keyword\">let</span> query = mongodb.collection(<span class=\"hljs-string\">'Articles'</span>);\n  <span class=\"hljs-keyword\">if</span> (orderField === <span class=\"hljs-string\">'id'</span>) {\n    query = limitQueryWithId(query, before, after, order);\n  } <span class=\"hljs-keyword\">else</span> {\n    query = <span class=\"hljs-keyword\">await</span> limitQuery(query, orderField, order, before, after);\n  }\n  <span class=\"hljs-keyword\">const</span> pageInfo = <span class=\"hljs-keyword\">await</span> applyPagination(\n    query, first, last\n  );\n  <span class=\"hljs-keyword\">return</span> {\n    query,\n    pageInfo,\n  }\n}\n\n<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">limitQueryWithId</span>(<span class=\"hljs-params\">query, before, after, order</span>) </span>{\n  <span class=\"hljs-keyword\">const</span> filter = {\n    _id: {},\n  };\n\n  <span class=\"hljs-keyword\">if</span> (before) {\n    <span class=\"hljs-keyword\">const</span> op = order === <span class=\"hljs-number\">1</span> ? <span class=\"hljs-string\">'$lt'</span> : <span class=\"hljs-string\">'$gt'</span>;\n    filter._id[op] = ObjectId(before.value);\n  }\n\n  <span class=\"hljs-keyword\">if</span> (after) {\n    <span class=\"hljs-keyword\">const</span> op = order === <span class=\"hljs-number\">1</span> ? <span class=\"hljs-string\">'$gt'</span> : <span class=\"hljs-string\">'$lt'</span>;\n    filter._id[op] = ObjectId(after.value);\n  }\n\n  <span class=\"hljs-keyword\">return</span> query.find(filter).sort([[<span class=\"hljs-string\">'_id'</span>, order]]);\n}\n\n<span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">limitQuery</span>(<span class=\"hljs-params\">query, field, order, before, after</span>) </span>{\n  <span class=\"hljs-keyword\">let</span> filter = {};\n  <span class=\"hljs-keyword\">const</span> limits = {};\n  <span class=\"hljs-keyword\">const</span> ors = [];\n  <span class=\"hljs-keyword\">if</span> (before) {\n    <span class=\"hljs-keyword\">const</span> op = order === <span class=\"hljs-number\">1</span> ? <span class=\"hljs-string\">'$lt'</span> : <span class=\"hljs-string\">'$gt'</span>;\n    <span class=\"hljs-keyword\">const</span> beforeObject = <span class=\"hljs-keyword\">await</span> query.findOne({\n      _id: ObjectId(before.value),\n    }, {\n      fields: {\n        [field]: <span class=\"hljs-number\">1</span>,\n      },\n    });\n    limits[op] = beforeObject[field];\n    ors.push(\n      {\n        [field]: beforeObject[field],\n        _id: { [op]: ObjectId(before.value) },\n      },\n    );\n  }\n\n  <span class=\"hljs-keyword\">if</span> (after) {\n    <span class=\"hljs-keyword\">const</span> op = order === <span class=\"hljs-number\">1</span> ? <span class=\"hljs-string\">'$gt'</span> : <span class=\"hljs-string\">'$lt'</span>;\n    <span class=\"hljs-keyword\">const</span> afterObject = <span class=\"hljs-keyword\">await</span> query.findOne({\n      _id: ObjectId(after.value),\n    }, {\n      fields: {\n        [field]: <span class=\"hljs-number\">1</span>,\n      },\n    });\n    limits[op] = afterObject[field];\n    ors.push(\n      {\n        [field]: afterObject[field],\n        _id: { [op]: ObjectId(after.value) },\n      },\n    );\n  }\n\n  <span class=\"hljs-keyword\">if</span> (before || after) {\n    filter = {\n      $or: [\n        {\n          [field]: limits,\n        },\n        ...ors,\n      ],\n    };\n  }\n\n  <span class=\"hljs-keyword\">return</span> query.find(filter).sort([[field, order], [<span class=\"hljs-string\">'_id'</span>, order]]);\n}\n</code></pre>\n<p>Now we can use these parameters in the schema.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> Viewer = <span class=\"hljs-keyword\">new</span> GraphQLObjectType({\n  name: <span class=\"hljs-string\">'Viewer'</span>,\n  fields: () =&gt; ({\n    id: {\n      type: <span class=\"hljs-keyword\">new</span> GraphQLNonNull(GraphQLID),\n    },\n    allArticles: {\n      type: ArticleConnection,\n      args: createConnectionArguments(),\n      resolve(parent, args, { mongodb }) {\n        <span class=\"hljs-keyword\">return</span> getArticles(mongodb, args, <span class=\"hljs-string\">'text'</span>, -<span class=\"hljs-number\">1</span>);\n      },\n    },\n  }),\n});\n</code></pre>\n<p>Now it should be possible to see the new ordering in GraphiQL.</p>\n<h2 id=\"a-word-about-performance\">A word about performance <a class=\"hash-link\" href=\"#a-word-about-performance\" aria-hidden=\"true\">#</a></h2>\n<p>These connections should perform especially well if you can create relevant indices. One should create an index for each possible sort order, including both ordering fields and <code>_id</code> in it. If your connections will support filtering, an index should be created for each possible combination of a filter and a sort order. When using filtering, it’s important to include the field being filtered into the MongoDB <code>.sort</code>, as this will advice MongoDB to use the relevant index.</p>\n<p>However, even if individual queries are very efficient, the approach described in this article can be quite wasteful in some data modeling situations and shouldn’t be applied blindly. When the cardinality of Connections is low (for example, if every user has about 10-20 articles), then different approaches should be used. Consider this query to a similar API.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allUsers<span class=\"hljs-list\">(<span class=\"hljs-keyword\">first:</span> <span class=\"hljs-number\">10</span>)</span> <span class=\"hljs-collection\">{\n      edges <span class=\"hljs-collection\">{\n        node <span class=\"hljs-collection\">{\n          articles<span class=\"hljs-list\">(<span class=\"hljs-keyword\">first:10</span>)</span> <span class=\"hljs-collection\">{\n            node <span class=\"hljs-collection\">{\n              id\n              text\n            }</span>\n          }</span>\n        }</span>\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<p>If the user won’t have many articles, ten index-backend queries is less efficient than one query that will simply fetch <em>all</em> articles for the given 10 users. The model layer can then be ordered and sliced. Although working with data in model layer rather than inside the database is counterintuitive, it may be a more efficient way to handle data.</p>\n<h2 id=\"conclusion\">Conclusion <a class=\"hash-link\" href=\"#conclusion\" aria-hidden=\"true\">#</a></h2>\n<p>We have created Relay-compliant pagination with GraphQL and MongoDB. The model layer is not often connected to the Article domain, so we can reuse it for different models by making collection an argument.</p>\n<p>GraphQL is an amazing technology for making fast and reusable APIs, and Relay compatibility is one of the more difficult aspects of making them. I hope this article\nhelps GraphQL API developers to make Relay-compatible APIs.</p>\n<p>All the code used in this project is available at <a href=\"https://github.com/reindexio/graphql-relay-mongodb-pagination\">GitHub</a>.</p>\n"}

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "04e794d8616679d3c8bfbe370b9d1f3a.png";

/***/ },
/* 349 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"Releasing Reindex, the GraphQL backend as a service","author":{"name":"Ville Immonen","image":"https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg","link":"https://twitter.com/VilleImmonen","twitter":"VilleImmonen","bio":"CEO & Co-founder"},"date":"2016-01-26T19:00:00.000Z","categories":["Reindex","GraphQL","News"],"excerpt":"Reindex is available now, time to start building serverless apps with GraphQL!","image":"/blog/releasing-reindex-graphql-backend-as-a-service/illustration-nobg.png","body":"<img src=\"illustration-nobg.png\" style=\"width: 100%; max-width: 800px;\">\n<p>Developers, we have exciting news to share today: we’re launching Reindex to the\nworld! Over the past few months we’ve been inviting developers to try Reindex,\nand developing it based on the great feedback we’ve received from the\nparticipants of the private beta.</p>\n<p>Today we’re making Reindex available to everyone. You can sign up on our website\nto start a free trial and immediately start building apps with Reindex.</p>\n<p>Reindex is the first backend as a service with GraphQL built in its core. This\nis particularly handy, if you’re building your app with React (Native) and\nRelay, as Relay has the best support for GraphQL today. But we’re also excited\nabout other emerging client-side libraries for GraphQL.</p>\n<p>The idea of Reindex grew out of our experiences building apps with React, first\non top of RESTful APIs built in-house and later with existing BaaS (backend as\na service) providers. When GraphQL was announced a year ago at React.js Conf,\nwe fell in love with it. There was finally a solution to the problems we had\nfaced with synchronizing state between the client-side app and the backend and\nwe wanted to build a BaaS that would make it super easy to spin up a GraphQL\nserver for our projects.</p>\n<p>We believe the future of product development is in using services as small\nbuilding blocks that you can combine to build your app without developing and\nmanaging your own backend servers. We’ll be writing about building apps like\nthis here in our blog over the coming weeks.</p>\n<p>We’re looking forward to seeing what <em>you</em> will build with Reindex!</p>\n"}

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "f2cd9e3a8075e437539b4d7d17c85916.png";

/***/ },
/* 351 */
/***/ function(module, exports) {

	module.exports = {"layout":"post","title":"You Might Not Need Underscore","author":{"name":"Ville Immonen","image":"https://www.gravatar.com/avatar/e89d8e6912bf23525337395769e16505.jpg","link":"https://twitter.com/VilleImmonen","twitter":"VilleImmonen","bio":"CEO & Co-founder"},"date":"2015-06-28T22:26:11.000Z","categories":["JavaScript"],"excerpt":"Latest features of JavaScript are now easy to use with Babel. We show how you can use the standard JavaScript features to do tasks that previously required a utility library to do without lots of code.","image":"/blog/you-might-not-need-underscore/ES_evolution1.png","body":"<p><img src=\"ES_evolution1.png\" alt=\"\"></p>\n<p>During past years utility libraries like <a href=\"http://underscorejs.org/\" target=\"_blank\">Underscore</a> and <a href=\"https://lodash.com/\" target=\"_blank\">lodash</a> have found their way into the toolchain of many JavaScript programmers.</p>\n<p>While those utility libraries might make the code easier for you to <em>write</em>, they don’t necessarily make the code <em>simpler</em> or easier to <em>understand</em>. People reading and maintaining the code are obliged to, in addition to knowing the language and its standard library, also know the utility library it’s using. Libraries come and go, and everyone has their own favorite. What’s the order of arguments for this <code>map()</code> function? Which library was it from again? Underscore (the perennial favorite), lodash (its speedy and versatile younger brother), <a href=\"http://ramdajs.com/\" target=\"_blank\">Ramda</a> (the more functional cousin that <a href=\"https://www.youtube.com/watch?v=m3svKOdZijA\">got the argument order right</a>), or whichever cool abstraction you found today? If you’re a team, whose favorite library should you choose? How about choosing the <em>standard library</em>?</p>\n<p>When you write simple code that uses the standard library functions, you are making it easier for the future user and maintainer (who might as well be you) to understand. Yes, it might be more characters to type, but since when is writing speed the bottleneck in writing good, maintainable software?</p>\n<blockquote>\n<p>It’s much easier to recover from no abstraction than the wrong abstraction. —<a href=\"http://2014.jsconf.eu/speakers/sebastian-markbage-minimal-api-surface-area-learning-patterns-instead-of-frameworks.html\" target=\"_blank\">Sebastian Markbåge</a></p>\n</blockquote>\n<p>It’s a lot easier to refactor verbose code with few abstractions than concise code with the wrong abstractions. When you start seeing patterns in your code repeated over and over, it’s time to abstract, but now you can tell what is the right abstraction and it’s more likely you end up with something that is worth the additional overhead <em>every</em> abstraction adds.</p>\n<p>JavaScript is evolving and new ES2015 and ES2016 editions (previously known as ES6 and ES7, respectively) pack a bunch of new features and <a href=\"https://babeljs.io/\" target=\"_blank\">Babel</a> makes it very easy to use of them today. These features make some previously essential functions from utility libraries obsolete.</p>\n<p>Good resources for learning those new features include the <a href=\"https://babeljs.io/docs/learn-es2015/\" target=\"_blank\">Learn ES2015</a> page on Babel website and <a href=\"https://leanpub.com/understandinges6/read\" target=\"_blank\">Understanding ECMAScript 6</a> book by Nicholas C. Zakas. Learning to fully utilize the language of the Web gives you a transferable skill. JavaScript is likely to stick around much longer than the utility library of the day.</p>\n<p>This is not to say there is no a place for any utility library or <em>function</em> installed from <a href=\"https://www.npmjs.com/\" target=\"_blank\">npm</a> anymore. It’s just that many utility functions that were almost essential in order to be productive when we were writing ES3 are not needed anymore and today you might be better off just using plain JavaScript to do those tasks.</p>\n<p>You might not need Underscore.</p>\n<hr>\n<h2 id=\"examples\">Examples <a class=\"hash-link\" href=\"#examples\" aria-hidden=\"true\">#</a></h2>\n<p>These examples illustrate some things ES5.1, ES2015 and ES2016 have made so easy that you might not need an utility library anymore.</p>\n<h5 id=\"what-do-i-need-to-use-them\">What do I need to use them? <a class=\"hash-link\" href=\"#what-do-i-need-to-use-them\" aria-hidden=\"true\">#</a></h5>\n<p><strong>ES5</strong> is now natively supported by all current browsers and Node.js. <strong>ES2015</strong> and <strong>ES2016</strong> examples can be <a href=\"http://babeljs.io/docs/setup/\" target=\"_blank\">compiled to ES5 with Babel.</a> Babel is easy to add to almost any common JavaScript build tool in existence or to use with the require hook on Node.js. If you need to support legacy browsers (IE8, released 6 years ago) you can still get most of ES5 with a polyfill like <a href=\"https://github.com/es-shims/es5-shim\" target=\"_blank\">es-shim</a>.</p>\n<h3 id=\"arrays\">Arrays <a class=\"hash-link\" href=\"#arrays\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"iterate\">Iterate <a class=\"hash-link\" href=\"#iterate\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.each(array, iteratee)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.forEach(iteratee)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"map\">Map <a class=\"hash-link\" href=\"#map\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.map(array, iteratee)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.map(iteratee)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"use-a-function-to-accumulate-a-single-value-from-an-array-left-to-right\">Use a function to accumulate a single value from an array (left-to-right) <a class=\"hash-link\" href=\"#use-a-function-to-accumulate-a-single-value-from-an-array-left-to-right\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.reduce(array, iteratee, memo)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.reduce(iteratee, memo)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"use-a-function-to-accumulate-a-single-value-from-an-array-right-to-left\">Use a function to accumulate a single value from an array (right-to-left) <a class=\"hash-link\" href=\"#use-a-function-to-accumulate-a-single-value-from-an-array-right-to-left\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.reduceRight(array, iteratee, memo)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.reduceRight(iteratee, memo)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"test-whether-all-elements-in-an-array-pass-a-predicate\">Test whether all elements in an array pass a predicate <a class=\"hash-link\" href=\"#test-whether-all-elements-in-an-array-pass-a-predicate\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.every(array, predicate)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.every(predicate)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"test-whether-some-element-in-an-array-passes-a-predicate\">Test whether some element in an array passes a predicate <a class=\"hash-link\" href=\"#test-whether-some-element-in-an-array-passes-a-predicate\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.some(array, predicate)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.some(predicate)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"find-a-value-in-an-array\">Find a value in an array <a class=\"hash-link\" href=\"#find-a-value-in-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.find(array, predicate)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">array.find(predicate)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"get-a-property-from-each-element-in-an-array\">Get a property from each element in an array <a class=\"hash-link\" href=\"#get-a-property-from-each-element-in-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.pluck(array, propertyName)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">array.map(value =&gt; value[propertyName])\n</code></pre>\n</li>\n</ul>\n<h4 id=\"check-if-array-includes-an-element\">Check if array includes an element <a class=\"hash-link\" href=\"#check-if-array-includes-an-element\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.includes(array, element)\n</code></pre>\n</li>\n<li>\n<p>ES2016</p>\n<pre><code class=\"language-javascript\">array.includes(element)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"convert-an-array-like-object-to-array\">Convert an array-like object to array <a class=\"hash-link\" href=\"#convert-an-array-like-object-to-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.toArray(<span class=\"hljs-built_in\">arguments</span>)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">[...arguments]\n</code></pre>\n</li>\n</ul>\n<h4 id=\"convert-an-array-of-keys-and-values-to-an-object\">Convert an array of keys and values to an object <a class=\"hash-link\" href=\"#convert-an-array-of-keys-and-values-to-an-object\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.object(array)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">array.reduce((result, [key, val]) =&gt; <span class=\"hljs-built_in\">Object</span>.assign(result, {[key]: val}), {})\n</code></pre>\n</li>\n<li>\n<p>Object Rest/Spread (Stage 2)</p>\n<pre><code class=\"language-javascript\">array.reduce((result, [key, val]) =&gt; {...result, [key]: val}, {})\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-a-copy-of-an-array-with-all-falsy-values-removed\">Create a copy of an array with all falsy values removed <a class=\"hash-link\" href=\"#create-a-copy-of-an-array-with-all-falsy-values-removed\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.compact(array)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.filter(<span class=\"hljs-built_in\">Boolean</span>)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">array.filter(x =&gt; !!x)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-a-copy-of-an-array-with-duplicates-removed\">Create a copy of an array with duplicates removed <a class=\"hash-link\" href=\"#create-a-copy-of-an-array-with-duplicates-removed\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.uniq(array)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">[...new <span class=\"hljs-built_in\">Set</span>(array)]\n</code></pre>\n</li>\n</ul>\n<h4 id=\"find-the-index-of-a-value-in-an-array\">Find the index of a value in an array <a class=\"hash-link\" href=\"#find-the-index-of-a-value-in-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.indexOf(array, value)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\">array.indexOf(value)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"find-the-index-in-an-array-by-predicate\">Find the index in an array by predicate <a class=\"hash-link\" href=\"#find-the-index-in-an-array-by-predicate\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.findIndex([<span class=\"hljs-number\">4</span>, <span class=\"hljs-number\">6</span>, <span class=\"hljs-number\">7</span>, <span class=\"hljs-number\">12</span>], isPrime);\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">[<span class=\"hljs-number\">4</span>, <span class=\"hljs-number\">6</span>, <span class=\"hljs-number\">7</span>, <span class=\"hljs-number\">12</span>].findIndex(isPrime);\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-an-array-with-n-numbers-starting-from-x\">Create an array with n numbers, starting from x <a class=\"hash-link\" href=\"#create-an-array-with-n-numbers-starting-from-x\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.range(x, x + n)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Array</span>.from(<span class=\"hljs-built_in\">Array</span>(n), (_, i) =&gt; x + i)\n</code></pre>\n</li>\n</ul>\n<h3 id=\"objects\">Objects <a class=\"hash-link\" href=\"#objects\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"names-of-own-enumerable-properties-as-an-array\">Names of own enumerable properties as an array <a class=\"hash-link\" href=\"#names-of-own-enumerable-properties-as-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.keys(object)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Object</span>.keys(object)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"number-of-keys-in-an-object\">Number of keys in an object <a class=\"hash-link\" href=\"#number-of-keys-in-an-object\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.size(object)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Object</span>.keys(object).length\n</code></pre>\n</li>\n</ul>\n<h4 id=\"names-of-all-enumerable-properties-as-an-array\">Names of all enumerable properties as an array <a class=\"hash-link\" href=\"#names-of-all-enumerable-properties-as-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.allKeys(object)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">[...Reflect.enumerate(object)]\n</code></pre>\n</li>\n</ul>\n<h4 id=\"values\">Values <a class=\"hash-link\" href=\"#values\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.values(object)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Object</span>.keys(object).map(key =&gt; object[key])\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-a-new-object-with-the-given-prototype-and-properties\">Create a new object with the given prototype and properties <a class=\"hash-link\" href=\"#create-a-new-object-with-the-given-prototype-and-properties\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.create(proto, properties)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Object</span>.assign(<span class=\"hljs-built_in\">Object</span>.create(proto), properties)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-a-new-object-from-merged-own-properties\">Create a new object from merged own properties <a class=\"hash-link\" href=\"#create-a-new-object-from-merged-own-properties\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.assign({}, source, { a: <span class=\"hljs-literal\">false</span> })\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Object</span>.assign({}, source, { a: <span class=\"hljs-literal\">false</span> })\n</code></pre>\n</li>\n<li>\n<p>Object Rest/Spread (Stage 2)</p>\n<pre><code class=\"language-javascript\">{ ...source, a: <span class=\"hljs-literal\">false</span> }\n</code></pre>\n</li>\n</ul>\n<h4 id=\"create-a-shallow-clone-of-own-properties-of-an-object\">Create a shallow clone of own properties of an object <a class=\"hash-link\" href=\"#create-a-shallow-clone-of-own-properties-of-an-object\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.extendOwn({}, object)\n</code></pre>\n</li>\n<li>\n<p>Object Rest/Spread (Stage 2)</p>\n<pre><code class=\"language-javascript\">{ ...object }\n</code></pre>\n</li>\n</ul>\n<h4 id=\"check-if-an-object-is-an-array\">Check if an object is an array <a class=\"hash-link\" href=\"#check-if-an-object-is-an-array\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.isArray(object)\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Array</span>.isArray(object)\n</code></pre>\n</li>\n</ul>\n<h4 id=\"check-if-an-object-is-a-finite-number\">Check if an object is a finite Number <a class=\"hash-link\" href=\"#check-if-an-object-is-a-finite-number\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.isNumber(object) &amp;&amp; _.isFinite(object)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Number</span>.isFinite(object)\n</code></pre>\n</li>\n</ul>\n<h3 id=\"functions\">Functions <a class=\"hash-link\" href=\"#functions\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"bind-a-function-to-an-object\">Bind a function to an object <a class=\"hash-link\" href=\"#bind-a-function-to-an-object\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">foo(_.bind(<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> (<span class=\"hljs-params\"></span>) </span>{\n  <span class=\"hljs-keyword\">this</span>.bar();\n}, <span class=\"hljs-keyword\">this</span>));\n\nfoo(_.bind(object.fun, object));\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">foo(() =&gt; {\n  <span class=\"hljs-keyword\">this</span>.bar();\n});\n\nfoo(() =&gt; object.fun());\n</code></pre>\n</li>\n</ul>\n<h3 id=\"utility\">Utility <a class=\"hash-link\" href=\"#utility\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"identity-function\">Identity function <a class=\"hash-link\" href=\"#identity-function\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.identity\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">value =&gt; value\n</code></pre>\n</li>\n</ul>\n<h4 id=\"a-function-that-returns-a-value\">A function that returns a value <a class=\"hash-link\" href=\"#a-function-that-returns-a-value\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.constant(value)\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">() =&gt; value\n</code></pre>\n</li>\n</ul>\n<h4 id=\"the-empty-function\">The empty function <a class=\"hash-link\" href=\"#the-empty-function\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.noop\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\">() =&gt; {}\n</code></pre>\n</li>\n</ul>\n<h4 id=\"get-the-current-time-in-milliseconds-since-the-epoch\">Get the current time in milliseconds since the epoch <a class=\"hash-link\" href=\"#get-the-current-time-in-milliseconds-since-the-epoch\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\">_.now()\n</code></pre>\n</li>\n<li>\n<p>ES5.1</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-built_in\">Date</span>.now()\n</code></pre>\n</li>\n</ul>\n<h4 id=\"template\">Template <a class=\"hash-link\" href=\"#template\" aria-hidden=\"true\">#</a></h4>\n<ul>\n<li>\n<p>Underscore</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">var</span> greeting = _.template(<span class=\"hljs-string\">\"hello &lt;%= name %&gt;\"</span>);\ngreeting({ name: <span class=\"hljs-string\">'moe'</span> });\n</code></pre>\n</li>\n<li>\n<p>ES2015</p>\n<pre><code class=\"language-javascript\"><span class=\"hljs-keyword\">const</span> greeting = ({ name }) =&gt; <span class=\"hljs-string\">`hello <span class=\"hljs-subst\">${name}</span>`</span>;\ngreeting({ name: <span class=\"hljs-string\">'moe'</span> });\n</code></pre>\n</li>\n</ul>\n<p>Did you find a bug? Do you have more examples of things that previously might have required an utility library, but not anymore? <a href=\"https://github.com/reindexio/youmightnotneedunderscore\" target=\"_blank\">Send us a pull request on GitHub!</a></p>\n<p><a href=\"https://news.ycombinator.com/item?id=9794773\" target=\"_blank\">Discuss this post on Hacker News.</a></p>\n"}

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(353);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(328)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./cookie.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./cookie.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(327)();
	// imports
	
	
	// module
	exports.push([module.id, "#iubenda{background-color:#eee}a{color:green}.center{margin-top:100px}#iubenda-cs-banner{bottom:0!important;left:0!important;position:fixed!important;width:100%!important;z-index:99999998!important;background-color:#000}.iubenda-cs-content{display:block;margin:0 auto;padding:20px;width:auto;font-size:14px;background:#444;color:#fff}.iubenda-cs-rationale{max-width:900px;position:relative;margin:0 auto}.iubenda-banner-content>p{line-height:1.5}.iubenda-cs-close-btn{margin:0;color:#fff;text-decoration:none;font-size:20px;position:absolute;top:0;right:0;border:none}.iubenda-cs-cookie-policy-lnk{text-decoration:underline;color:#fff;font-size:14px;font-weight:900}", ""]);
	
	// exports


/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(__filename) {'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _lodashCollectionPartition = __webpack_require__(355);
	
	var _lodashCollectionPartition2 = _interopRequireDefault(_lodashCollectionPartition);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodashCollectionSortBy = __webpack_require__(250);
	
	var _lodashCollectionSortBy2 = _interopRequireDefault(_lodashCollectionSortBy);
	
	var _reactRouter = __webpack_require__(155);
	
	var _gatsbyHelpers = __webpack_require__(259);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var styles = {
	  container: {
	    maxWidth: 960,
	    marginLeft: 'auto',
	    marginRight: 'auto',
	    padding: '0 ' + rhythm(1 / 2) + ' ' + rhythm(1 / 2) + ' ' + rhythm(1) + ' '
	  },
	  desktop: {
	    display: 'flex',
	    '@media (max-width: 700px)': {
	      display: 'none'
	    }
	  },
	  mobile: {
	    display: 'none',
	    '@media (max-width: 700px)': {
	      display: 'block'
	    }
	  },
	  pageItem: {
	    marginBottom: rhythm(1 / 2)
	  },
	  pageChildItem: {
	    marginTop: rhythm(1 / 2)
	  },
	  pageLink: {
	    textDecoration: 'none'
	  },
	  pageLinkActive: {
	    textDecoration: 'none',
	    fontWeight: _ui_ReindexTypography2['default'].options.boldWeight
	  }
	};
	
	var DocsPage = _react2['default'].createClass({
	  displayName: 'DocsPage',
	
	  mixins: [_reactRouter.State, _reactRouter.Navigation],
	
	  handleTopicChange: function handleTopicChange(e) {
	    this.transitionTo(e.target.value);
	  },
	
	  renderPageLink: function renderPageLink(page) {
	    return _react2['default'].createElement(
	      _reactRouter.Link,
	      {
	        to: page.path,
	        style: styles.pageLink,
	        activeStyle: _extends({}, styles.pageLink, { fontWeight: 'bold' }),
	        activeClass: 'active' },
	      page.data.title
	    );
	  },
	
	  render: function render() {
	    var _this = this;
	
	    var allPages = (0, _lodashCollectionSortBy2['default'])((0, _gatsbyHelpers.templateChildrenPages)(__filename, this.props.state), 'data.order');
	
	    var _partition = (0, _lodashCollectionPartition2['default'])(allPages, function (page) {
	      return page.file.name === 'index';
	    });
	
	    var _partition2 = _slicedToArray(_partition, 2);
	
	    var topLevelPages = _partition2[0];
	    var nestedPages = _partition2[1];
	
	    var pages = topLevelPages.map(function (page) {
	      return _extends({}, page, {
	        children: nestedPages.filter(function (nestedPage) {
	          return nestedPage.file.dirname === page.file.dirname;
	        })
	      });
	    });
	
	    var pageOptions = [];
	    var _iteratorNormalCompletion = true;
	    var _didIteratorError = false;
	    var _iteratorError = undefined;
	
	    try {
	      for (var _iterator = pages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	        var page = _step.value;
	
	        pageOptions.push(_react2['default'].createElement(
	          'option',
	          { key: page.path, value: page.path },
	          page.data.title
	        ));
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = page.children[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var child = _step2.value;
	
	            pageOptions.push(_react2['default'].createElement(
	              'option',
	              { key: child.path, value: child.path },
	              page.data.title,
	              ' - ',
	              child.data.title
	            ));
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	              _iterator2['return']();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    } catch (err) {
	      _didIteratorError = true;
	      _iteratorError = err;
	    } finally {
	      try {
	        if (!_iteratorNormalCompletion && _iterator['return']) {
	          _iterator['return']();
	        }
	      } finally {
	        if (_didIteratorError) {
	          throw _iteratorError;
	        }
	      }
	    }
	
	    var pageItems = pages.map(function (page) {
	      return _react2['default'].createElement(
	        'li',
	        {
	          key: page.path,
	          style: styles.pageItem },
	        _this.renderPageLink(page),
	        _react2['default'].createElement(
	          'ol',
	          { style: { marginBottom: 0 } },
	          page.children.map(function (child) {
	            return _react2['default'].createElement(
	              'li',
	              {
	                key: child.path,
	                style: styles.pageChildItem },
	              _this.renderPageLink(child)
	            );
	          })
	        )
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { style: styles.container },
	      _react2['default'].createElement(
	        'div',
	        { style: styles.desktop },
	        _react2['default'].createElement(
	          'div',
	          {
	            style: {
	              width: 'calc(' + rhythm(9) + ' - 1px)',
	              borderRight: '1px solid lightgrey'
	            } },
	          _react2['default'].createElement(
	            'ul',
	            {
	              style: {
	                listStyle: 'none',
	                margin: rhythm(1 / 2) + ' 0 0'
	              } },
	            pageItems
	          )
	        ),
	        _react2['default'].createElement(
	          'div',
	          {
	            style: {
	              flex: 1,
	              padding: '0 ' + rhythm(1) + ' 0'
	            } },
	          _react2['default'].createElement(_reactRouter.RouteHandler, this.props)
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: styles.mobile },
	        _react2['default'].createElement(
	          'strong',
	          null,
	          'Topics:'
	        ),
	        ' ',
	        _react2['default'].createElement(
	          'select',
	          {
	            defaultValue: this.props.state.path,
	            onChange: this.handleTopicChange },
	          pageOptions
	        ),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement('br', null),
	        _react2['default'].createElement(_reactRouter.RouteHandler, this.props)
	      )
	    );
	  }
	});
	
	exports['default'] = (0, _radium2['default'])(DocsPage);
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, "docs/_template.jsx"))

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var createAggregator = __webpack_require__(356);
	
	/**
	 * Creates an array of elements split into two groups, the first of which
	 * contains elements `predicate` returns truthy for, while the second of which
	 * contains elements `predicate` returns falsey for. The predicate is bound
	 * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	 *
	 * If a property name is provided for `predicate` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `predicate` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to iterate over.
	 * @param {Function|Object|string} [predicate=_.identity] The function invoked
	 *  per iteration.
	 * @param {*} [thisArg] The `this` binding of `predicate`.
	 * @returns {Array} Returns the array of grouped elements.
	 * @example
	 *
	 * _.partition([1, 2, 3], function(n) {
	 *   return n % 2;
	 * });
	 * // => [[1, 3], [2]]
	 *
	 * _.partition([1.2, 2.3, 3.4], function(n) {
	 *   return this.floor(n) % 2;
	 * }, Math);
	 * // => [[1.2, 3.4], [2.3]]
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': false },
	 *   { 'user': 'fred',    'age': 40, 'active': true },
	 *   { 'user': 'pebbles', 'age': 1,  'active': false }
	 * ];
	 *
	 * var mapper = function(array) {
	 *   return _.pluck(array, 'user');
	 * };
	 *
	 * // using the `_.matches` callback shorthand
	 * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	 * // => [['pebbles'], ['barney', 'fred']]
	 *
	 * // using the `_.matchesProperty` callback shorthand
	 * _.map(_.partition(users, 'active', false), mapper);
	 * // => [['barney', 'pebbles'], ['fred']]
	 *
	 * // using the `_.property` callback shorthand
	 * _.map(_.partition(users, 'active'), mapper);
	 * // => [['fred'], ['barney', 'pebbles']]
	 */
	var partition = createAggregator(function(result, value, key) {
	  result[key ? 0 : 1].push(value);
	}, function() { return [[], []]; });
	
	module.exports = partition;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(220),
	    baseEach = __webpack_require__(198),
	    isArray = __webpack_require__(215);
	
	/**
	 * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	 *
	 * @private
	 * @param {Function} setter The function to set keys and values of the accumulator object.
	 * @param {Function} [initializer] The function to initialize the accumulator object.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee, thisArg) {
	    var result = initializer ? initializer() : {};
	    iteratee = baseCallback(iteratee, thisArg, 3);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        setter(result, value, iteratee(value, index, collection), collection);
	      }
	    } else {
	      baseEach(collection, function(value, key, collection) {
	        setter(result, value, iteratee(value, key, collection), collection);
	      });
	    }
	    return result;
	  };
	}
	
	module.exports = createAggregator;


/***/ },
/* 357 */
/***/ function(module, exports) {

	module.exports = {"title":"Built-in types","order":4,"body":"<p>Reindex comes with a set of built-in node types. Names of those types start with\n<code>Reindex</code>. Built-in types are not defined in <code>ReindexSchema.json</code>, they are\nadded automatically and can’t be modified like the other types. It’s also not\npossible to use a built-in type as a type of a field.</p>\n<p>The built-in types generally have root fields that can be read and modify nodes of those types. Access is always limited to admin users.</p>\n<p><a name=\"ReindexAuthenticationProvider\"></a></p>\n<h2 id=\"reindexauthenticationprovider\">ReindexAuthenticationProvider <a class=\"hash-link\" href=\"#reindexauthenticationprovider\" aria-hidden=\"true\">#</a></h2>\n<p><em>Available operations</em>:</p>\n<ul>\n<li><code>reindexAuthenticationProviderById</code></li>\n<li><code>reindexAuthenticationProviderByType</code></li>\n<li><code>createReindexAuthenticationProvider</code></li>\n<li><code>updateReindexAuthenticationProvider</code></li>\n<li><code>replaceReindexAuthenticationProvider</code></li>\n<li><code>deleteReindexAuthenticationProvider</code></li>\n</ul>\n<p>An authentication provider includes the settings for an\nauthentication method used for signup and login.</p>\n<p>Supported providers are:</p>\n<ul>\n<li>Auth0 (provider type <code>auth0</code>)</li>\n<li>Facebook (provider type <code>facebook</code>)</li>\n<li>Google (provider type <code>google</code>)</li>\n<li>Twitter (provider type <code>twitter</code>)</li>\n<li>GitHub (provider type <code>github</code>)</li>\n</ul>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/security/authentication/\">Reindex docs: Authentication\n</a></li>\n<li><a href=\"https://www.reindex.io/docs/tutorial/authentication/\">Reindex tutorial: Authentication\n</a></li>\n</ul>\n<p><a name=\"ReindexSecret\"></a></p>\n<h2 id=\"reindexsecret\">ReindexSecret <a class=\"hash-link\" href=\"#reindexsecret\" aria-hidden=\"true\">#</a></h2>\n<p><em>Available operations</em>:</p>\n<ul>\n<li><code>reindexSecretById</code></li>\n<li><code>createReindexSecret</code></li>\n<li><code>deleteReindexSecret</code></li>\n</ul>\n<p>Stores a secret used for signing authentication tokens for an app.</p>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/security/authentication/\">Reindex docs: Authentication\n</a></li>\n</ul>\n<p><a name=\"ReindexType\"></a></p>\n<h2 id=\"reindextype\">ReindexType <a class=\"hash-link\" href=\"#reindextype\" aria-hidden=\"true\">#</a></h2>\n<p><em>Available operations</em>:</p>\n<ul>\n<li><code>reindexTypeById</code></li>\n<li><code>reindexTypeByName</code></li>\n</ul>\n<p>A custom type defined in the app. Normally created by\ncreating a migration with the CLI tool.</p>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/reindex-schema/\">Reindex docs: Reindex Schema\n</a></li>\n<li><a href=\"https:///www.reindex.io/docs/reindex-cli/\">Reindex docs: Reindex CLI\n</a></li>\n<li><a href=\"https://www.reindex.io/docs/tutorial/defining-the-schema/\">Reindex tutorial: Defining the schema\n</a></li>\n<li><a href=\"https://www.reindex.io/docs/graphql-api/mutations/#migrate\">Reindex docs: migrate\n</a></li>\n</ul>\n<p><a name=\"ReindexHook\"></a></p>\n<h2 id=\"reindexhook\">ReindexHook <a class=\"hash-link\" href=\"#reindexhook\" aria-hidden=\"true\">#</a></h2>\n<p><em>Available operations</em>:</p>\n<ul>\n<li><code>reindexHookById</code></li>\n<li><code>createReindexHook</code></li>\n<li><code>updateReindexHook</code></li>\n<li><code>replaceReindexHook</code></li>\n<li><code>deleteReindexHook</code></li>\n</ul>\n<p>A hook that is triggered after some event happening to some type. Performs a\nPOST request to a specified URL.</p>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/integrations/\">Reindex docs: Integrating third-party services\n</a></li>\n</ul>\n<h2 id=\"reindexhooklog\">ReindexHookLog <a class=\"hash-link\" href=\"#reindexhooklog\" aria-hidden=\"true\">#</a></h2>\n<p><em>Available operations</em>:</p>\n<ul>\n<li><code>reindexHookLogById</code></li>\n<li><code>createReindexHookLog</code></li>\n<li><code>deleteReindexHookLog</code></li>\n</ul>\n<p>Log of the executed hooks. Contains result of the hook fragment execution.</p>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/integrations/hooks/\">Reindex docs: Hooks\n</a></li>\n</ul>\n"}

/***/ },
/* 358 */
/***/ function(module, exports) {

	module.exports = {"title":"Connections","order":3,"body":"<p>The connection model is <a href=\"https://facebook.github.io/relay/docs/graphql-connections.html#content\">Relay’s standardized way to express a collection of\nnodes</a>\nand paginate through them.</p>\n<p>Reindex supports relational data, with one-to-many and many-to-many\nrelationships between nodes. Connection fields are used to access nodes in these\nrelationships and also to fetch all nodes of a certain type.</p>\n<p>Relay’s pagination using the connection model is supported out of the box and\nthe necessary <em>Connection Types</em> and <em>Edge Types</em> are generated automatically\nfor all the node types in the schema.</p>\n<h2 id=\"connection-types\">Connection types <a class=\"hash-link\" href=\"#connection-types\" aria-hidden=\"true\">#</a></h2>\n<pre><code><span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _XConnection <span class=\"hljs-container\">{\n  count: <span class=\"hljs-type\">Int</span>\n  nodes: [<span class=\"hljs-type\">X</span>]\n  edges: [_XEdge]\n  pageInfo: <span class=\"hljs-type\">PageInfo</span>!\n}</span></span>\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _XEdge <span class=\"hljs-container\">{\n  cursor: <span class=\"hljs-type\">Cursor</span>!\n  node: <span class=\"hljs-type\">X</span>\n}</span></span>\n\n<span class=\"hljs-title\">scalar</span> <span class=\"hljs-type\">Cursor</span>\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> <span class=\"hljs-type\">PageInfo</span> <span class=\"hljs-container\">{\n  hasNextPage: <span class=\"hljs-type\">Boolean</span>!\n  hasPreviousPage: <span class=\"hljs-type\">Boolean</span>!\n}</span></span>\n</code></pre>\n<h3 id=\"connection\">Connection <a class=\"hash-link\" href=\"#connection\" aria-hidden=\"true\">#</a></h3>\n<ul>\n<li><code>count</code> - the total number of elements in the connection.</li>\n<li><code>edges</code> - a list of <em>Edges</em> included in the connection</li>\n<li><code>nodes</code> - a plain list of nodes in the connection, without the edge wrapper\nobject</li>\n<li><code>pageInfo</code> - information about if there are any more elements before or after\nthe current slice</li>\n</ul>\n<h3 id=\"edges\">Edges <a class=\"hash-link\" href=\"#edges\" aria-hidden=\"true\">#</a></h3>\n<p>Edges are elements of <code>edges</code> list of Connections.</p>\n<ul>\n<li><code>node</code> - the object wrapped by this edge.</li>\n<li><code>cursor</code> - an opaque string-like object, that points to the current node.\nTo be used with <code>before</code> and <code>after</code> arguments.</li>\n</ul>\n<h2 id=\"connection-arguments\">Connection arguments <a class=\"hash-link\" href=\"#connection-arguments\" aria-hidden=\"true\">#</a></h2>\n<p>All connections fields provide similar arguments. <code>first</code>, <code>last</code>, <code>before</code> and\n<code>after</code> are <a href=\"https://facebook.github.io/relay/graphql/connections.htm\">required by Relay</a>.\n<code>orderBy</code> is a Reindex extension to support ordering.</p>\n<pre><code class=\"language-graphql\">connectionField(<span class=\"hljs-keyword\">first</span>, <span class=\"hljs-keyword\">last</span>: Int, <span class=\"hljs-keyword\">before</span>: Cursor, <span class=\"hljs-keyword\">after</span>: Cursor, orderBy: _SomeOrdering): _SomeConnection\n</code></pre>\n<ul>\n<li><code>first</code> - number of edges to include from the beginning of the result.</li>\n<li><code>last</code> - number of edges to include from the end of the result.</li>\n<li><code>before</code> - only return edges before given cursor.</li>\n<li><code>after</code> - оnly return edges after given cursor.</li>\n</ul>\n<h3 id=\"orderby\">orderBy <a class=\"hash-link\" href=\"#orderby\" aria-hidden=\"true\">#</a></h3>\n<p>Each type can have a number of orderable fields that can be used as a sort order\nfor the connections of that type. For example, if we have a <code>Todo</code> type with\norderable field <code>name</code>, the allowed orderings are defined by an enum like this:</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-class\"><span class=\"hljs-keyword\">enum</span> <span class=\"hljs-title\">_TodoOrdering</span> {</span>\n  <span class=\"hljs-constant\">NAME_ASC</span>\n  <span class=\"hljs-constant\">NAME_DESC</span>\n}\n</code></pre>\n<p>We can use the <code>orderBy</code> argument in a connection field like this:</p>\n<pre><code><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allTodos<span class=\"hljs-list\">(<span class=\"hljs-keyword\">orderBy:</span> NAME_DESC)</span> <span class=\"hljs-collection\">{\n      nodes <span class=\"hljs-collection\">{\n        name\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<h3 id=\"filtering\">Filtering <a class=\"hash-link\" href=\"#filtering\" aria-hidden=\"true\">#</a></h3>\n<p>Fields marked in schema as <code>filterable</code>, node fields and connections can all be\nused to filter connections. Filters are available both in viewer and in\nrelationship connections. Argument name for filter is the same as the field\nitself and it accepts an object, where keys are filtering operator and value\nis the filter value.</p>\n<p>For example:</p>\n<pre><code class=\"language-graphql\">{\n  viewer {\n    allTodos(isCompleted: { eq: true }) {\n      nodes {\n        name\n      }\n    }\n  }\n}\n\nquery(<span class=\"hljs-variable\">$id</span>: ID!) {\n  userById(id: <span class=\"hljs-variable\">$id</span>) {\n    todos(createdAt: { gte: <span class=\"hljs-string\">\"2016-01-01\"</span>, lt: <span class=\"hljs-string\">\"2016-02-01\"</span>}) {\n      nodes {\n        name\n      }\n    }\n  }\n}\n\nquery(<span class=\"hljs-variable\">$id</span>: ID!)  {\n  viewer {\n    allTodos(user: { eq: <span class=\"hljs-variable\">$id</span> }) {\n      nodes {\n        name\n      }\n    }\n  }\n}\n\nquery(<span class=\"hljs-variable\">$id</span>: ID!)  {\n  viewer {\n    allUsers(microposts: { includes: <span class=\"hljs-variable\">$id</span> }) {\n      nodes {\n        name\n      }\n    }\n  }\n}\n</code></pre>\n<p>When multiple operators are provided to a filter or multiple fields are filtered\nby, all conditions must be satisfied.</p>\n<p>Available operators depend on the type of the field. Full list of possible\noperators:</p>\n<ul>\n<li><code>eq</code> - equals</li>\n<li><code>neq</code> - not equals</li>\n<li><code>lt</code> - less than, can be used also for <code>DateTime</code> fields</li>\n<li><code>lte</code> - less than or equal, can be used also for <code>DateTime</code> fields</li>\n<li><code>gt</code> - greater than, can be used also for <code>DateTime</code> fields</li>\n<li><code>gte</code> - greater than or equal, can be used also for <code>DateTime</code> fields</li>\n<li><code>isNull</code> - if passed value is <code>true</code>, returns all nodes where field is\n<code>null</code>, if <code>false</code> returns all nodes where fields is not null.</li>\n<li><code>includes</code> - for <code>List</code> fields of scalars, check if the passed scalar\nis member of the list. For <code>Connection</code>, accepts <code>ID</code> and checks if the\nobject of such id is a member of the connection</li>\n<li><code>excludes</code> - as with includes, but checks if the item is <em>not</em> member of\n<code>Conection</code> or <code>List</code></li>\n</ul>\n"}

/***/ },
/* 359 */
/***/ function(module, exports) {

	module.exports = {"title":"GraphQL API","order":3,"body":"<p>Reindex provides a GraphQL API as the primary way to work with the data in your\napplication. Using the <a href=\"../reindex-schema/\">schema</a>, Reindex generates a set\nof <em>root fields</em>, both for queries and mutations. In addition it generates\ntypes that are required to make those root fields work, such as input objects or\npayloads.</p>\n<ul>\n<li><a href=\"/docs/graphql-api/queries/\">Queries</a> getting the data</li>\n<li><a href=\"/docs/graphql-api/mutations/\">Mutations</a> changing the data</li>\n<li><a href=\"/docs/graphql-api/connections/\">Connections</a> Relay connection API and how\nReindex supports it</li>\n<li><a href=\"/docs/graphql-api/built-in-types/\">Built-in types</a> types that Reindex\nprovides by default</li>\n</ul>\n"}

/***/ },
/* 360 */
/***/ function(module, exports) {

	module.exports = {"title":"Mutations","order":2,"body":"<p>Reindex mutations allow you to perform basic create, update, delete operations\non nodes and also add and remove nodes in the many-to-many relationships.</p>\n<p>All Reindex mutations share several common traits - they all have one argument\ncalled <code>input</code>, that holds one optional field <code>clientMutationId</code>. Mutations\nreturn a <em>payload</em> object, which also always contains a <code>clientMutationId</code>.</p>\n<p>If <code>clientMutationId</code> is passed to input it will always be returned as-is in\nthe payload. This way client libraries, like Relay, can tell results of\ndifferent mutations apart.</p>\n<h2 id=\"create-update-replace-delete\">Create, Update, Replace, Delete <a class=\"hash-link\" href=\"#create-update-replace-delete\" aria-hidden=\"true\">#</a></h2>\n<p>Those basic operations share payloads and have similar <code>input</code> formats. They\naccept all fields that can be modified in the node. The difference is that\n<code>update</code> and <code>replace</code> also require <code>id</code> of the node being modified in the\ninput, while <code>create</code> doesn’t allow it. <code>delete</code> just accepts the <code>id</code> of the\ntype in the input.</p>\n<p>Payload types are generated from the types being modified by the mutation.\nTheir structure is the same for all the mutations of that type.</p>\n<pre><code><span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _XPayload <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  id: <span class=\"hljs-type\">ID</span>\n  changedX: <span class=\"hljs-type\">X</span>\n  changedXEdge: _XEdge\n\n  viewer: <span class=\"hljs-type\">ReindexViewer</span>\n  # <span class=\"hljs-type\">Fields</span> with <span class=\"hljs-type\">Nodes</span> to which <span class=\"hljs-type\">Node</span> fields of the type point\n  y: <span class=\"hljs-type\">Y</span>,\n  # for example\n  user: <span class=\"hljs-type\">User</span>,\n}</span></span>\n</code></pre>\n<p>As payloads need to support various mutation types of Relay, there are multiple\nfields included in them. In addition to <code>clientMutationId</code>, there is:</p>\n<ul>\n<li>\n<p><code>id</code> - the ID of the mutated node</p>\n</li>\n<li>\n<p><code>changedX</code> - the mutated node</p>\n</li>\n<li>\n<p><code>changedXEdge</code> - a connection edge containg the mutated node. Can be used to\nadd a newly created node to a connection in Relay.</p>\n</li>\n<li>\n<p><code>viewer</code> - The global viewer object. Can be used on the client to add\na newly created node to the connection of all nodes of the type.</p>\n<p>E.g. when creating a Todo object, you can add it\nto <code>viewer.allTodos</code> using the following Relay\nmutation config:</p>\n<pre><code class=\"language-javascript\">{\n  type: <span class=\"hljs-string\">'RANGE_ADD'</span>,\n  parentID: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n  connectionName: <span class=\"hljs-string\">'allTodos'</span>,\n  edgeName: <span class=\"hljs-string\">'changedTodoEdge'</span>,\n  rangeBehaviors: {\n    <span class=\"hljs-string\">''</span>: <span class=\"hljs-string\">'prepend'</span>,\n  },\n}\n</code></pre>\n</li>\n<li>\n<p>All the node reference fields in this type. These can be used to\nrefer to the parent node for <code>RANGE_ADD</code> mutations in Relay.</p>\n</li>\n</ul>\n<p>See this\n<a href=\"https://facebook.github.io/relay/docs/graphql-mutations.html#content\">guide</a>\nfor more information about Relay mutations.</p>\n<h3 id=\"createx\">createX <a class=\"hash-link\" href=\"#createx\" aria-hidden=\"true\">#</a></h3>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">createX</span><span class=\"hljs-params\">(input: _CreateXInput)</span></span>: _XPayload\n</code></pre>\n<p>Create a node of some type. <code>input</code> is a flat object with all the fields\nof the type alongside <code>clientMutationId</code>. All <code>nonNull</code> fields are required.</p>\n<pre><code class=\"language-graphql\">mutation {\n  createUser(input: {\n    username: <span class=\"hljs-string\">\"freiksenet\"</span>,\n    email: <span class=\"hljs-string\">\"freiksenet@example.com\"</span>\n  }) {\n    changedUser {\n      id\n      username\n      email\n    }\n  }\n}\n</code></pre>\n<h3 id=\"updatex\">updateX <a class=\"hash-link\" href=\"#updatex\" aria-hidden=\"true\">#</a></h3>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">updateX</span><span class=\"hljs-params\">(input: _UpdateXInput)</span></span>: _XPayload\n</code></pre>\n<p>Update the given node. Given fields are merged into existing object. <code>input</code>\nis a flat object with all the fields of the type alongside <code>clientMutationId</code>\nand <code>id</code>. <code>id</code> is an id of the node being updated and it is required.</p>\n<pre><code class=\"language-graphql\">mutation {\n  updateUser(input: {\n    id: <span class=\"hljs-string\">\"some-user-id\"</span>\n    username: <span class=\"hljs-string\">\"freiksenets-new-name\"</span>,\n  }) {\n    changedUser {\n      id\n      username\n    }\n  }\n}\n</code></pre>\n<h3 id=\"replacex\">replaceX <a class=\"hash-link\" href=\"#replacex\" aria-hidden=\"true\">#</a></h3>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">replaceX</span><span class=\"hljs-params\">(input: _ReplaceXInput)</span></span>: _XPayload\n</code></pre>\n<p>Replaces the given node with a new one. <code>input</code> is a flat object with all the\nfields of the type alongside <code>clientMutationId</code> and <code>id</code>. <code>id</code> is an id of\nthe node being replaced and it is required. All <code>nonNull</code> fields are required.</p>\n<pre><code class=\"language-graphql\">mutation {\n  replaceUser(input: {\n    id: <span class=\"hljs-string\">\"some-user-id\"</span>\n    username: <span class=\"hljs-string\">\"freiksenets-new-name\"</span>,\n    email: <span class=\"hljs-string\">\"freiksenet-new@example.com\"</span>\n  }) {\n    changedUser {\n      id\n      username\n      email\n    }\n  }\n}\n</code></pre>\n<h3 id=\"deletex\">deleteX <a class=\"hash-link\" href=\"#deletex\" aria-hidden=\"true\">#</a></h3>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">deleteX</span><span class=\"hljs-params\">(input: _DeleteXInput)</span></span>: _XPayload\n</code></pre>\n<p>Delete the given node. <code>input</code> is an object with fields <code>clientMutationId</code> and\n<code>id</code>. <code>id</code> is an id of the node being deleted and it is required.</p>\n<pre><code class=\"language-graphql\">mutation {\n  deleteUser(input: {\n    id: <span class=\"hljs-string\">\"some-user-id\"</span>\n  }) {\n    # Will contain deleted object\n    changedUser {\n      id\n      username\n      email\n    }\n  }\n}\n</code></pre>\n<h2 id=\"operations-on-many-to-many-relationships\">Operations on many-to-many relationships <a class=\"hash-link\" href=\"#operations-on-many-to-many-relationships\" aria-hidden=\"true\">#</a></h2>\n<p>Many-to-many relationships can not be updated using the create/replace\nmutations. Instead, every many-to-many relationship has mutations to add or\nremove items from them. The name takes the form of\n<code>add&lt;Type1&gt;From&lt;Type2&gt;&lt;ConnectionName&gt;</code>, e.g. <code>addMicropostToUserFavorites</code> or\n<code>removeUserFromUserFriends</code>. Note that relationships have mutations for both of\nthe connection fields, so there will be both <code>AddMicropostToUserFavorites</code> and\n<code>AddUserToMicropostFavoritedBy</code>. They are equivalent, they always add or remove\nitems from <em>both</em> connections and are provided for convenience.</p>\n<p>Adding item to a relationship that already has it doesn’t produce an error, as\nwon’t removing item from a relationship that doesn’t include it.</p>\n<h3 id=\"inputs\">Inputs <a class=\"hash-link\" href=\"#inputs\" aria-hidden=\"true\">#</a></h3>\n<p>Inputs for both operations have the following format:</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _Type1Type2ConnectionNameConnectionInput <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  type1Id: <span class=\"hljs-type\">ID</span>!\n  type2Id: <span class=\"hljs-type\">ID</span>!\n}</span></span>\n\n# <span class=\"hljs-type\">For</span> example\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _MicropostUserFavoritesConnectionInput <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  micropostId: <span class=\"hljs-type\">ID</span>!,\n  userId: <span class=\"hljs-type\">ID</span>!\n}</span></span>\n\n# <span class=\"hljs-type\">If</span> connecting the same <span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span></span>\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _UserFriendsConnectionInput <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  user1Id: <span class=\"hljs-type\">ID</span>!,\n  user2Id: <span class=\"hljs-type\">ID</span>!\n}</span></span>\n</code></pre>\n<h3 id=\"payloads\">Payloads <a class=\"hash-link\" href=\"#payloads\" aria-hidden=\"true\">#</a></h3>\n<p>Payload for both operations has the following format:</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _Type1Type2ConnectionNamePayload <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  changedType1: <span class=\"hljs-type\">Type1</span>\n  changedType1Edge: _Type1Edge\n  changedType2: <span class=\"hljs-type\">Type2</span>\n  changedType2Edge: _Type2Edge\n}</span></span>\n\n# <span class=\"hljs-type\">For</span> example\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _MicropostUserFavoritesPayload <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  changedMicropost: <span class=\"hljs-type\">Micropost</span>\n  changedMicropostEdge: _MicropostEdge\n  changedUser: <span class=\"hljs-type\">User</span>\n  changedUserEdge: _UserEdge,\n}</span></span>\n\n# <span class=\"hljs-type\">If</span> connecting the same <span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span></span>\n\n<span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> _UserFriendsPayload <span class=\"hljs-container\">{\n  clientMutationId: <span class=\"hljs-type\">String</span>\n  changedUser1: <span class=\"hljs-type\">User</span>\n  changedUser1Edge: _UserEdge\n  changedUser2: <span class=\"hljs-type\">User</span>\n  changedUser2Edge: _UserEdge\n}</span></span>\n</code></pre>\n<h3 id=\"operations\">Operations <a class=\"hash-link\" href=\"#operations\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"addtype1totype2connectionname\">addType1ToType2ConnectionName <a class=\"hash-link\" href=\"#addtype1totype2connectionname\" aria-hidden=\"true\">#</a></h4>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">addTypeToType2ConnectionName</span><span class=\"hljs-params\">(input: _Type1Type2ConnectionNameConnectionInput)</span></span>: _Type1Type2ConnectionNamePayload\n</code></pre>\n<p>For example:</p>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">addMicropostToUserFavorites</span><span class=\"hljs-params\">(input: _MicropostUserFavoritesConnectionInput)</span></span>: _MicropostUserFavoritesPayload\nmutation <span class=\"hljs-function\"><span class=\"hljs-title\">addUserToUserFriends</span><span class=\"hljs-params\">(input: _UserFriendsConnectionInput)</span></span>: _UserFriendsPayload\n</code></pre>\n<p>Add node defined by <code>type1Id</code> to connection <code>connectionName</code> of node defined\nby <code>type2Id</code>.</p>\n<pre><code class=\"language-graphql\">mutation {\n  addMicropostToUserFavorites(input: {\n    micropostId: <span class=\"hljs-string\">\"some-micropost-id\"</span>,\n    userId: <span class=\"hljs-string\">\"some-user-id\"</span>\n  }) {\n    changedMicropost {\n      favoritedBy {\n        count\n      }\n    }\n    changedUser {\n      favorites {\n        count\n      }\n    }\n  }\n}\n</code></pre>\n<h4 id=\"removetype1fromtype2connectionname\">removeType1FromType2ConnectionName <a class=\"hash-link\" href=\"#removetype1fromtype2connectionname\" aria-hidden=\"true\">#</a></h4>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">removeTypeFromType2ConnectionName</span><span class=\"hljs-params\">(input: _Type1Type2ConnectionNameConnectionInput)</span></span>: _Type1Type2ConnectionNamePayload\n</code></pre>\n<p>For example:</p>\n<pre><code class=\"language-graphql\">mutation <span class=\"hljs-function\"><span class=\"hljs-title\">removeMicropostFromUserFavorites</span><span class=\"hljs-params\">(input: _MicropostUserFavoritesConnectionInput)</span></span>: _MicropostUserFavoritesPayload\nmutation <span class=\"hljs-function\"><span class=\"hljs-title\">removeUserFromUserFriends</span><span class=\"hljs-params\">(input: _UserFriendsConnectionInput)</span></span>: _UserFriendsPayload\n</code></pre>\n<p>Remove node defined by <code>type1Id</code> from connection <code>connectionName</code> of node\ndefined by <code>type2Id</code>.</p>\n<pre><code class=\"language-graphql\">mutation {\n  removeMicropostFromUserFavorites(input: {\n    micropostId: <span class=\"hljs-string\">\"some-micropost-id\"</span>,\n    userId: <span class=\"hljs-string\">\"some-user-id\"</span>\n  }) {\n    changedMicropost {\n      favoritedBy {\n        count\n      }\n    }\n    changedUser {\n      favorites {\n        count\n      }\n    }\n  }\n}\n</code></pre>\n<h2 id=\"migration-api\">Migration API <a class=\"hash-link\" href=\"#migration-api\" aria-hidden=\"true\">#</a></h2>\n<p>While most of the time, one would use <code>reindex-cli schema-push</code> to perform\nmigration, you could also use the low-level GraphQL mutation API directly.</p>\n<h3 id=\"migrate\">migrate <a class=\"hash-link\" href=\"#migrate\" aria-hidden=\"true\">#</a></h3>\n<pre><code class=\"language-graphql\"><span class=\"hljs-tag\">mutation</span> <span class=\"hljs-tag\">migrate</span>(<span class=\"hljs-tag\">input</span>: <span class=\"hljs-tag\">ReindexMigrationInput</span>!): <span class=\"hljs-tag\">ReindexMigrationPayload</span>\n\n<span class=\"hljs-tag\">input</span> <span class=\"hljs-tag\">ReindexMigrationInput</span> <span class=\"hljs-rules\">{\n  <span class=\"hljs-rule\"><span class=\"hljs-attribute\">types</span>:<span class=\"hljs-value\"> [ReindexTypeInput]\n  force: Boolean\n  dryRun: Boolean\n  clientMutationId: String\n</span></span></span>}\n\n<span class=\"hljs-tag\">type</span> <span class=\"hljs-tag\">ReindexMigrationPayload</span> <span class=\"hljs-rules\">{\n  <span class=\"hljs-rule\"><span class=\"hljs-attribute\">clientMutationId</span>:<span class=\"hljs-value\"> String\n  commands: [ReindexMigrationCommand]\n  isExecuted: Boolean\n</span></span></span>}\n\n<span class=\"hljs-tag\">type</span> <span class=\"hljs-tag\">ReindexMigrationCommand</span> <span class=\"hljs-rules\">{\n  <span class=\"hljs-rule\"><span class=\"hljs-attribute\">commandType</span>:<span class=\"hljs-value\"> String\n  isDestructive: Boolean\n  description: String\n</span></span></span>}\n</code></pre>\n<p>Performs a schema migration.</p>\n<ul>\n<li><code>types</code> is the list of types in the desired\n<a href=\"/docs/reindex-schema/\">Reindex schema</a>.</li>\n<li><code>force</code> - must be <code>true</code> to run the migration, if it includes destructive\ncommands.</li>\n<li><code>dryRun</code> - if <code>true</code>, we only validate the schema and return the migration\ncommands without running them.</li>\n</ul>\n<p>Output is a list of commands and whether they have been performed.</p>\n<ul>\n<li><a href=\"https://www.reindex.io/docs/reindex-schema/\">Reindex docs: Reindex schema\n</a></li>\n<li><a href=\"https://www.reindex.io/docs/reindex-cli/\">Reindex docs: Reindex CLI\n</a></li>\n</ul>\n"}

/***/ },
/* 361 */
/***/ function(module, exports) {

	module.exports = {"title":"Queries","order":1,"body":"<p><a name=\"node\"></a></p>\n<h2 id=\"node\">node <a class=\"hash-link\" href=\"#node\" aria-hidden=\"true\">#</a></h2>\n<pre><code class=\"language-graphql\"><span class=\"hljs-keyword\">node</span><span class=\"hljs-identifier\"></span><span class=\"hljs-title\">(id</span>: ID!): <span class=\"hljs-keyword\">Node</span><span class=\"hljs-identifier\">\n</span><span class=\"hljs-title\"></span></code></pre>\n<p>All Reindex types that implement the <code>Node</code> interface have an <code>id</code> that is\nglobally unique among all types. By using this fact, it’s possible to retrieve\nany node by its id. <code>node</code> root field does exactly that - returns any object\nthat has the <code>Node</code> interface.</p>\n<p>This root field is\n<a href=\"https://facebook.github.io/relay/docs/graphql-object-identification.html#content\">used by Relay</a> to update its client-side cache.</p>\n<p>Note that <code>Node</code> only has one field - <code>id</code>. If you want to retrieve fields of\nconcrete type, you need to use typed fragment.</p>\n<pre><code class=\"language-graphql\">query NodeExample {\n  node(<span class=\"hljs-property\">id</span>: <span class=\"hljs-string\">\"some-id\"</span>) {\n    <span class=\"hljs-property\">id</span>,\n    ... <span class=\"hljs-function_start\"><span class=\"hljs-keyword\">on</span></span> Todo {\n      <span class=\"hljs-type\">text</span>,\n      completed,\n    }\n  }\n}\n</code></pre>\n<p><a name=\"xByField\"></a></p>\n<h2 id=\"xbyfield\">xByField <a class=\"hash-link\" href=\"#xbyfield\" aria-hidden=\"true\">#</a></h2>\n<pre><code><span class=\"hljs-attribute\">xByField(fieldName</span>: <span class=\"hljs-string\">fieldType!): X</span>\n\n<span class=\"less\"># <span class=\"hljs-tag\">For</span> <span class=\"hljs-tag\">example</span>\n<span class=\"hljs-tag\">todoById</span>(<span class=\"hljs-attribute\">id</span>: ID!): <span class=\"hljs-tag\">Todo</span>\n<span class=\"hljs-tag\">reindexTypeByName</span>(<span class=\"hljs-attribute\">name</span>: String!): <span class=\"hljs-tag\">ReindexType</span>\n</span></code></pre>\n<p>Get an object by one of it’s unique fields. <code>id</code> is always unique, so all types\nget <code>XById</code>.</p>\n<h2 id=\"viewer\">viewer <a class=\"hash-link\" href=\"#viewer\" aria-hidden=\"true\">#</a></h2>\n<pre><code class=\"language-graphql\"><span class=\"hljs-attribute\">viewer</span>: <span class=\"hljs-string\">ReindexViewer</span>\n\n<span class=\"elm\"><span class=\"hljs-typedef\"><span class=\"hljs-keyword\">type</span> <span class=\"hljs-type\">ReindexViewer</span> implements <span class=\"hljs-type\">Node</span> <span class=\"hljs-container\">{\n  id: <span class=\"hljs-type\">ID</span>!\n  user: <span class=\"hljs-type\">User</span>\n  # connections to all types\n  allXs(first: <span class=\"hljs-type\">Int</span> = 10, last: <span class=\"hljs-type\">Int</span>, before: <span class=\"hljs-type\">Cursor</span>, after: <span class=\"hljs-type\">Cursor</span>, orderBy: _XOrdering): _XConnection\n  # for example\n  allTodos(first: <span class=\"hljs-type\">Int</span> = 10, last: <span class=\"hljs-type\">Int</span>, before: <span class=\"hljs-type\">Cursor</span>, after: <span class=\"hljs-type\">Cursor</span>, orderBy: _TodoOrdering): _TodoConnection\n}</span></span>\n</span></code></pre>\n<p><code>viewer</code> is a root field that returns <code>ReindexViewer</code>. <code>viewer</code> is a\nRelay pattern and it holds information about current user and connections to all\nthe nodes of each node type. In many applications, most queries will start with\n<code>viewer</code>.</p>\n<p><code>ReindexViewer</code> is a global <code>Node</code> used to query all nodes and the current user.</p>\n<p><code>ReindexViewer</code> has a <code>user</code> field, which is the currently logged-in user.\nIf there is no logged-in user, this field will return <code>null</code>.</p>\n<p>For each node type, <code>ReindexViewer</code> has a connection field with all nodes\nof that type. The field is named is <code>allObjects</code> where <code>Objects</code> is the pluralized name of the type.</p>\n"}

/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports = {"title":"Importing data","order":6,"body":"<p>To import existing data to Reindex, you can create a script that reads data\nfrom any data source like JSON files, SQL databases or REST APIs and then uses a\nGraphQL mutation to add the data to Reindex.</p>\n<p>Here’s a simple example of a Node.js script that imports data using\n<a href=\"https://github.com/reindexio/reindex-js\">reindex-js</a>:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'reindex-js'</span>;\n\n<span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(process.env.REINDEX_URL);\nreindex.setToken(process.env.REINDEX_TOKEN);\n\n<span class=\"hljs-keyword\">const</span> todos = [\n  { text: <span class=\"hljs-string\">'Build an app'</span>, complete: <span class=\"hljs-literal\">true</span> },\n  { text: <span class=\"hljs-string\">'???'</span>, complete: <span class=\"hljs-literal\">false</span> },\n  { text: <span class=\"hljs-string\">'Profit'</span>, complete: <span class=\"hljs-literal\">true</span> }\n];\n\n<span class=\"hljs-keyword\">const</span> mutation = <span class=\"hljs-string\">`\nmutation ImportTodo($todo: _CreateTodoInput!) {\n  createTodo(input: $todo) {\n    id\n  }\n}\n`</span>;\n\n<span class=\"hljs-keyword\">async</span> <span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">importTodos</span>(<span class=\"hljs-params\"></span>) </span>{\n  <span class=\"hljs-keyword\">for</span> (<span class=\"hljs-keyword\">const</span> todo <span class=\"hljs-keyword\">of</span> todos) {\n    <span class=\"hljs-keyword\">const</span> result = <span class=\"hljs-keyword\">await</span> reindex.query(mutation, { todo });\n    <span class=\"hljs-keyword\">if</span> (result.errors) {\n      <span class=\"hljs-built_in\">console</span>.error(result.errors);\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-built_in\">console</span>.log(<span class=\"hljs-string\">'Created a todo with id:'</span>, result.data.createTodo.id);\n    }\n  }\n}\n\nimportTodos().catch((e) =&gt; <span class=\"hljs-built_in\">console</span>.error(e));\n</code></pre>\n"}

/***/ },
/* 363 */
/***/ function(module, exports) {

	module.exports = {"title":"Introduction","order":0,"body":"<hr>\n<p><strong>Note:</strong> Reindex backend as a service has been <a href=\"/blog/discontinuing-backend-as-a-service/\">discontinued</a>. The documentation is kept here for reference.</p>\n<hr>\n<p><strong>Reindex</strong> is a backend as a service for\n<a href=\"https://facebook.github.io/react/\">React</a> apps. With Reindex you can build\nmobile and web apps without time consuming backend development. We provide the\nstorage with a <a href=\"http://graphql.org/\">GraphQL</a> API, so you can concentrate on\nshipping amazing apps to your users.</p>\n<p>Reindex integrates seamlessly with <a href=\"https://facebook.github.io/relay/\">Relay</a>,\nthe JavaScript framework for building data-driven React applications. Together\nwith Relay and other open source tools for GraphQL, Reindex provides a great\ndeveloper experience: instead of writing complex logic for data fetching and\nmutations, you can write declarative queries and the framework handles the\ncomplex details.</p>\n<h2 id=\"initial-steps\">Initial steps <a class=\"hash-link\" href=\"#initial-steps\" aria-hidden=\"true\">#</a></h2>\n<p><a href=\"/docs/tutorial/\">Tutorial</a> goes through creating a Reindex, Relay and React\nTodoMVC web application.</p>\n<ol>\n<li><a href=\"/docs/tutorial/setup/\">Setup</a>: configuring <code>reindex-cli</code> and\n<code>reindex-starter-kit-react</code></li>\n<li><a href=\"/docs/tutorial/defining-the-schema/\">Defining the schema</a>: creating schema,\nperforming queries with GraphiQL</li>\n<li><a href=\"/docs/tutorial/displaying-todos\">Displaying todos</a>: displaying data\nin your React/Relay app</li>\n<li><a href=\"/docs/tutorial/adding-mutations/\">Adding mutations</a>: performing Relay mutations</li>\n<li><a href=\"/docs/tutorial/deployment/\">Deployment</a>: deploying your app to a static site\nhosting</li>\n<li><a href=\"/docs/tutorial/authenticating-users/\">Authenticating users</a>: setting up Google API as a\nauthentication provider for your app’s users</li>\n</ol>\n<h2 id=\"detailed-guides\">Detailed guides <a class=\"hash-link\" href=\"#detailed-guides\" aria-hidden=\"true\">#</a></h2>\n<ul>\n<li><a href=\"/docs/reindex-schema/\">Reindex schema</a>: in-depth guide to the schema JSON\nlanguage</li>\n<li><a href=\"/docs/graphql-api/\">GraphQL API</a>: Reindex’s core API\n<ul>\n<li><a href=\"/docs/graphql-api/queries/\">Queries</a></li>\n<li><a href=\"/docs/graphql-api/mutations/\">Mutations</a></li>\n<li><a href=\"/docs/graphql-api/connections/\">Connections</a></li>\n<li><a href=\"/docs/graphql-api/built-in-types/\">Built-in types</a></li>\n</ul>\n</li>\n<li><a href=\"/docs/security/\">Security</a>\n<ul>\n<li><a href=\"/docs/security/authentication/\">Authentication</a>: authentication and\nuser management</li>\n<li><a href=\"/docs/security/authorization/\">Authorization</a>: permission system</li>\n</ul>\n</li>\n<li><a href=\"/docs/integrations/\">Integrating third-party services</a>\n<ul>\n<li><a href=\"/docs/integrations/hooks/\">Hooks</a> web hooks that allow you to react to\nmutations on certain types</li>\n<li><a href=\"/docs/integrations/emails/\">Sending emails</a> guide to sending emails with\nhooks, Zapier and Mailgun.</li>\n</ul>\n</li>\n<li><a href=\"/docs/importing-data/\">Importing data</a>: importing existing data into Reindex</li>\n</ul>\n<h2 id=\"useful-tools\">Useful tools <a class=\"hash-link\" href=\"#useful-tools\" aria-hidden=\"true\">#</a></h2>\n<ul>\n<li><a href=\"/docs/reindex-js/\">reindex-js</a>: universal Javascript client library</li>\n<li><a href=\"/docs/reindex-cli/\">reindex-cli</a>: command line interface documentation</li>\n</ul>\n<h2 id=\"starter-kits-and-examples\">Starter kits and examples <a class=\"hash-link\" href=\"#starter-kits-and-examples\" aria-hidden=\"true\">#</a></h2>\n<ul>\n<li><a href=\"https://github.com/reindexio/reindex-starter-kit-react\">React + Relay starter kit</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-starter-kit-apollo\">Apollo Client + React starter kit</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-examples\">Reindex examples</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-examples/tree/master/todomvc-multi-user\">TodoMVC (React + Relay)</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-examples/tree/master/react-native-gallery\">Instagram-like gallery app (React Native + Reindex)</a></li>\n<li><a href=\"https://github.com/reindexio/reindex-examples/tree/master/motion-gallery\">Instagram-like gallery app (Motion + Relay)</a></li>\n</ul>\n"}

/***/ },
/* 364 */
/***/ function(module, exports) {

	module.exports = {"title":"Sending emails","order":3,"body":"<p>A very common task in many applications is sending emails. Sending emails is\nsurprisingly hard and thus many people embrace service providers that allow\nsending emails. This guide illustrates using Reindex hooks to send emails with\n<a href=\"https://mailgun.com/\">Mailgun</a>.</p>\n<p>We will use <a href=\"http://zapier.com/\">Zapier</a>, an app that connects different APIs\ntogether. This way you could later use any other integrations that Zapier\nprovides. You can also use a custom backend or any other API integrator\ninstead.</p>\n<p>First go to Zapier and register. We will connect Zapier WebHook app and\nMailgun. Choose ‘Catch hook’ action in WebHook app and ‘Send email’ action in\nMailgun. You will get a hook url, save it somewhere. Zapier will ask you to\nconnect the Mailgun account and after that you are ready to go.</p>\n<p>Let’s send email every time a new Todo is created. First we need to get an id\nof the Todo <code>ReindexType</code>.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  reindexTypeByName<span class=\"hljs-list\">(<span class=\"hljs-keyword\">name:</span> <span class=\"hljs-string\">\"Todo\"</span>)</span> <span class=\"hljs-collection\">{\n    id,\n  }</span>\n}</span>\n</code></pre>\n<p>Now we can create our hook</p>\n<pre><code>mutation createhook {\n  createReindexHook(input: {\n    type: <span class=\"hljs-string\">\"YOUR-TODO-REINDEXTYPE-ID\"</span>,\n    trigger: afterCreate,\n    url: <span class=\"hljs-string\">\"https://zapier.com/hooks/catch/YOUR-ZAPIER-HOOK/\"</span>,\n    fragment: <span class=\"hljs-string\">\"{ changedTodo { text, user { email } } }\"</span>\n  }) {\n    id\n  }\n}\n</code></pre>\n<p>After you create a Todo, Zapier will analyze the structure of your hook and\nyou should be able to select appropriate fields for Recipient and a template to\nformat an email. You can also add a Zapier filter that will check that user’s\nemail is present.</p>\n"}

/***/ },
/* 365 */
/***/ function(module, exports) {

	module.exports = {"title":"Hooks","order":1,"body":"<p>Hooks allow you to define a URL to send a POST request to when mutation on some\ntype is performed. This lets you react to user actions and integrate\nthird-party services without much hassle.</p>\n<p>Hooks are stored in type <code>ReindexHook</code>. It has the following fields:</p>\n<ul>\n<li><code>type</code> - type, from operation on which hook triggers. If null, hook will\ntrigger to any type operation.</li>\n<li><code>trigger</code> - event that triggers the hook. Can be <code>afterCreate</code>, <code>afterUpdate</code>\nor <code>afterDelete</code>.</li>\n<li><code>url</code> - full URL to send the request to</li>\n<li><code>fragment</code> - fragment body on the corresponding type payload. Must be\nsurrounded by {} and not have a name. Can include typed inline fragments.</li>\n<li><code>logLevel</code> - <code>all</code>, <code>error</code> or <code>none</code>. Defines which results of the hook\nfragment execution to save in <code>ReindexHookLog</code>. <code>all</code> - all results are saved,\n<code>error</code> - only failed hooks are saved.</li>\n</ul>\n<p>For example, let’s assume we have a service listening at\n<code>http://www.example.com/testservice</code> and we want to POST to it when new todo is\ncreated.</p>\n<p>First, we need to find the ID of <code>Todo</code> <code>ReindexType</code>.</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-collection\">{\n  reindexTypeByName<span class=\"hljs-list\">(<span class=\"hljs-keyword\">name:</span> <span class=\"hljs-string\">\"Todo\"</span>)</span> <span class=\"hljs-collection\">{\n    id,\n  }</span>\n}</span>\n</code></pre>\n<p>After that we can create a hook. Fragment is used on the same type as the\nmutation result (payload). Let’s say we want to get todo’s text and the user id\nthat it belongs to.</p>\n<pre><code class=\"language-graphql\">mutation {\n  createReindexHook(<span class=\"hljs-keyword\">input</span>: {\n    <span class=\"hljs-keyword\">type</span>: <span class=\"hljs-string\">\"YOUR-TODO-TYPE-ID\"</span>,\n    trigger: afterCreate,\n    url: <span class=\"hljs-string\">\"http://www.example.com/testservice\"</span>,\n    fragment: <span class=\"hljs-string\">\"{ changedTodo { text, user { id } } }\"</span>,\n    logLevel: <span class=\"hljs-keyword\">error</span>\n  }) {\n    id\n  }\n}\n</code></pre>\n<p>Now every time new Todo will be created, the service should receive a POST\nrequest.</p>\n<p>Operations on many-to-many relationships trigger hooks for both of the affected\nnodes.</p>\n<h2 id=\"hook-log\">Hook log <a class=\"hash-link\" href=\"#hook-log\" aria-hidden=\"true\">#</a></h2>\n<p>Often it’s useful to check if your hook is actually doing something. It’s easy\nto make mistake in a fragment or URL. Hook logs provide a way to log executed\nhooks and then check if there was a problem.</p>\n<p>Depending on your hook <code>logLevel</code>, hook log will contain a list of hook log\nresults. You can access it directly by reading the corresponding hook:</p>\n<pre><code><span class=\"hljs-collection\">{\n  reindexHookById<span class=\"hljs-list\">(<span class=\"hljs-keyword\">id:</span> <span class=\"hljs-string\">\"YOUR-HOOK-ID\"</span>)</span> <span class=\"hljs-collection\">{\n    log<span class=\"hljs-list\">(<span class=\"hljs-keyword\">orderBy:</span> CREATED_AT_DESC)</span> <span class=\"hljs-collection\">{\n      nodes <span class=\"hljs-collection\">{\n        createdAt,\n        type,\n        errors\n      }</span>\n    }</span>\n  }</span>\n}</span>\n</code></pre>\n<h2 id=\"hookbook\">Hookbook <a class=\"hash-link\" href=\"#hookbook\" aria-hidden=\"true\">#</a></h2>\n<h3 id=\"sending-emails-with-mailgun-through-zapier\"><a href=\"/docs/integrations/emails/\">Sending emails with Mailgun through Zapier</a> <a class=\"hash-link\" href=\"#sending-emails-with-mailgun-through-zapier\" aria-hidden=\"true\">#</a></h3>\n<p><a href=\"http://zapier.com/\">Zapier</a> provides out of the box integrations with many\nservices. This guide shows how to send emails through <a href=\"https://mailgun.com/\">Mailgun</a>\nby using Zapier Post-hook app.</p>\n"}

/***/ },
/* 366 */
/***/ function(module, exports) {

	module.exports = {"title":"Integrating third-party services","order":6,"body":"<p>When developing applications, you often would like to off-load some common task\nto some existing service provider. It could be handling payments or\nsending emails. In addition, sometimes your application might have more complex\nvalidation rules than Reindex provides and you’d need to write a small custom\nbackend to handle that.</p>\n<p>Reindex provides <em>hooks</em> as a mechanism to integrate third-party services and\nbackends. It allows you to specify a URL to send a POST request to in response\nto a certain mutation for a certain type.</p>\n<ul>\n<li><a href=\"/docs/integrations/hooks/\">Hooks</a>: detailed documentation on hooks</li>\n<li><a href=\"/docs/integrations/emails/\">Sending emails</a>: sending emails with Mailgun and Zapier</li>\n</ul>\n"}

/***/ },
/* 367 */
/***/ function(module, exports) {

	module.exports = {"title":"Reindex CLI","order":9,"body":"<p><code>reindex-cli</code> is a console interface for Reindex.</p>\n<pre><code>npm <span class=\"hljs-operator\"><span class=\"hljs-keyword\">install</span> -<span class=\"hljs-keyword\">g</span> reindex-cli\nreindex login\nreindex <span class=\"hljs-keyword\">schema</span>-<span class=\"hljs-keyword\">fetch</span>\n</span></code></pre>\n<h2 id=\"usage\">Usage <a class=\"hash-link\" href=\"#usage\" aria-hidden=\"true\">#</a></h2>\n<h5 id=\"reindex-login-url-token\"><code>reindex login [url] [token]</code> <a class=\"hash-link\" href=\"#reindex-login-url-token\" aria-hidden=\"true\">#</a></h5>\n<p>Login to Reindex using given Reindex URL and token. Prompts for url and token if\nthey are not provided. Credentials are stored in <code>.netrc</code> file in user’s HOME\nfolder.</p>\n<h5 id=\"reindex-logout\"><code>reindex logout</code> <a class=\"hash-link\" href=\"#reindex-logout\" aria-hidden=\"true\">#</a></h5>\n<p>Clear stored credentials.</p>\n<h5 id=\"reindex-graphiql\"><code>reindex graphiql</code> <a class=\"hash-link\" href=\"#reindex-graphiql\" aria-hidden=\"true\">#</a></h5>\n<p>Opens <a href=\"https://github.com/graphql/graphiql\">GraphiQL</a> console for your\nReindex app in your browser.</p>\n<h5 id=\"reindex-schema-fetch-schema-file-force\"><code>reindex schema-fetch [SCHEMA_FILE] [--force]</code> <a class=\"hash-link\" href=\"#reindex-schema-fetch-schema-file-force\" aria-hidden=\"true\">#</a></h5>\n<p>Fetch Reindex JSON schema to <code>SCHEMA_FILE</code> file (<code>ReindexSchema.json</code> if not\nprovided).</p>\n<p>If <code>--force</code> flag is not set, it will not run if schema file already exists.</p>\n<h5 id=\"reindex-schema-push-schema-file-dry-run-force\"><code>reindex schema-push [SCHEMA_FILE] [--dry-run --force]</code> <a class=\"hash-link\" href=\"#reindex-schema-push-schema-file-dry-run-force\" aria-hidden=\"true\">#</a></h5>\n<p>Push JSON schema from <code>SCHEMA_FILE</code> (defaults to <code>ReindexSchema.json</code>)\nto Reindex API to perform a migration. Validates the schema and runs the\nmigration, if it only includes safe operations.</p>\n<p>If the migration includes destructive operations, <code>--force</code> flag must be used\nto run it.</p>\n<p>If <code>--dry-run</code> flag is given, the command only validates the schema\nand displays the migration without running.</p>\n<h5 id=\"reindex-schema-relay-output\"><code>reindex schema-relay OUTPUT</code> <a class=\"hash-link\" href=\"#reindex-schema-relay-output\" aria-hidden=\"true\">#</a></h5>\n<p>Get Relay compatible GraphQL schema from Reindex API at <code>HOST</code>. <code>OUTPUT</code> is a\nfile name. If output is specified, result is written into it. Otherwise result\nis written to stdout.</p>\n<h2 id=\"options\">Options <a class=\"hash-link\" href=\"#options\" aria-hidden=\"true\">#</a></h2>\n<h5 id=\"u-reindex-url-url-reindex-url\"><code>-u REINDEX_URL --url REINDEX_URL</code> <a class=\"hash-link\" href=\"#u-reindex-url-url-reindex-url\" aria-hidden=\"true\">#</a></h5>\n<p>Your Reindex application host (eg <code>https://YOURAPP.myreindex.com</code>). Can be set\neither with this flag or via <code>REINDEX_URL</code> environment variable. If you use\n<code>reindex login</code>, this parameter overrides stored credentials.</p>\n<h5 id=\"t-reindex-token-token-reindex-token\"><code>-t REINDEX_TOKEN --token REINDEX_TOKEN</code> <a class=\"hash-link\" href=\"#t-reindex-token-token-reindex-token\" aria-hidden=\"true\">#</a></h5>\n<p>Your Reindex application authorization token. Can be set\neither with this flag or via <code>REINDEX_TOKEN</code> environment variable. If you use\n<code>reindex login</code>, this parameter overrides stored credentials.</p>\n"}

/***/ },
/* 368 */
/***/ function(module, exports) {

	module.exports = {"title":"reindex-js","order":8,"body":"<p><code>reindex-js</code> is a client library that makes using Reindex easier. It provides\nsupport for authentication, including social login. It also exposes hooks for\nusing Reindex with Relay and other libraries.</p>\n<p><code>reindex-js</code> is a universal Javascript library, so it works in browser, React\nNative and Node.js. However, some features, like social login, currently only\nworks in browser.</p>\n<h2 id=\"installation\">Installation <a class=\"hash-link\" href=\"#installation\" aria-hidden=\"true\">#</a></h2>\n<pre><code class=\"language-sh\">npm install reindex-js\n</code></pre>\n<h2 id=\"usage\">Usage <a class=\"hash-link\" href=\"#usage\" aria-hidden=\"true\">#</a></h2>\n<p>Import the library</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'reindex-js'</span>\n</code></pre>\n<p>Create an instance.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(<span class=\"hljs-string\">'https://YOUR-REINDEX-URL.myreindex.com'</span>);\n</code></pre>\n<h2 id=\"api\">API <a class=\"hash-link\" href=\"#api\" aria-hidden=\"true\">#</a></h2>\n<h5 id=\"new-reindexurl-string-reindex\"><code>new Reindex(url: String) -&gt; Reindex</code> <a class=\"hash-link\" href=\"#new-reindexurl-string-reindex\" aria-hidden=\"true\">#</a></h5>\n<p>Create a new instance of Reindex. Usually only one instance is needed so you can\ncreate it in one model and export.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'reindex'</span>;\n\n<span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(<span class=\"hljs-string\">'https://YOUR-REINDEX-URL.myreindex.com'</span>);\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> reindex;\n</code></pre>\n<p>In browser environment, if token was stored in <code>localStorage</code>, it will be\nretrieved and stored inside the instance.</p>\n<h3 id=\"authentication\">Authentication <a class=\"hash-link\" href=\"#authentication\" aria-hidden=\"true\">#</a></h3>\n<h5 id=\"loginprovidername-string-promise\"><code>.login(providerName: String) -&gt; Promise</code> <a class=\"hash-link\" href=\"#loginprovidername-string-promise\" aria-hidden=\"true\">#</a></h5>\n<p><em>Browser only</em></p>\n<p>Attempt to login with a <code>providerName</code>. Currently only Social Login providers\nare available (<code>google</code>, <code>facebook</code>, <code>twitter</code>, <code>github</code>). Provider should be\nset up and enabled in your Reindex app.</p>\n<p>Practically, it opens a browser window with provider’s login screen, where user\nneeds to grant your application permissions to read his data. If everything\nsucceeds promise is resolved with an object of <code>token</code> - JSON Web Token for the\nuser, <code>user</code> - information about the user. If anything fails for any reason,\npromise rejects with an error as result.</p>\n<p>Token is stored inside the instance and inside browser <code>localStorage</code>.</p>\n<p>Emits <code>login</code> and <code>tokenChange</code> events.</p>\n<h5 id=\"loginwithtokenprovidername-string-logintoken-string\"><code>.loginWithToken(providerName: String, loginToken: String)</code> <a class=\"hash-link\" href=\"#loginwithtokenprovidername-string-logintoken-string\" aria-hidden=\"true\">#</a></h5>\n<p>Attempt to login to Reindex with a login token provided by some provider.\nCurrently only Auth0 (<code>auth0</code>) is supported. Reindex validates the token on\nthe backend side and performs normal login there. As no browser interaction is\nrequired from user, it can be used on server or in React Native.\nOtherwise behaves as <code>login</code>: sets token and stores token in <code>localStorage</code>\n(if available).</p>\n<p>Emits <code>login</code> and <code>tokenChange</code> events.</p>\n<p>Example usage with Auth0 lock:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> lock = <span class=\"hljs-keyword\">new</span> Auth0Lock(<span class=\"hljs-string\">'YOUR-AUTH0-CLIENT-ID'</span>, <span class=\"hljs-string\">'YOUR-AUTH0-DOMAIN'</span>);\nlock.show(<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> (<span class=\"hljs-params\">error, profile, token</span>) </span>{\n  <span class=\"hljs-keyword\">if</span> (error) {\n    <span class=\"hljs-built_in\">console</span>.log(error);\n  } <span class=\"hljs-keyword\">else</span> {\n    Reindex.loginWithToken(<span class=\"hljs-string\">'auth0'</span>, token)\n      .then(() =&gt; <span class=\"hljs-built_in\">console</span>.log(<span class=\"hljs-string\">'Success'</span>))\n      .catch((err) =&gt; <span class=\"hljs-built_in\">console</span>.log(err));\n  }\n});\n</code></pre>\n<h5 id=\"logout-promise\"><code>.logout() -&gt; Promise</code> <a class=\"hash-link\" href=\"#logout-promise\" aria-hidden=\"true\">#</a></h5>\n<p><em>Browser only</em></p>\n<p>Clears token from the instance and <code>localStorage</code>. Resolve promise with map\nof <code>token</code> and <code>user</code>, both of which are null.</p>\n<p>Emits <code>logout</code> and <code>tokenChange</code> events.</p>\n<h5 id=\"isloggedin-boolean\"><code>.isLoggedIn() -&gt; Boolean</code> <a class=\"hash-link\" href=\"#isloggedin-boolean\" aria-hidden=\"true\">#</a></h5>\n<p>Returns true if there is a token stored inside the instance.</p>\n<h5 id=\"settokentoken-string\"><code>.setToken(token: String)</code> <a class=\"hash-link\" href=\"#settokentoken-string\" aria-hidden=\"true\">#</a></h5>\n<p>Set the token manually. Can be used when custom authentication provider is used\nor on server.</p>\n<p>Emits <code>tokenChange</code> event.</p>\n<h3 id=\"querying\">Querying <a class=\"hash-link\" href=\"#querying\" aria-hidden=\"true\">#</a></h3>\n<h5 id=\"queryquery-string-variables-object-promise\"><code>.query(query: String, variables: Object) -&gt; Promise</code> <a class=\"hash-link\" href=\"#queryquery-string-variables-object-promise\" aria-hidden=\"true\">#</a></h5>\n<p>Queries the Reindex backend. Returns Promise that resolves if HTTP request\nsucceeded, rejects otherwise.</p>\n<h5 id=\"getauthenticationheaders-object\"><code>.getAuthenticationHeaders() -&gt; Object</code> <a class=\"hash-link\" href=\"#getauthenticationheaders-object\" aria-hidden=\"true\">#</a></h5>\n<p>Returns map of header name to value that need to be used to authenticate request\nwith Reindex backend.</p>\n<h3 id=\"usage-with-relay\">Usage with Relay <a class=\"hash-link\" href=\"#usage-with-relay\" aria-hidden=\"true\">#</a></h3>\n<h5 id=\"getrelaynetworklayertimeout-int-retrydelays-int-relaynetworklayer\"><code>.getRelayNetworkLayer(timeout: int, retryDelays: int) -&gt; RelayNetworkLayer</code> <a class=\"hash-link\" href=\"#getrelaynetworklayertimeout-int-retrydelays-int-relaynetworklayer\" aria-hidden=\"true\">#</a></h5>\n<p>Returns RelayNetworkLayer. Usage:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n<span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'reindex-js'</span>;\n\n<span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(<span class=\"hljs-string\">'https://YOUR-REINDEX-URL.myreindex.com'</span>);\n\nRelay.injectNetworkLayer(reindex.getRelayNetworkLayer());\n</code></pre>\n<h3 id=\"events\">Events <a class=\"hash-link\" href=\"#events\" aria-hidden=\"true\">#</a></h3>\n<p><code>Reindex</code> extends <a href=\"https://nodejs.org/api/events.html\">EventEmitter</a>, so it\ncan be (un)subscribed with <code>on</code> and <code>off</code>. Here are the possible events:</p>\n<h5 id=\"login-loginresponse-object\"><code>login (loginResponse: Object)</code> <a class=\"hash-link\" href=\"#login-loginresponse-object\" aria-hidden=\"true\">#</a></h5>\n<p>When login succeded. <code>loginResponse</code> is the response from backend.</p>\n<h5 id=\"logout\"><code>logout</code> <a class=\"hash-link\" href=\"#logout\" aria-hidden=\"true\">#</a></h5>\n<p>When logout succeded.</p>\n<h5 id=\"tokenchange-token-string\"><code>tokenChange (token: String)</code> <a class=\"hash-link\" href=\"#tokenchange-token-string\" aria-hidden=\"true\">#</a></h5>\n<p>When token changes. <code>token</code> is the new token.</p>\n<h2 id=\"compiling-manually\">Compiling manually <a class=\"hash-link\" href=\"#compiling-manually\" aria-hidden=\"true\">#</a></h2>\n<p>To build UMD bundle:</p>\n<pre><code class=\"language-sh\">npm run build:umd\n</code></pre>\n"}

/***/ },
/* 369 */
/***/ function(module, exports) {

	module.exports = {"title":"Reindex schema","order":2,"body":"<p>The schema for a Reindex app is defined in JSON. You can fetch the schema for\nyour app using a CLI command:</p>\n<pre><code class=\"language-sh\">reindex schema-fetch\n</code></pre>\n<p>By default this saves the schema to a file named <code>ReindexSchema.json</code>.\nAfter editing the schema in your favorite editor, push it to your app with:</p>\n<pre><code class=\"language-sh\">reindex schema-push\n</code></pre>\n<p>Reindex automatically migrates the database of the app to the new schema and\ngenerates things like mutations and input objects for it automatically.</p>\n<p>You can also do migrations programmatically using\n<a href=\"../graphql-api/mutations/#migrate\">migrate mutation</a>.</p>\n<blockquote>\n<h5 id=\"tip-documentation-browser\">Tip: Documentation browser <a class=\"hash-link\" href=\"#tip-documentation-browser\" aria-hidden=\"true\">#</a></h5>\n<p>After pushing the schema to your app, you can view the whole GraphQL schema,\nincluding also the builtin types and auto-generated fields, in the\ndocumentation browser of GraphiQL.</p>\n<p>Open GraphiQL with <code>reindex graphiql</code> and click “Docs” in the top right\ncorner.</p>\n</blockquote>\n<h2 id=\"schema-json\">Schema JSON <a class=\"hash-link\" href=\"#schema-json\" aria-hidden=\"true\">#</a></h2>\n<p>The schema file includes an array of types for the schema. For example:</p>\n<pre><code class=\"language-json\">[\n  {\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"User\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>}\n    ]\n  </span>}\n]\n</code></pre>\n<p>The properties supported in the schema definition are documented below.</p>\n<p><a name=\"type-object\"></a></p>\n<h3 id=\"type-object\">Type object <a class=\"hash-link\" href=\"#type-object\" aria-hidden=\"true\">#</a></h3>\n<p>The type object defines a single type in the schema.</p>\n<h4 id=\"fields-reindexfield\"><code>fields: [ReindexField]</code> <a class=\"hash-link\" href=\"#fields-reindexfield\" aria-hidden=\"true\">#</a></h4>\n<p>Array of <a href=\"#field-object\">field objects</a> that describe the fields of the\ntype.</p>\n<h4 id=\"permissions-reindexpermission\"><code>permissions: [ReindexPermission]</code> <a class=\"hash-link\" href=\"#permissions-reindexpermission\" aria-hidden=\"true\">#</a></h4>\n<p>Array of <a href=\"../security/authorization\">permissions</a> that determine who has rights\nto read and change the nodes of this type.</p>\n<h4 id=\"interfaces-string\"><code>interfaces: [String]</code> <a class=\"hash-link\" href=\"#interfaces-string\" aria-hidden=\"true\">#</a></h4>\n<p>Array with the names of interfaces the type implements.</p>\n<p>Supported interfaces are:</p>\n<ul>\n<li><code>Node</code>: Defines a type with globally unique ID.</li>\n</ul>\n<blockquote>\n<h5 id=\"node-types\">Node types <a class=\"hash-link\" href=\"#node-types\" aria-hidden=\"true\">#</a></h5>\n<p>The node types can be fetched using the <code>node</code> root field or the automatically\ncreated type specific root fields (e.g. <code>todoById</code>). They are also accessible\nthrough the connection of all nodes of a type\n(e.g. <code>{ viewer { allTodos { ... } } }</code>).</p>\n<p>They can also be referenced in other node types, forming relationships\nbetween types.</p>\n<p>The node types also get a set of mutations created for them automatically.\nHere’s a list of mutations for type <code>Todo</code>:</p>\n<ul>\n<li><code>createTodo</code> – Creates a new <code>Todo</code> object.</li>\n<li><code>updateTodo</code> – Updates the given <code>Todo</code> object. The given fields are merged\nto the existing object.</li>\n<li><code>replaceTodo</code> – Replaces the given <code>Todo</code> object.</li>\n<li><code>deleteTodo</code> – Deletes the given <code>Todo</code> object.</li>\n</ul>\n</blockquote>\n<h4 id=\"kind-string\"><code>kind: String!</code> <a class=\"hash-link\" href=\"#kind-string\" aria-hidden=\"true\">#</a></h4>\n<p>The kind of the type. At the moment <code>&quot;OBJECT&quot;</code> is the only supported value.</p>\n<h4 id=\"name-string\"><code>name: String!</code> <a class=\"hash-link\" href=\"#name-string\" aria-hidden=\"true\">#</a></h4>\n<p>The name of the type.</p>\n<p>The name must start with a capital letter. Allowed characters are letters A-Z,\na-z and underscore (_). Type names that start with “Reindex” are reserved for\nbuiltin types.</p>\n<h4 id=\"pluralname-string\"><code>pluralName: String</code> <a class=\"hash-link\" href=\"#pluralname-string\" aria-hidden=\"true\">#</a></h4>\n<p>An optional pluralized name for the type. If not specified, the default English\npluralization will be used for generated field names like <code>allStories</code>.</p>\n<p><a name=\"field-object\"></a></p>\n<h3 id=\"field-object\">Field object <a class=\"hash-link\" href=\"#field-object\" aria-hidden=\"true\">#</a></h3>\n<h4 id=\"defaultordering-reindexordering\"><code>defaultOrdering: ReindexOrdering</code> <a class=\"hash-link\" href=\"#defaultordering-reindexordering\" aria-hidden=\"true\">#</a></h4>\n<p>For fields of type <code>Connection</code>, defines the default sorting order for the items\nin the connection. If specified, must be an object with properties <code>field</code>\n(name of a field) and <code>order</code> (either “ASC” or “DESC”).</p>\n<h4 id=\"deprecationreason-string\"><code>deprecationReason: String</code> <a class=\"hash-link\" href=\"#deprecationreason-string\" aria-hidden=\"true\">#</a></h4>\n<p>If given, makes the field show as deprecated.</p>\n<h4 id=\"description-string\"><code>description: String</code> <a class=\"hash-link\" href=\"#description-string\" aria-hidden=\"true\">#</a></h4>\n<p>An optional description for the GraphQL field. The description is shown in the\ndocumentation of your app’s API and also when you’re typing a query in GraphiQL.</p>\n<h4 id=\"name-string-2\"><code>name: String!</code> <a class=\"hash-link\" href=\"#name-string-2\" aria-hidden=\"true\">#</a></h4>\n<p>The name of the field. Allowed characters are letters A-Z, a-z and underscore\n(_).</p>\n<h4 id=\"nonnull-boolean\"><code>nonNull: Boolean</code> <a class=\"hash-link\" href=\"#nonnull-boolean\" aria-hidden=\"true\">#</a></h4>\n<p>Sets the GraphQL field as non-null.</p>\n<h4 id=\"unique-boolean\"><code>unique: Boolean</code> <a class=\"hash-link\" href=\"#unique-boolean\" aria-hidden=\"true\">#</a></h4>\n<p>Makes Reindex enforce uniqueness for this field. In addition, for each unique\nfield <a href=\"/docs/graphql-api/queries/#xbyfield\">a root field</a> will be\ncreated for fetching this field.</p>\n<h4 id=\"oftype-string\"><code>ofType: String</code> <a class=\"hash-link\" href=\"#oftype-string\" aria-hidden=\"true\">#</a></h4>\n<p>The inner type of the field, required for <code>Connection</code> and <code>List</code> fields. For\nexample:</p>\n<ul>\n<li>A list of strings:<pre><code class=\"language-json\">{ \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"myList\"</span></span>, \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>, \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span> </span>}\n</code></pre>\n</li>\n<li>A connection with <code>User</code> nodes:<pre><code>{ \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"myUsers\"</span></span>, \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>, \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"User\"</span> </span>}\n</code></pre>\n</li>\n</ul>\n<h4 id=\"orderable-boolean\"><code>orderable: Boolean</code> <a class=\"hash-link\" href=\"#orderable-boolean\" aria-hidden=\"true\">#</a></h4>\n<p>If set, <code>orderBy</code> can be used on this field. Can be only set on scalar fields.</p>\n<h4 id=\"filterable-boolean\"><code>filterable: Boolean</code> <a class=\"hash-link\" href=\"#filterable-boolean\" aria-hidden=\"true\">#</a></h4>\n<p>If set, connection filter argument will be generated for this field. Can only\nbe set on scalar fields.</p>\n<h4 id=\"reversename-string\"><code>reverseName: String</code> <a class=\"hash-link\" href=\"#reversename-string\" aria-hidden=\"true\">#</a></h4>\n<p>The name of the related field in the referenced type, required for object fields\nwith a node type and for the corresponding Connection fields.</p>\n<h4 id=\"type-string\"><code>type: String!</code> <a class=\"hash-link\" href=\"#type-string\" aria-hidden=\"true\">#</a></h4>\n<p>Type of the field.</p>\n<p>Following types are supported.</p>\n<ul>\n<li>Scalar types:\n<ul>\n<li><code>Boolean</code></li>\n<li><code>DateTime</code></li>\n<li><code>Float</code></li>\n<li><code>ID</code> (only valid as the <code>id</code> field for nodes)</li>\n<li><code>Int</code></li>\n<li><code>String</code></li>\n</ul>\n</li>\n<li><code>List</code> – A list of scalars or non-node objects. <code>ofType</code> defines the type of\nlist elements.</li>\n<li><code>Connection</code> – A paginated list of nodes. Used to define one-to-many or\nmany-to-many relationships between node types. <code>ofType</code> defines the type of\nconnected nodes. A connection field always has a corresponding reverse field\nin the other type and the name of that field is defined with <code>reverseName</code>.\n<ul>\n<li><em>One-to-many relationships:</em>\nThe <code>type</code> of the reverse field is a node object type.</li>\n<li><em>Many-to-many relationships:</em>\nThe <code>type</code> of the reverse field is also <code>Connection</code>.</li>\n</ul>\n</li>\n<li>Any object type:\n<ul>\n<li>When object type implements the <code>Node</code> interface, the field creates a\n<em>connection</em> between the types. The field must have a related <code>Connection</code>\nfield in the other type.</li>\n<li>An object field with non-node type is stored inline.</li>\n</ul>\n</li>\n</ul>\n<h3 id=\"example\">Example <a class=\"hash-link\" href=\"#example\" aria-hidden=\"true\">#</a></h3>\n<p>Here’s a larger example of a schema for an app that stores movies and TV shows\nfetched from <a href=\"https://www.themoviedb.org/\">The Movie Database (TMDb)</a>:</p>\n<pre><code class=\"language-json\">[\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeason\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"air_date\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"episodes\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvEpisode\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"season\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"overview\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"poster_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"season_number\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"series\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeries\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"seasons\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Person\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"adult\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Boolean\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"also_known_as\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"biography\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"birthday\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Credit\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"person\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"deathday\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"homepage\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"imdb_id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"place_of_birth\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"popularity\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"profile_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvEpisode\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"air_date\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"episode_number\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"overview\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"production_code\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"season\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeason\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"episodes\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"season_number\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"still_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_average\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_count\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Country\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"iso_3166_1\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Genre\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Creator\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"profile_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Movie\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"adult\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Boolean\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"backdrop_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"belongs_to_collection\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Collection\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"budget\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Credit\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"movie\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"genres\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Genre\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"homepage\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"imdb_id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"original_language\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"original_title\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"overview\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"popularity\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"poster_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"production_companies\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Company\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"production_countries\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Country\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"release_date\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"revenue\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"runtime\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"spoken_languages\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Language\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"status\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"tagline\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"title\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"video\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Boolean\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_average\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_count\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Language\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"iso_639_1\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"User\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeries\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"backdrop_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"File path for the backdrop image URL.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"created_by\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"A list of creators of the TV series.\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Creator\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"All the cast and crew credits for the TV series.\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Credit\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"series\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"episode_run_time\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"A list of all episode run times (in minutes)\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"first_air_date\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"genres\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Genre\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"homepage\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"in_production\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Boolean\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"languages\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"last_air_date\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"DateTime\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"networks\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvNetwork\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"number_of_episodes\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"number_of_seasons\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"origin_country\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"original_language\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"original_name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"overview\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"popularity\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"A number representing the relative popularity of the TV series.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"poster_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"production_companies\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"List\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Company\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"seasons\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Connection\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"A connection to all the seasons of this TV series.\"</span></span>,\n        \"<span class=\"hljs-attribute\">ofType</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeason\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"series\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"status\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"type\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_average\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Float\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Average rating of this TV series. (0-10)\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"vote_count\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Collection\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"backdrop_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"poster_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Credit\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[\n      <span class=\"hljs-string\">\"Node\"</span>\n    ]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"character\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Name of a character. Included in cast credits.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credit_type\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Credit type. Possible values are \\\"cast\\\" and \\\"crew\\\".\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"department\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">nonNull</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span></span>,\n        \"<span class=\"hljs-attribute\">unique</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"job\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Job title. Included in crew credits.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"media_type\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Media type of this Credit. (`tv` or `movie`).\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"movie\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Movie\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"For movie credits, includes the movie of this Credit.\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Name of the person this Credit belongs to.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"order\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Int\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"A sequence number for default ordering of credits\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"person\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Person\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"The person this Credit belongs to.\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"profile_path\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"The file path for the profile image URL.\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"series\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvSeries\"</span></span>,\n        \"<span class=\"hljs-attribute\">description</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"For TV credits, includes the TV series of this Credit.\"</span></span>,\n        \"<span class=\"hljs-attribute\">reverseName</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"credits\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"TvNetwork\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>},\n  {\n    \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"Company\"</span></span>,\n    \"<span class=\"hljs-attribute\">kind</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"OBJECT\"</span></span>,\n    \"<span class=\"hljs-attribute\">interfaces</span>\": <span class=\"hljs-value\">[]</span>,\n    \"<span class=\"hljs-attribute\">fields</span>\": <span class=\"hljs-value\">[\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"id\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>},\n      {\n        \"<span class=\"hljs-attribute\">name</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"name\"</span></span>,\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"String\"</span>\n      </span>}\n    ]\n  </span>}\n]\n</code></pre>\n"}

/***/ },
/* 370 */
/***/ function(module, exports) {

	module.exports = {"title":"Authentication","order":1,"body":"<p>Authentication allows you to know who is the current user, to log user in and to\nregister new users. There are two main parts of authentication system. Reindex\nrequest may contain a JSON Web Token (JWT), that holds the credentials of the\nuser making the request. In addition, Reindex provides a way to authenticate\nnew or existing users via one of social login providers (e.g. Google), so that\nuser can receive an appropriate JWT. Such users are also stored as an object\nof <code>User</code> type.</p>\n<p>JWT can be used without social login and even without the <code>User</code> type. For\ninstance, an admin token that you have received is a JWT that does not include\na user ID, but just a flag that tells the user is an admin instead. Similarly,\nyou can generate your own tokens if you’d want to integrate custom login system\nwith Reindex.</p>\n<h2 id=\"json-web-tokens\">JSON Web Tokens <a class=\"hash-link\" href=\"#json-web-tokens\" aria-hidden=\"true\">#</a></h2>\n<p>Every request to Reindex GraphQL API may contain a <code>Authorization</code> header with a\n<a href=\"http://jwt.io/\">JSON Web Token</a> inside. JSON Web Token is a JSON object, that\nis Base64 encoded and cryptographically signed by a secret key. Reindex can\nverify the signature and see that the token is valid. Reindex will then use the\ninformation passed in token for authentication.</p>\n<p>We support <code>sub</code> (Subject), <code>isAdmin</code>, <code>exp</code> (Expiration Time) and <code>iat</code>\n(Issued At) <em>claims</em>.</p>\n<p>If <code>sub</code> is present it must be a valid ID of <code>User</code> object. <code>isAdmin</code> is a\nboolean and determines if a user has admin permissions. Both <code>exp</code> and <code>iat</code> is\na number of seconds since Unix epoch.</p>\n<h3 id=\"reindexsecret\">ReindexSecret <a class=\"hash-link\" href=\"#reindexsecret\" aria-hidden=\"true\">#</a></h3>\n<p>The secret key that is used to sign the token is stored in an object of type\n<code>ReindexSecret</code>. <code>createReindexSecret</code> and <code>deleteReindexSecret</code> allow you to\ncreate new secret keys and delete existing ones. There is currently no way to\nchoose what secret is used for signing, so unless you generate the token\nmanually, there is little reason to have more than one secret.</p>\n<p>You may manually create JWT with the secret using one of the JWT libraries or\neven through <a href=\"http://jwt.io\">jwt.io</a> website. You should use <code>HS256</code> as a\nsigning algorithm.</p>\n<h2 id=\"social-login-authentication-providers\">Social login authentication providers <a class=\"hash-link\" href=\"#social-login-authentication-providers\" aria-hidden=\"true\">#</a></h2>\n<p>Reindex provides a built-in facility to log user in, using one of the supported\nauthentication providers. Supported providers are:</p>\n<ul>\n<li>Auth0 (<a href=\"https://auth0.com/docs\">Auth0 Documentation</a>)</li>\n<li>Facebook (<a href=\"https://developers.facebook.com/docs/facebook-login\">Facebook Login documentation</a>)</li>\n<li>GitHub (<a href=\"https://developer.github.com/guides/basics-of-authentication/\">GitHub Authentication documentation</a>)</li>\n<li>Google (<a href=\"https://developers.google.com/identity/protocols/OAuth2\">Google OAuth 2.0 documentation</a>)</li>\n<li>Twitter (<a href=\"https://dev.twitter.com/web/sign-in\">Sign in with Twitter documentation</a>)</li>\n</ul>\n<p>Using those providers requires configuring them at the provider’s website.\nRefer to the documentation of each authentication provider for details on how to\ncreate an app in their system. When you’re asked to provide a callback URL you\nshould use <code>https://NAME-OF-YOUR-APP.myreindex.com/auth/PROVIDER_NAME</code>.\nAfter the configuration you should get two IDs, client or app ID and client or\napp secret. This configuration should be stored in Reindex\n<code>ReindexAuthenticationProvider</code> type. You can create one, for example for\nGoogle, with the following GraphQL query:</p>\n<pre><code class=\"language-graphql\">mutation {\n  createReindexAuthenticationProvider(input: {\n    <span class=\"hljs-class\"><span class=\"hljs-keyword\">type</span>: <span class=\"hljs-title\">google</span>,</span>\n    clientId: <span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-ID\"</span>,\n    clientSecret: <span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-SECRET\"</span>,\n    isEnabled: <span class=\"hljs-keyword\">true</span>\n  }) {\n    changedReindexAuthenticationProvider {\n      clientId,\n      id,\n      clientSecret,\n      <span class=\"hljs-class\"><span class=\"hljs-keyword\">type</span>,</span>\n      isEnabled\n    }\n  }\n}\n</code></pre>\n<p>Tutorial has a detailed guide on\n<a href=\"/docs/tutorial/authenticating-users/\">how to enable Google authentication</a>.</p>\n<p>After the provider is configured, users can login using a selected provider. The\nlogic of cross-domain OAuth communication is pretty complicated, but\n<code>reindex-js</code> provides a shortcut. Refer to\n<a href=\"../../reindex-js/\">reindex-js</a> documentation.</p>\n<h3 id=\"custom-scopes\">Custom scopes <a class=\"hash-link\" href=\"#custom-scopes\" aria-hidden=\"true\">#</a></h3>\n<p>When a user authenticates using one of the social login providers, the app will\nobtain an access token that can be used to securely make requests to the API of\nthe provider. The access token is stored in the <code>accessToken</code> field of the user\ncredentials object and you can use it to request more data in your own\nserver-side code, for example Facebook friends or GitHub repositories.</p>\n<p>In order to fetch additional data, you may need to ask additional permissions\n(OAuth scopes) during the authentication. These scopes can be configured using\nthe <code>scopes</code> field of <code>ReindexAuthenticationProvider</code>, which takes a list of\nscope strings. If not defined, default scopes for each provider will be used.</p>\n<p>You can find the list of supported scopes from the developer documentation of\neach provider:</p>\n<ul>\n<li><a href=\"https://developers.facebook.com/docs/facebook-login/permissions/v2.5\">Permissions with Facebook Login</a>, default: <code>[&quot;email&quot;]</code>.</li>\n<li><a href=\"https://developer.github.com/v3/oauth/#scopes\">GitHub OAuth Scopes</a>, default: <code>[&quot;user:email&quot;]</code>.</li>\n<li><a href=\"https://developers.google.com/identity/protocols/googlescopes\">OAuth 2.0 Scopes for Google APIs</a>, default: <code>[&quot;profile&quot;, &quot;email&quot;]</code>.</li>\n</ul>\n<p>(Twitter provider does not have custom scopes.)</p>\n<p>For example, to configure Facebook login to request the <code>user_likes</code> permission\nin addition to the <code>email</code> permission (included by default) set up a\n<code>ReindexAuthenticationProvider</code> object like this:</p>\n<pre><code>{\n  <span class=\"hljs-attribute\">type</span>: facebook,\n  <span class=\"hljs-attribute\">clientId</span>: <span class=\"hljs-string\">\"YOUR-FACEBOOK-APP-ID\"</span>,\n  <span class=\"hljs-attribute\">clientSecret</span>: <span class=\"hljs-string\">\"YOUR-FACEBOOK-APP-SECRET\"</span>,\n  <span class=\"hljs-attribute\">isEnabled</span>: true,\n  <span class=\"hljs-attribute\">scopes</span>: [<span class=\"hljs-string\">\"email\"</span>, <span class=\"hljs-string\">\"user_likes\"</span>]\n}\n</code></pre>\n<h3 id=\"login-with-auth0-lock\">Login with Auth0 Lock <a class=\"hash-link\" href=\"#login-with-auth0-lock\" aria-hidden=\"true\">#</a></h3>\n<p>Auth0 also provides an embeddable login form <a href=\"https://auth0.com/lock\">Lock</a>\nthat makes it easy to add a polished login experience to any web or native app.\nYou can use Lock for authenticating with Reindex using the <code>loginWithToken</code>\nmutation that takes an Auth0 <code>id_token</code> as an input and returns a Reindex token\nfor a signed in user.</p>\n<p>To set up login with Lock, first create an authentication provider with your\nAuth0 credentials (in GraphiQL):</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-name\">mutation</span> {\n  createReindexAuthenticationProvider(input: {\n    <span class=\"hljs-built_in\">type</span>: auth<span class=\"hljs-number\">0</span>,\n    clientId: <span class=\"hljs-string\">\"AUTH0-CLIENT-ID\"</span>,\n    clientSecret: <span class=\"hljs-string\">\"AUTH0-CLIENT-SECRET\"</span>,\n    <span class=\"hljs-built_in\">domain</span>: <span class=\"hljs-string\">\"AUTH0-DOMAIN\"</span>,\n    isEnabled: <span class=\"hljs-keyword\">true</span>,\n  }) {\n    id\n  }\n}\n</code></pre>\n<p>Then add Lock in your app and call <code>loginWithToken</code> in the callback function for\nLock:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> reindex = <span class=\"hljs-keyword\">new</span> Reindex(reindexURL);\n<span class=\"hljs-keyword\">const</span> lock = <span class=\"hljs-keyword\">new</span> Auth0Lock(auth0ClientID, auth0Domain);\nlock.show((error, profile, id_token) =&gt; {\n  reindex.loginWithToken(<span class=\"hljs-string\">'auth0'</span>, id_token);\n});\n</code></pre>\n<p>That’s all! You can now enable any Auth0 connection and your users can login\nto your Reindex app with it. And as with other Reindex authentication providers,\nthe user profile in Reindex is automatically updated on every login from Auth0.</p>\n<h2 id=\"user-type\">User type <a class=\"hash-link\" href=\"#user-type\" aria-hidden=\"true\">#</a></h2>\n<p>Social login stores the data about the user inside <code>User</code> nodes. The\nfield <code>credentials</code> contains fields with a corresponding provider name (\n<code>google</code>, <code>facebook</code>, <code>twitter</code>, <code>github</code>) and information received from the\nprovider. Credentials can only be read by the user themself or admins.\nIf you want to display some of this information to other users, you\nshould copy it to some other user field.</p>\n<p>A new user is created on the first time the user signs in using a provider.\nAfter that the same user object is used.</p>\n<p>Unlike other built-in types, you can extend <code>User</code> type and thus it’s included\nin your schema. It’s not possible to delete the <code>User</code> type, though.</p>\n<h3 id=\"copying-providers-user-information-to-public-fields\">Copying provider’s user information to public fields <a class=\"hash-link\" href=\"#copying-providers-user-information-to-public-fields\" aria-hidden=\"true\">#</a></h3>\n<p>Very often you would want to display some user information, like their username\nand email, that are available from the social login providers. Credentials are\nonly readable by the user, so you need to copy that data to some of your defined\nfields. Let’s assume that the user type has fields <code>username</code> and <code>avatar</code> and\nwe want to copy them from one of the user’s social login profiles.</p>\n<ol>\n<li>Copying as a Relay mutation</li>\n</ol>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>\n\nexport default class UpdateUserInfoMutation extends Relay.Mutation {\n  static fragments = {\n    user: () =&gt; Relay.QL`\n      fragment on User {\n        id\n        credentials {\n          github {\n            displayName\n            picture\n          }\n          google {\n            displayName\n            picture(size: 73)\n          }\n          facebook {\n            displayName\n            picture(height: 73, width: 73)\n          }\n          twitter {\n            displayName\n            picture(size: bigger)\n          }\n          auth0 {\n            displayName\n            picture\n          }\n        }\n      }\n    `\n  };\n\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation { updateUser }`</span>\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">const</span> credentials = normalizeCredentials(<span class=\"hljs-keyword\">this</span>.props.user)\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.user.id,\n      username: credentials.displayName,\n      avatarUrl: credentials.picture,\n    }\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _UserPayload {\n        changedUser {\n          username\n          avatarUrl\n        }\n      }\n    `</span>\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [\n      {\n        type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n        fieldIDs: {\n          changedUser: <span class=\"hljs-keyword\">this</span>.props.user.id,\n        },\n      },\n    ]\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">const</span> credentials = normalizeCredentials(<span class=\"hljs-keyword\">this</span>.props.user)\n    <span class=\"hljs-keyword\">return</span> {\n      changedUser: {\n        username: credentials.displayName,\n        avatarUrl: credentials.picture,\n      }\n    }\n  }\n}\n\n<span class=\"hljs-function\"><span class=\"hljs-keyword\">function</span> <span class=\"hljs-title\">normalizeCredentials</span>(<span class=\"hljs-params\">user</span>) </span>{\n  <span class=\"hljs-keyword\">for</span> (<span class=\"hljs-keyword\">const</span> provider <span class=\"hljs-keyword\">of</span> [\n    <span class=\"hljs-string\">'github'</span>, <span class=\"hljs-string\">'google'</span>, <span class=\"hljs-string\">'facebook'</span>, <span class=\"hljs-string\">'twitter'</span>, <span class=\"hljs-string\">'auth0'</span>\n  ]) {\n    <span class=\"hljs-keyword\">if</span> (user.credentials[provider]) {\n      <span class=\"hljs-keyword\">return</span> user.credentials[provider]\n    }\n  }\n}\n</code></pre>\n<p>You can run this mutation in, for example, <code>componentDidMount</code> of your root\ncomponent.</p>\n<ol start=\"2\">\n<li>Updating via direct GraphQL call, let’s assume <code>profile</code> contains\n<code>displayName</code> and <code>picture</code>.</li>\n</ol>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">const</span> updateResult = <span class=\"hljs-keyword\">await</span> reindex.query(<span class=\"hljs-string\">`\n  mutation($input: _UpdateUserInput!) {\n    updateUser(input: $input) {\n      id\n    }\n  }\n`</span>, {\n  input: {\n    id: reindexUserId,\n    username: profile.displayName,\n    avatarUrl: profile.picture,\n  },\n});\n\n<span class=\"hljs-keyword\">for</span> (<span class=\"hljs-keyword\">const</span> error <span class=\"hljs-keyword\">of</span> updateResult.errors || []) {\n  <span class=\"hljs-built_in\">console</span>.error(error);\n}\n</code></pre>\n"}

/***/ },
/* 371 */
/***/ function(module, exports) {

	module.exports = {"title":"Authorization","order":2,"body":"<p>An important part of the security of your application is authorization. You need\nto control what data which users can access in your app.</p>\n<p>Role based access control (RBAC) is the de facto standard for authorization.\nHowever, it introduces many complexities for practical applications: roles can\nbe inflexible to change, and additional mapping between users and roles must be\nmaintained separately.</p>\n<p>Ideally we should be able to derive the authorizations from the application data\nusing access rules. Such rules could be written with code, but maintaining the\ncode can become difficult when the data model evolves.</p>\n<p>Reindex permissions are declarative rules, defined in the schema of the\napplication and make use of the data graph of the application the determine\naccess at runtime.</p>\n<h2 id=\"default-permissions\">Default permissions <a class=\"hash-link\" href=\"#default-permissions\" aria-hidden=\"true\">#</a></h2>\n<p>Requests made with an admin token always have all the permissions to all types.\nOtherwise, the <code>permissions</code> list in your type in the schema determines the\npermissions.</p>\n<p>If a type doesn’t have <code>permissions</code> defined in the schema, then by default\neveryone gets full permissions to do anything to the nodes of that type.</p>\n<p>Built-in types require admin permissions to work with.</p>\n<h2 id=\"permissions-in-the-schema\">Permissions in the schema <a class=\"hash-link\" href=\"#permissions-in-the-schema\" aria-hidden=\"true\">#</a></h2>\n<p>The <code>permissions</code> property of a type defines the permissions for that type. For\nexample, you could give all logged-in users a permission to read comments\nin your app by adding this permission list to a <code>Comment</code> type in the schema:</p>\n<pre><code class=\"language-js\">permissions: [\n  {\n    grantee: <span class=\"hljs-string\">'AUTHENTICATED'</span>,\n    read: <span class=\"hljs-literal\">true</span>,\n  },\n]\n</code></pre>\n<p>The full type definition for elements of the <code>permissions</code> list is:</p>\n<pre><code class=\"language-graphql\"><span class=\"hljs-keyword\">type</span> <span class=\"hljs-constant\">ReindexPermisssion</span> {\n  <span class=\"hljs-symbol\">grantee:</span> <span class=\"hljs-constant\">ReindexGrantee</span>!\n  <span class=\"hljs-symbol\">userPath:</span> [<span class=\"hljs-constant\">String</span>]\n  <span class=\"hljs-symbol\">read:</span> <span class=\"hljs-constant\">Boolean</span>\n  <span class=\"hljs-symbol\">create:</span> <span class=\"hljs-constant\">Boolean</span>\n  <span class=\"hljs-symbol\">update:</span> <span class=\"hljs-constant\">Boolean</span>\n  <span class=\"hljs-symbol\">delete:</span> <span class=\"hljs-constant\">Boolean</span>\n  <span class=\"hljs-symbol\">permittedFields:</span> [<span class=\"hljs-constant\">String</span>]\n}\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">enum</span> <span class=\"hljs-title\">ReindexGrantee</span> {</span>\n  <span class=\"hljs-constant\">EVERYONE</span>\n  <span class=\"hljs-constant\">AUTHENTICATED</span>\n  <span class=\"hljs-constant\">USER</span>\n}\n</code></pre>\n<p><code>grantee</code> determines the scope of the permission. Permission can be granted\neither to:</p>\n<ul>\n<li><code>EVERYONE</code> (all users, including anonymous)</li>\n<li><code>AUTHENTICATED</code> logged-in users) or</li>\n<li><code>USER</code>, a <code>User</code> related to the node\n(see <a href=\"#user-permissions\">User permissions</a> below). When <code>grantee</code> is <code>USER</code>,\n<code>userPath</code> defines the path to the related user from the node in question.</li>\n</ul>\n<p><code>read</code>, <code>create</code>, <code>update</code> and <code>delete</code> determine if a particular permission is granted to the <code>grantee</code>.</p>\n<ul>\n<li>\n<p>Any operations that <em>read</em> nodes require a <code>read</code> permission. Read permission\nis also checked when listing the nodes in a connection field.</p>\n</li>\n<li>\n<p><em>Creating</em> nodes requires a <code>create</code> permission and field permissions on all\nfields that node is created with.</p>\n</li>\n<li>\n<p><em>Updating</em> nodes requires an <code>update</code> permission and permissions for each\nfield that is being updated. <em>Replacing</em> nodes also requires an <code>update</code>\npermission and permissions for fields both in old and new nodes.</p>\n</li>\n<li>\n<p><em>Deleting</em> a node requires a <code>delete</code> permission. Adding or removing items\nfrom  a one-to-many or many-to-many relationship requires an <code>update</code>\npermission to the connection fields for both nodes.</p>\n</li>\n</ul>\n<p><code>permittedFields</code> allows you to specify the fields a <em>create, update\nor delete</em> permission applies to. If <code>permittedFields</code> is omitted, the\npermissions are granted on all fields.</p>\n<h2 id=\"user-permissions\">User permissions <a class=\"hash-link\" href=\"#user-permissions\" aria-hidden=\"true\">#</a></h2>\n<p>In addition to granting permissions to all or logged-in users, it’s possible to\ngrant permissions to users that are related to the node in question somehow.\nThe relationship is specified with <code>userPath</code>, which should be a list of fields\nthat will form a chain that terminates at a reference to a <code>User</code> node or\na connection to <code>User</code> nodes. Each element of a chain should be a name of a\nnode reference or a connection.</p>\n<p>For example, we could allow only the author of a comment to delete it:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'author'</span>],\n  <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>,\n}\n</code></pre>\n<p>Additionally, we can let only the friends of the author read comments:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'author'</span>, <span class=\"hljs-string\">'friends'</span>],\n  read: <span class=\"hljs-literal\">true</span>,\n}\n</code></pre>\n<h3 id=\"permissions-to-own-user-node\">Permissions to own <code>User</code> node <a class=\"hash-link\" href=\"#permissions-to-own-user-node\" aria-hidden=\"true\">#</a></h3>\n<p>Permissions to <code>User</code> own node is a special case of User permissions. They are\ngranted by having a permission in type <code>User</code> with <code>userPath</code> set  to <code>[&quot;id&quot;]</code>.</p>\n<p>For example, to let users update their own user profile, you can this permission\nto the <code>User</code> type:</p>\n<pre><code class=\"language-js\">{\n  grantee: <span class=\"hljs-string\">'USER'</span>,\n  userPath: [<span class=\"hljs-string\">'id'</span>],\n  update: <span class=\"hljs-literal\">true</span>,\n}\n</code></pre>\n<h3 id=\"examples\">Examples <a class=\"hash-link\" href=\"#examples\" aria-hidden=\"true\">#</a></h3>\n<p>Let’s consider another example - there are users and each <code>User</code> can be in a\nteam. A user can have another user as supervisor. Each <code>User</code> can read\nand update themself, team members can read each other. Supervisor can be read by\ntheir subordinates and can read and update them. Members of the team can read\nthe team.</p>\n<pre><code class=\"language-js\">[\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"team\"</span>,\n        type: <span class=\"hljs-string\">\"Team\"</span>,\n        reverseName: <span class=\"hljs-string\">\"members\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"supervisor\"</span>,\n        type: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"supervises\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"supervises\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"supervisor\"</span>\n      }\n    ],\n    permissions: [\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"id\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>,\n        update: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"supervisor\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>,\n        update: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"supervises\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"team\"</span>,\n          <span class=\"hljs-string\">\"members\"</span>\n        ]\n      }\n    ]\n  },\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    name: <span class=\"hljs-string\">\"Team\"</span>,\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"members\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"team\"</span>\n      }\n    ],\n    permissions: [\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"members\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>\n      }\n    ]\n  }\n]\n</code></pre>\n<h2 id=\"relationships-and-related-permission-requirements\">Relationships and related permission requirements <a class=\"hash-link\" href=\"#relationships-and-related-permission-requirements\" aria-hidden=\"true\">#</a></h2>\n<p>When nodes have relationships to other nodes, permissions make sure that the\nuser has permission to modify the other side of the relationship too, before\nallowing a mutation. Let’s consider the schema below.</p>\n<pre><code class=\"language-js\">[\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"microposts\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"Micropost\"</span>,\n        reverseName: <span class=\"hljs-string\">\"author\"</span>\n      }\n    ]\n  },\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    name: <span class=\"hljs-string\">\"Micropost\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"author\"</span>,\n        type: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"microposts\"</span>\n      }\n    ]\n  }\n]\n</code></pre>\n<p><code>Micropost</code> nodes can have a reference to <code>User</code> nodes. <code>User</code> nodes have a\nconnection to all <code>Micropost</code> nodes that reference them. To do a mutation that\nwill change the contents of the <code>User.microposts</code> connection, you need to have a\npermission to update it.</p>\n<p>For example, when creating a <code>Micropost</code>, a permission to <code>User.microposts</code> is\nalso required, as this field is referenced by the <code>author</code> field. When updating\nor replacing a node reference, an <code>update</code> permission to corresponding\nconnection field is required, in both the existing and the new node referenced.\nFor deleting, an <code>update</code> permission to the connection field in the currently\nreferenced node is required.</p>\n<p>Additionally, deleting will be blocked, if the connection fields of the node\nstill contain any nodes. E.g. you can’t delete a <code>User</code> node that has anything\nin <code>microposts</code>.</p>\n<p>One important use case for <code>permittedFields</code> is granting of permissions only\non the connection fields of types, thus allowing other nodes to connect, but\nnot allowing any other operations. For example, logged-in user can have a\npermission to add <code>Micropost</code>s only for themself.</p>\n<h3 id=\"example\">Example <a class=\"hash-link\" href=\"#example\" aria-hidden=\"true\">#</a></h3>\n<p><code>User</code>s have friends. <code>User</code>‘s have <code>Micropost</code>s, <code>Micropost</code>‘s have comments.\nFriends can read and add comments to their friends’ microposts. Users can only\ncreate microposts where they are the author. Friends can read each other.\nUsers can delete any comments to their microposts. Friends can read all\ncomments to friends’ microposts. Authors of comments can update and delete their\ncomments.</p>\n<pre><code class=\"language-js\">[\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    name: <span class=\"hljs-string\">\"Micropost\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"text\"</span>,\n        type: <span class=\"hljs-string\">\"String\"</span>,\n        orderable: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"createdAt\"</span>,\n        type: <span class=\"hljs-string\">\"DateTime\"</span>,\n        orderable: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"author\"</span>,\n        type: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"microposts\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"comments\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"Comment\"</span>,\n        reverseName: <span class=\"hljs-string\">\"micropost\"</span>\n      }\n    ],\n    permissions: [\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"author\"</span>\n        ],\n        create: <span class=\"hljs-literal\">true</span>,\n        read: <span class=\"hljs-literal\">true</span>,\n        update: <span class=\"hljs-literal\">true</span>,\n        <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"author\"</span>,\n          <span class=\"hljs-string\">\"friends\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>,\n        permittedFields: [\n          <span class=\"hljs-string\">\"comments\"</span>\n        ]\n      }\n    ]\n  },\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"handle\"</span>,\n        type: <span class=\"hljs-string\">\"String\"</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"email\"</span>,\n        type: <span class=\"hljs-string\">\"String\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"friends\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"friends\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"microposts\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"Micropost\"</span>,\n        reverseName: <span class=\"hljs-string\">\"author\"</span>,\n        defaultOrdering: {\n          field: <span class=\"hljs-string\">\"createdAt\"</span>,\n          order: <span class=\"hljs-string\">\"ASC\"</span>\n        }\n      },\n      {\n        name: <span class=\"hljs-string\">\"comments\"</span>,\n        type: <span class=\"hljs-string\">\"Connection\"</span>,\n        ofType: <span class=\"hljs-string\">\"Comment\"</span>,\n        reverseName: <span class=\"hljs-string\">\"author\"</span>\n      }\n    ],\n    permissions: [\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"id\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>,\n        update: <span class=\"hljs-literal\">true</span>,\n        permittedFields: [\n          <span class=\"hljs-string\">\"handle\"</span>,\n          <span class=\"hljs-string\">\"email\"</span>,\n          <span class=\"hljs-string\">\"friends\"</span>,\n          <span class=\"hljs-string\">\"microposts\"</span>,\n          <span class=\"hljs-string\">\"comments\"</span>\n        ]\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"friends\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>\n      }\n    ]\n  },\n  {\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    name: <span class=\"hljs-string\">\"Comment\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"text\"</span>,\n        type: <span class=\"hljs-string\">\"String\"</span>,\n        orderable: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"createdAt\"</span>,\n        type: <span class=\"hljs-string\">\"DateTime\"</span>,\n        orderable: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"author\"</span>,\n        type: <span class=\"hljs-string\">\"User\"</span>,\n        reverseName: <span class=\"hljs-string\">\"comments\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"micropost\"</span>,\n        type: <span class=\"hljs-string\">\"Micropost\"</span>,\n        reverseName: <span class=\"hljs-string\">\"comments\"</span>\n      }\n    ],\n    permissions: [\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"author\"</span>\n        ],\n        create: <span class=\"hljs-literal\">true</span>,\n        read: <span class=\"hljs-literal\">true</span>,\n        update: <span class=\"hljs-literal\">true</span>,\n        <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"micropost\"</span>,\n          <span class=\"hljs-string\">\"author\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>,\n        <span class=\"hljs-keyword\">delete</span>: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        grantee: <span class=\"hljs-string\">\"USER\"</span>,\n        userPath: [\n          <span class=\"hljs-string\">\"micropost\"</span>,\n          <span class=\"hljs-string\">\"author\"</span>,\n          <span class=\"hljs-string\">\"friends\"</span>\n        ],\n        read: <span class=\"hljs-literal\">true</span>\n      }\n    ]\n  }\n]\n</code></pre>\n"}

/***/ },
/* 372 */
/***/ function(module, exports) {

	module.exports = {"title":"Security","order":5,"body":"<p>To secure your app you need to be able to do two things - know who the user is\nand configure which data they can access.</p>\n<p><a href=\"./authentication/\">Authentication</a> allows you to add signup and login\nto your app with Auth0 or one of the social login providers like Facebook Login.\nThe requests to the API of your Reindex app are authenticated using tokens.</p>\n<p><a href=\"./authorization/\">Authorization</a> allows configuring access to your data using\npermissions. You can add permissions to your schema that define access to each\nnode type on a granular level based on your data. That means you don’t need to\nmaintain the memberships of separate groups or roles, but you can infer the\npermissions from your data instead. This system is flexible enough that you can\nalso use it to add role based access control to your app when you need it.</p>\n"}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "1cfd67667e764da964f32827343d395a.png";

/***/ },
/* 374 */
/***/ function(module, exports) {

	module.exports = {"title":"Adding mutations","order":4,"body":"<p>We are displaying our Todos, now we can enable the mutations that we need. The\nmutations that we need are:</p>\n<ul>\n<li><code>src/mutations/AddTodoMutation.js</code> - adding a new Todo</li>\n<li><code>src/mutations/DeleteTodoMutation.js</code> - delete a Todo</li>\n<li><code>src/mutations/ChangeTodoCompleteMutation.js</code> - toggle Todo completion</li>\n<li><code>src/mutations/ChangeTodoTextMutation.js</code> - change Todo text</li>\n</ul>\n<p>We can compose mass operations on Todos using those mutations several times.</p>\n<h2 id=\"changetodocompletemutation\">ChangeTodoCompleteMutation <a class=\"hash-link\" href=\"#changetodocompletemutation\" aria-hidden=\"true\">#</a></h2>\n<p>Let’s start by looking at the source code of <code>src/mutations/ChangeTodoCompleteMutation.js</code></p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">ChangeTodoStatusMutation</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Mutation</span> </span>{\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation{ updateTodo }`</span>;\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.id,\n      complete: <span class=\"hljs-keyword\">this</span>.props.complete,\n    };\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoPayload {\n        changedTodo {\n          complete,\n        },\n      }\n    `</span>;\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [{\n      type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n      fieldIDs: {\n        changedTodo: <span class=\"hljs-keyword\">this</span>.props.id,\n      },\n    }];\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      changedTodo: {\n        id: <span class=\"hljs-keyword\">this</span>.props.id,\n        complete: <span class=\"hljs-keyword\">this</span>.props.complete,\n      },\n    };\n  }\n}\n</code></pre>\n<p>Let’s look at this method one-by-one.</p>\n<ul>\n<li><code>getMutation()</code> must return a root mutation field, similar to Route.\nReindex provides basic CRUD methods for all user defined types, for updating\nTodo <code>updateTodo</code> is created.</li>\n<li><code>getVariables()</code> returns an object that is passed as <code>input</code> to the mutation.\nIn this mutation we need to pass a todo id and its new <code>complete</code> status.</li>\n<li><code>getFatQuery()</code> must return a query fragment on the result of the mutation.\nLike with connection, type of result of mutation is generated by Reindex and\nis called <code>_TodoPayload</code> in our case. It has updated object in <code>changedTodo</code>\nfield, we know that only <code>complete</code> can change in this mutation, so we only\ninclude it.</li>\n<li><code>getConfigs()</code> returns a list of Relay Mutation Configs, which indicate how\nRelay should propagate that mutation into the store. <code>FIELDS_CHANGE</code> is the\nsimplest kind of mutation, it just updates data in client store by id. As we\nhave mentioned, updated todo will be in <code>changedTodo</code> and we indicate that in\n<code>fieldIDs</code>.</li>\n<li><code>getOptimisticResponse()</code> returns a fake payload so that Relay can apply the\nupdate optimistically.</li>\n</ul>\n<p>We can now update our <code>src/components/Todo.js</code> to use that mutation.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> ChangeTodoStatusMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/ChangeTodoCompleteMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Todo</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleCompleteChange = () =&gt; {\n    Relay.Store.commitUpdate(\n      <span class=\"hljs-keyword\">new</span> ChangeTodoStatusMutation({\n        id: <span class=\"hljs-keyword\">this</span>.props.todo.id,\n        complete: !<span class=\"hljs-keyword\">this</span>.props.todo.complete,\n      }),\n    );\n  }\n  <span class=\"hljs-comment\">// ...</span>\n}\n<span class=\"hljs-comment\">// ...</span>\n</code></pre>\n<p>We can also make <code>src/components/TodoList.js</code> use that mutation for “toggle all”.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> ChangeTodoStatusMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/ChangeTodoCompleteMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoList</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleToggleAllChange = () =&gt; {\n    <span class=\"hljs-keyword\">const</span> todoCount = <span class=\"hljs-keyword\">this</span>.props.todos.count;\n    <span class=\"hljs-keyword\">const</span> done = <span class=\"hljs-keyword\">this</span>.props.todos.edges.reduce((next, edge) =&gt; (\n      next + (edge.node.complete ? <span class=\"hljs-number\">1</span> : <span class=\"hljs-number\">0</span>)\n    ), <span class=\"hljs-number\">0</span>);\n    <span class=\"hljs-keyword\">let</span> setTo = <span class=\"hljs-literal\">true</span>;\n    <span class=\"hljs-keyword\">if</span> (todoCount === done) {\n      setTo = <span class=\"hljs-literal\">false</span>;\n    }\n\n    <span class=\"hljs-keyword\">this</span>.props.todos.edges\n      .filter((edge) =&gt; edge.node.complete !== setTo)\n      .forEach((edge) =&gt; Relay.Store.commitUpdate(\n        <span class=\"hljs-keyword\">new</span> ChangeTodoStatusMutation({\n          id: edge.node.id,\n          complete: setTo,\n        })\n      ));\n  }\n  <span class=\"hljs-comment\">// ...</span>\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoList, {\n  fragments: {\n    todos: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoConnection {\n        count,\n        edges {\n          node {\n            id,\n            complete,\n            <span class=\"hljs-subst\">${Todo.getFragment('todo')}</span>\n          }\n        }\n      }\n    `</span>\n  },\n});\n</code></pre>\n<p>Note how we dispatch the mutation multiple times to toggle all todos. We had to\nalso add <code>id</code> to our fragment, so we can pass it to the mutation.</p>\n<h2 id=\"changetodotextmutation\">ChangeTodoTextMutation <a class=\"hash-link\" href=\"#changetodotextmutation\" aria-hidden=\"true\">#</a></h2>\n<p>The mutation for changing todo text (<code>src/mutations/ChangeTodoTextMutation.js</code>)\nis very similar:</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">ChangeTodoTextMutation</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Mutation</span> </span>{\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation{ updateTodo }`</span>;\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.id,\n      text: <span class=\"hljs-keyword\">this</span>.props.text,\n    };\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoPayload {\n        changedTodo {\n          text,\n        },\n      }\n    `</span>;\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [{\n      type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n      fieldIDs: {\n        changedTodo: <span class=\"hljs-keyword\">this</span>.props.id,\n      },\n    }];\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      changedTodo: {\n        id: <span class=\"hljs-keyword\">this</span>.props.id,\n        text: <span class=\"hljs-keyword\">this</span>.props.text,\n      },\n    };\n  }\n}\n</code></pre>\n<p>We can update <code>src/components/Todo.js</code> with it too.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> ChangeTodoTextMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/ChangeTodoTextMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Todo</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleInputSave = (text) =&gt; {\n    Relay.Store.commitUpdate(\n      <span class=\"hljs-keyword\">new</span> ChangeTodoTextMutation({\n        id: <span class=\"hljs-keyword\">this</span>.props.todo.id,\n        text: text,\n      }),\n    );\n    <span class=\"hljs-keyword\">this</span>.setState({\n      isEditing: <span class=\"hljs-literal\">false</span>,\n    });\n  }\n  <span class=\"hljs-comment\">// ...</span>\n}\n<span class=\"hljs-comment\">// ...</span>\n</code></pre>\n<h2 id=\"addtodomutation\">AddTodoMutation <a class=\"hash-link\" href=\"#addtodomutation\" aria-hidden=\"true\">#</a></h2>\n<p>Adding a Todo is more complex. The reason for this is that we need to update\nnot only the state of a Todo object that we will create, but also a connection\nwhere it is stored - the count of Todos will change, as well as the listing of\nTodo nodes in <code>edges</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">AddTodoMutation</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Mutation</span> </span>{\n  static fragments = {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`fragment on ReindexViewer {\n      id\n      allTodos {\n        count,\n      }\n    }`</span>\n  };\n\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation{ createTodo }`</span>;\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      text: <span class=\"hljs-keyword\">this</span>.props.text,\n      complete: <span class=\"hljs-literal\">false</span>,\n    };\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoPayload {\n        changedTodoEdge,\n        viewer {\n          id,\n          allTodos {\n            count\n          }\n        }\n      }\n    `</span>;\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [{\n      type: <span class=\"hljs-string\">'RANGE_ADD'</span>,\n      parentID: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n      connectionName: <span class=\"hljs-string\">'allTodos'</span>,\n      edgeName: <span class=\"hljs-string\">'changedTodoEdge'</span>,\n      rangeBehaviors: {\n        <span class=\"hljs-string\">''</span>: <span class=\"hljs-string\">'prepend'</span>,\n      },\n    }, {\n      type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n      fieldIDs: {\n        viewer: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n      },\n    }];\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      changedTodoEdge: {\n        node: {\n          text: <span class=\"hljs-keyword\">this</span>.props.text,\n          complete: <span class=\"hljs-literal\">false</span>,\n        },\n      },\n      viewer: {\n        id: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n        allTodos: {\n          count: <span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.count + <span class=\"hljs-number\">1</span>,\n        },\n      },\n    };\n  }\n}\n</code></pre>\n<p>In order to perform this mutation, we need some data that might not be available\nto the component - the id of <code>viewer</code> object and count of <code>allTodos</code> connection.\nTherefore we need to specify fragments for the mutation same way as we specify\nthem for containers.</p>\n<p>Our configs are more complex this time too - we need to add our new Todo to\na connection, so we use <code>RANGE_ADD</code> mutation config. Relay expects an <code>edge</code> to\nbe passed in payload, not just a Todo, Reindex provides <code>changedTodoEdge</code> for\nthis. Lastly we need to fetch updated connection count from the server and for\nthis <code>viewer</code> field is available for every payload.</p>\n<p>In our optimistic update we increment the count of allTodos, so that we change\nour “total” display without any delay.</p>\n<p>Let’s use our mutation in <code>TodoApp</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> AddTodoMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/AddTodoMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoApp</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleInputSave = (text) =&gt; {\n    Relay.Store.commitUpdate(\n      <span class=\"hljs-keyword\">new</span> AddTodoMutation({\n        text,\n        viewer: <span class=\"hljs-keyword\">this</span>.props.viewer,\n      }),\n    );\n  }\n  <span class=\"hljs-comment\">// ...</span>\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoApp, {\n  fragments: {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on ReindexViewer {\n        allTodos(first: 1000000) {\n          count,\n          edges {\n            node {\n              id,\n              complete\n            }\n          }\n          <span class=\"hljs-subst\">${TodoList.getFragment('todos')}</span>\n        },\n        <span class=\"hljs-subst\">${AddTodoMutation.getFragment('viewer')}</span>\n      }\n    `</span>,\n  },\n});\n</code></pre>\n<h2 id=\"deletetodomutation\">DeleteTodoMutation <a class=\"hash-link\" href=\"#deletetodomutation\" aria-hidden=\"true\">#</a></h2>\n<p><code>DeleteTodoMutation</code> is similar, but we use <code>NODE_DELETE</code> instead of\n<code>RANDE_ADD</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">DeleteTodoMutation</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Mutation</span> </span>{\n  static fragments = {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`fragment on ReindexViewer {\n      id\n      allTodos(first: 1000000) {\n        count,\n      }\n    }`</span>\n  };\n\n  getMutation() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`mutation{ deleteTodo }`</span>;\n  }\n\n  getVariables() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.id,\n    };\n  }\n\n  getFatQuery() {\n    <span class=\"hljs-keyword\">return</span> Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoPayload {\n        id,\n        viewer {\n          id,\n          allTodos {\n            count,\n          }\n        }\n      }\n    `</span>;\n  }\n\n  getConfigs() {\n    <span class=\"hljs-keyword\">return</span> [{\n      type: <span class=\"hljs-string\">'NODE_DELETE'</span>,\n      parentName: <span class=\"hljs-string\">'viewer'</span>,\n      parentID: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n      connectionName: <span class=\"hljs-string\">'allTodos'</span>,\n      deletedIDFieldName: <span class=\"hljs-string\">'id'</span>,\n    }, {\n      type: <span class=\"hljs-string\">'FIELDS_CHANGE'</span>,\n      fieldIDs: {\n        viewer: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n      },\n    }];\n  }\n\n  getOptimisticResponse() {\n    <span class=\"hljs-keyword\">return</span> {\n      id: <span class=\"hljs-keyword\">this</span>.props.id,\n      viewer: {\n        id: <span class=\"hljs-keyword\">this</span>.props.viewer.id,\n        allTodos: {\n          count: <span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.count - <span class=\"hljs-number\">1</span>,\n        },\n      },\n    };\n  }\n}\n</code></pre>\n<p><code>DeleteTodoMutation</code> can be used in <code>Todo.js</code>, but it requires some data from\nviewer. Therefore we’d need to create a new fragment in the component, that will\nrequest that required data.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> DeleteTodoMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/DeleteTodoMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Todo</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleDestroyClick = () =&gt; {\n    Relay.Store.commitUpdate(\n      <span class=\"hljs-keyword\">new</span> DeleteTodoMutation({\n        id: <span class=\"hljs-keyword\">this</span>.props.todo.id,\n        viewer: <span class=\"hljs-keyword\">this</span>.props.viewer,\n      }),\n    );\n  }\n  <span class=\"hljs-comment\">// ...</span>\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(Todo, {\n  fragments: {\n    todo: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on Todo {\n        id,\n        text,\n        complete\n      }\n    `</span>,\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on ReindexViewer {\n        <span class=\"hljs-subst\">${DeleteTodoMutation.getFragment('viewer')}</span>\n      }\n    `</span>\n  }\n});\n</code></pre>\n<p>Similarly, we need to include this viewer fragment in <code>TodoList</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoList, {\n  fragments: {\n    todos: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoConnection {\n        count,\n        edges {\n          node {\n            id,\n            complete,\n            <span class=\"hljs-subst\">${Todo.getFragment('todo')}</span>\n          }\n        }\n      }\n    `</span>,\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on ReindexViewer {\n        <span class=\"hljs-subst\">${Todo.getFragment('viewer')}</span>\n      }\n    `</span>,\n  },\n});\n</code></pre>\n<p>And finally in the <code>TodoApp</code>. We will also include “clear completed”\nfunctionality.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-comment\">// ...</span>\n<span class=\"hljs-keyword\">import</span> DeleteTodoMutation <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../mutations/DeleteTodoMutation'</span>;\n<span class=\"hljs-comment\">// ...</span>\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoApp</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  <span class=\"hljs-comment\">// ...</span>\n  handleClearCompleted = () =&gt; {\n    <span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.edges\n      .filter((edge) =&gt; edge.node.complete)\n      .forEach((edge) =&gt; Relay.Store.commitUpdate(\n        <span class=\"hljs-keyword\">new</span> DeleteTodoMutation({\n          id: edge.node.id,\n          viewer: <span class=\"hljs-keyword\">this</span>.props.viewer,\n        })\n      ));\n  };\n  <span class=\"hljs-comment\">// ...</span>\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoApp, {\n  fragments: {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on ReindexViewer {\n        allTodos(first: 1000000) {\n          count,\n          edges {\n            node {\n              id,\n              complete\n            }\n          }\n          <span class=\"hljs-subst\">${TodoList.getFragment('todos')}</span>\n        },\n        <span class=\"hljs-subst\">${TodoList.getFragment('viewer')}</span>\n        <span class=\"hljs-subst\">${AddTodoMutation.getFragment('viewer')}</span>\n        <span class=\"hljs-subst\">${DeleteTodoMutation.getFragment('viewer')}</span>\n      }\n    `</span>,\n  },\n});\n</code></pre>\n<h2 id=\"mutations-mutations\">Mutations? Mutations! <a class=\"hash-link\" href=\"#mutations-mutations\" aria-hidden=\"true\">#</a></h2>\n<p>We have enabled mutations in our Todo application and we can now create and\nupdate todos. You can also find the final code on\n<a href=\"https://github.com/reindexio/reindex-examples/tree/master/todomvc-single-user\">GitHub</a>.</p>\n<p>In the <a href=\"/docs/tutorial/deployment/\">next section</a> we’ll deploy our application.</p>\n"}

/***/ },
/* 375 */
/***/ function(module, exports) {

	module.exports = {"title":"Authenticating users","order":6,"body":"<p>Many apps need a way to authenticate users – to verify their identity.\nThis allows the app to tell users apart, store information about them and grant\nthem special permissions. Reindex provides a built-in user authentication\nsystem. When user is authenticated the following happens:</p>\n<ul>\n<li>If such user didn’t exist, a new record in <code>User</code> type is created</li>\n<li><code>viewer</code> root field will return current user information (it returns null\nfor anonymous users)</li>\n<li>Permission system starts to use current user <code>id</code> instead of using anonymous\nuser permissions.</li>\n</ul>\n<p>Reindex provides social login with Facebook, Google, Twitter and GitHub.\nIt is a client-side only solution, so no backend code is required.</p>\n<h2 id=\"setting-up-authentication-providers\">Setting up authentication providers <a class=\"hash-link\" href=\"#setting-up-authentication-providers\" aria-hidden=\"true\">#</a></h2>\n<p>Adding Reindex authentication to your app has following steps:</p>\n<ol>\n<li>Setting up an app in the provider system (e.g. Google).</li>\n<li>Adding app access keys to <code>ReindexAuthenticationProvider</code> type.</li>\n<li>Using <code>reindex-js</code> client library to sign users in.</li>\n</ol>\n<p>Let’s create a Google application and configure it for Reindex authentication.</p>\n<p>Go to <a href=\"https://cloud.google.com/console\">Google Application Console</a>, click at\n<em>Create Project</em> and enter required information.</p>\n<p>When the app has been created, to <em>APIs</em> (under <em>APIs &amp; auth</em>) and find\n<em>Google+ API</em> on the list. Click <em>Enable API</em>.</p>\n<p>Go to <em>Credentials</em>. Click on <em>Add credentials</em> and select\n<em>OAuth 2.0 client ID</em>. Click on <em>Configure consent screen</em> and fill in the name\nof the project and other information, if you desire. Click <em>Save</em>.</p>\n<p>Now you can select <em>Web application</em> in Create Client ID dialog. Set\n<em>Authorized redirect URIs</em> to:</p>\n<pre><code class=\"language-sh\">https://NAME-OF-YOUR-APP.myreindex.com/auth/google\n</code></pre>\n<p>Press <em>Create</em>. A dialog will appear with <em>Client ID</em> and <em>Cliend secret</em>.\nOpen GraphiQL console (<code>reindex graphiql</code>) and add the authentication provider\nusing the following query:</p>\n<pre><code class=\"language-graphql\">mutation createGoogleProvider {\n  createReindexAuthenticationProvider(input: {\n    <span class=\"hljs-class\"><span class=\"hljs-keyword\">type</span>: <span class=\"hljs-title\">google</span>,</span>\n    clientId: <span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-ID\"</span>,\n    clientSecret: <span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-SECRET\"</span>,\n    isEnabled: <span class=\"hljs-keyword\">true</span>\n  }) {\n    changedReindexAuthenticationProvider {\n      clientId,\n      id,\n      clientSecret,\n      <span class=\"hljs-class\"><span class=\"hljs-keyword\">type</span>,</span>\n      isEnabled\n    }\n  }\n}\n</code></pre>\n<p>Here we create an authentication provider in Reindex system. The result should\nbe:</p>\n<pre><code class=\"language-json\">{\n  \"<span class=\"hljs-attribute\">data</span>\": <span class=\"hljs-value\">{\n    \"<span class=\"hljs-attribute\">createReindexAuthenticationProvider</span>\": <span class=\"hljs-value\">{\n      \"<span class=\"hljs-attribute\">ReindexAuthenticationProvider</span>\": <span class=\"hljs-value\">{\n        \"<span class=\"hljs-attribute\">type</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"google\"</span></span>,\n        \"<span class=\"hljs-attribute\">clientId</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-ID\"</span></span>,\n        \"<span class=\"hljs-attribute\">clientSecret</span>\": <span class=\"hljs-value\"><span class=\"hljs-string\">\"YOUR-GOOGLE-CLIENT-SECRET\"</span></span>,\n        \"<span class=\"hljs-attribute\">isEnabled</span>\": <span class=\"hljs-value\"><span class=\"hljs-literal\">true</span>\n      </span>}\n    </span>}\n  </span>}\n</span>}\n</code></pre>\n<p>This means we have successfully enabled Google as our authentication provider.\nThe only thing left is to use that on our client.</p>\n<h2 id=\"logging-the-user-in\">Logging the user in <a class=\"hash-link\" href=\"#logging-the-user-in\" aria-hidden=\"true\">#</a></h2>\n<p><code>Reindex</code> instances provides method <code>login</code> to authenticate user. It accepts\nprovider name and returns a promise. Promise resolves when user successfully\nlogged in with an object that has key <code>user</code> with user information in it. If\nlogin failed for any reason, promises fails with information about the reason.\nIn addition to <code>login</code>, <code>Reindex</code> also provides <code>logout</code> method for the\nopposite action.</p>\n<p><code>reindex-starter-kit-react</code> already comes with the code to log in and log out\nenabled for all supported providers. We can remove every provider by Google for\nnow. We force reload on every authentication status change to clear Relay\ninternal store, so that it can’t leak to unauthorized user.</p>\n<p>If everything went fine, once you click “Login with Google”, the window should\nappear asking for your Google login. Once you successfully authorized the\napplication, the view will change to one displaying your login information.</p>\n"}

/***/ },
/* 376 */
/***/ function(module, exports) {

	module.exports = {"title":"Defining the schema","order":2,"body":"<p>Every Relay application needs a GraphQL server and a GraphQL server needs a\nschema. The schema defines all the types of data in your application.</p>\n<p>Typically you would have to write your schema as code and set up the server\nyourself, but with Reindex you can just define the types, push them to\nReindex and your GraphQL server is ready for use.</p>\n<p>Your Reindex app has a minimal schema by default. Go to your project folder and\nfetch it:</p>\n<pre><code class=\"language-sh\">reindex schema-fetch\n</code></pre>\n<p>Reindex Schema is a JSON file. We use <a href=\"http://json5.org/\">JSON5</a> as our parser,\nso it’s much nicer to manually edit than normal JSON, as it supports comments,\nunquoted property names and trailing commas. Let’s take a look the\n<code>ReindexSchema.json</code> that we just fetched. It includes the initial Reindex\nschema for your app:</p>\n<pre><code class=\"language-js\">[\n  {\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      }\n    ]\n  },\n]\n</code></pre>\n<p>Every Reindex app has a type named <code>User</code>, which represents a user of the app.\nIt implements the <code>Node</code> interface, which means it is an object with an <code>ID</code>\nand it can be fetched using the <code>node</code> root field. The field <code>id</code> must be\ndefined as <code>nonNull</code>. <code>unique</code> means that all values of the <code>id</code> field must be\nunique within <code>User</code> nodes.</p>\n<p>Let’s add a new type <code>Todo</code>, which we will use to represent todo items in our\napp. Replace the contents of <code>ReindexSchema.json</code> with this new schema:</p>\n<pre><code class=\"language-js\">[\n  {\n    name: <span class=\"hljs-string\">\"User\"</span>,\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      }\n    ]\n  },\n  {\n    name: <span class=\"hljs-string\">\"Todo\"</span>,\n    kind: <span class=\"hljs-string\">\"OBJECT\"</span>,\n    interfaces: [\n      <span class=\"hljs-string\">\"Node\"</span>\n    ],\n    fields: [\n      {\n        name: <span class=\"hljs-string\">\"id\"</span>,\n        type: <span class=\"hljs-string\">\"ID\"</span>,\n        nonNull: <span class=\"hljs-literal\">true</span>,\n        unique: <span class=\"hljs-literal\">true</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"text\"</span>,\n        type: <span class=\"hljs-string\">\"String\"</span>\n      },\n      {\n        name: <span class=\"hljs-string\">\"complete\"</span>,\n        type: <span class=\"hljs-string\">\"Boolean\"</span>\n      }\n    ]\n  }\n]\n\n</code></pre>\n<p>Then you can push this schema to your Reindex app:</p>\n<pre><code class=\"language-sh\">reindex schema-push\n</code></pre>\n<p>Congratulations! You now have a GraphQL server. Next, let’s make some GraphQL\nqueries.</p>\n<h2 id=\"browse-your-api-with-graphiql\">Browse your API with GraphiQL <a class=\"hash-link\" href=\"#browse-your-api-with-graphiql\" aria-hidden=\"true\">#</a></h2>\n<p>GraphiQL is an interactive console for working with GraphQL servers. You can\nquickly open GraphiQL by using the <code>graphiql</code> command of Reindex CLI:</p>\n<pre><code class=\"language-sh\">reindex graphiql\n</code></pre>\n<p>Now make some queries to your brand new GraphQL server.\nLet’s add a todo. Type this mutation in GraphiQL and run it:</p>\n<pre><code class=\"language-graphql\">mutation AddTodo {\n  createTodo(<span class=\"hljs-string\">input:</span> { <span class=\"hljs-string\">text:</span> <span class=\"hljs-string\">\"Do the dishes\"</span>, <span class=\"hljs-string\">complete:</span> <span class=\"hljs-literal\">false</span> }) {\n    changedTodo {\n      text\n      complete\n    }\n  }\n}\n</code></pre>\n<p>Add a few todos. You can then see all of them by running this query:</p>\n<pre><code><span class=\"hljs-collection\">{\n  viewer <span class=\"hljs-collection\">{\n    allTodos <span class=\"hljs-collection\">{\n      nodes <span class=\"hljs-collection\">{\n        text\n      }</span>\n    }</span>\n  }</span>  \n}</span>\n</code></pre>\n<p>We’ve created a schema and inserted some data with GraphiQL. In the\n<a href=\"/docs/tutorial/displaying-todos/\">next section</a> we’ll make Relay get this data\nfor us.</p>\n"}

/***/ },
/* 377 */
/***/ function(module, exports) {

	module.exports = {"title":"Deployment","order":5,"body":"<p>Make a production build of your app by running:</p>\n<pre><code class=\"language-sh\">npm run build\n</code></pre>\n<p>You can now push the <code>public</code> directory to your favorite static page hosting\nservice. We recommend <a href=\"https://surge.sh\">Surge</a>, but you can also use Github\nPages, Amazon S3 or any static web hosting provider.</p>\n<p>With Surge CLI you can deploy your app with just a few commands:</p>\n<pre><code class=\"language-sh\">npm install -g surge\nsurge ./public\n</code></pre>\n<p>You’re app is live. Nice! In the final section of the tutorial you will learn\nhow to easily <a href=\"/docs/tutorial/authenticating-users/\">add authentication to your Reindex apps.</a></p>\n"}

/***/ },
/* 378 */
/***/ function(module, exports) {

	module.exports = {"title":"Displaying todos","order":3,"body":"<p>Now that we have a schema, we can display the Todos in our client application.</p>\n<p>Let’s install some dependencies, like libraries to handle keycodes and\nclassnames and css for TodoMVC.</p>\n<pre><code class=\"language-sh\">npm install --save classnames keycodes todomvc-app-css\n</code></pre>\n<p>Let’s create components Todo.js, TodoInput.js, TodoList.js and TodoApp.js.</p>\n<h2 id=\"running-the-app\">Running the app <a class=\"hash-link\" href=\"#running-the-app\" aria-hidden=\"true\">#</a></h2>\n<p>Let’s start the app so that we can see it’s current state in the browser. At\nthis point it will show the default <code>reindex-starter-kit-react</code> view.</p>\n<p>First fetch the schema for Relay. You need to fetch it every time you push the\nschema to the Reindex backend.</p>\n<pre><code class=\"language-sh\">reindex schema-relay data/schema.json\n</code></pre>\n<p>Then start the app:</p>\n<pre><code class=\"language-sh\">npm start\n</code></pre>\n<h2 id=\"todojs\">Todo.js <a class=\"hash-link\" href=\"#todojs\" aria-hidden=\"true\">#</a></h2>\n<p>The biggest difference between a ‘plain’ React app and React + Relay app is that\nevery component you create is wrapped into a container. Container contains a\nquery fragment, that describes what data a component needs. For example for a\nTodo, we need text and whether it is completed, as well its ID. So the fragment\nwould be:</p>\n<pre><code class=\"language-graphql\">fragment <span class=\"hljs-function_start\"><span class=\"hljs-keyword\">on</span></span> Todo {\n  <span class=\"hljs-property\">id</span>,\n  <span class=\"hljs-type\">text</span>,\n  complete\n}\n</code></pre>\n<p>You wrap the component into container by providing this fragment to a <code>fragment</code>\nobject. The key of that fragment would be passed to the component props.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(Todo, {\n  fragments: {\n    todo: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on Todo {\n        id,\n        text,\n        complete\n      }\n    `</span>\n  }\n});\n</code></pre>\n<p>Here is full <code>src/components/Todo.js</code> file. We leave stubs in place of future\nmutative actions.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> React, {Component} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n<span class=\"hljs-keyword\">import</span> classNames <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'classnames'</span>;\n\n<span class=\"hljs-keyword\">import</span> TodoInput <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./TodoInput'</span>;\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">Todo</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  state = {\n    isEditing: <span class=\"hljs-literal\">false</span>,\n  }\n\n  handleCompleteChange = () =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle complete</span>\n  }\n\n  handleLabelDoubleClick = () =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({\n      isEditing: <span class=\"hljs-literal\">true</span>,\n    });\n  }\n\n  handleDestroyClick = () =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle destroy</span>\n  }\n\n  handleInputSave = (text) =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle text change</span>\n    <span class=\"hljs-keyword\">this</span>.setState({\n      isEditing: <span class=\"hljs-literal\">false</span>,\n    });\n  }\n\n  handleInputCancel = () =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({\n      isEditing: <span class=\"hljs-literal\">false</span>,\n    });\n  }\n\n  handleInputDelete = () =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({\n      isEditing: <span class=\"hljs-literal\">false</span>,\n    });\n  }\n\n  makeInput() {\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.state.isEditing) {\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TodoInput</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"edit\"</span>\n                   <span class=\"hljs-attribute\">saveOnBlur</span>=<span class=\"hljs-value\">{true}</span>\n                   <span class=\"hljs-attribute\">initialValue</span>=<span class=\"hljs-value\">{this.props.todo.text}</span>\n                   <span class=\"hljs-attribute\">onSave</span>=<span class=\"hljs-value\">{this.handleInputSave}</span>\n                   <span class=\"hljs-attribute\">onCancel</span>=<span class=\"hljs-value\">{this.handleInputCancel}</span>\n                   <span class=\"hljs-attribute\">onDelete</span>=<span class=\"hljs-value\">{this.handleInputDelete}</span> /&gt;</span>\n      )</span>;\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> <span class=\"hljs-literal\">null</span>;\n    }\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">li</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">{classNames({</span>\n        <span class=\"hljs-attribute\">completed:</span> <span class=\"hljs-attribute\">this.props.todo.complete</span>,\n        <span class=\"hljs-attribute\">editing:</span> <span class=\"hljs-attribute\">this.state.isEditing</span>\n      })}&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">div</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"view\"</span>&gt;</span>\n          <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">input</span> <span class=\"hljs-attribute\">checked</span>=<span class=\"hljs-value\">{this.props.todo.complete}</span>\n                 <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"toggle\"</span>\n                 <span class=\"hljs-attribute\">onChange</span>=<span class=\"hljs-value\">{this.handleCompleteChange}</span>\n                 <span class=\"hljs-attribute\">type</span>=<span class=\"hljs-value\">\"checkbox\"</span> /&gt;</span>\n           <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">label</span> <span class=\"hljs-attribute\">onDoubleClick</span>=<span class=\"hljs-value\">{this.handleLabelDoubleClick}</span>&gt;</span>\n             {this.props.todo.text}\n           <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">label</span>&gt;</span>\n          <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">button</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"destroy\"</span>\n                  <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{this.handleDestroyClick}</span> /&gt;</span>\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">div</span>&gt;</span>\n        {this.makeInput()}\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">li</span>&gt;</span>\n    )</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(Todo, {\n  fragments: {\n    todo: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on Todo {\n        id,\n        text,\n        complete\n      }\n    `</span>,\n  }\n});\n\n</code></pre>\n<h2 id=\"todoinputjs\">TodoInput.js <a class=\"hash-link\" href=\"#todoinputjs\" aria-hidden=\"true\">#</a></h2>\n<p>Here is <code>src/components/TodoInput.js</code>, an input component. It’s “dumb”\ncomponent, without any Relay containers.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> keycodes <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'keycodes'</span>;\n<span class=\"hljs-keyword\">import</span> React, {Component} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> {findDOMNode} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-dom'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoInput</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  state = {\n    text: <span class=\"hljs-keyword\">this</span>.props.initialValue || <span class=\"hljs-string\">''</span>,\n  };\n\n  handleBlur = () =&gt; {\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.saveOnBlur) {\n      <span class=\"hljs-keyword\">this</span>.save();\n    }\n  }\n\n  handleChange = (e) =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({\n      text: e.target.value,\n    });\n  }\n\n  handleKeyDown = (e) =&gt; {\n    <span class=\"hljs-keyword\">if</span> (e.keyCode === keycodes(<span class=\"hljs-string\">'esc'</span>)) {\n      <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.onCancel) {\n        <span class=\"hljs-keyword\">this</span>.props.onCancel();\n      }\n    } <span class=\"hljs-keyword\">else</span> <span class=\"hljs-keyword\">if</span> (e.keyCode === keycodes(<span class=\"hljs-string\">'enter'</span>)) {\n      <span class=\"hljs-keyword\">this</span>.save();\n    }\n  }\n\n  save() {\n    <span class=\"hljs-keyword\">const</span> text = <span class=\"hljs-keyword\">this</span>.state.text.trim();\n    <span class=\"hljs-keyword\">if</span> (text === <span class=\"hljs-string\">''</span>) {\n      <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.onDelete) {\n        <span class=\"hljs-keyword\">this</span>.props.onDelete();\n      }\n    } <span class=\"hljs-keyword\">else</span> <span class=\"hljs-keyword\">if</span> (text === <span class=\"hljs-keyword\">this</span>.props.initialValue) {\n      <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.onCancel) {\n        <span class=\"hljs-keyword\">this</span>.props.onCancel();\n      }\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.onSave) {\n        <span class=\"hljs-keyword\">this</span>.props.onSave(text);\n      }\n      <span class=\"hljs-keyword\">this</span>.setState({\n        text: <span class=\"hljs-string\">''</span>,\n      });\n    }\n  }\n\n  componentDidMount() {\n    findDOMNode(<span class=\"hljs-keyword\">this</span>).focus();\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">input</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">{this.props.className</span> || ''}\n             <span class=\"hljs-attribute\">placeholder</span>=<span class=\"hljs-value\">{this.props.placeholder</span> || ''}\n             <span class=\"hljs-attribute\">value</span>=<span class=\"hljs-value\">{this.state.text}</span>\n             <span class=\"hljs-attribute\">onBlur</span>=<span class=\"hljs-value\">{this.handleBlur}</span>\n             <span class=\"hljs-attribute\">onChange</span>=<span class=\"hljs-value\">{this.handleChange}</span>\n             <span class=\"hljs-attribute\">onKeyDown</span>=<span class=\"hljs-value\">{this.handleKeyDown}</span> /&gt;</span>\n    )</span>;\n  }\n}\n</code></pre>\n<h2 id=\"todolistjs\">TodoList.js <a class=\"hash-link\" href=\"#todolistjs\" aria-hidden=\"true\">#</a></h2>\n<p><em>Connection</em> is Relay’s convention for representing lists of data.\nRelay knows how to use connections for, for example, optimistic updates or pagination.</p>\n<p>Reindex creates connection types automatically for all types with the interface\n<code>Node</code> (“node types”). The name of such connection type for is\n<code>_&lt;name-of-type&gt;Connection</code>, so for <code>Todo</code> it is <code>_TodoConnection</code>.</p>\n<p>The <code>TodoList</code> component will display multiple todos, so the fragment needs to\nbe defined on <code>_TodoConnection</code>.</p>\n<p>The connection type has two important fields:</p>\n<ul>\n<li><code>count</code>, the total number of nodes in the connection</li>\n<li><code>edges</code>, a list of items, with the actual node (todo in this case) accessible\nusing the <code>node</code> key.</li>\n</ul>\n<pre><code class=\"language-graphql\">fragment on _TodoConnection {\n  count,\n  edges {\n    node {\n      complete,\n      ${Todo.getFragment(<span class=\"hljs-string\">'todo'</span>)}\n    }\n  }\n}\n</code></pre>\n<p>With the <code>${}</code> syntax we can include requirements of the child components, in\nthis case <code>Todo</code> in our parent query. Note how we still have added <code>complete</code> to\nthe query, even though it is there from <code>Todo</code> - this is because we enable\nfiltering based on the completion inside <code>TodoList</code> and Relay only passed\ncomponent the data it directly requested in props.</p>\n<p>Here is full listing of <code>src/components/TodoList.js</code></p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> React, {Component} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">import</span> Todo <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./Todo'</span>;\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoList</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  getFilteredTodos() {\n    <span class=\"hljs-keyword\">const</span> edges = <span class=\"hljs-keyword\">this</span>.props.todos.edges;\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.filter === <span class=\"hljs-string\">'active'</span>) {\n      <span class=\"hljs-keyword\">return</span> edges.filter((todo) =&gt; !todo.node.complete);\n    } <span class=\"hljs-keyword\">else</span> <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.filter === <span class=\"hljs-string\">'completed'</span>) {\n      <span class=\"hljs-keyword\">return</span> edges.filter((todo) =&gt; todo.node.complete);\n    } <span class=\"hljs-keyword\">else</span> {\n      <span class=\"hljs-keyword\">return</span> edges;\n    }\n  }\n\n  handleToggleAllChange = () =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle toggle all</span>\n  }\n\n  makeTodo = (edge) =&gt; {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Todo</span> <span class=\"hljs-attribute\">key</span>=<span class=\"hljs-value\">{edge.node.id}</span>\n            <span class=\"hljs-attribute\">todo</span>=<span class=\"hljs-value\">{edge.node}</span>\n            <span class=\"hljs-attribute\">viewer</span>=<span class=\"hljs-value\">{this.props.viewer}</span> /&gt;</span>\n    )</span>;\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">const</span> todoCount = <span class=\"hljs-keyword\">this</span>.props.todos.count;\n    <span class=\"hljs-keyword\">const</span> done = <span class=\"hljs-keyword\">this</span>.props.todos.edges.reduce((next, edge) =&gt; (\n      next + (edge.node.complete ? <span class=\"hljs-number\">1</span> : <span class=\"hljs-number\">0</span>)\n    ), <span class=\"hljs-number\">0</span>);\n    <span class=\"hljs-keyword\">const</span> todos = <span class=\"hljs-keyword\">this</span>.getFilteredTodos();\n    <span class=\"hljs-keyword\">const</span> todoList = todos.map(<span class=\"hljs-keyword\">this</span>.makeTodo);\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">section</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"main\"</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">input</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"toggle-all\"</span>\n               <span class=\"hljs-attribute\">checked</span>=<span class=\"hljs-value\">{todoCount</span> =<span class=\"hljs-value\">==</span> <span class=\"hljs-attribute\">done</span>}\n               <span class=\"hljs-attribute\">onChange</span>=<span class=\"hljs-value\">{this.handleToggleAllChange}</span>\n               <span class=\"hljs-attribute\">type</span>=<span class=\"hljs-value\">\"checkbox\"</span> /&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">ul</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"todo-list\"</span>&gt;</span>\n          {todoList}\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">ul</span>&gt;</span>\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">section</span>&gt;</span>\n    )</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoList, {\n  fragments: {\n    todos: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on _TodoConnection {\n        count,\n        edges {\n          node {\n            complete,\n            <span class=\"hljs-subst\">${Todo.getFragment('todo')}</span>\n          }\n        }\n      }\n    `</span>\n  },\n});\n</code></pre>\n<h2 id=\"todoappjs\">TodoApp.js <a class=\"hash-link\" href=\"#todoappjs\" aria-hidden=\"true\">#</a></h2>\n<p>As we discussed before, to get all the Todos we will use <code>allTodos</code> field on\nfrom <code>viewer</code> root. <code>viewer</code> type is <code>ReindexViewer</code>, so our <code>TodoApp</code>\ncontainer will define fragment on it.</p>\n<pre><code class=\"language-graphql\">fragment on ReindexViewer {\n  allTodos(first: <span class=\"hljs-number\">1000000</span>) {\n    count,\n    edges {\n      node {\n        complete\n      }\n    }\n    ${TodoList.getFragment(<span class=\"hljs-string\">'todos'</span>)}\n  },\n</code></pre>\n<p>Again, we include some more data manually, because we need information about\ncompletion in the App component to display it in the footer.</p>\n<p><code>first</code> argument needs to be passed to all connections in Relay, so that it can\nhandle pagination. We don’t plan to implement pagination in our TodoApp, but\nwe still have to pass some arbitrary big number for Relay’s sake. This limitation\nwill be removed in future version of Relay. The common pattern in Relay is to\nuse <code>Number.MAX_SAFE_INTEGER</code> for this, but Reindex only supports 32 bits\nintegers as arguments to <code>first</code> and <code>last</code>.</p>\n<p>Full code listing for <code>src/components/TodoApp.js</code>.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> React, {Component} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n<span class=\"hljs-keyword\">import</span> classNames <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'classnames'</span>;\n\n<span class=\"hljs-keyword\">import</span> TodoList <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./TodoList'</span>;\n<span class=\"hljs-keyword\">import</span> TodoInput <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./TodoInput'</span>;\n\n<span class=\"hljs-keyword\">import</span> <span class=\"hljs-string\">'todomvc-app-css/index.css'</span>;\n\n<span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">TodoApp</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  state = {\n    selectedFilter: <span class=\"hljs-string\">'all'</span>,\n  };\n\n  handleFilterChange = (filter) =&gt; {\n    <span class=\"hljs-keyword\">this</span>.setState({\n      selectedFilter: filter,\n    });\n  }\n\n  handleInputSave = (text) =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle save</span>\n  }\n\n  handleClearCompleted = () =&gt; {\n    <span class=\"hljs-comment\">// <span class=\"hljs-doctag\">TODO:</span> handle clear completed</span>\n  };\n\n  makeHeader() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">header</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"header\"</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">h1</span>&gt;</span>Todos<span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">h1</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TodoInput</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"new-todo\"</span>\n                   <span class=\"hljs-attribute\">placeholder</span>=<span class=\"hljs-value\">\"What needs to be done?\"</span>\n                   <span class=\"hljs-attribute\">onSave</span>=<span class=\"hljs-value\">{this.handleInputSave}</span> /&gt;</span>\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">header</span>&gt;</span>\n    )</span>;\n  }\n\n  makeFooter() {\n    <span class=\"hljs-keyword\">const</span> total = <span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.count;\n    <span class=\"hljs-keyword\">const</span> undone = <span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.edges.reduce((next, edge) =&gt; (\n      next + (edge.node.complete ? <span class=\"hljs-number\">0</span> : <span class=\"hljs-number\">1</span>)\n    ), <span class=\"hljs-number\">0</span>);\n\n    <span class=\"hljs-keyword\">const</span> filters = [<span class=\"hljs-string\">'all'</span>, <span class=\"hljs-string\">'active'</span>, <span class=\"hljs-string\">'completed'</span>].map((filter) =&gt; {\n      <span class=\"hljs-keyword\">const</span> selected = filter === <span class=\"hljs-keyword\">this</span>.state.selectedFilter;\n      <span class=\"hljs-keyword\">return</span> (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">li</span> <span class=\"hljs-attribute\">key</span>=<span class=\"hljs-value\">{filter}</span>&gt;</span>\n          <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">a</span> <span class=\"hljs-attribute\">href</span>=<span class=\"hljs-value\">{'#'</span> + <span class=\"hljs-attribute\">filter</span>}\n             <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">{classNames({</span> <span class=\"hljs-attribute\">selected</span> })}\n             <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{selected</span> ? <span class=\"hljs-attribute\">null</span> <span class=\"hljs-attribute\">:</span> <span class=\"hljs-attribute\">this.handleFilterChange.bind</span>(\n               <span class=\"hljs-attribute\">this</span>, <span class=\"hljs-attribute\">filter</span>\n             )}&gt;</span>\n             {filter}\n          <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">a</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">li</span>&gt;</span>\n      )</span>;\n    })\n\n    <span class=\"hljs-keyword\">let</span> clearButton;\n    <span class=\"hljs-keyword\">if</span> (<span class=\"hljs-keyword\">this</span>.props.viewer.allTodos.edges.some((edge) =&gt; edge.node.complete)) {\n      clearButton = (\n        <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">button</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"clear-completed\"</span>\n                <span class=\"hljs-attribute\">onClick</span>=<span class=\"hljs-value\">{this.handleClearCompleted}</span>&gt;</span>\n          Clear completed\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">button</span>&gt;</span>\n      )</span>;\n    }\n\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">footer</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"footer\"</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">span</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"todo-count\"</span>&gt;</span>\n          {undone} / {total} items left\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">span</span>&gt;</span>\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">ul</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"filters\"</span>&gt;</span>\n          {filters}\n        <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">ul</span>&gt;</span>\n        {clearButton}\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">footer</span>&gt;</span>\n    )</span>;\n  }\n\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">section</span> <span class=\"hljs-attribute\">className</span>=<span class=\"hljs-value\">\"todoapp\"</span>&gt;</span>\n        {this.makeHeader()}\n        <span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">TodoList</span> <span class=\"hljs-attribute\">todos</span>=<span class=\"hljs-value\">{this.props.viewer.allTodos}</span>\n                  <span class=\"hljs-attribute\">filter</span>=<span class=\"hljs-value\">{this.state.selectedFilter}</span>\n                  <span class=\"hljs-attribute\">viewer</span>=<span class=\"hljs-value\">{this.props.viewer}</span> /&gt;</span>\n        {this.makeFooter()}\n      <span class=\"hljs-tag\">&lt;/<span class=\"hljs-title\">section</span>&gt;</span>\n    )</span>;\n  }\n}\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> Relay.createContainer(TodoApp, {\n  fragments: {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`\n      fragment on ReindexViewer {\n        allTodos(first: 1000000) {\n          count,\n          edges {\n            node {\n              id,\n              complete\n            }\n          }\n          <span class=\"hljs-subst\">${TodoList.getFragment('todos')}</span>\n        },\n      }\n    `</span>,\n  },\n});\n</code></pre>\n<h2 id=\"routes-and-appjs\">Routes and App.js <a class=\"hash-link\" href=\"#routes-and-appjs\" aria-hidden=\"true\">#</a></h2>\n<p>Last thing to do is to fix our Route and App.js. Routes in Relay define entry\npoints in the application, in our example the entry point would be <code>viewer</code>.</p>\n<p>Let’s create <code>src/routes/AppRoute.js</code></p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">AppRoute</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Relay</span>.<span class=\"hljs-title\">Route</span> </span>{\n  static queries = {\n    viewer: () =&gt; Relay.QL<span class=\"hljs-string\">`query { viewer }`</span>,\n  };\n  static routeName = <span class=\"hljs-string\">'AppRoute'</span>;\n}\n</code></pre>\n<p>Let’s hook it all up in <code>src/components/App.js</code></p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">import</span> React, {Component} <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react'</span>;\n<span class=\"hljs-keyword\">import</span> Relay <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'react-relay'</span>;\n\n<span class=\"hljs-keyword\">import</span> Reindex <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../Reindex'</span>;\n<span class=\"hljs-keyword\">import</span> TodoApp <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'./TodoApp'</span>;\n<span class=\"hljs-keyword\">import</span> AppRoute <span class=\"hljs-keyword\">from</span> <span class=\"hljs-string\">'../routes/AppRoute'</span>;\n\n<span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> <span class=\"hljs-class\"><span class=\"hljs-keyword\">class</span> <span class=\"hljs-title\">App</span> <span class=\"hljs-keyword\">extends</span> <span class=\"hljs-title\">Component</span> </span>{\n  render() {\n    <span class=\"hljs-keyword\">return</span> (\n      <span class=\"xml\"><span class=\"hljs-tag\">&lt;<span class=\"hljs-title\">Relay.RootContainer</span>\n        <span class=\"hljs-attribute\">Component</span>=<span class=\"hljs-value\">{TodoApp}</span>\n        <span class=\"hljs-attribute\">route</span>=<span class=\"hljs-value\">{new</span> <span class=\"hljs-attribute\">AppRoute</span>}\n        <span class=\"hljs-attribute\">forceFetch</span>=<span class=\"hljs-value\">{true}</span> /&gt;</span>\n    )</span>;\n  }\n}\n</code></pre>\n<h2 id=\"run-the-app\">Run the app <a class=\"hash-link\" href=\"#run-the-app\" aria-hidden=\"true\">#</a></h2>\n<p>We have now defined our components and containers. In browser, you should be\nable to see the app with todos we created in GraphiQL.</p>\n<p><img src=\"/docs/todomvc_screenshot.png\" alt=\"Screenshot\"></p>\n<p>In the <a href=\"/docs/tutorial/adding-mutations/\">next section</a> we will define Relay\nmutations to update our todos.</p>\n"}

/***/ },
/* 379 */
/***/ function(module, exports) {

	module.exports = {"title":"Tutorial","order":1,"body":"<p>In this tutorial we will build a TodoMVC app using Reindex, React and Relay.\nThe structure of the app is roughly similar to the\n<a href=\"https://github.com/facebook/relay/tree/master/examples/todo\">Relay example</a>,\nbut instead of writing a GraphQL server from scratch, we will simply use\nReindex.</p>\n<p>Source code for this tutorial is available at\n<a href=\"https://github.com/reindexio/reindex-examples/tree/master/todomvc-single-user\">GitHub</a>.</p>\n"}

/***/ },
/* 380 */
/***/ function(module, exports) {

	module.exports = {"title":"Setup","order":1,"body":"<p>To get started, you should have the app URL and an admin token for your Reindex\napp. If you don’t have a Reindex app yet, you can sign up for a free development\naccount at <a href=\"https://www.reindex.io\">reindex.io</a>.</p>\n<h2 id=\"get-the-starter-kit\">Get the starter kit <a class=\"hash-link\" href=\"#get-the-starter-kit\" aria-hidden=\"true\">#</a></h2>\n<p>We have assembled an\n<a href=\"https://github.com/reindexio/reindex-starter-kit-react\">open source starter kit</a>\nfor getting started with Reindex. It includes React and Relay set up together\nwith the <code>reindex-js</code> client library. The starter kit also has examples on how\nto quickly add authentication to your app and deploy it in production.</p>\n<p>Clone the starter kit:</p>\n<pre><code class=\"language-sh\">git <span class=\"hljs-built_in\">clone</span> git@github.com:reindexio/reindex-starter-kit-react.git\n</code></pre>\n<p>Install the dependencies and Reindex CLI:</p>\n<pre><code class=\"language-sh\"><span class=\"hljs-built_in\">cd</span> reindex-starter-kit-react\nnpm install\nnpm install -g reindex-cli\n</code></pre>\n<p>Login to Reindex. You will be prompted for your Reindex URL and admin token.</p>\n<pre><code class=\"language-sh\">$ reindex login\nReindex URL: https://YOUR-REINDEX-APP.myreindex.com\nReindex Token: YOUR-REINDEX-TOKEN\n</code></pre>\n<p>Edit <code>./src/config.js</code> file to contain your URL.</p>\n<pre><code class=\"language-js\"><span class=\"hljs-keyword\">export</span> <span class=\"hljs-keyword\">default</span> {\n  REINDEX_URL: <span class=\"hljs-string\">'https://YOUR-REINDEX-APP.myreindex.com'</span>,\n};\n</code></pre>\n"}

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "caf00a3ca8bf10c58b60f61b3dca2d62.png";

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "4c3d712c4a90f8aa261223698cc3c15a.png";

/***/ },
/* 383 */
339,
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(385);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(328)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./graphiql.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./graphiql.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(327)();
	// imports
	
	
	// module
	exports.push([module.id, "#graphiql-container{margin:0;overflow:hidden;color:#141823;width:100%;display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;height:100%;font-family:system,-apple-system,San Francisco,\\.SFNSDisplay-Regular,Segoe UI,Segoe,Segoe WP,Helvetica Neue,helvetica,Lucida Grande,arial,sans-serif;font-size:14px}#graphiql-container .editorWrap{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;-webkit-flex:1;flex:1}#graphiql-container .title{font-size:18px}#graphiql-container .title em{font-family:georgia;font-size:19px}#graphiql-container .topBarWrap{flex-direction:row}#graphiql-container .topBar,#graphiql-container .topBarWrap{display:-webkit-flex;display:flex;-webkit-flex-direction:row}#graphiql-container .topBar{background:-webkit-linear-gradient(#f7f7f7,#e2e2e2);background:linear-gradient(#f7f7f7,#e2e2e2);border-bottom:1px solid #d0d0d0;cursor:default;height:34px;padding:7px 14px 6px;-webkit-user-select:none;user-select:none;flex-direction:row;-webkit-flex:1;flex:1;-webkit-align-items:center;align-items:center}#graphiql-container .toolbar{overflow-x:scroll}#graphiql-container .docExplorerShow{background:-webkit-linear-gradient(#f7f7f7,#e2e2e2);background:linear-gradient(#f7f7f7,#e2e2e2);border:none;border-bottom:1px solid #d0d0d0;border-left:1px solid rgba(0,0,0,.2);color:#3b5998;cursor:pointer;font-size:14px;outline:0;padding:2px 20px 0 18px}#graphiql-container .docExplorerShow:before{border-left:2px solid #3b5998;border-top:2px solid #3b5998;content:'';display:inline-block;height:9px;margin:0 3px -1px 0;position:relative;width:9px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}#graphiql-container .editorBar{display:-webkit-flex;display:flex;-webkit-flex-direction:row;flex-direction:row;-webkit-flex:1;flex:1}#graphiql-container .queryWrap,#graphiql-container .resultWrap{display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;-webkit-flex:1;flex:1}#graphiql-container .resultWrap{position:relative;border-left:1px solid #e0e0e0}#graphiql-container .docExplorerWrap{box-shadow:0 0 8px rgba(0,0,0,.15);z-index:3;position:relative;background:#fff}#graphiql-container .docExplorerResizer{cursor:col-resize;height:100%;left:-5px;position:absolute;top:0;width:10px;z-index:10}#graphiql-container .docExplorerHide{cursor:pointer;font-size:18px;margin:-7px -8px -6px 0;padding:18px 16px 15px 12px}#graphiql-container .query-editor{-webkit-flex:1;flex:1;position:relative}#graphiql-container .variable-editor{height:30px;display:-webkit-flex;display:flex;-webkit-flex-direction:column;flex-direction:column;position:relative}#graphiql-container .variable-editor-title{background:#eee;border-bottom:1px solid #d6d6d6;border-top:1px solid #e0e0e0;color:#777;font-variant:small-caps;font-weight:700;letter-spacing:1px;line-height:14px;padding:6px 0 8px 43px;text-transform:lowercase;-webkit-user-select:none;user-select:none}#graphiql-container .codemirrorWrap,#graphiql-container .result-window{-webkit-flex:1;flex:1;position:relative}#graphiql-container .footer{background:#f6f7f8;border-left:1px solid #e0e0e0;border-top:1px solid #e0e0e0;margin-left:12px;position:relative}#graphiql-container .footer:before{background:#eee;bottom:0;content:\" \";left:-13px;position:absolute;top:-1px;width:12px}#graphiql-container .result-window .CodeMirror{background:#f6f7f8}#graphiql-container .result-window .CodeMirror-gutters{background-color:#eee;border-color:#e0e0e0;cursor:col-resize}#graphiql-container .result-window .CodeMirror-foldgutter,#graphiql-container .result-window .CodeMirror-foldgutter-folded:after,#graphiql-container .result-window .CodeMirror-foldgutter-open:after{padding-left:3px}#graphiql-container .toolbar-button{background:#fdfdfd;background:-webkit-linear-gradient(#fbfbfb,#f8f8f8);background:linear-gradient(#fbfbfb,#f8f8f8);border:.5px solid;border-color:#d3d3d3 #d0d0d0 #bababa;border-radius:4px;box-shadow:0 1px 1px -1px rgba(0,0,0,.13),inset 0 1px #fff;color:#444;cursor:pointer;display:inline-block;margin:0 5px;padding:2px 8px 4px}#graphiql-container .toolbar-button:active{background:-webkit-linear-gradient(#ececec,#d8d8d8);background:linear-gradient(#ececec,#d8d8d8);border-color:#cacaca #c9c9c9 #b0b0b0;box-shadow:0 1px 0 #fff,inset 0 1px hsla(0,0%,100%,.2),inset 0 1px 1px rgba(0,0,0,.08)}#graphiql-container .toolbar-button.error{background:-webkit-linear-gradient(#fdf3f3,#e6d6d7);background:linear-gradient(#fdf3f3,#e6d6d7);color:#b00}#graphiql-container .execute-button{background:-webkit-linear-gradient(#fdfdfd,#d2d3d6);background:linear-gradient(#fdfdfd,#d2d3d6);border:1px solid rgba(0,0,0,.25);border-radius:17px;box-shadow:0 1px 0 #fff;cursor:pointer;fill:#444;height:34px;margin:0 14px 0 28px;padding:0;width:34px}#graphiql-container .execute-button:active{background:-webkit-linear-gradient(#e6e6e6,silver);background:linear-gradient(#e6e6e6,silver);box-shadow:0 1px 0 #fff,inset 0 0 2px rgba(0,0,0,.3),inset 0 0 6px rgba(0,0,0,.2)}#graphiql-container .execute-button:focus{outline:0}#graphiql-container .CodeMirror-scroll{-webkit-overflow-scrolling:touch}#graphiql-container .CodeMirror{position:absolute;top:0;left:0;height:100%;width:100%;font-size:13px;font-family:Consolas,Inconsolata,Droid Sans Mono,Monaco,monospace;color:#141823}#graphiql-container .CodeMirror-lines{padding:20px 0}.CodeMirror-hint-information .content{-webkit-box-orient:vertical;color:#141823;display:-webkit-box;font-family:system,-apple-system,San Francisco,\\.SFNSDisplay-Regular,Segoe UI,Segoe,Segoe WP,Helvetica Neue,helvetica,Lucida Grande,arial,sans-serif;font-size:13px;-webkit-line-clamp:3;line-height:16px;max-height:48px;overflow:hidden;text-overflow:-o-ellipsis-lastline}.CodeMirror-hint-information .content p:first-child{margin-top:0}.CodeMirror-hint-information .content p:last-child{margin-bottom:0}.CodeMirror-hint-information .infoType{color:#30a;margin-right:.5em;display:inline;cursor:pointer}.autoInsertedLeaf.cm-property{padding:2px 4px 1px;margin:-2px -4px -1px;border-radius:2px;border-bottom:2px solid hsla(0,0%,100%,0);-webkit-animation-duration:6s;animation-duration:6s;-webkit-animation-name:insertionFade;animation-name:insertionFade}@-webkit-keyframes insertionFade{0%,to{background:hsla(0,0%,100%,0);border-color:hsla(0,0%,100%,0)}15%,85%{background:#fbffc9;border-color:#f0f3c0}}@keyframes insertionFade{0%,to{background:hsla(0,0%,100%,0);border-color:hsla(0,0%,100%,0)}15%,85%{background:#fbffc9;border-color:#f0f3c0}}div.CodeMirror-lint-tooltip{background-color:#fff;color:#141823;border:0;border-radius:2px;box-shadow:0 1px 3px rgba(0,0,0,.45);font-family:system,-apple-system,San Francisco,\\.SFNSDisplay-Regular,Segoe UI,Segoe,Segoe WP,Helvetica Neue,helvetica,Lucida Grande,arial,sans-serif;font-size:13px;line-height:16px;padding:6px 10px;opacity:0;transition:opacity .15s;-moz-transition:opacity .15s;-webkit-transition:opacity .15s;-o-transition:opacity .15s;-ms-transition:opacity .15s}div.CodeMirror-lint-message-error,div.CodeMirror-lint-message-warning{padding-left:23px}#graphiql-container .CodeMirror-foldmarker{border-radius:4px;background:#08f;background:-webkit-linear-gradient(#43a8ff,#0f83e8);background:linear-gradient(#43a8ff,#0f83e8);color:#fff;box-shadow:0 1px 1px rgba(0,0,0,.2),inset 0 0 0 1px rgba(0,0,0,.1);font-family:arial;line-height:0;padding:0 4px 1px;font-size:12px;margin:0 3px;text-shadow:0 -1px rgba(0,0,0,.1)}#graphiql-container div.CodeMirror span.CodeMirror-matchingbracket{color:#555;text-decoration:underline}#graphiql-container div.CodeMirror span.CodeMirror-nonmatchingbracket{color:red}.cm-comment{color:#999}.cm-punctuation{color:#555}.cm-keyword{color:#b11a04}.cm-def{color:#d2054e}.cm-property{color:#1f61a0}.cm-qualifier{color:#1c92a9}.cm-attribute{color:#8b2bb9}.cm-number{color:#2882f9}.cm-string{color:#d64292}.cm-builtin{color:#d47509}.cm-string-2{color:#0b7fc7}.cm-variable{color:#397d13}.cm-meta{color:#b33086}.cm-atom{color:#ca9800}.CodeMirror{font-family:monospace;height:300px;color:#000}.CodeMirror-lines{padding:4px 0}.CodeMirror pre{padding:0 4px}.CodeMirror-gutter-filler,.CodeMirror-scrollbar-filler{background-color:#fff}.CodeMirror-gutters{border-right:1px solid #ddd;background-color:#f7f7f7;white-space:nowrap}.CodeMirror-linenumber{padding:0 3px 0 5px;min-width:20px;text-align:right;color:#999;white-space:nowrap}.CodeMirror-guttermarker{color:#000}.CodeMirror-guttermarker-subtle{color:#999}.CodeMirror div.CodeMirror-cursor{border-left:1px solid #000}.CodeMirror div.CodeMirror-secondarycursor{border-left:1px solid silver}.CodeMirror.cm-fat-cursor div.CodeMirror-cursor{width:auto;border:0;background:#7e7}.CodeMirror.cm-fat-cursor div.CodeMirror-cursors{z-index:1}.cm-animate-fat-cursor{width:auto;border:0;-webkit-animation:blink 1.06s steps(1) infinite;animation:blink 1.06s steps(1) infinite}@-webkit-keyframes blink{0%{background:#7e7}50%{background:none}to{background:#7e7}}@keyframes blink{0%{background:#7e7}50%{background:none}to{background:#7e7}}.cm-tab{display:inline-block;text-decoration:inherit}.CodeMirror-ruler{border-left:1px solid #ccc;position:absolute}.cm-s-default .cm-keyword{color:#708}.cm-s-default .cm-atom{color:#219}.cm-s-default .cm-number{color:#164}.cm-s-default .cm-def{color:#00f}.cm-s-default .cm-variable-2{color:#05a}.cm-s-default .cm-variable-3{color:#085}.cm-s-default .cm-comment{color:#a50}.cm-s-default .cm-string{color:#a11}.cm-s-default .cm-string-2{color:#f50}.cm-s-default .cm-meta,.cm-s-default .cm-qualifier{color:#555}.cm-s-default .cm-builtin{color:#30a}.cm-s-default .cm-bracket{color:#997}.cm-s-default .cm-tag{color:#170}.cm-s-default .cm-attribute{color:#00c}.cm-s-default .cm-header{color:blue}.cm-s-default .cm-quote{color:#090}.cm-s-default .cm-hr{color:#999}.cm-s-default .cm-link{color:#00c}.cm-negative{color:#d44}.cm-positive{color:#292}.cm-header,.cm-strong{font-weight:700}.cm-em{font-style:italic}.cm-link{text-decoration:underline}.cm-strikethrough{text-decoration:line-through}.cm-invalidchar,.cm-s-default .cm-error{color:red}.CodeMirror-composing{border-bottom:2px solid}div.CodeMirror span.CodeMirror-matchingbracket{color:#0f0}div.CodeMirror span.CodeMirror-nonmatchingbracket{color:#f22}.CodeMirror-matchingtag{background:rgba(255,150,0,.3)}.CodeMirror-activeline-background{background:#e8f2ff}.CodeMirror{position:relative;overflow:hidden;background:#fff}.CodeMirror-scroll{overflow:scroll!important;margin-bottom:-30px;margin-right:-30px;padding-bottom:30px;height:100%;outline:none;position:relative}.CodeMirror-sizer{position:relative;border-right:30px solid transparent}.CodeMirror-gutter-filler,.CodeMirror-hscrollbar,.CodeMirror-scrollbar-filler,.CodeMirror-vscrollbar{position:absolute;z-index:6;display:none}.CodeMirror-vscrollbar{right:0;top:0;overflow-x:hidden;overflow-y:scroll}.CodeMirror-hscrollbar{bottom:0;left:0;overflow-y:hidden;overflow-x:scroll}.CodeMirror-scrollbar-filler{right:0;bottom:0}.CodeMirror-gutter-filler{left:0;bottom:0}.CodeMirror-gutters{position:absolute;left:0;top:0;z-index:3}.CodeMirror-gutter{white-space:normal;height:100%;display:inline-block;margin-bottom:-30px;*zoom:1;*display:inline}.CodeMirror-gutter-wrapper{position:absolute;z-index:4;height:100%}.CodeMirror-gutter-elt{position:absolute;cursor:default;z-index:4}.CodeMirror-gutter-wrapper{-webkit-user-select:none;-moz-user-select:none;user-select:none}.CodeMirror-lines{cursor:text;min-height:1px}.CodeMirror pre{border-radius:0;border-width:0;background:transparent;font-family:inherit;font-size:inherit;margin:0;white-space:pre;word-wrap:normal;line-height:inherit;color:inherit;z-index:2;position:relative;overflow:visible;-webkit-tap-highlight-color:transparent}.CodeMirror-wrap pre{word-wrap:break-word;white-space:pre-wrap;word-break:normal}.CodeMirror-linebackground{position:absolute;left:0;right:0;top:0;bottom:0;z-index:0}.CodeMirror-linewidget{position:relative;z-index:2;overflow:auto}.CodeMirror-code{outline:none}.CodeMirror-gutter,.CodeMirror-gutters,.CodeMirror-linenumber,.CodeMirror-scroll,.CodeMirror-sizer{box-sizing:content-box}.CodeMirror-measure{position:absolute;width:100%;height:0;overflow:hidden;visibility:hidden}.CodeMirror-measure pre{position:static}.CodeMirror div.CodeMirror-cursor{position:absolute;border-right:none;width:0}div.CodeMirror-cursors{visibility:hidden;position:relative;z-index:3}.CodeMirror-focused div.CodeMirror-cursors{visibility:visible}.CodeMirror-selected{background:#d9d9d9}.CodeMirror-focused .CodeMirror-selected{background:#d7d4f0}.CodeMirror-crosshair{cursor:crosshair}.CodeMirror ::selection{background:#d7d4f0}.CodeMirror ::-moz-selection{background:#d7d4f0}.cm-searching{background:#ffa;background:rgba(255,255,0,.4)}.CodeMirror span{*vertical-align:text-bottom}.cm-force-border{padding-right:.1px}@media print{.CodeMirror div.CodeMirror-cursors{visibility:hidden}}.cm-tab-wrap-hack:after{content:''}span.CodeMirror-selectedtext{background:none}#graphiql-container .doc-explorer{background:#fff}#graphiql-container .doc-explorer-title-bar{cursor:default;display:-webkit-flex;display:flex;height:34px;line-height:14px;padding:8px 8px 5px;position:relative;-webkit-user-select:none;user-select:none}#graphiql-container .doc-explorer-title{padding:10px 0 10px 10px;font-weight:700;text-align:center;text-overflow:ellipsis;white-space:nowrap;overflow-x:hidden;-webkit-flex:1;flex:1}#graphiql-container .doc-explorer-back{color:#3b5998;cursor:pointer;margin:-7px 0 -6px -8px;overflow-x:hidden;padding:17px 12px 16px 16px;text-overflow:ellipsis;white-space:nowrap}#graphiql-container .doc-explorer-back:before{border-left:2px solid #3b5998;border-top:2px solid #3b5998;content:'';display:inline-block;height:9px;margin:0 3px -1px 0;position:relative;width:9px;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}#graphiql-container .doc-explorer-rhs{position:relative}#graphiql-container .doc-explorer-contents{background-color:#fff;border-top:1px solid #d6d6d6;bottom:0;left:0;min-width:300px;overflow-y:auto;padding:20px 15px;position:absolute;right:0;top:47px}#graphiql-container .doc-type-description blockquote:first-child,#graphiql-container .doc-type-description p:first-child{margin-top:0}#graphiql-container .doc-explorer-contents a{cursor:pointer;text-decoration:none}#graphiql-container .doc-explorer-contents a:hover{text-decoration:underline}#graphiql-container .doc-value-description{padding:4px 0 8px 12px}#graphiql-container .doc-category{margin:20px 0}#graphiql-container .doc-category-title{border-bottom:1px solid #e0e0e0;color:#777;cursor:default;font-size:14px;font-variant:small-caps;font-weight:700;letter-spacing:1px;margin:0 -15px 10px 0;padding:10px 0;-webkit-user-select:none;user-select:none}#graphiql-container .doc-category-item{margin:12px 0;color:#555}#graphiql-container .keyword{color:#b11a04}#graphiql-container .type-name{color:#ca9800}#graphiql-container .field-name{color:#1f61a0}#graphiql-container .value-name{color:#0b7fc7}#graphiql-container .arg-name{color:#8b2bb9}#graphiql-container .arg:after{content:', '}#graphiql-container .arg:last-child:after{content:''}#graphiql-container .doc-alert-text{color:#f00f00;font-family:Consolas,Inconsolata,Droid Sans Mono,Monaco,monospace;font-size:13px}#graphiql-container .search-box-outer{border:1px solid #d3d6db;box-sizing:border-box;display:inline-block;font-size:12px;height:24px;margin-bottom:12px;padding:3px 8px 5px;vertical-align:middle;width:100%}#graphiql-container .search-box-input{border:0;font-size:12px;margin:0;outline:0;padding:0;width:100%}.CodeMirror-foldmarker{color:blue;text-shadow:#b9f 1px 1px 2px,#b9f -1px -1px 2px,#b9f 1px -1px 2px,#b9f -1px 1px 2px;font-family:arial;line-height:.3;cursor:pointer}.CodeMirror-foldgutter{width:.7em}.CodeMirror-foldgutter-folded,.CodeMirror-foldgutter-open{cursor:pointer}.CodeMirror-foldgutter-open:after{content:\"\\25BE\"}.CodeMirror-foldgutter-folded:after{content:\"\\25B8\"}.CodeMirror-lint-markers{width:16px}.CodeMirror-lint-tooltip{background-color:infobackground;border:1px solid #000;border-radius:4px 4px 4px 4px;color:infotext;font-family:monospace;font-size:10pt;overflow:hidden;padding:2px 5px;position:fixed;white-space:pre;white-space:pre-wrap;z-index:100;max-width:600px;opacity:0;transition:opacity .4s;-moz-transition:opacity .4s;-webkit-transition:opacity .4s;-o-transition:opacity .4s;-ms-transition:opacity .4s}.CodeMirror-lint-mark-error,.CodeMirror-lint-mark-warning{background-position:left bottom;background-repeat:repeat-x}.CodeMirror-lint-mark-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJDw4cOCW1/KIAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAHElEQVQI12NggIL/DAz/GdA5/xkY/qPKMDAwAADLZwf5rvm+LQAAAABJRU5ErkJggg==\")}.CodeMirror-lint-mark-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAADCAYAAAC09K7GAAAAAXNSR0IArs4c6QAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9sJFhQXEbhTg7YAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAMklEQVQI12NkgIIvJ3QXMjAwdDN+OaEbysDA4MPAwNDNwMCwiOHLCd1zX07o6kBVGQEAKBANtobskNMAAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-error,.CodeMirror-lint-marker-warning{background-position:center center;background-repeat:no-repeat;cursor:pointer;display:inline-block;height:16px;width:16px;vertical-align:middle;position:relative}.CodeMirror-lint-message-error,.CodeMirror-lint-message-warning{padding-left:18px;background-position:top left;background-repeat:no-repeat}.CodeMirror-lint-marker-error,.CodeMirror-lint-message-error{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAHlBMVEW7AAC7AACxAAC7AAC7AAAAAAC4AAC5AAD///+7AAAUdclpAAAABnRSTlMXnORSiwCK0ZKSAAAATUlEQVR42mWPOQ7AQAgDuQLx/z8csYRmPRIFIwRGnosRrpamvkKi0FTIiMASR3hhKW+hAN6/tIWhu9PDWiTGNEkTtIOucA5Oyr9ckPgAWm0GPBog6v4AAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-warning,.CodeMirror-lint-message-warning{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAANlBMVEX/uwDvrwD/uwD/uwD/uwD/uwD/uwD/uwD/uwD6twD/uwAAAADurwD2tQD7uAD+ugAAAAD/uwDhmeTRAAAADHRSTlMJ8mN1EYcbmiixgACm7WbuAAAAVklEQVR42n3PUQqAIBBFUU1LLc3u/jdbOJoW1P08DA9Gba8+YWJ6gNJoNYIBzAA2chBth5kLmG9YUoG0NHAUwFXwO9LuBQL1giCQb8gC9Oro2vp5rncCIY8L8uEx5ZkAAAAASUVORK5CYII=\")}.CodeMirror-lint-marker-multiple{background-image:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAHCAMAAADzjKfhAAAACVBMVEUAAAAAAAC/v7914kyHAAAAAXRSTlMAQObYZgAAACNJREFUeNo1ioEJAAAIwmz/H90iFFSGJgFMe3gaLZ0od+9/AQZ0ADosbYraAAAAAElFTkSuQmCC\");background-repeat:no-repeat;background-position:right bottom;width:100%;height:100%}#graphiql-container .spinner-container{position:absolute;top:50%;height:36px;width:36px;left:50%;transform:translate(-50%,-50%);z-index:10}#graphiql-container .spinner{vertical-align:middle;display:inline-block;height:24px;width:24px;position:absolute;-webkit-animation:rotation .6s infinite linear;animation:rotation .6s infinite linear;border-left:6px solid hsla(0,0%,59%,.15);border-right:6px solid hsla(0,0%,59%,.15);border-bottom:6px solid hsla(0,0%,59%,.15);border-top:6px solid hsla(0,0%,59%,.8);border-radius:100%}@-webkit-keyframes rotation{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(359deg)}}@keyframes rotation{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.CodeMirror-hints{font-family:Consolas,Inconsolata,Droid Sans Mono,Monaco,monospace;font-size:13px;list-style:none;margin:0;margin-left:-6px;max-height:14.5em;overflow-y:auto;overflow:hidden;padding:0}.CodeMirror-hints,.CodeMirror-hints-wrapper{background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.45);position:absolute;z-index:10}.CodeMirror-hints-wrapper{margin-left:-6px}.CodeMirror-hints-wrapper .CodeMirror-hints{box-shadow:none;position:relative;margin-left:0;z-index:0}.CodeMirror-hint{border-top:1px solid #f7f7f7;color:#141823;cursor:pointer;margin:0;max-width:300px;overflow:hidden;padding:2px 6px;white-space:pre}li.CodeMirror-hint-active{background-color:#08f;border-top-color:#fff;color:#fff}.CodeMirror-hint-information{border-top:1px solid silver;max-width:300px;padding:4px 6px;position:relative;z-index:1}.CodeMirror-hint-information:first-child{border-bottom:1px solid silver;border-top:none;margin-bottom:-1px}", ""]);
	
	// exports


/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a9474a204af99bf5449e575d46ff02b7.png";

/***/ },
/* 387 */
339,
/* 388 */
339,
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactDocumentTitle = __webpack_require__(262);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _chromaJs = __webpack_require__(275);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(155);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var fontSizeToPx = _ui_ReindexTypography2['default'].fontSizeToPx;
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var headingStyle = fontSizeToPx('250%');
	var styles = {
	  codeAlt: {
	    color: '#666'
	  },
	  paragraph: {
	    maxWidth: '72ex'
	  },
	  testimonials: {
	    marginBottom: rhythm(2),
	    display: 'flex'
	  },
	  testimonial: {
	    flexShrink: 0,
	    '@media (max-width: 800px)': {
	      flexShrink: 1,
	      margin: '0 ' + rhythm(2)
	    }
	  },
	  testimonialText: {
	    position: 'relative',
	    margin: '0 auto ' + rhythm(1.5),
	    width: '60ex',
	    padding: 50,
	    '@media (max-width: 800px)': {
	      width: 'auto'
	    }
	  },
	  testimonialHighlight: _extends({
	    fontWeight: 'bold',
	    color: 'rgba(0, 0, 0, 0.6)'
	  }, fontSizeToPx('120%')),
	  triangle: {
	    borderWidth: '15px 15px 0',
	    borderStyle: 'solid',
	    borderColor: 'whitesmoke transparent',
	    display: 'block',
	    width: 0,
	    position: 'absolute',
	    bottom: -15,
	    left: 50 + 60 / 2 - 15
	  },
	  testimonialQuote: _extends({
	    backgroundColor: 'transparent',
	    color: (0, _chromaJs2['default'])('#3cd8ff').alpha(0.75).css(),
	    margin: 50
	  }, fontSizeToPx('300%'), {
	    '@media (max-width: 800px)': {
	      display: 'none'
	    }
	  }),
	  recommender: {
	    margin: '0 auto',
	    paddingLeft: 50,
	    display: 'flex',
	    alignItems: 'center'
	  },
	  recommenderPicture: {
	    borderRadius: '50%',
	    width: 64,
	    height: 64,
	    margin: '0 20px 0 0'
	  },
	  recommenderInfo: {
	    marginLeft: '1em',
	    display: 'block'
	  },
	  textRhythm: {
	    marginLeft: rhythm(1),
	    marginRight: rhythm(1)
	  }
	};
	
	var Index = (function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, _Index);
	
	    _get(Object.getPrototypeOf(_Index.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactDocumentTitle2['default'],
	        { title: 'Reindex' },
	        _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'header',
	            {
	              style: {
	                minHeight: 480,
	                marginTop: rhythm(-1.5),
	                textAlign: 'center',
	                color: 'white'
	              } },
	            _react2['default'].createElement(
	              'div',
	              { style: {
	                  width: 800,
	                  maxWidth: '80%',
	                  margin: '0 auto ' + rhythm(2)
	                } },
	              _react2['default'].createElement('div', {
	                style: {
	                  height: 0,
	                  paddingBottom: 100 * 480 / 800 + '%',
	                  paddingTop: rhythm(2),
	                  margin: 0,
	                  backgroundImage: 'url(/illustration_2017.svg)',
	                  backgroundRepeat: 'no-repeat',
	                  backgroundPosition: 'center bottom',
	                  backgroundSize: '100% auto'
	                } })
	            ),
	            _react2['default'].createElement(
	              'h1',
	              {
	                style: _extends({}, headingStyle, {
	                  textAlign: 'center',
	                  margin: 0,
	                  paddingBottom: rhythm(2),
	                  fontWeight: 200
	                }) },
	              'Web, Mobile and Beyond'
	            )
	          ),
	          _react2['default'].createElement(
	            'div',
	            { style: {
	                textAlign: 'center',
	                paddingBottom: rhythm(1),
	                display: 'flex',
	                flexDirection: 'column',
	                alignItems: 'center'
	              } },
	            _react2['default'].createElement(
	              'div',
	              { style: _extends({ maxWidth: '70ex' }, styles.textRhythm) },
	              _react2['default'].createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                'We create tools that change how developers build mobile apps and websites.'
	              ),
	              _react2['default'].createElement(
	                'p',
	                { style: { textAlign: 'center' } },
	                'We\'re a team of software engineers focused on GraphQL, React.js and related open source technologies. ',
	                _react2['default'].createElement(
	                  _reactRouter.Link,
	                  { to: '/team/' },
	                  'Read more.'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Index = Index;
	  Index = (0, _radium2['default'])(Index) || Index;
	  return Index;
	})(_react2['default'].Component);
	
	exports['default'] = Index;
	module.exports = exports['default'];

/***/ },
/* 390 */
339,
/* 391 */
339,
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(155);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var styles = {
	  container: {
	    display: 'flex',
	    maxWidth: 960,
	    marginLeft: 'auto',
	    marginRight: 'auto',
	    '@media (max-width: 700px)': {
	      flexDirection: 'column'
	    }
	  },
	  content: {
	    flex: 1
	  },
	  sidebar: {
	    width: 100 * 3 / 12 + '%',
	    marginTop: 55,
	    marginLeft: 100 * 1 / 12 + '%',
	    '@media (max-width: 700px)': {
	      width: 'auto',
	      order: -1
	    }
	  }
	};
	
	var pages = [{
	  path: '/policies/terms-and-conditions/',
	  title: 'Terms and Conditions'
	}, {
	  path: '/policies/privacy-policy/',
	  title: 'Privacy Policy'
	}, {
	  path: '/policies/open-source/',
	  title: 'Open Source'
	}];
	
	var PoliciesPage = _react2['default'].createClass({
	  displayName: 'PoliciesPage',
	
	  mixins: [_reactRouter.State],
	
	  render: function render() {
	    var _this = this;
	
	    var links = pages.map(function (child) {
	      return _react2['default'].createElement(
	        'li',
	        {
	          key: child.path,
	          style: {
	            marginBottom: rhythm(1 / 2)
	          } },
	        _react2['default'].createElement(
	          'a',
	          { href: child.path },
	          _this.isActive(child.path) ? _react2['default'].createElement(
	            'strong',
	            null,
	            child.title
	          ) : child.title
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      'div',
	      { style: styles.container },
	      _react2['default'].createElement(
	        'div',
	        { style: styles.content },
	        _react2['default'].createElement(_reactRouter.RouteHandler, this.props)
	      ),
	      _react2['default'].createElement(
	        'div',
	        { style: styles.sidebar },
	        _react2['default'].createElement(
	          'ul',
	          { style: { listStyle: 'none', margin: 0 } },
	          links
	        )
	      )
	    );
	  }
	});
	
	exports['default'] = (0, _radium2['default'])(PoliciesPage);
	module.exports = exports['default'];

/***/ },
/* 393 */
/***/ function(module, exports) {

	module.exports = {"body":"<h1 id=\"open-source\">Open Source <a class=\"hash-link\" href=\"#open-source\" aria-hidden=\"true\">#</a></h1>\n<h2 id=\"open-source-sdks\">Open Source SDKs <a class=\"hash-link\" href=\"#open-source-sdks\" aria-hidden=\"true\">#</a></h2>\n<p>We are committed to open source software. <strong>All our SDKs are available under\npermissive open source licenses</strong> at\n<a href=\"https://github.com/reindexio/\">github.com/reindexio</a>.</p>\n<h2 id=\"third-party-components\">Third-party components <a class=\"hash-link\" href=\"#third-party-components\" aria-hidden=\"true\">#</a></h2>\n<p>Reindex platform includes open source components. Following copyright notices\nare included here as required by the copyright holders.</p>\n<h3 id=\"graphiql\">GraphiQL <a class=\"hash-link\" href=\"#graphiql\" aria-hidden=\"true\">#</a></h3>\n<p>LICENSE AGREEMENT For GraphiQL software</p>\n<p>Facebook, Inc. (“Facebook”) owns all right, title and interest, including all\nintellectual property and other proprietary rights, in and to the GraphiQL\nsoftware. Subject to your compliance with these terms, you are hereby granted a\nnon-exclusive, worldwide, royalty-free copyright license to (1) use and copy the\nGraphiQL software; and (2) reproduce and distribute the GraphiQL software as\npart of your own software (“Your Software”). Facebook reserves all rights not\nexpressly granted to you in this license agreement.</p>\n<p>THE SOFTWARE AND DOCUMENTATION, IF ANY, ARE PROVIDED “AS IS” AND ANY EXPRESS OR\nIMPLIED WARRANTIES (INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF\nMERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE) ARE DISCLAIMED. IN NO\nEVENT SHALL FACEBOOK OR ITS AFFILIATES, OFFICES, DIRECTORS OR EMPLOYEES BE\nLIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR\nCONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE\nGOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION)\nHOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT\nLIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF\nTHE USE OF THE SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.</p>\n<p>You will include in Your Software (e.g., in the file(s), documentation or other\nmaterials accompanying your software): (1) the disclaimer set forth above; (2)\nthis sentence; and (3) the following copyright notice:</p>\n<p>Copyright © 2015, Facebook, Inc. All rights reserved.</p>\n"}

/***/ },
/* 394 */
/***/ function(module, exports) {

	module.exports = "<a\n  href=\"https://www.iubenda.com/privacy-policy/7763734\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Privacy Policy\">\n  Privacy Policy\n</a>\n"

/***/ },
/* 395 */
/***/ function(module, exports) {

	module.exports = "<a\n  href=\"https://www.iubenda.com/terms-and-conditions/7763742\"\n  class=\"iubenda-nostyle no-brand iub-body-embed iubenda-embed\"\n  title=\"Terms and Conditions\">\n  Terms and Conditions\n</a>\n"

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a115d43e467293ac57076fcc25f7a175.png";

/***/ },
/* 397 */
339,
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable max-len */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _reactDocumentTitle = __webpack_require__(262);
	
	var _reactDocumentTitle2 = _interopRequireDefault(_reactDocumentTitle);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _chromaJs = __webpack_require__(275);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _ui_ReindexTypography = __webpack_require__(308);
	
	var _ui_ReindexTypography2 = _interopRequireDefault(_ui_ReindexTypography);
	
	var backgrounds = {
	  teal: (0, _chromaJs2['default'])('#7dccc8').alpha(0.15).css(),
	  orange: (0, _chromaJs2['default'])('#ef6900').alpha(0.15).css(),
	  purple: (0, _chromaJs2['default'])('#4e14ae').alpha(0.15).css(),
	  blue: (0, _chromaJs2['default'])('#3cd8ff').alpha(0.15).css()
	};
	
	var fontSizeToPx = _ui_ReindexTypography2['default'].fontSizeToPx;
	var rhythm = _ui_ReindexTypography2['default'].rhythm;
	
	var maxWidth = 750;
	var styles = {
	  container: {
	    marginTop: rhythm(-1.5),
	    paddingTop: rhythm(1.5)
	  },
	  heading: {
	    textAlign: 'center'
	  },
	  content: {
	    maxWidth: maxWidth,
	    margin: '0 auto',
	    padding: rhythm(1)
	  },
	  notes: _extends({}, fontSizeToPx('80%'), {
	    textAlign: 'center',
	    marginTop: rhythm(1),
	    color: '#777'
	  })
	};
	
	var padding = rhythm(1);
	var gutter = rhythm(1.5);
	
	var gridStyle = {
	  display: 'flex',
	  flexWrap: 'wrap',
	  margin: '-' + gutter + ' 0 0 -' + gutter,
	  alignItems: 'stretch',
	  paddingBottom: padding
	};
	var columnStyle = {
	  padding: gutter + ' 0 0 ' + gutter,
	  display: 'flex',
	  flex: '0 0 50%',
	  '@media (max-width: 570px)': {
	    flex: '0 0 100%',
	    textAlign: 'left'
	  }
	};
	
	var Team = (function (_React$Component) {
	  _inherits(Team, _React$Component);
	
	  function Team() {
	    _classCallCheck(this, _Team);
	
	    _get(Object.getPrototypeOf(_Team.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Team, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        _reactDocumentTitle2['default'],
	        { title: 'Team | ' + this.props.config.siteTitle },
	        _react2['default'].createElement(
	          'div',
	          { style: styles.container },
	          _react2['default'].createElement(
	            'div',
	            { style: styles.content },
	            _react2['default'].createElement(
	              'h1',
	              null,
	              'About Us'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              _react2['default'].createElement(
	                'em',
	                null,
	                'Reindex Software'
	              ),
	              ' is a team of software engineers focused on GraphQL, React.js and related open source technologies.'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'We built Reindex, the first Backend as a Service platform based on GraphQL, because we needed an API for building mobile and web apps with JavaScript faster. We\'ve enjoyed using React for frontend development since 2013 and it\'s changed the way we think about client-side code. But integrating client-side apps with various backend technologies and hosted databases using more or less RESTful APIs was a constant source of complexity. When Facebook introduced their approach for tackling this complexity with GraphQL and Relay, ',
	              _react2['default'].createElement(
	                'a',
	                { href: '/blog/how-facebooks-graphql-will-change-backend-development/' },
	                'we saw in this a huge potential'
	              ),
	              ' for the kind of applications we love to build. And we wanted a service for storing data with GraphQL that could be set up in minutes, without time consuming backend development, a "Firebase of GraphQL".',
	              _react2['default'].createElement('br', null),
	              'Reindex was born.'
	            ),
	            _react2['default'].createElement(
	              'h2',
	              null,
	              'Services'
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'We provide consulting and training services for companies wanting to make the most out of GraphQL, React and related technologies.'
	            ),
	            _react2['default'].createElement(
	              'div',
	              { style: gridStyle },
	              _react2['default'].createElement(
	                'div',
	                { style: columnStyle },
	                _react2['default'].createElement(
	                  'div',
	                  { style: { backgroundColor: backgrounds.blue, padding: padding, flex: 1 } },
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'GraphQL Training'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'If you want to get your engineering team up to speed with GraphQL and/or Relay we can lead an on-site training course tailored to your needs.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'The course can cover the basics of GraphQL, Relay and scalable GraphQL server architecture, or go deeper in more advanced topics relevant to your application.'
	                  )
	                )
	              ),
	              _react2['default'].createElement(
	                'div',
	                { style: columnStyle },
	                _react2['default'].createElement(
	                  'div',
	                  { style: { backgroundColor: backgrounds.teal, padding: padding, flex: 1 } },
	                  _react2['default'].createElement(
	                    'h3',
	                    null,
	                    'Software Development'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Whether it\'s building an MVP with React Native, moving your web app to React or developing a GraphQL API for all of your backend services, we\'re ready to jump in to help.'
	                  ),
	                  _react2['default'].createElement(
	                    'p',
	                    null,
	                    'Reindex can deliver the whole project from an idea to a polished product or we can work together with your existing team of developers.'
	                  )
	                )
	              )
	            ),
	            _react2['default'].createElement(
	              'p',
	              null,
	              'Interested? Send an email to ',
	              _react2['default'].createElement(
	                'a',
	                { href: 'mailto:hello@reindex.io' },
	                'hello@reindex.io'
	              ),
	              ' and tell us about your project!'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  var _Team = Team;
	  Team = (0, _radium2['default'])(Team) || Team;
	  return Team;
	})(_react2['default'].Component);
	
	exports['default'] = Team;
	module.exports = exports['default'];

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _chromaJs = __webpack_require__(275);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var style = function style(backgroundColor) {
	  var width = arguments.length <= 1 || arguments[1] === undefined ? 'auto' : arguments[1];
	  return {
	    fontSize: 16,
	    fontWeight: 500,
	    border: '1px solid #ddd',
	    color: 'white',
	    display: 'inline-block',
	    backgroundColor: backgroundColor,
	    borderRadius: 5,
	    padding: '0 16px',
	    margin: '8px',
	    height: 48,
	    lineHeight: '48px',
	    outline: 'none',
	    textDecoration: 'none',
	    transition: 'background-color 0.2s',
	    width: width,
	    ':active': {
	      backgroundColor: (0, _chromaJs2['default'])(backgroundColor).darken(5).hex()
	    }
	  };
	};
	
	var Button = (function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  function Button() {
	    _classCallCheck(this, _Button);
	
	    _get(Object.getPrototypeOf(_Button.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Button, [{
	    key: 'render',
	    value: function render() {
	      var Element = this.props.element || 'button';
	      var backgroundColor = this.props.backgroundColor || '#5bbae9';
	      return _react2['default'].createElement(Element, _extends({
	        type: 'button',
	        style: [style(backgroundColor, this.props.width), this.props.disabled && { backgroundColor: '#ddd' }]
	      }, this.props));
	    }
	  }]);
	
	  var _Button = Button;
	  Button = (0, _radium2['default'])(Button) || Button;
	  return Button;
	})(_react2['default'].Component);
	
	exports['default'] = Button;
	module.exports = exports['default'];

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x2, _x3, _x4) { var _again = true; _function: while (_again) { var object = _x2, property = _x3, receiver = _x4; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x2 = parent; _x3 = property; _x4 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _chromaJs = __webpack_require__(275);
	
	var _chromaJs2 = _interopRequireDefault(_chromaJs);
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var style = function style(backgroundColor) {
	  var width = arguments.length <= 1 || arguments[1] === undefined ? 'auto' : arguments[1];
	  return {
	    fontSize: 16,
	    fontWeight: 500,
	    border: '1px solid #222',
	    color: 'white',
	    display: 'inline-block',
	    backgroundColor: backgroundColor,
	    borderRadius: 5,
	    padding: '0 16px',
	    margin: '8px',
	    height: 36,
	    lineHeight: '36px',
	    outline: 'none',
	    textDecoration: 'none',
	    textTransform: 'uppercase',
	    transition: 'background-color 0.2s',
	    whiteSpace: 'nowrap',
	    width: width,
	    ':active': {
	      backgroundColor: (0, _chromaJs2['default'])(backgroundColor).darken(5).hex()
	    }
	  };
	};
	
	var HeaderButton = (function (_React$Component) {
	  _inherits(HeaderButton, _React$Component);
	
	  function HeaderButton() {
	    _classCallCheck(this, _HeaderButton);
	
	    _get(Object.getPrototypeOf(_HeaderButton.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(HeaderButton, [{
	    key: 'render',
	    value: function render() {
	      var Element = this.props.element || 'button';
	      var backgroundColor = this.props.backgroundColor || '#5bbae9';
	      return _react2['default'].createElement(Element, _extends({
	        type: 'button',
	        style: [style(backgroundColor, this.props.width), this.props.disabled && { backgroundColor: '#ddd' }]
	      }, this.props));
	    }
	  }]);
	
	  var _HeaderButton = HeaderButton;
	  HeaderButton = (0, _radium2['default'])(HeaderButton) || HeaderButton;
	  return HeaderButton;
	})(_react2['default'].Component);
	
	exports['default'] = HeaderButton;
	module.exports = exports['default'];

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/* global ga */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _radium = __webpack_require__(282);
	
	var _radium2 = _interopRequireDefault(_radium);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Button = __webpack_require__(399);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var emailInputStyle = {
	  width: 280,
	  border: '1px solid #ddd',
	  borderRadius: 5,
	  padding: '0 16px',
	  margin: '8px',
	  height: 48,
	  lineHeight: '48px',
	  outline: 'none',
	  ':focus': {
	    border: '1px solid #5bbae9'
	  }
	};
	
	var MailingListSignupForm = (function (_React$Component) {
	  _inherits(MailingListSignupForm, _React$Component);
	
	  function MailingListSignupForm() {
	    _classCallCheck(this, _MailingListSignupForm);
	
	    _get(Object.getPrototypeOf(_MailingListSignupForm.prototype), 'constructor', this).apply(this, arguments);
	
	    this.handleSubmit = function () {
	      ga('send', 'event', 'newsletter', 'signup');
	    };
	  }
	
	  _createClass(MailingListSignupForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2['default'].createElement(
	        'form',
	        {
	          action: '//reindex.us10.list-manage.com/subscribe/post' + '?u=9b29b7af813c2dada1bfb8d55&amp;id=e0eb2d3a8a',
	          method: 'post', id: 'mc-embedded-subscribe-form',
	          name: 'mc-embedded-subscribe-form',
	          target: '_blank',
	          onSubmit: this.handleSubmit },
	        _react2['default'].createElement(
	          'h5',
	          null,
	          'Join the Beta'
	        ),
	        _react2['default'].createElement(
	          'div',
	          { style: { display: 'flex', justifyContent: 'center' } },
	          _react2['default'].createElement(
	            'p',
	            { style: { maxWidth: '70ex' } },
	            'Request access our beta program to be among the first developers to build React apps with Reindex. Sign up now and we will email you more information.'
	          )
	        ),
	        _react2['default'].createElement('input', {
	          type: 'email',
	          defaultValue: '',
	          name: 'EMAIL',
	          placeholder: 'Your email address',
	          style: emailInputStyle }),
	        _react2['default'].createElement(
	          'div',
	          { style: { position: 'absolute', left: -5000 } },
	          _react2['default'].createElement('input', {
	            type: 'text',
	            name: 'b_9b29b7af813c2dada1bfb8d55_e0eb2d3a8a',
	            tabIndex: -1,
	            value: '' })
	        ),
	        _react2['default'].createElement(_Button2['default'], {
	          element: 'input',
	          type: 'submit',
	          value: 'Request an invite',
	          name: 'subscribe' })
	      );
	    }
	  }]);
	
	  var _MailingListSignupForm = MailingListSignupForm;
	  MailingListSignupForm = (0, _radium2['default'])(MailingListSignupForm) || MailingListSignupForm;
	  return MailingListSignupForm;
	})(_react2['default'].Component);
	
	exports['default'] = MailingListSignupForm;
	module.exports = exports['default'];

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cf91fa9e47fc080a2876ce9d5f019127.png";

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** bundle.js
 **/